import { mdiLaunch } from "@mdi/js";

export default {
	CrmDashboard: {
		totalUsers: 'Total de Usuários',
		increasedInDays: 'Aumento de {percent} em {days} dias',
		totalCountriesWithUsers: 'Total de Países com Usuários',
		totalSalesRevenue: 'Receita Total de Vendas',
		activeSubscriptions: 'Assinaturas Ativas',
		hideTotal: 'Ocultar total',
		revealTotal: 'Revelar total',
	},
	MailSendingAccounts: {
		title: 'Contas de Envio',
		subtitle: 'Troque qual credencial está mandando e-mail — sem editar .env, sem entrar no container.',
		activeNowTitle: 'Conta de envio ativa',
		activeNowSubtitle: 'É isso que todo serviço está usando pra enviar agora. Escolha uma conta cadastrada e troque — sem editar .env, sem reiniciar nada.',
		currentlySending: 'Enviando atualmente via',
		noActiveAccount: 'Nenhuma conta ativada ainda — os serviços continuam usando a credencial do próprio .env.',
		switchLabel: 'Trocar para',
		switchButton: 'Trocar agora',
		create: 'Nova conta',
		editTitle: 'Editar conta',
		label: 'Rótulo',
		scope: 'Escopo',
		networkWide: 'Rede inteira',
		scopeHint: 'Deixe em "rede inteira" a menos que esse serviço precise de credencial própria.',
		driver: 'Tipo',
		sesKey: 'Chave SES',
		sesSecret: 'Secret SES',
		sesRegion: 'Região',
		sesConfigurationSet: 'Configuration set (SES)',
		sesConfigurationSetHint: 'Sem ele a conta envia normalmente e não devolve entrega, bounce nem reclamação. Deixe em branco só se esta conta não precisar de retorno.',
		smtpHost: 'Host',
		smtpPort: 'Porta',
		smtpEncryption: 'Criptografia',
		smtpUsername: 'Usuário',
		smtpPassword: 'Senha',
		keepCurrent: 'Deixe em branco para manter o valor atual',
		fromOverride: 'Endereço de envio (override)',
		fromOverrideHint: 'Opcional — deixe em branco para manter o remetente de cada serviço.',
		fromNameOverride: 'Nome de envio (override)',
		notes: 'Notas',
		active: 'Ativa',
		status: 'Status',
		test: 'Testar',
		activate: 'Ativar',
		activateConfirmTitle: 'Ativar esta conta?',
		activateConfirmText: 'Isso torna "{label}" o remetente de {scope}. Cada requisição/job pega a mudança em segundos — isso afeta o envio ao vivo imediatamente.',
		testOk: 'Conexão bem-sucedida.',
		testFailed: 'Falha na conexão — veja o erro abaixo.',
		activated: 'Conta ativada.',
		deleted: 'Conta apagada.',
		cannotDeleteActive: 'Não é possível apagar a conta ativa — ative outra primeiro.',
	},
	SesHealth: {
		title: 'Saúde de envio da SES',
		widgetTitle: 'Envio de e-mail (SES)',
		statusHealthy: 'Saudável',
		statusWarning: 'Atenção',
		statusCritical: 'Crítico',
		topSender: 'Maior emissor: {name} ({count})',
		seeDetail: 'Ver detalhe',
		subtitle: 'Cota e reputação da conta compartilhada, e de qual serviço veio o volume.',
		quota: 'Cota diária',
		bounceRate: 'Taxa de bounce',
		complaintRate: 'Taxa de reclamação',
		limits: 'atenção {warning}% · revisão {review}%',
		byClass: 'Por tipo de e-mail, últimas 24h',
		bySystem: 'Por serviço, últimas 24h',
		mailClass: 'E-mail',
		sends: 'Envios',
		recipients: 'Destinatários',
		perRecipient: 'Por destinatário',
		noLoggedMail: 'Nenhum envio registrado nas últimas 24 horas.',
		loggedFloor: 'Contado a partir de email_logs, então é um piso e não um total — envios que não registram não aparecem aqui.',
		awsUnavailable: 'Números da AWS indisponíveis. A atribuição local abaixo continua valendo.',
	},
	VideoSubmissions: {
		title: 'Distribuição de Vídeo',
		subtitle: 'Vídeos enviados por estúdios aguardando revisão antes de o motor de publicação assumir.',
		video: 'Vídeo',
		cover: 'Capa',
		coverNone: 'Sem capa — a thumbnail será montada com um frame do vídeo',
		coverEdit: 'Trocar capa',
		coverAdd: 'Adicionar',
		coverTitle: 'Capa da thumbnail',
		coverHint: 'Recorte em 16:9. O enquadramento é travado em 1280x720 — o mesmo tamanho em que o motor gera a thumbnail. Sem capa, ele usa um frame do vídeo.',
		coverPick: 'Escolher imagem',
		coverSave: 'Salvar capa',
		coverRemove: 'Remover capa',
		coverSaveFailed: 'Não foi possível salvar a capa.',
		coverCropFailed: 'Não foi possível gerar o recorte. Escolha a imagem novamente.',
		game: 'Jogo',
		type: 'Tipo',
		source: 'Origem',
		videoLink: 'Link do vídeo',
		status: 'Status',
		published: 'Publicado',
		date: 'Data',
		search: 'Buscar por título ou descrição',
		view: 'Ver detalhes',
		watch: 'Assistir',
		approve: 'Aprovar',
		reject: 'Recusar',
		cancel: 'Cancelar',
		close: 'Fechar',
		description: 'Descrição',
		retry: 'Reprocessar',
		engineError: 'Erro do motor',
		engineErrorHint: 'O nosso motor de publicação não conseguiu processar este vídeo (culpa nossa, não do estúdio). Ele tenta de novo automaticamente e o estúdio não foi avisado. Tentativas: {n}.',
		reviewNotes: 'Notas da revisão',
		consent: 'Consentimento de direitos',
		consentGiven: 'Confirmado',
		consentMissing: 'Ausente',
		approveTitle: 'Aprovar este vídeo?',
		approveConfirm: 'Ele entra na fila de publicação e vai ao ar automaticamente no horário dele. O estúdio é notificado.',
		rejectTitle: 'Recusar este vídeo?',
		rejectHint: 'O motivo abaixo é enviado ao estúdio na íntegra, então escreva pensando em quem vai ler.',
		rejectReason: 'Motivo',
		studio: 'Estúdio',
		submittedBy: 'Enviado por',
		storePage: 'Página na loja',
		pressKit: 'Press kit',
		releaseDate: 'Lançamento',
		desiredDate: 'Data pedida pelo estúdio',
		desiredDateShort: 'Pedido:',
		desiredDateHint: 'Data que o estúdio pediu. Ainda não há slot agendado.',
		scheduledFor: 'Agendado para',
		schedule: 'Agendar',
		reschedule: 'Reagendar',
		scheduleTitle: 'Agendar publicação',
		scheduleHint: 'O estúdio recebe esta data e hora por e-mail assim que você salvar, então trate como compromisso.',
		scheduleDate: 'Data',
		scheduleTime: 'Hora',
		scheduleUrl: 'Link do YouTube (opcional)',
		scheduleUrlHint: 'Preencha só se o vídeo já foi agendado no YouTube e a URL existe. Ela vai junto no e-mail.',
		scheduleSaved: 'Publicação agendada e estúdio notificado.',
		consentClips: 'Cortes verticais',
		consentClipsGiven: 'Cortes autorizados',
		consentClipsWithheld: 'Cortes não autorizados',
		contentTypes: {
			trailer: 'Trailer',
			gameplay: 'Gameplay',
			unboxing: 'Unboxing',
			review: 'Análise',
			firstlook: 'Primeiras impressões',
			interview: 'Entrevista',
			other: 'Outro',
		},
		sourceTypes: {
			file_url: 'Arquivo original',
			url: 'Link de plataforma',
			upload: 'Upload',
		},
		statuses: {
			pending: 'Em revisão',
			approved: 'Aprovado',
			scheduled: 'Agendado',
			published: 'Publicado',
			rejected: 'Reprovado',
			cancelled: 'Cancelado',
		},
	},
	unit: 'Unidade',
	format: 'Formato',
	decimals: 'Casas decimais',
	prefix: 'Prefixo',
	suffix: 'Sufixo',
	subtitle_template: 'Modelo de legenda',
	sort_order: 'Ordem de classificação',
	kpiGroup: 'Grupo de KPI',
	continue: 'Continuar',
	add: 'Adicionar',
	applications: 'Candidaturas',
	information: 'Informações',
	candidates: 'Candidatos',
	appliedAt: 'Candidatou-se',
	rating: 'Avaliação',
	accesses: 'Acessos',
	applied: 'Candidatou-se',
	externalClicks: 'Cliques externos',
	lastView: 'Última visualização',
	lastClick: 'Último clique',
	country: 'País',
	interactionsHint: 'Usuários logados que visualizaram ou clicaram no link externo de candidatura desta vaga.',
	team: 'Equipe',
	owner: 'Proprietário',
	makeOwner: 'Tornar proprietário',
	display: 'Exibir',
	other: 'Outro',
	externalContact: 'Contato Externo',
	externalContactHint: 'Contato público opcional (para não usuários da plataforma)',
	saveCompanyFirstToManageTeam: 'Salve a empresa primeiro para gerenciar os membros da equipe.',
	initialOwner: 'Proprietário Inicial',
	confirmTransferOwnership: 'Tem certeza que deseja transferir a propriedade para este usuário?',
	ownershipTransferred: 'Propriedade transferida com sucesso.',
	savedSuccessfully: 'Salvo com sucesso.',
	deletedSuccessfully: 'Removido com sucesso.',
	errorSavingData: 'Erro ao salvar dados.',
	accountClosures: {
		title: 'Pedidos de deleção de conta',
		subtitle: 'Contas encerradas e o motivo que cada pessoa deu. Somente leitura — as contas já foram anonimizadas e os registros existem por retenção legal (LGPD Art. 16).',
		from: 'De',
		to: 'Até',
		reason: 'Motivo',
		search: 'Buscar',
		searchHint: 'Nome ou texto do motivo',
		statTotal: 'Encerramentos no período',
		statWithDetails: 'Com texto escrito',
		statUnexplained: 'Sem motivo informado',
		person: 'Pessoa',
		details: 'Nas palavras dela',
		initiatedBy: 'Iniciado por',
		closedAt: 'Encerrada em',
		followUp: 'E-mail de retorno',
		noReason: 'Não informado',
		byAdmin: 'Admin',
		byUser: 'Usuário',
		reasons: {
			not_using: 'Não usa mais',
			too_many_emails: 'E-mails demais',
			privacy: 'Privacidade',
			found_alternative: 'Achou alternativa',
			duplicate_account: 'Conta duplicada',
			missing_features: 'Faltavam recursos',
			bad_experience: 'Experiência ruim',
			other: 'Outro',
		},
	},
	errorLoadingData: 'Erro ao carregar dados.',
	common: {
		loading: 'Carregando...',
	},
	addCategoryPeriodicity: 'Adicionar categoria e periodicidade',
	categoryPeriodicity: 'Categoria e periodicidade',
	healthCheck: 'Controle de saúde',
	healthCheckSubTitle: 'Verifique agora o status das Plataformas da Mundo Gamer Network',
	networkFilterInfo:
		'* Para que essa campanha seja utilizada somente em 1 plataforma, por favor selecione uma plataforma. Para uso em todas, mantenha sem selecionar.',
	teamBirthdays: 'Próximos Aniversários',
	teamBirthdaysSubTitle: 'Confira os próximos aniversários da equipe Mundo Gamer',
	teamYears: 'anos',
	Schedulers: 'Agendamentos',
	image: 'Imagem',
	width: 'Largura',
	height: 'Altura',
	situation: 'Situação',
	pixelsCount: 'Contagem de pixels',
	maxEmployees: 'Máximo de funcionários',
	maxUses: 'Máximo de usos',
	maxUsesUser: 'Máximo de usos por usuário',
	maxUsesItem: 'Máximo de usos por item',
	directUser: 'Direcionado para o usuário',
	minEmployees: 'Mínimo de funcionários',
	minFollowers: 'Mínimo de seguidores',
	maxFollowers: 'Máximo de seguidores',
	quantityEmployees: 'Quantidade de funcionários',
	employees: 'funcionários',
	edition: 'Edição',
	pages: 'Páginas',
	editorials: 'Editorias',
	interviewees: 'Entrevistados',
	shortDescription: 'Descrição curta',
	professionalDescription: 'Descrição Profissional',
	cover: 'Capa',
	dragDropImage: 'Arraste e Solte uma Imagem',
	back: 'Voltar',
	next: 'Próximo',
	noResults: 'Nenhum resultado encontrado.',
	all: 'Todos',
	yes: 'Sim',
	no: 'Não',
	english: 'Inglês',
	deutsch: 'Alemão',
	portuguese: 'Português',
	spanish: 'Espanhol',
	romeno: 'Romeno',
	version: 'Versão',
	newVersion: 'Nova Versão',
	versions: 'Versões',
	parameter: 'Parâmetro',
	favorite: 'Favoritar',
	competitors: 'Concorrentes',
	competitor: 'Concorrente',
	brands: 'Marcas',
	new: 'Novo(a)',
	post: 'Postagem',
	fullAddress: 'Endereço completo',
	address: 'Endereço',
	postalCode: 'Código Postal',
	localization: 'Localização',
	street: 'Endereço',
	number: 'Número',
	neighborhood: 'Bairro',
	complement: 'Complemento',
	nationality: 'Nacionalidade',
	zipCode: 'CEP',
	city: 'Cidade',
	cities: 'Cidades',
	state: 'Estado',
	states: 'Estados',
	country: 'País',
	countries: 'Países',
	flag: 'Bandeira',
	officialName: 'Nome Oficial',
	shortName: 'Nome abreviado',
	callingCode: 'Código de Chamada',
	countryOperation: 'País de Operação',
	region: 'Região',
	regionInterest: 'Região de Interesse',
	administratorName: 'Nome do Administrador',
	administratorDocument: 'Documento do Administrador (CPF/Passaporte)',
	administratorTitle: 'Cargo do Administrador (ex: CEO)',
	admissionDate: 'Data de admissão',
	demissionDate: 'Data de demissão',
	managementExperience: 'Experiência de gestão',
	intention: 'Intenção',
	phone: 'Telefone',
	mobilePhone: 'Telefone celular',
	jobTitle: 'Cargo',
	genderDominances: 'Gêneros Dominantes',
	niches: 'Nichos',
	trackingPlatforms: 'Plataformas de rastreamento',
	mgNetworkSystem: 'Sistema MG Network',
	slug: 'SLUG',
	global: 'Global',
	timezone: 'Fuso Horário',
	conversionLogs: {
		title: 'Logs de Conversão (Meta CAPI)',
		subtitle: 'Acompanhe todos os eventos de conversão server-side enviados ao Meta, com status e reenvio.',
		event: 'Evento',
		user: 'Usuário',
		country: 'País',
		platform: 'Plataforma',
		value: 'Valor',
		source: 'Origem',
		page: 'Página',
		guest: 'Visitante',
		sent: 'Enviado',
		failed: 'Falhou',
		pending: 'Pendente',
		failedPending: 'Falhou / Pendente',
		retryAllFailed: 'Reenviar Todos com Falha',
		exportCsv: 'Exportar CSV',
		retry: 'Reenviar',
		viewDetails: 'Ver Detalhes',
		error: 'Erro',
	},
	ageRanges: 'Faixas etárias',
	styleContent: 'Estilo de conteúdo',
	tiers: 'Níveis',
	membership: 'Membro',
	file: 'Arquivo',
	planName: 'Nome do Plano',
	alias: 'Alias',
	documents: 'Documentos',
	documentsInformation: 'Informação de documentos',
	documentName: 'Nome do documento',
	memberPosition: 'Posição do Membro',
	meetingURL: 'Link para Meeting',
	goal: 'Objetivo',
	purpose: 'Propósito',
	logout: 'Sair',
	logoForDarkBg: 'Logo para fundo escuro — versão com texto claro/branco',
	logoForLightBg: 'Logo para fundo claro e documentos — versão com texto escuro',
	profile: 'Perfil',
	profileProgress: 'Progresso de Perfil',
	applicationStatuss: 'Status da aplicação',
	applicationMethod: 'Método de aplicação',
	method: 'Método',
	application: 'Aplicação',
	applicationDate: 'Data de aplicação',
	categories: 'Categorias',
	skills: 'Habilidades',
	skill: 'Habilidade',
	streamerType: 'Tipo do Streamer',
	requiresApproval: 'Requer aprovação',
	requiresMaterial: 'Requer envio de material',
	materialDeadlineDays: 'Prazo para Envio de Material',
	managementMode: 'Modo de Gestão',
	managedBy: 'Gerenciado Por',
	yearsOfExperience: 'Anos de Experiência',
	realocate: 'Disponibilidade de mudança',
	candidatePool: 'Na Pool de Candidatos',
	personalLinks: 'Links Pessoais',
	revised: 'Revisado',
	subCategories: 'Sub-categorias',
	category: 'Categoria',
	categoryName: 'Nome da categoria',
	subCategory: 'Sub-Categoria',
	title: 'Título',
	subtitle: 'Subtítulo',
	source: 'Fonte',
	share: 'Compartilhar',
	author: 'Autor',
	creatorBy: 'Criado por',
	publicationDate: 'Data Publicação',
	name: 'Nome',
	slug: 'Slug',
	public: 'Público',
	alternativeName: 'Nome Alternativo',
	termsUse: 'Termos de Uso',
	privacyPolicy: 'Política de Privacidade',
	termsAccepted: 'Termos aceitos em:',
	language: 'Idioma',
	close: 'Fechar',
	save: 'Salvar',
	update: 'Atualizar',
	loading: 'Carregando... Aguarde',
	settings: 'Configurações',
	active: 'Ativo',
	inactive: 'Inativo',
	blocked: 'Bloqueado',
	deleted: 'Deletado',
	description: 'Descrição',
	confirmation: 'Confirmação',
	confirmDelete: 'Tem certeza que deseja remover o item {item} ?',
	confirmDeleteApplication: 'Tem certeza que deseja remover: {item} ?',
	confirmedSubmission: 'Submissão confirmada',
	currentEdition: 'Edição atual',
	setAsCurrent: 'Marcar como edição atual',
	confirmSetCurrent: 'Marcar esta como a edição atual? Qualquer outra edição marcada será desmarcada automaticamente.',
	startTypeSearch: 'Comece a Digitar para Buscar',
	search: 'Buscar',
	searchByNameOrEmail: 'Buscar por nome ou e-mail',
	searchByCompany: 'Buscar por Empresa/Estúdio',
	searchFilter: 'Buscar por',
	filter: 'Filtro',
	orderBy: 'Ordenar por',
	contact: 'Contato',
	percentage: 'Porcentagem',
	contactName: 'Nome de Contato',
	contactPhone: 'Nome de Contato',
	contactEmail: 'E-mail de Contato',
	contactPosition: 'Posição de Contato',
	companyInformation: 'Informações da Empresa',
	experience: 'Experiência',
	employmentType: 'Tipo de emprego',
	per: 'Períodos de pagamento',
	period: 'Período',
	courseDuration: 'Duração do Curso',
	workMethodology: 'Metodologia de Trabalho',
	Methodology: 'Metodologia',
	workAvailability: 'Disponibilidade de Trabalho',
	availability: 'Disponibilidade',
	workHour: 'Horario de trabalho',
	vacancies: 'Vagas',
	vacancy: 'Vaga',
	specialVacancy: 'Vaga especial',
	notSpecial: 'Não especial',
	pwd: 'PcD',
	numberVacancies: 'Número de Vagas',
	numberPlatforms: 'Número de Plataformas',
	currency: 'Moeda',
	symbol: 'Símbolo',
	amount: 'Quantia',
	price: 'Preço',
	catalogPrice: 'Preço de Catálogo',
	free: 'Grátis',
	used: 'Usados',
	expired: 'Expirados',
	creditsPerProduct: 'Créditos por Produto',
	product: 'Produto',
	priceOptional: 'Preço (opcional)',
	priceOptionalHint: 'Deixe vazio para conceder créditos gratuitamente',
	pricePublic: 'Preço Público',
	priceCut: 'Redução de preço',
	originalPrice: 'Preço Original',
	localizedPrices: 'Preços localizados',
	minimumSalary: 'Salário mínimo',
	maximumSalary: 'Salário máximo',
	institution: 'Instituição',
	educationLevels: 'Níveis de Instrução',
	courseName: 'Nome do Curso',
	initialDate: 'Data inicial',
	finalDate: 'Data final',
	position: 'Cargo',
	occupation: 'Ocupação',
	currentJob: 'Trabalho atual',
	companyPerks: 'Benefícios da Empresa',
	vacancyPaymentInformations: 'Forma de Contratação e Pagamento',
	languageLevels: 'Níveis de idioma',

	confirmedCompanySubmission: 'Envio de empresa confirmada',
	acceptedTerms: 'Termos aceitos',
	isPublic: 'É público',
	allowPublicUse: 'Permite uso público',
	allowMarketing: 'Permite Marketing',
	anonymousCompany: 'Empresa Anônima',
	monthlySalary: 'Salário Mensal',
	anualSalary: 'Salário Anual',
	gross: 'Bruto',
	vacationDays: 'Dias de férias',
	unlimitedVacation: ' Férias ilimitadas',

	icon: 'Ícone',
	positiveRate: 'Índice Positivo',
	negativeRate: 'Índice Negativo',
	introduction: 'Introdução ',
	conclusion: 'Conclusão',
	externalLink: 'Link Externo',
	primarilyQuestion: 'O que é ensinado principalmente no seu curso?',
	type: 'Tipo',
	text: 'Texto',
	NotificationTitle: 'Título da notificação (max 76 caracteres)',
	message: 'Mensagem',
	notificationFilter: 'Filtros incompatíveis com usuários, tente outro.',
	notificationLanguageRequired: 'O idioma é obrigatório ao enviar para todos os usuários.',
	successMessage: 'Salvo com sucesso!',
	NotificationMessage: 'Mensagem de notificação (max 135 caracteres)',
	sendNotification: 'Enviar Notificação',
	nameAbrev: 'Abreviação do nome',
	statusName: 'Nome do Status',
	publicStatus: 'Status Público',
	systemStatus: 'Status no Sistema',
	level: 'Nível',
	model: 'Modelo',
	timeQuiz: 'Tempo para responder uma pergunta (segundos)',
	typeQuiz: 'Tipo de Quiz',
	themeQuiz: 'Tema do Quiz',
	nameType: 'Nome do Tipo',
	question: 'Pergunta',
	countQuestions: 'Perguntas',
	totalQuestions: 'Total de Perguntas',
	totalVotes: 'Total de Votos',
	totalCompetitors: 'Total de Competidores',
	countAnswers: 'Alternativas',
	answer: 'Resposta',
	correctAnswer: 'Resposta correta',
	answerOptions: 'Opções de Respostas',
	participants: 'Participantes',
	required: 'Campo obrigatório',
	financialInformation: 'Informações financeiras',
	personalInformation: 'Informações Pessoais',
	professionalInformation: 'Informações Profissionais',
	accountInformations: 'Informações da Conta',
	languagePreferred: 'Preferência de Linguagem',
	verified: 'Verificado',
	genres: 'Gêneros',
	styles: 'Estilos',
	service: 'Serviço',
	budgetBuilder: {
		regions: 'Regiões',
		currencyMixed: 'Moedas divergentes',
		currencyMixedRow: 'Rate cards em moedas diferentes',
		currencyMixedBlock: 'A seleção mistura moedas — ajuste os rate cards para uma única moeda antes de gerar a ordem.',
		briefing: 'Briefing',
		services: 'Serviços',
		addService: 'Adicionar serviço',
		contentFormat: 'Formato de conteúdo',
		currency: 'Moeda',
		budget: 'Teto de verba',
		maxInfluencers: 'Máx. influencers',
		match: 'Buscar perfis',
		matches: 'Influencers encontrados',
		total: 'Total',
		generateOrder: 'Gerar pedido',
		cost: 'Custo',
		relevance: 'Relevância',
		noRate: 'sem rate card',
		runHint: 'Preencha o briefing e clique em Buscar perfis.',
		orderCreated: 'Pedido rascunho criado',
		budgetExceeded: 'O orçamento montado excede o budget do cliente. Reduza a seleção ou aumente o budget.',
	},
	mediaKitMetrics: 'Métricas do Media Kit',
	mediaKitMetricsHint: 'Engajamento por plataforma, média de views e o selo verificado (aparecem no media kit).',
	mediaKitMetricsSaved: 'Métricas salvas',
	emailVerified: 'Email Verificado',
	emailNotVerified: 'Não Verificado',
	resendVerificationEmail: 'Reenviar Email de Verificação',
	verificationEmailSent: 'Email de verificação enviado com sucesso',
	keyAccessBlockedTitle: 'Pedidos de Chave Bloqueados',
	keyAccessBlockedSince: 'Bloqueado desde',
	keyAccess: 'Acesso a chaves',
	keyAccessBlocked: 'Bloqueado',
	keyAccessBlockedOnly: 'Somente bloqueados para pedidos de chave',
	keyAccessRevokeHint: 'Se um pedido específico está causando isso (ex: chave com problema), mude o status desse pedido para "Revoked" em Keys > Key Requests antes de desbloquear, para não disparar o bloqueio novamente.',
	keyAccessUnblockButton: 'Desbloquear pedidos de chave',
	keyAccessUnblockSuccess: 'Acesso a pedidos de chave do usuário restaurado',
	aiModelsTitle: 'Modelos de IA por uso',
	aiModelsSubtitle: 'Escolha em qual modelo cada parte da plataforma roda e veja quanto cada uma consumiu. Um uso deixado no padrão se comporta como sempre.',
	aiModelsUse: 'Uso',
	aiModelsModel: 'Modelo',
	aiModelsRunsOn: 'Roda em',
	aiModelsLast7Days: 'Últimos 7 dias',
	aiModelsDefault: 'Padrão da plataforma',
	aiModelsCalls: 'chamadas',
	aiModelsTokens: 'tokens',
	aiModelsSaved: '{use}: salvo',
	aiModelsStale: 'O modelo escolhido não pode mais ser usado (inativo ou sem credencial), então este uso está no padrão.',
	aiModelsChosenByCaller: 'Escolhido pelo serviço que envia o pedido',
	aiModelsServiceDefault: 'Padrão do serviço: {model}',
	aiModelsWarnSender: 'Quem envia ainda pede {model}, que o catálogo desativou. Escolha um modelo aqui para parar de depender dele.',
	aiModelsWarnDefault: 'O padrão do serviço, {model}, não é um modelo ativo no catálogo. Escolha um modelo aqui para parar de depender dele.',
	aiModelsNoModels: 'Nenhum modelo pode ser escolhido ainda: nenhum está ativo com credencial. Ative um em Language Models primeiro.',
	aiModelsDenied: 'Só quem recebe os alertas de saldo de IA pode ver e alterar isto.',
	aiModelsOtherTitle: 'Outro consumo',
	aiModelsOtherHint: 'Pedidos que nenhum uso listado reivindicou (chat, relatórios agendados, ou um endpoint sem entrada própria). Mostrado pelo nome da rota.',
	aiCreditsPausedTitle: '{provider} sem saldo',
	aiCreditsPausedBody: 'As chamadas à {provider} estão pausadas desde {since}, então nada é gasto nem repetido. Recarregue o saldo e depois retome.',
	aiCreditsResume: 'Retomar',
	aiCreditsResumed: '{provider} retomado',
	userActivity: 'Última atividade',
	userActivityFilter: 'Atividade',
	userActivityAny: 'Qualquer atividade',
	userActivityOnline: 'Online agora',
	userActivityActive7d: 'Ativos nos últimos 7 dias',
	userActivityActive30d: 'Ativos nos últimos 30 dias',
	userActivityDormant: 'Inativos há 30 a 90 dias',
	userActivityLost: 'Inativos há mais de 90 dias',
	userActivityNever: 'Nunca vistos',
	userActivityAnyPlatform: 'Qualquer plataforma',
	userActivityOnlineChip: 'Online',
	userActivityNeverShort: 'Nunca',
	userActivityJustNow: 'agora há pouco',
	userActivityMinutesAgo: 'há {n} min',
	userActivityHoursAgo: 'há {n} h',
	userActivityDaysAgo: 'há {n} d',
	userActivityLastLogin: 'Último login',
	userActivityNoLogin: 'Nenhum login registrado',
	userActivityHint: 'Atualizado a cada poucos minutos por heartbeats e logins. Enquanto o usuário não é visto de novo, o valor é estimado pelo último login.',
	bankAccount: 'Conta bancária',
	iban: 'IBAN',
	swiftBic: 'SWIFT/BIC',
	bankAccountSchemesHint: 'Preencha banco, agência, conta e operação para uma conta brasileira, ou IBAN e SWIFT/BIC para uma conta internacional. Qualquer uma das duas identificações basta.',
	bankName: 'Nome do Banco',
	bankAgency: 'Agência:',
	request: 'Solicitação',
	requestDate: 'Data de Solicitação',
	operation: 'Operação',
	mainAccount: 'Conta Principal',
	main: 'Principal',
	gameName: 'Nome do Jogo',
	gameType: 'Tipo de Jogo',
	gameStatus: 'Status do Jogo',
	gameMode: 'Modo de Jogo',
	gameModes: 'Modos de Jogo',
	gameEngine: 'Motor de jogo',
	gameEngines: 'Motores de jogo',
	genreName: 'Nome do gênero',
	playerPerspective: 'Perspectiva do jogador',
	themes: 'Temas',
	theme: 'Tema',
	themeSecondary: 'Fonte Secundária',
	themePrimary: 'Fonte Primária',
	themeColor: 'Fonte Principal',
	themeBackground: 'Background',
	fontType: 'Tipo da Fonte',
	perPage: 'Máximo por página',
	themesVariables: 'Variáveis de Temas',
	similarGames: 'Jogos Similares',
	characters: 'Personagens',
	character: 'Personagem',
	charactersPer: 'Caracteres por lauda',
	fixedValue: 'Valor ajustado',
	minCharacters: 'Mínimo de caracteres',
	maxCharacters: 'Mázimo de caracteres',
	phrase: 'Frase',
	gender: 'Gênero',
	specie: 'Espécie',
	games: 'Jogos',
	game: 'Jogo',
	platformType: 'Tipo de Plataforma',
	platformFamily: 'Família daPlataforma',
	predecessor: 'Predecessor',
	redeemed_by: 'Resgatado por',
	redeemed_at: 'Resgatado em',
	successor: 'Sucessor',
	generation: 'Geração',
	releaseDate: 'Data de Lançamento',
	lastUpdate: 'Última Atualização',
	actions: 'Ações',
	promoteGame: 'Promover jogo',
	promoteGameHint: 'Jogos em destaque aparecem primeiro nas recomendações de jogos do feed da comunidade.',
	promoted: 'Promovido',
	promotedFrom: 'Início da promoção',
	promotedDuration: 'Duração',
	promotionSavedSuccess: 'Promoção atualizada com sucesso.',
	promotionSaveError: 'Falha ao atualizar a promoção.',
	saveGameFirst: 'Salve o jogo primeiro — a promoção só pode ser definida depois que ele tiver um id.',
	in: 'em',
	total: 'Total',
	published: 'Publicado',
	pending: 'Pendente',
	disapproved: 'Reprovado',
	approved: 'Aprovado',
	cancelled: 'Cancelado',
	notCancelled: 'Não Cancelado',
	refunded: 'Reembolsado',
	notRefunded: 'Não Reembolsado',
	paid: 'Pago',
	notPaid: 'Não Pago',
	contentRequestUnpaid: 'Pedido de conteúdo — não pago',
	complimentary: 'Gratuito (Cortesia)',
	notComplimentary: 'Submissão Paga',
	access: 'Acesso',
	exportCsv: 'Exportar CSV',
	order: 'Pedido',
	perItem: 'por item',
	OriginalValue: 'Valor Original',
	DiscountValue: 'Desconto',
	FinalValue: 'Valor Final',
	ComissionValue: 'Comissão',
	ValueFinal: 'Valor da Compra',
	mentorshipRecruitmentStatus: 'Status do recrutamento de mentores',
	shoppingCard: 'Shopping Card ID',
	age: 'Idade',
	remove: 'Removido',
	pendingReview: 'Revisão pendente',
	scheduled: 'Agendado',
	document: 'Documento',
	code: 'Código',
	copy_code: 'Copiar código',
	hide_code: 'Esconder código',
	code_copied: 'Código copiado com sucesso!',
	sizeError: 'O tamanho da imagem precisa ser ',
	workingHour: 'Horários de trabalho',
	priority: 'Prioridade',
	viewMessage: 'Ver Mensagem',
	invoice: 'Fatura',
	invoiceDate: 'Data da Fatura',
	dueDate: 'Data de Vencimento',
	billTo: 'Fatura para',
	items: 'Itens',
	item: 'Item',
	frequency: 'Frequência',
	ipAddress: 'Endereço IP',
	popular: 'Popular',
	audience: 'Público',
	business: 'Empresarial',
	create: 'Criar',
	write: 'Escrever',
	permission: 'Permissão',
	id: 'ID',
	paymentMethod: 'Método de Pagamento',
	confirm: 'Confirmar',
	genericError: 'Ocorreu um erro. Tente novamente.',
	sortOrder: 'Ordem de Classificação',
	noBenefitsAvailable: 'Nenhum benefício disponível',
	recipient: 'Destinatário',
	dateFrom: 'De',
	itemName: 'Nome do Item',
	billSingle: 'Faturar cliente único',
	billMultiple: 'Faturar vários clientes',
	tax: 'Taxa',
	quantity: 'Quantidade',
	salesperson: 'Vendedor (a)',
	couponCode: 'Código do Cupom',
	couponSource: 'Origem',
	couponSourceAll: 'Todos',
	couponSourceManual: 'Manual',
	couponSourceNurture: 'Nurture (gerado automaticamente)',
	couponInfoPart1:
		'*O código do cupom é o nome que o usuário deverá usar para que o desconto seja aplicado. para que um cupom seja válido para todos os itens do carrinho, não selecione nenhum produto, pacote ou plano específico.',
	couponInfoPart2:
		'*Para uso específico e limitado de itens, especifique para qual plano, pacote, país ou moeda o código do cupom será válido.',
	couponInfoPart3: '*É possível criar um cupom global ou especificar a validade para um país ou moeda específica.',
	discount: 'Desconto %',
	commission: 'Comissão %',
	commissionToUser: 'Comissão para',
	discountBundlePriceInfo:
		'* Para manter o valor original setado na aba de Preços, deixe o campo de desconto vazio para que seja calculado automaticamente o desconto, mantendo o valor original.',
	discountBundlePriceInfo2:
		'Caso queira que o sistema calcule automaticamente os valores dos Pacotes insira a % de desconto que deseja.',
	note: 'Nota',
	noteOptional: 'Nota (opcional)',
	sale: 'Venda',
	invoiceNumber: 'Número da Fatura',
	sendInvoice: 'Enviar Fatura',
	changeStatus: 'Alterar Status',
	currentStatus: 'Status atual',
	newStatus: 'Novo status',
	sendPaymentLink: 'Enviar Link de Pagamento',
	sendPaymentLinkConfirm: 'Tem certeza que deseja enviar o email com link de pagamento para este usuario?',
	generateReceipt: 'Gerar Comprovante',
	regenerateReceipt: 'Gerar Comprovante Novamente',
	customizeReceipt: 'Personalizar Comprovante',
	receiptFiscalData: 'Dados fiscais do comprador',
	receiptFiscalDataHint: 'Estes dados substituem apenas as informações do comprador no comprovante. Os itens da compra e o registro original do gateway não são alterados.',
	receiptCommercialCorrections: 'Correções comerciais',
	receiptCommercialCorrectionsHint: 'Use quando o cliente pagou de forma diferente da que a fatura foi aberta. As duas alterações ficam registradas no histórico da fatura.',
	receiptNoteHint: 'Impresso no próprio documento, abaixo dos totais — use para descrever o serviço/produto ou adicionar qualquer comentário que o cliente deva ver.',
	saveAndDownloadReceipt: 'Salvar e Baixar',
	receiptDetailsSaved: 'Dados do comprovante salvos. Gere ou baixe novamente para obter o PDF atualizado.',
	linkedBuyerCompany: 'Empresa compradora vinculada (CRM)',
	issuingCompany: 'Empresa emissora',
	detectedPaymentIssuer: 'Emissora detectada no pagamento',
	issuerOverride: 'Substituir empresa emissora',
	issuerOverrideReason: 'Motivo da substituição fiscal',
	historicalIssuerVerified: 'Snapshot histórico confirmado',
	historicalIssuerInferred: 'Associação atual da credencial (não comprovada historicamente)',
	gatewayCredential: 'Credencial do gateway',
	issuerHistoricalWarning: 'Esta invoice é anterior ao snapshot fiscal. A conta Stripe/PayPal é a usada no pagamento, mas a empresa exibida foi inferida pela associação atual dessa credencial. Confirme com os registros contábeis antes de substituir.',
	receiptGenerationQueued: 'Geração do comprovante enfileirada. Atualize em alguns instantes.',
	downloadReceipt: 'Baixar Comprovante',
	resendReceipt: 'Reenviar Comprovante',
	resendReceiptConfirm: 'Revise o comprovante gerado abaixo. Ao confirmar, ele será enviado por email para o usuário.',
	receiptDownloaded: 'Comprovante baixado com sucesso',
	receiptResent: 'Email com comprovante enviado com sucesso',
	sendReceiptToUser: 'Enviar ao usuário',
	generatingReceiptPreview: 'Gerando prévia do comprovante...',
	receiptPreviewError: 'Não foi possível carregar a prévia do comprovante. Tente novamente.',
	send: 'Enviar',
	manualPrice: 'Valor Manual',
	professionalSituation: 'Situação Profissional',
	reportedItem: 'Item Reportado',
	reportedOn: 'Reportado em',
	resolvedOn: 'Resolvido em',
	reportedIdentifier: 'Identificador reportado',
	reportedResource: 'Recurso reportado',
	motive: 'Motivo',
	reportedBy: 'Reportado por',
	general: 'Geral',
	loadMore: 'Carregar mais',
	responsible: 'Responsável',

	noLanguages: 'Não há Linguagens',
	noCertifications: 'Não há Certificados',
	noGraduations: 'Não há Formações',
	noSkills: 'Não há Habilidades',
	noExperiences: 'Não há Experiências',
	certifications: 'Certificados',
	graduations: 'Formações',
	experiences: 'Experiências',
	viewResume: 'View resume',

	viewers: 'Visualizadores',
	channel: 'Canal',
	channelName: 'Nome do Canal',
	affiliate: 'Afiliado',
	accepted: 'Aceito',
	provider: 'Provedor',
	contents: 'Conteúdos',
	registeredOn: 'Registrado em',
	expiresOn: 'Expira em',
	neverExpires: 'Nunca expira',
	editExpiration: 'Editar expiração',
	editExpirationHint: 'Deixe o campo vazio para o crédito nunca expirar. Produtos permanentes (ex.: Wall pixel) permanecem sempre sem expiração.',
	expirationUpdated: 'Expiração atualizada com sucesso.',
	domain: 'Domínio',
	status: 'Status',

	visibility: 'Visibilidade',
	show: 'Mostrar',
	hide: 'Esconder',
	not: 'Não',
	read: 'Lido',
	notread: 'Não Lido',
	value: 'Valor',
	estimatedValue: 'Valor Estimado',
	valueCredits: 'Valor em Créditos',
	credits: 'Créditos',
	valuePerPage: 'Valor por Lauda',
	valuePerCharacter: 'Valor por Caractere',
	originalValue: 'Valor Original',
	subject: 'Assunto',
	cancel: 'Cancelar',
	ok: 'OK',
	success: 'Sucesso',
	savedSuccess: 'Salvo com Sucesso',
	updatedSuccess: 'Atualizado com Sucesso',
	deletedSuccess: 'Deletado com Sucesso',
	approved: 'Aprovado',
	rejected: 'Rejeitado',
	approve: 'Aprovar',
	reject: 'Rejeitar',
	reviewNotes: 'Notas de Revisão',
	email: 'Email',
	saveAll: 'Salvar Todas as Alterações',
	errorGeneric: 'Ocorreu um erro. Por favor, tente novamente.',

	errors: {
		403: {
			title: 'Acesso Negado',
			message: 'Você não tem permissão para acessar esta página.',
			hint: 'Se acredita que isso é um erro, entre em contato com o administrador.',
		},
		404: {
			title: 'Página Não Encontrada',
			message: 'Não conseguimos encontrar a página que você está procurando.',
		},
		backToHome: 'Voltar para o Início',
	},

	createdDate: 'Data de Criação',
	updatedDate: 'Data de Atualização',
	publishDate: 'Data de Publicação',
	expirationDate: 'Data de Expiração',

	sumContents: 'Soma dos Conteúdos',
	contentAnswer: 'Resposta ao conteúdo',

	sentAt: 'Enviado em',
	counts: 'Enviados',
	results: 'Resultados',

	employmentStatus: 'Situação de Emprego',
	visaSponsorship: 'Patrocínio de Visto',

	updatedAt: 'Atualizado em',
	clientSecret: 'Segredo do Cliente',
	career: 'Carreira',
	careers: 'Carreiras',
	recruitment: 'Recrutamento',
	mentorship: 'Mentoria',
	operationalArea: 'Área Operacional',
	projectName: 'Nome do Projeto',
	mgPlatform: 'Plataforma MG',
	key: 'Chave',
	keysCount: 'Total de Chaves',
	statesCount: 'Total de Estados',
	keyStatus: 'Status da Chave',
	available: 'Disponível',
	availables: 'Disponíveis',
	date: 'Data',
	publicationDateHint: 'A data exibida publicamente no site e no app. Deixe vazio para manter o momento em que a review foi aprovada.',
	time: 'Hora',
	dateBirth: 'Data de Nascimento',
	birthYear: 'Ano do Nascimento',
	birthday: 'Aniversário',
	birthdayToday: 'É hoje?',
	startYear: 'Ano de início',
	lastYear: 'Último ano',
	hour: 'Hora',
	currentGeneration: 'Geração atual',
	currentlyUsed: 'Usado Atualmente',
	days: 'dias',
	closing: 'Fechando em',
	closed: 'Encerrado',
	preview: 'Visualizar',
	open: 'Aberto',

	totalSize: 'Tamanho Total',
	totalArea: 'Área Total',
	franchiseModel: 'Modelo de Franquia',

	scheduledDate: 'Data Marcada',
	startDate: 'Data de início',
	foundationDate: 'Data de Fundação',
	closureDate: 'Data de encerramento',
	embargoDate: 'Data do embargo',
	embargoTime: 'Hora do embargo',
	startTime: 'Hora de início',
	closureTime: 'Hora de encerramento',

	views: 'Visualizações',
	viewAll: 'Ver Todos(a)',

	view: 'Visualizar',
	edit: 'Editar',
	download: 'Baixar',
	delete: 'Apagar',

	clicks: 'Cliques',

	start: 'Início',
	finish: 'Término',

	location: 'Localização',
	guidelines: 'Diretrizes ',
	developed: 'Desenvolvido',
	manufactured: 'Fabricado',
	images: 'Imagens',
	imageCover: 'Imagem de Capa',
	currentImageCover: 'Imagem de Capa Atual',
	imageBanner: 'Imagem de Banner',
	currentImageBanner: 'Imagem de Banner Atual',
	imageIcon: 'Imagem de Ícone',
	galleryImage: 'Galeria de Imagem',

	numberCompanies: 'Número de Empresas',
	partner: 'Parceiro',
	partners: 'Parceiros',
	domains: 'Domínios',
	teams: 'Times',
	users: 'Usuários',
	color: 'Cor',

	captain: 'Capitão',
	members: 'Membros',
	member: 'Membro',
	events: 'Eventos',
	event: 'Evento',
	ongoingEvents: 'Eventos Atuais',
	upcomingEvents: 'Próximos Eventos',
	pastEvents: 'Eventos Passados',

	company: 'Empresa',
	fantasyName: 'Nome Fantasia',
	companyName: 'Nome da Empresa',
	issuerCompany: 'Empresa Emissora',
	studioName: 'Nome do Estúdio',
	studio: 'Studio',
	influencer: 'Influencer',
	mediaPartner: 'Parceiro de Mídia',
	mediaPartnerApplication: 'Candidatura de Parceiro de Mídia',
	sponsor: 'Patrocinador',
	companyType: 'Tipo de Empresa',
	companyHour: 'Horário de trabalho da empresa',
	companySize: 'Tamanho da Empresa',
	registrationNumber: 'Número de registro',
	inscriptionNumber: 'Número da inscrição',
	openingDate: 'Data de abertura',
	descriptionOfActivities: 'Descrição das atividades',

	firstName: 'Primeiro Nome',
	lastName: 'Último Nome',
	nickName: 'Apelido',
	location: 'Local',
	origin: 'Origem',
	destination: 'Destino',
	platform: 'Plataforma',
	collection: 'Coleção',
	franchise: 'Franquia',
	genre: 'Gênero',
	release: 'Lançamento',
	platforms: 'Plataformas',
	createdAt: 'Criado em',
	validAt: 'Válido até',
	submittedAt: 'Enviado em',
	viewMore: 'Ver Mais',
	role: 'Função',
	roles: 'Funções',
	rolesPermissions: 'Funções & Permissões',
	latestReviewsCommentary: 'Comentário sobre as últimas classificações',
	commentary: 'Comentário',
	contentsComments: 'Comentários dos conteúdos',
	latestGames: 'Últimos Jogos',
	upcomingGames: 'Próximos Lançamentos',
	achievement: 'Conquista',
	gamesPublished: 'Jogos Publicados',
	gamesDeveloped: 'Jogos Desenvolvidos',
	trophiesType: 'Tipo de Troféu',
	trophie: 'Troféu',
	owners: 'Proprietários',
	popularity: 'Popularidade',
	minimumAge: 'Idade mínima',
	maximumAge: 'Idade máxima',
	transactions: 'Transações',
	contentType: 'Tipo de Conteúdo',
	contentTypeId: 'Id do Conteúdo',
	validyDays: 'Dias válidos',

	operatingSystem: 'Sistema operacional',
	memory: 'Memória',
	graphics: 'Gráficos',
	supportedResolutions: 'Resoluções suportadas',
	media: 'Mídia',
	socialNetworks: 'Redes Sociais',
	onlineServices: 'Serviços on-line',
	storage: 'Armazenamento',
	sound: 'Som',
	output: 'Saída',
	connectivity: 'Conectividade',

	followers: 'Seguidores',
	news: 'Notícias',

	details: 'Detalhes',
	detail: 'Detalhe',

	loadingText: 'Carregando... Aguarde.',
	translations: 'Traduções',
	translated: 'Traduzido',
	noTranslation: 'Sem tradução',
	noData: 'Sem dados',
	topicName: 'Nome do Tópico',
	completed: 'Completo',
	editStage: 'Editar Etapa',
	newStage: 'Nova Etapa',

	deleteNotification: 'Você tem certeza que deseja excluir este item',
	deleteNotificationAccount: 'Você tem certeza que deseja excluir este Conta?',
	launch: 'Lançamento',
	titleHighlight: 'Título do Destaque',
	buttonText: 'Texto do Botão',
	buttonColor: 'Cor do Botão',
	backgroundColor: 'Cor de fundo',
	titleColor: 'Cor do Título',
	styleSettings: 'Definições do estilo',
	highlight: 'Destaque',
	highlightBanner: 'Banner Rotativo',
	listingPriority: 'Prioridade na listagem',
	listingPriorityHint: 'Valores mais altos posicionam esta campanha acima das demais na listagem pública (0 = sem prioridade).',
	tvBanner: 'Banner TV',
	worldwide: 'Mundialmente',

	widgets: 'Widgets',
	widgetFormat: 'Formatos de Widgets',

	credentials: 'Credenciais',
	account: 'Conta',
	client: 'Cliente',

	checkVideo: 'Verificar vídeo',
	videoIsValid: 'URL é válida',
	videoIsNotValid: 'URL é inválida',
	getThumbnail: 'Obter capa do vídeo',

	flipbookURL: 'URL da revista',
	magazineURL: 'URL da revista',

	category: 'Categoria',
	votation: 'Votação',

	howWeCanHelp: 'Como podemos ajudar?',
	websiteMessage: 'Mensagem recebida pelo site',

	documentType: 'Tipo Documento',
	presentation: 'Apresentação',
	currentPdf: 'PDF Atual',

	invoiceStatusCompleted: 'Faturas Pagas',
	invoiceStatusPending: 'Faturas à receber',
	invoiceStatusCancelled: 'Faturas Canceladas',
	invoiceStatusRefunded: 'Faturas Reembolsadas',

	translate: {
		translate: 'Traduzir',
		confirm: 'Gostaria de traduzir?',
		language: 'Escolha os idiomas para a tradução',
		notification: 'Tradução adicionada à fila',
	},

	notifications: {
		notifications: 'Notificações',
		new: 'nova',
		news: 'novas',
		loadMore: 'Carregar mais',
		seeAll: 'Ver todas',
		allRead: 'Marcar como lidas',
	},

	whatsNew: {
		loading: 'Carregando... Aguarde',
		status: {
			draft: 'Rascunho',
			pending_approval: 'Aguardando aprovação',
			scheduled: 'Agendado',
			published: 'Publicado',
			archived: 'Arquivado',
		},
		kind: {
			update: 'Atualização',
			release: 'Release',
			launch: 'Lançamento',
			maintenance: 'Manutenção',
		},
		sectionType: {
			feature: 'Novos recursos',
			improvement: 'Melhorias',
			fix: 'Correções',
			note: 'Aviso',
		},
		steps: {
			draft: 'Rascunho',
			pending_approval: 'Aguardando aprovação',
			live: 'Agendado / Publicado',
			archived: 'Arquivado',
		},
		tabs: {
			content: 'Conteúdo',
			media: 'Mídia',
			reach: 'Alcance',
			schedule: 'Agenda',
			translations: 'Traduções',
			notification: 'Notificação',
			results: 'Resultados',
		},
		list: {
			title: 'Novidades',
			subTitle: 'Comunicados dentro dos sites e apps, mostrados em um modal: updates, releases e lançamentos.',
			new: 'Novo comunicado',
			defaults: 'Padrões',
			search: 'Buscar pelo título',
			status: 'Status',
			kind: 'Tipo',
			empty: 'Nenhum comunicado ainda.',
			allPlatforms: 'Todas as plataformas',
			deleted: 'Comunicado excluído.',
			archiveFirst: 'Este comunicado está no ar. Arquive primeiro, depois exclua.',
			pendingBanner: '{count} comunicado(s) aguardando a sua aprovação.',
			showPending: 'Ver',
			columns: {
				title: 'Título',
				kind: 'Tipo',
				reach: 'Alcance',
				status: 'Status',
				window: 'Janela',
				views: 'Exibições',
			},
		},
		actions: {
			preview: 'Pré-visualizar',
			duplicate: 'Duplicar',
			archive: 'Arquivar',
			saveDraft: 'Salvar rascunho',
			requestApproval: 'Pedir aprovação',
			reject: 'Rejeitar',
			approvePublish: 'Aprovar e publicar',
			approveSchedule: 'Aprovar e agendar',
			publish: 'Publicar',
			schedule: 'Agendar',
		},
		editor: {
			newTitle: 'Novo comunicado',
			editTitle: 'Editar comunicado',
			saved: 'Salvo.',
			waitingApproval: 'Este comunicado aguarda a aprovação de um admin_master. Editar mantém ele na fila.',
			reviewHint: 'Revise o conteúdo, a pré-visualização e o alcance, depois aprove ou rejeite com um motivo.',
			rejected: 'Rejeitado: {reason}',
			rejectReason: 'Por que está sendo rejeitado?',
			archiveConfirm: 'Ele deixa de aparecer para os usuários na hora. Você pode duplicar depois.',
			done: {
				'request-approval': 'Enviado para aprovação.',
				approve: 'Aprovado.',
				publish: 'Publicado.',
				schedule: 'Agendado.',
				reject: 'Rejeitado e devolvido como rascunho.',
				archive: 'Arquivado.',
				duplicate: 'Duplicado como rascunho.',
			},
		},
		content: {
			sourceLocale: 'Idioma em que você escreve',
			sourceLocaleHint: 'Os outros idiomas são traduzidos a partir deste. O que não for traduzido cai para o inglês.',
			kind: 'Tipo',
			title: 'Título',
			summary: 'Resumo',
			sections: 'Seções',
			addSection: 'Adicionar seção',
			addItem: 'Adicionar item',
			sectionType: 'Tipo da seção',
			sectionTitle: 'Título da seção',
			sectionTitleAuto: 'Vazio = título padrão do tipo',
			itemBody: 'Texto do item',
			itemLink: 'Link do item inteiro (opcional, https://)',
			cta: 'Botão principal (opcional)',
			ctaType: 'Abre',
			ctaTypeUrl: 'Um endereço da web',
			ctaTypeRoute: 'Uma tela do app / site',
			ctaUrl: 'Endereço (https://…)',
			ctaRoute: 'Rota (/game-jams)',
			ctaLabel: 'Texto do botão',
			footerLinks: 'Links do rodapé deste comunicado',
			footerLinksHint: 'Vazio = os links padrão de cada plataforma (configure em Padrões na lista).',
		},
		guide: {
			title: 'Como escrever o texto',
			short: 'Uma frase curta por item.',
			linkRule: 'cria um link: https://… ou um /caminho interno.',
			noHtml: 'Sem HTML. O resto aparece como texto simples.',
			limits: 'Título até 60 caracteres, resumo até 160, item até 140.',
			variables: 'Variáveis',
			standIn: 'reserva',
			variablesHint: 'Sem nome, {first_name} vira a reserva que você escrever depois da barra, ou o padrão neutro do idioma (você, there, du, tú).',
			livePreview: 'Prévia ao vivo',
			withName: 'Com nome (Ana)',
			withoutName: 'Sem nome',
		},
		markup: {
			bold: 'Negrito',
			boldSample: 'texto',
			insertLink: 'Link',
			linkText: 'Texto do link',
			insert: 'Inserir',
			linkInvalid: 'Use https://… ou um /caminho interno.',
			badLinks: 'Links não permitidos: {urls}',
			badVariables: 'Variáveis desconhecidas: {names}',
		},
		media: {
			cropHint: 'Recorte a imagem no quadro 16:9 (exportada em 1600×900, mínimo 1280×720). GIFs e vídeos são enviados como estão.',
			useCrop: 'Usar este recorte',
			saveFirst: 'O rascunho é salvo sozinho quando você enviar o primeiro arquivo.',
			none: 'Sem mídia',
			image: 'Imagem',
			gif: 'GIF',
			videoUpload: 'Arquivo de vídeo',
			videoEmbed: 'Link do YouTube / Vimeo',
			file: 'Arquivo',
			imageHint: 'JPG, PNG ou WebP, no mínimo 1280×720 (16:9), até 8 MB.',
			gifHint: 'Até 6 MB. Prefira um vídeo MP4: GIF é pesado.',
			videoHint: 'MP4 ou WebM, até 10 MB, 20 segundos, 720p. Toca mudo em loop.',
			embedHint: 'Só o id do vídeo é guardado. Ele carrega quando a pessoa toca em play, sem cookies.',
			useLink: 'Usar link',
			poster: 'Imagem de capa (poster)',
			posterHint: 'Obrigatória para vídeos. Aparece antes do play e quando o movimento está reduzido.',
			description: 'Descrição (lida por leitores de tela)',
			descriptionHint: 'Descreva a imagem, ou resuma o que é dito no vídeo.',
			current: 'Mídia atual',
			focalHint: 'Clique na imagem para definir o ponto de foco usado quando ela é recortada.',
			remove: 'Remover mídia',
		},
		confirm: {
			title: {
				publish: 'Publicar este comunicado?',
				schedule: 'Agendar este comunicado?',
				approve: 'Aprovar e publicar este comunicado?',
			},
			announcement: 'Comunicado',
			reach: 'Alcance',
			allPlatforms: 'Todas as plataformas (site e apps)',
			languages: 'Idiomas',
			auto: 'tradução automática',
			when: 'Entra no ar',
			now: 'Imediatamente',
			channels: 'Notificações',
			inApp: 'Modal no app e no site',
			push: 'push',
			email: 'e-mail',
			confirm: 'Confirmar',
		},
		reach: {
			global: 'Global (todas as plataformas)',
			globalHint: 'Aparece em todos os sites e apps. Adicione plataformas abaixo só para restringir por app/versão.',
			platforms: 'Plataformas',
			narrow: 'Restringir para plataformas específicas (opcional)',
			narrowHint: 'Uma plataforma listada aqui segue a sua própria superfície e versão abaixo.',
			platform: 'Plataforma',
			surface: 'Onde',
			minVersion: 'A partir da versão do app',
			maxVersion: 'Até a versão do app',
			surfaces: {
				any: 'Site e apps',
				web: 'Só o site',
				ios: 'App iOS',
				android: 'App Android',
			},
			versionHint: 'Versões valem só para os apps (por exemplo 2.4.0). Vazio = qualquer versão.',
			requiresLogin: 'Só para quem está logado',
			requiresLoginHint: 'Desligue para mostrar também na primeira abertura do app, antes do login. Os sites nunca mostram para visitantes.',
			shareSeen: 'Contar como visto em todas as plataformas',
			shareSeenHint: 'Desligado: cada plataforma mostra uma vez. Ligado: ver em um lugar esconde em todos.',
		},
		schedule: {
			startsAt: 'Começa',
			startsAtHint: 'Vazio = assim que for publicado.',
			endsAt: 'Termina',
			endsAtHint: 'Vazio = até ser arquivado.',
			displayMode: 'Com que frequência aparece',
			once: 'Uma vez por pessoa',
			untilDismissed: 'Até a pessoa fechar (no máximo uma vez por dia)',
			priority: 'Prioridade',
			priorityHint: 'Maior vai primeiro quando dois estão no ar.',
			bump: 'Mostrar de novo para quem já viu',
			bumpHint: 'Aumenta a versão (agora {version}). Use para correções importantes.',
		},
		translations: {
			translate: 'Traduzir para {langs}',
			hint: 'As traduções automáticas aparecem como rascunho em cada idioma. Edite se quiser: idiomas editados deixam de ser marcados como automáticos. Ao publicar, os idiomas que faltarem são completados sozinhos.',
			original: 'original',
			auto: 'automático',
			reviewed: 'revisado',
			missingRequired: 'faltando (completa ao publicar)',
			fallsBackToEn: 'cai para o inglês',
			failed: 'Não foi possível traduzir: {langs}.',
		},
		notification: {
			once: 'Push e e-mail saem uma única vez, depois que o comunicado é aprovado e já começou.',
			push: 'Enviar notificação push',
			pushHint: 'Para quem tem o app nas plataformas escolhidas, no idioma e com o nome da pessoa. O horário de silêncio é respeitado.',
			email: 'Enviar e-mail',
			emailHint: 'Só para quem aceitou receber comunicados por e-mail. Só links https:// viram link.',
			sentAt: 'Enviado em {date}',
			textsHint: 'O push usa o título e o resumo.',
		},
		results: {
			views: 'Exibições',
			dismissals: 'Dispensados',
			cta_clicks: 'Cliques no botão',
			link_clicks: 'Cliques em links',
			video_plays: 'Plays de vídeo',
			rates: 'Dispensados {dismiss} · Botão {cta} · Links {link} (das exibições)',
			by: {
				platform: 'Por plataforma',
				surface: 'Por superfície',
				locale: 'Por idioma',
			},
			topLinks: 'Links mais clicados',
			noLinks: 'Nenhum clique em link ainda.',
		},
		preview: {
			title: 'Pré-visualização',
			light: 'Claro',
			dark: 'Escuro',
			platform: 'Plataforma',
			language: 'Idioma',
			name: 'Primeiro nome',
			nameHint: 'Vazio mostra a reserva neutra',
			heading: 'Novidades',
			seeAll: 'Ver tudo',
		},
		defaults: {
			title: 'Padrões',
			nameHint: 'Palavra usada no lugar de {first_name} quando a pessoa não tem nome, por idioma.',
			linksTitle: 'Links do rodapé por plataforma',
			linksHint: 'Redes sociais mostradas no fim de todo comunicado que não tem links próprios.',
			platform: 'Plataforma',
			label: 'Nome',
			addLink: 'Adicionar link',
			saved: 'Padrões salvos.',
		},
		errors: {
			generic: 'Algo deu errado. Tente de novo.',
			admin_master_only: 'Só um admin_master pode aprovar, rejeitar, publicar ou agendar.',
			title_required: 'O título é obrigatório.',
			target_required: 'Escolha pelo menos uma plataforma, ou deixe global.',
			ends_before_start: 'O fim precisa ser depois do início.',
			cta_incomplete: 'O botão precisa de tipo, endereço e texto.',
			cta_url_invalid: 'O endereço do botão deve começar com https://.',
			cta_route_invalid: 'A rota do botão deve começar com /.',
			media_type_invalid: 'Tipo de mídia inválido.',
			embed_incomplete: 'O link do vídeo está incompleto.',
			media_url_required: 'Envie o arquivo da mídia.',
			poster_required: 'Vídeos precisam de uma imagem de capa.',
			media_description_required: 'Descreva a mídia.',
			item_body_required: 'Todo item precisa de um texto.',
			item_link_invalid: 'O link de um item deve começar com https://.',
			link_invalid: 'Um link no texto não é permitido: use https:// ou um /caminho interno.',
			unknown_variable: 'Uma variável no texto é desconhecida. Só existe {first_name}.',
			content_required: 'Adicione um resumo, uma seção ou uma mídia.',
			english_required: 'Falta o texto em inglês: traduza primeiro.',
			starts_at_must_be_future: 'Para agendar, defina um início no futuro.',
			invalid_transition: 'Este passo não é possível no status atual.',
			file_too_large: 'O arquivo é grande demais.',
			image_too_small: 'A imagem é pequena demais (mínimo 1280×720).',
			video_too_long: 'O vídeo passa de 20 segundos.',
			video_too_tall: 'O vídeo passa de 720p.',
			unsupported_media_type: 'Esse tipo de arquivo não é aceito.',
			embed_url_invalid: 'Use um link do YouTube ou do Vimeo.',
			archive_first: 'Arquive antes de excluir.',
		},
	},
	menu: {
		blog: 'Conteúdo do blog',
		institutional: 'Institucional',
		messages: 'Mensagens',
		profiles: 'Perfis',
		profilesCategories: 'Categorias de perfis',
		ugcPersonas: 'Personas UGC',
		languageModel: 'Modelo de idioma',
		services: 'Serviços',
		tokenConfigs: 'Configurações de Token',
		quickPrompts: 'Quick Prompts',
		communityProfiles: 'Perfis da Comunidade',
		marketplace: 'Marketplace',
		usage: 'Uso',
		settings: 'Configurações',
		socialiteProviders: 'Provedores de socialites',
		awards: 'Premiações',
		awardsCategories: 'Categorias de Premiações',
		votings: 'Votações',
		gameJamsReview: 'Revisão de game jams',
		gameJamSponsors: 'Patrocinadores',
		gameJams: 'Game jams',
		gameJamsOverview: 'Visão geral',
		gameJamsAll: 'Todas as jams',
		gameJamsReports: 'Denúncias',
		institutions: 'Instituições de Ensino',
		wall: 'Wall',
		wallBlocks: 'Blocos da Wall',
		wallCategories: 'Categorias da Wall',
		wallMaps: 'Mapas da Wall',
		wallRewards: 'Recompensas da Wall',
		wallGrants: 'Pixels Gratuitos',
		magazines: {
			title: 'Revistas',
			sections: 'Editorias',
		},
		editorial: {
			title: 'Configurações Editoriais',
			journalistCategories: 'Categorias de Jornalistas',
			contentTypes: 'Tipos de Conteúdo',
			calculationRules: 'Regras de Cálculo',
		},
		projectsAndKeys: {
			title: 'Projetos e Keys',
			list: 'Lista de Keys',
			projects: 'Lista de Projetos',
		},
		careers: {
			title: 'Carreiras',
			applications: 'Candidatos',
			careers: 'Carreiras',
			skills: 'Habilidades',
		},
		notifications: {
			list: 'Notificações',
			templates: 'Templates',
			suggestions: 'Sugestões Automáticas',
		},
		partners: {
			title: 'Parceiros',
			list: 'Lista de Parceiros',
			categories: 'Categorias de parceiros',
		},
		podcasts: {
			title: 'Podcasts',
			shows: 'Programas',
			episodes: 'Episódios',
			guests: 'Convidados',
			hosts: 'Apresentadores',
			sponsors: 'Patrocinadores',
			consents: 'Termos de Cessão',
			slots: 'Slots de Gravação',
			calendar: 'Calendário',
		},
		financialSystem: {
			title: 'Sistema financeiro',
			currencies: 'Moedas',
			invoices: 'Faturas',
				invoicesList: 'Listar',
				invoicesCreate: 'Nova Fatura',
			failedPayments: 'Pagamentos Falhados',
			expensesCategories: 'Categorias de despesas',
			paymentMethods: 'Métodos de Pagamento',
			paymentPeriods: 'Períodos de Pagamento',
			paymentFees: 'Taxas de pagamento',
			paymentRefunds: 'Reembolsos de pagamento',
			paymentStatus: 'Status do pagamento',
			paymentTaxes: 'Pagamento de impostos',
			paymentTypes: 'Tipos de pagamento',
			banks: 'Bancos',
			cupons: 'Cupons de desconto',
			salePipeline: 'Venda Pipeline',
			commissions: 'Comissões / Splits',
			customCarts: 'Carrinhos Personalizados',
			abandonedCarts: 'Carrinhos Abandonados',
			affiliates: 'Afiliados',
			payoutsOverview: '💸 Saques Pendentes',
			ledgerOverview: '📊 Resultado da Plataforma',
			ledgerLiabilities: '📒 Devido a Criadores',
			executionMode: '🔀 Modo de Execução',
			payoutFlags: '🔌 Ativar Payouts',
			affiliatesList: 'Afiliados',
			affiliatesTransactions: 'Transações',
			affiliatesCommissions: 'Comissões de Afiliados',
			affiliatesRequests: 'Pedidos de Afiliados',
			affiliatesDocuments: 'Documentos de Afiliados',
		},
		languagesAndLocations: {
			title: 'Idiomas e Locais',
			cities: 'Cidades',
			countries: 'Paises',
			currencies: 'Moedas',
			languages: 'Idiomas',
			locations: 'Locais',
			nationalities: 'Nacionalidades',
			regions: 'Regiões',
			globalRegions: 'Regiões Globais',
			states: 'Estados',
			timezones: 'Fusos Horários',
		},
		pressMedia: {
			title: 'Imprensa & Mídia',
			posts: 'Posts da Imprensa',
			files: 'Arquivos de Mídia',
			journalists: {
				title: 'Base de Imprensa & Mídia',
				subtitle: 'Jornalistas, veículos e contatos de mídia.',
				outlet: 'Veículo',
				outletName: 'Nome do Veículo / Empresa',
				outletUrl: 'URL do Site',
				contact: 'Contato',
				contactName: 'Nome do Contato',
				firstName: 'Nome',
				lastName: 'Sobrenome',
				role: 'Cargo',
				email: 'Email',
				phone: 'Telefone',
				country: 'País',
				language: 'Idioma',
				mediaType: 'Tipo',
				receivesPress: 'PR',
				reviewKeys: 'Keys',
				verificationTier: 'Verificação',
				verificationTiers: {
					unverified: 'Não verificado',
					verified: 'Verificado',
				},
				verify: 'Verificar',
				unverify: 'Remover verificação',
				verifiedMsg: 'Marcado como verificado.',
				unverifiedMsg: 'Marcado como não verificado.',
				actions: 'Ações',
				newContact: 'Novo Contato',
				editContact: 'Editar Contato',
				createContact: 'Criar Contato',
				deleteConfirm: 'Excluir "{name}"?',
				contacts: 'contatos',
				selected: '{count} contato(s) selecionado(s)',
				selectAll: 'Selecionar todos {count}',
				allSelected: 'Todos os {count} contatos selecionados (todas as páginas)',
				sendEmail: 'Enviar Email',
				sendToAll: 'Enviar para Todos',
				sendTo: 'Enviar para {count}',
				copyEmail: 'Copiar Email',
				noEmail: 'Sem email para copiar',
				copied: 'Copiado: {email}',
				updated: 'Atualizado',
				deleted: 'Contato excluído',
				prYes: 'Sim',
				prPaid: 'Pago',
				prRelevant: 'Relevante',
				addUrl: 'adicionar url...',
				addRole: 'adicionar cargo...',
				observations: 'Observações',
				openForInterviews: 'Disponível para Entrevistas',
				doesReviews: 'Faz Reviews',
				acceptsReviewKeys: 'Aceita Keys de Review',
				hasMediaKit: 'Tem Media Kit',
				mediaKitUrl: 'URL do Media Kit',
				statusPreferences: 'Status & Preferências',
				personalInfo: 'Informações Pessoais',
				locationLanguage: 'Localização & Idioma',
				outletCompany: 'Veículo / Empresa',
				emailSent: 'Email enviado para {count} contatos',
				emailAllInfo: 'Email será enviado para todos os contatos com email que correspondam aos filtros atuais.',
				recipientsCount: 'Destinatários ({count}):',
				noEmailSkipped: '{count} contato(s) sem email serão ignorados.',
				subject: 'Assunto',
				emailBody: 'Corpo do Email',
				signature: 'Assinatura',
				yes: 'Sim',
				no: 'Não',
				paidOnly: 'Somente Pago',
				relevantOnly: 'Somente Relevante',
				discover: 'Descobrir (Apify)',
				discoverTerms: 'Termos de busca (cargo, veículo)',
				maxResults: 'Máx. resultados',
				discoverHint: 'Busca no LinkedIn via Apify. Requer configuração do Apify (credencial apify_linkedin). Os contatos entram como pendentes de revisão. Caso contrário, use entrada manual, CSV ou ClickUp.',
				termsRequired: 'Informe ao menos um termo de busca (ex.: "jornalista de games", "editor de tecnologia").',
				discoverQueued: 'Descoberta iniciada em segundo plano — você será avisado quando terminar.',
				discoverBusy: 'Já existe uma descoberta em andamento. Aguarde terminar.',
			},
		},
		observatory: {
			title: 'Observatório',
			organizations: 'Organizações e acessos',
			intelligence: 'Inteligência',
			accessRequests: 'Pedidos de acesso',
			professionalIntroductions: 'Apresentações (profissionais)',
			precedence: 'Precedência de fontes',
			applications: 'Candidaturas',
			entityClaims: 'Correções regionais',
			experiments: 'Experimentos',
			events: 'Eventos internos',
			demo: 'Demonstração',
		},
		networkSystems: {
			title: 'Sistemas da Rede',
			documents: 'Documentos',
			documentsTypes: 'Tipos de Documentos',
			documentsWebsites: 'Documentos de Websites',
			domains: 'Dominios',
			MGPlatforms: 'Plataformas MG',
			operationalArea: 'Área Operacional',
			roadmap: 'Roadmap',
			roadmapStatus: 'Status do Roadmap',
			teamMembers: 'Membros do Time',
			FAQs: 'FAQs',
			FAQsCategories: 'Categorias de FAQs',
			workflow: 'Status do fluxo de trabalho',
			ACL: {
				rolesList: 'Lista de Funções',
				permissionsList: 'Lista de Permissões',
				modulesList: 'Módulos',
				companyAccess: 'Acesso por Empresa',
				userAccess: 'Acesso por Utilizador',
				platformOverview: 'Visão Geral da Plataforma',
			},
			plans: 'Planos',
			benefits: 'Benefícios',
			dayTips: 'Dicas do dia',
			announcementBanners: 'Banners de Anúncio',
			announcementBannerPresets: 'Presets de Banner',
			whatsNew: 'Novidades',
			promotionBanners: 'Banners Promocionais',
			appBanners: 'Banners de Instalação do App',
			products: 'Produtos',
			productBundles: 'Pacote de Produtos',
			productTags: 'Tags de Produtos',
			pageTags: 'Tags de Páginas',
			pricingRegions: 'Regiões de Preço',
			subscriptions: 'Assinaturas',
			cancellations: 'Feedback de Cancelamentos',
		},
		themes: {
			themes: 'Temas',
			appThemes: 'Temas do App',
			projectsVariables: 'Variáveis de Projetos',
		},
		reports: {
			title: 'Relatórios',
			payments: 'Pagamentos',
			operational: 'Custo de Operação',
		},
		todo: {
			title: 'Tarefas',
			items: 'Itens para Fazer',
			list: 'Lista de Afazeres',
		},
		users: {
			title: 'Usuários',
			list: 'Lista de Usuários',
			group: 'Grupo de Usuários',
			genders: 'Lista de Gêneros',
			accountClosures: 'Pedidos de Deleção',
		},
		polls: {
			title: 'Enquente',
			list: 'Lista de Enquentes',
			new: 'Nova Enquente',
		},
		companies: {
			companies: 'Empresas',
			companiesList: 'Listas de Empresas',
			companiesType: 'Tipo de empresa',
			companiesSize: 'Tamanho de empresa',
			companiesStage: 'Estágios de empresa',
			companiesRole: 'Cargos de Empresa',
			companyClaims: 'Reivindicações de Empresa',
		},
		community: {
			moderation: 'Moderação de Conteúdo',
			communities: {
				communities: 'Comunidades',
				creators: 'Criadores',
				features: 'Recursos',
				ratings: 'Avaliações',
				comments: 'Comentários',
			},
			pulses: {
				pulses: 'Pulses',
				category: 'Categoria',
				pending: 'Pendentes',
				source: 'Fonte',
				status: 'Status',
			},
			wikigamer: {
				achievements: 'Conquistas',
				characters: {
					characters: 'Personagens',
					genders: 'Genêros',
					phrases: 'Frases',
					species: 'Espécies',
					status: 'Status',
					statusWebsite: 'Website Status',
				},
				collections: 'Coleções',

				events: {
					events: 'Eventos',
					eventsList: 'Lista de Eventos',
					eventsCategories: 'Categorias de Eventos',
				},
				franchises: 'Franquias',
				games: {
					games: 'Jogos',
					gamesAchievements: 'Conquistas de Jogos',
					gamesTypes: 'Tipos de Jogos',
					gamesEngines: 'Motores de jogos',
					gamesGenres: 'Gêneros de jogos',
					gamesModes: 'Modos de jogos',
					gamesPerspectives: 'Perspectivas de Jogos',
					gamesStatus: 'Status de jogos',
					gamesThemes: 'Temas de Jogos',
					gamesWebsites: 'Websites de Jogos',
					gamesPriceWatchlist: 'Lista de Preços de Consoles',
				},
				gamesRating: {
					gamesRating: 'Classificação de jogos',
					ESRBRatings: 'Classificação da ESRB',
					ESRBContents: 'Conteúdo da ESRB',
					PegiRatings: 'Classificação da Pegi',
					PegiContents: 'Conteúdo da Pegi',
				},
				mediaTypes: 'Tipos de Mídia',
				regions: 'Regiões',

				platforms: {
					platforms: 'Plataformas',
					generations: 'Gerações',
					platformsFamily: 'Família de Plataformas',
					platformsType: 'Tipo de plataforma',
				},
			},
			Schedulers: 'Agendadores',
			pushNotifications: 'Notificações via Push',
			quizzes: 'Quizzes',
			reviews: {
				reviews: 'Avaliações',
				list: 'Todas as Avaliações',
				create: 'Nova Avaliação',
				aiCreate: 'Criar com IA',
				aiJobs: 'Jobs de IA',
				distribution: 'Distribuição de Avaliações',
			},
			videos: {
				videos: 'Vídeos',
				category: 'Categoria',
				sources: 'Canais do YouTube',
			},
			translationQueue: 'Fila de Tradução',
			feedConfig: 'Config. do Feed',
			feedPromotions: 'Promoções no Feed',
			gameClaims: 'Reivindicações de Jogos',
			gameContributions: 'Contribuições de Jogos',
			gameCreationSuggestions: 'Sugestões de Jogos Novos',
			contentRequests: 'Demandas de Conteúdo',
			guestWriterInvites: 'Redatores Convidados',
		},
		network: {
			overview: 'Visão geral',
			changePlatform: 'Trocar plataforma',
			liveAnalytics: 'Análises ao vivo',
			polls: 'Enquetes',
			pollsList: 'Todas as Enquetes',
			pollsCreate: 'Nova Enquete',
			pollsCategories: 'Categorias',
			deletionRequests: 'Pedidos de Exclusão',
		},
		agency: {
			programs: 'Partner Programs',
			services: 'Serviços',
			categories: 'Categorias',
			contactMessages: 'Solicitações',
			requestMessages: 'Pedidos',
			audience: 'Público-alvo',
			workflow: 'Status do fluxo de trabalho',
			game: 'Status dos Projetos',
			goals: 'Metas',
			projects: 'Projetos',
			testimonials: 'Depoimentos',
			userTestimonials: 'Depoimentos de usuários',
			keys: 'Chaves',
			keysContents: 'Tipo de conteúdo de chaves',
			keysTypes: 'Tipos de chaves',
			keysStatus: 'Status de chaves',
			keysRequestsStatus: 'Status de Solicitações de chaves',
			keysSuppliers: 'Fornecedores de chaves',
			keysSuppliersPrs: 'Fornecedores de RP',
			keysRequests: 'Solicitações de chaves',
			keysMaterials: 'Materiais de chaves',
			marketing: {
				bannerModeration: 'Moderação de banner',
				bannerArtwork: 'Arte de banner',
				highlightBannersApp: 'App Banners',
				highlightBannersWeb: 'Web Banners',
				tvBanners: 'Banners TV',
				providers: 'Provedores',
				campaigns: 'Campanhas',
				campaignsTypes: 'Tipos de Campanhas',
				campaignsCategories: 'Categorias de Campanhas',
				cases: 'Casos',
				casesTypes: 'Tipos de Casos',
				presentations: 'Apresentações',
				ads: 'Anúncios',
				adChannels: 'Canais de Anúncios',
				adFormats: 'Formatos de Anúncios',
				adSizes: 'Tamanhos de Anúncios',
				adTypes: 'Tipos de Anúncios',
				kpiGroups: 'Grupos de KPI',
				kpiOptions: 'Opções de KPI',
			},
			newsletter: {
				categories: 'Categorias',
				periodicities: 'Frequências',
				campaigns: 'Campanhas',
			},
			influencers: 'Influenciadores',
			budgetBuilder: 'Montador de Orçamento',
			showcases: 'Showcase',
			showcasesSubmissions: 'Inscrições',
			showcaseDeliverables: 'Entregas',
			showcasesCoverages: 'Coberturas',
			showcasesCoverageSourceTypes: 'Tipos de Fonte de Cobertura',
			showcasesCoverageFeedSources: 'Fontes de cobertura',
			showcasesMediaPartnerApplications: 'Aplicações de Media Partner',
			showcasesCoverageSubmissions: 'Submissões de Cobertura',
			videoSubmissions: 'Distribuição de Vídeo',
			showcasesCoverageSuggestions: 'Sugestões de Cobertura',
			coveragesBulkImport: 'Importação em Massa de Coberturas',
			runDiscovery: 'Buscar Automaticamente',
			showcasesSponsorApplications: 'Aplicações de Patrocinador',
			pressRoomKeyRequests: 'Solicitações de Chave - Press Room',
			studioOutreach: 'Prospecção de Estúdios',
			studioProspects: 'Prospectos Steam',
			studioProspectsBoard: 'Kanban de Prospectos',
			studioProspectSourceReviews: 'Revisão de Fontes',
			commercialAccountOpportunities: 'Prospectos de Patrocínio',
			commercialAccountsWorklist: 'Contas de Hoje',
			commercialAccountsList: 'Contas Comerciais',
			commercialAccountsConversion: 'Relatório de Conversão',
			commercialAccountsBoard: 'Quadro do Funil',
			prospectEmailTemplates: 'Templates de E-mail para Prospectos',
			fieldActivations: 'Ativações de campo',
			studioOnboardingInvites: 'Convites de Onboarding',
			studioOnboardingQuestions: 'Perguntas de Onboarding',
			studioOnboardingSubmissions: 'Submissões de Onboarding',
			studioOnboardingFollowups: 'Funil de Follow-up',
			pressRelease: 'Press Release',
			pressReleaseGenerate: 'Gerar Press Release',
			pressReleaseTemplates: 'Modelos',
			pressReleaseCampaigns: 'Campanhas',
			pressReleaseCalendar: 'Calendário',
			pressReleaseUnsubscribeReasons: 'Motivos de Cancelamento',
			pressReleaseProfessionalLeads: 'PR Profissional — Leads',
			pressReleaseProfessionalBoard: 'PR Profissional — Atribuições',
			pressReleaseFunnels: 'Funis',
			pressReleaseFunnelsList: 'Todos os Funis',
			pressReleaseBriefings: 'Briefings',
			wallOfLegends: 'Wall of Legends',
			pressKits: 'Press Kits',
			pressKitsList: 'Todos os Press Kits',
			mediaKits: 'Media Kits',
			mediaKitsList: 'Todos os Media Kits',
		},
		academy: {
			courses: 'Cursos',
			categories: 'Categorias',
			subcategories: 'SubCategorias',
			formats: 'Formatos',
			levels: 'Níveis',
		},

		club: {
			clubs: 'Clubs',
			franchiseModels: 'Modelos de Franquia',
			contactFranchise: 'Contatos com Franquias',
		},
		exchange: {},
		jobs: {
			vacancies: 'Vagas',
			vacanciesDrop: {
				list: 'Lista de Vagas',
				status: 'Lista de Status de Vagas',
				applications: 'Pedidos de Emprego',
				urlChecker: 'Verificador de URLs',
			},
			resumes: 'Currículos',
			employment: {
				employment: 'Emprego',
				employmentType: 'Tipo de Emprego',
			},
			experiences: 'Experiências',
			workHours: 'Horas de trabalho',
			workMethodologies: 'Metodologias de trabalho',
			workAvailabilities: 'Disponibilidades de trabalho',
			industrySectors: 'Setores da Indústria',
			gigs: 'Freelancers',
			gigCategories: 'Categorias de Freelancer',
			gigListings: 'Anúncios de Freelancer',
			gigNegotiations: 'Negociações de Freelancer',
			gigProposalPayouts: 'Pagamentos de Freelancer',
			gigDisputes: 'Disputas de Freelancer',
			gigReviewContests: 'Avaliações Contestadas',
			gigSocialBoosts: 'Pedidos de Impulsionamento',
			professionalSituations: 'Situações profissionais',
			requests: 'Solicitações',
			selectionProcesses: 'Processos Seletivos',
			salary: 'Salário',
			salarySource: 'Tipos de Fontes Salariais',
			salarySubmissions: 'Envio de salários',
			salaryInsightTextCategories: 'Categorias de Textos de Insights',
			salaryInsightTexts: 'Textos de Insights Salariais',
			salaryTaxRates: 'Taxas de Impostos',
			vacancyTitle: 'Título da vaga',
		},
		shop: {
			productSuppliers: 'Fornecedores de Ofertas',
			deals: 'Ofertas',
			dealCommunity: 'Comunidade de ofertas',
			dealsDashboard: 'Painel de ofertas',
			coupons: 'Cupons',
			stores: 'Lojas',
			products: 'Produtos',
		},
		token: {},
		tv: {
			banners: {
				rotatingBanners: 'Banners Rotativos',
			},
			streamersApplications: 'Candidaturas',
			streamersTypes: 'Tipos de Streamers',
		},
		accountBenefits: 'Benefícios da Conta',
		website: 'Website',
		broadcast: 'Broadcast',
		aiStatus: 'Status de IA',
		aiModels: 'Modelos de IA por Uso',
		webhookChannels: 'Canais Webhook',
		bots: 'Bots',
		deployCenter: 'Deploy Center',
		fulfillmentQueue: 'Fila de Entregas',
		contentEngineQueue: 'Central de Curadoria',
		contentEngineArticlesQueue: 'Fila RSS (clássica)',
		contentEngineFeeds: 'Fontes RSS',
		contentEngineSettings: 'Configurações',
		mailHub: 'Email Hub',
		mailHubInbox: 'Caixa de Entrada',
		mailHubSuggestions: 'Sugestões IA',
		mailHubLeads: 'Leads',
		mailHubSent: 'Enviados',
		mailHubSuppression: 'Supressão de Email',
		mailHubAccounts: 'Contas',
		mailHubChannels: 'Canais de Notificação',
		mailHubTemplates: 'Modelos de Resposta',
		mailHubKeyRequestsStudio: 'Solicitar keys a estúdio',
		mailHubSystemEmails: 'Emails do Sistema',
		mailHubSystemEmailsDesc: 'Ative ou desative emails do sistema em todo o ecossistema.',
		mailHubSystemEmailsPlatform: 'Plataforma',
		mailHubSystemEmailsStatus: 'Status',
		mailHubSystemEmailsSearch: 'Buscar',
		mailHubSystemEmailsEnabled: 'Ativo',
		mailHubSystemEmailsDisabled: 'Inativo',
		mailHubSystemEmailsColLabel: 'Email',
		mailHubSystemEmailsColPlatform: 'Plataforma',
		mailHubSystemEmailsColEnabled: 'Ativo',
		mailHubSystemEmailsColFrequency: 'Frequência padrão',
		mailHubSystemEmailsFrequencyDaily: 'Diária',
		mailHubSystemEmailsFrequencyWeekly: 'Semanal',
		mailHubSystemEmailsFrequencyHint: 'Vale para quem ainda não escolheu a sua. Cada destinatário pode alterar a própria nas configurações de notificação.',
		nurtureSequences: 'Sequências de Nutrição',
		mailHubSettings: 'Configurações',
		supportTickets: 'Tickets de Suporte',
		nurtureSequencesDesc: 'Gerencie sequências de email automatizadas para leads, testes e assinaturas.',
		nurtureSequencesStatus: 'Status',
		nurtureSequencesSearch: 'Buscar',
		nurtureSequencesActive: 'Ativa',
		nurtureSequencesPaused: 'Pausada',
		nurtureSequencesTotal: 'total',
		nurtureSequencesCompleted: 'concluídos',
		nurtureSequencesUnsubscribed: 'descad.',
		nurtureSequencesColName: 'Sequência',
		nurtureSequencesColEnrollments: 'Inscrições',
		nurtureSequencesColActive: 'Ativa',
		nurtureSequencesViewEnrollments: 'Ver Inscrições',
		nurtureEnrollments: 'Inscrições',
		nurtureEnrollmentsStatus: 'Status',
		nurtureEnrollmentsSteps: 'etapas',
		nurtureEnrollmentsColEmail: 'Contato',
		nurtureEnrollmentsColLocale: 'Idioma',
		nurtureEnrollmentsColStatus: 'Status',
		nurtureEnrollmentsColProgress: 'Progresso',
		nurtureEnrollmentsColEnrolledAt: 'Inscrito em',
		nurtureEnrollmentsColLastSent: 'Último Envio',
		nurtureEnrollmentStatus_active: 'Ativo',
		nurtureEnrollmentStatus_completed: 'Concluído',
		nurtureEnrollmentStatus_unsubscribed: 'Descadastrado',
		nurtureEnrollmentsColReason: 'Motivo',
		nurtureEnrollmentsColPurchased: 'Comprou',
		nurtureEnrollmentsColOpens: 'Aberturas',
		nurtureDoubtReason_price: 'Preço',
		nurtureDoubtReason_not_sure_fits: 'Não sabe se é pra ele(a)',
		nurtureDoubtReason_no_time: 'Sem tempo',
		nurtureDoubtReason_technical_issue: 'Problema técnico',
		nurtureFunnelTitle: 'Taxa de abertura por etapa',
		nurtureFunnelStep: 'Etapa',
		nurtureFunnelSent: 'Enviados',
		nurtureFunnelOpened: 'Abertos',
		nurtureFunnelEmpty: 'Nenhum e-mail enviado ainda.',
		nurtureEnrollmentsColCountry: 'País',
		nurtureEnrollmentsColPriceShown: 'Preço Visto',
		nurtureRegionTitle: 'Leads e compras por região de preço',
		nurtureRegionColRegion: 'Região',
		nurtureRegionColDiscount: 'Desconto',
		nurtureRegionColLeads: 'Leads',
		nurtureRegionColPurchased: 'Compraram',
		nurtureRegionColRate: 'Taxa',
		nurtureRegionUnknown: 'Desconhecido (sem dado de geo)',
		nurtureRegionStandard: 'Padrão (sem desconto)',
		nurtureRegionEmpty: 'Nenhum lead ainda.',
		networkMarketing: 'Marketing',
		networkMarketingCampaignsBanners: 'Banners de Campanha',
		contentEngine: 'Content Engine',
		contentEngineDashboard: 'Painel',
		contentEngineClips: 'Fila de Clips',
		contentEngineCalendar: 'Calendário',
		contentEngineTitles: 'Gerador de Títulos',
		contentEngineAnalytics: 'Análises',
		contentEngineCreativeStudio: 'Creative Studio',
		contentEngineRssFeeds: 'RSS Feeds',
		contentEngineRssQueue: 'Fila de Artigos',
		contentEngineSocialPosts: 'Posts Sociais',
		contentEngineEcosystem: 'Ecossistema',
		ventures: {
			dashboard: 'Painel',
			references: 'Referências',
			categories: 'Categorias',
			regions: 'Regiões',
			investorTypes: 'Tipos de Investidor',
			pitchMediaTypes: 'Tipos de Mídia de Pitch',
			scoreAxes: 'Eixos de Pontuação',
			stages: 'Etapas',
			projects: 'Projetos',
			studioProspects: 'Prospecção de Estúdios',
			investors: 'Investidores',
			investorProspects: 'Prospecção de Investidores',
			publishers: 'Publishers',
			investments: 'Investimentos',
			operational: 'Operacional',
			waitlist: 'Lista de Espera',
			pitches: 'Pitches',
			connections: 'Conexões',
			scoreEngine: 'Motor de Pontuação',
			subscriptions: 'Assinaturas',
		},
	},

	userSubscriptions: {
		plan: 'Plano',
		platform: 'Plataforma',
		pricing: 'Preço',
		status: 'Status',
		cancelAt: 'Cancelar em',
		nextPayment: 'Próximo Pagamento',
		free: 'Gratuito',
		paid: 'Pago',
		trial: 'Teste',
		cancelling: 'Cancelando',
		statusActive: 'Ativa',
		statusInactive: 'Inativa',
		planDetails: 'Detalhes do Plano',
		type: 'Tipo',
		paymentsCount: 'Pagamentos',
		lastPayment: 'Último Pagamento',
		trialUntil: 'Teste até',
		featureLimits: 'Limites de Recursos',
		feature: 'Recurso',
		enabled: 'Habilitado',
		limit: 'Limite',
		tier: 'Nível',
		unlimited: 'Ilimitado',
		noFeatureLimits: 'Nenhum limite de recurso configurado para este plano.',
		activeSubscriptions: 'Assinaturas Ativas',
		activeProducts: 'Produtos Ativos',
		noActiveSubscriptions: 'Nenhuma assinatura encontrada para este usuário.',
		unlimitedAccess: 'Acesso ilimitado — sem limites de recursos.',
		noActiveSubscription: 'Nenhuma assinatura ativa para esta plataforma.',
	},

	networkSubscriptions: {
		title: 'Assinaturas',
		subtitle: 'Gerenciar todas as assinaturas das plataformas',
		user: 'Usuário',
		system: 'Plataforma',
		plan: 'Plano',
		pricing: 'Preço',
		status: 'Status',
		nextPayment: 'Próximo Pagamento',
		createdAt: 'Criado em',
		canceledAt: 'Termina / Cancelado em',
		statusActive: 'Ativa',
		statusTrial: 'Teste — termina em {date}',
		statusCancelling: 'Cancelando',
		statusCancelled: 'Cancelada',
		cancelSubscription: 'Cancelar Assinatura',
		cancelTitle: 'Cancelar Assinatura',
		cancelConfirm: 'Tem certeza que deseja cancelar a assinatura de:',
		cancelReason: 'Motivo do cancelamento',
		cancelReasonRequired: 'Por favor, informe o motivo do cancelamento',
		confirmCancel: 'Confirmar Cancelamento',
		cancelledSuccess: 'Assinatura cancelada com sucesso',
		assignPlan: 'Atribuir Plano',
		assignTitle: 'Atribuir Assinatura',
		confirmAssign: 'Atribuir',
		assignSuccess: 'Assinatura atribuída com sucesso',
		changePlan: 'Alterar Plano',
		changeTitle: 'Alterar Plano da Assinatura',
		changeConfirm: 'Selecione o novo plano para:',
		confirmChange: 'Salvar Alterações',
		changeSuccess: 'Plano da assinatura alterado com sucesso',
		gateway: 'Gateway',
		statsStripe: 'Ativos Stripe',
		statsPaypal: 'Ativos PayPal',
		statsFree: 'Ativos Free',
		statsCancelled: 'Canceladas',
		statsActiveRevenue: 'Receita Ativa',
		grantFree: 'Conceder gratuitamente (trial)',
		accessEndsAt: 'Acesso termina em',
		accessEndsAtHint: 'Deixe em branco para acesso permanente. Vale tanto pra plano grátis quanto pago.',
		period7Days: '7 dias',
		period30Days: '30 dias',
		period90Days: '90 dias',
		period1Year: '1 ano',
		forceReplaceTitle: 'Substituir Assinatura Ativa?',
		forceReplaceConfirm: 'Este usuário já possui uma assinatura ativa nesta plataforma. Ao prosseguir, a assinatura existente será cancelada e a nova será criada.',
		forceReplaceConfirmBtn: 'Substituir Assinatura',
		bulkAssignPlan: 'Atribuir em Lote',
		bulkAssignTitle: 'Atribuir Múltiplas Plataformas',
		bulkAssignHint: 'Conceda acesso a várias plataformas de uma vez — por exemplo, um estúdio entrando em Agency, Ventures e Jobs juntos. Ou todas as plataformas são concedidas, ou nenhuma, caso algo dê errado.',
		platformN: 'Plataforma {n}',
		addPlatform: 'Adicionar Plataforma',
		confirmBulkAssign: 'Atribuir Todas',
		bulkAssignSuccess: '{count} assinatura(s) atribuída(s) com sucesso',
		bulkForceReplaceConfirm: 'Este usuário já possui uma assinatura ativa em uma ou mais das plataformas selecionadas. Ao prosseguir, essas assinaturas existentes serão canceladas e as novas serão criadas.',
	},

	networkCancellations: {
		title: 'Feedback de Cancelamentos',
		search: 'Buscar usuário',
		filter: 'Filtrar',
		active: 'Ativo',
		inactive: 'Cancelado',
		col_user: 'Usuário',
		col_system: 'Plataforma',
		col_plan: 'Plano',
		col_status: 'Status',
		col_reasons: 'Motivos',
		col_feedback: 'Feedback',
		col_offer: 'Oferta Resgatada',
		col_date: 'Data',
		offer_discount: 'off',
		offer_free: 'grátis',
		reasons: {
			too_expensive: 'Muito caro',
			missing_features: 'Faltam recursos',
			technical_issues: 'Problemas técnicos',
			just_want_to_cancel: 'Quer cancelar',
		},
	},

	messages: {
		list: {
			title: 'Lista de Mensagens',
			subTitle: 'Confira a lista de mensagens.',
		},
	},

	newsletters: {
		list: {
			title: 'Lista de Newsletter do Mundo Gamer',
			subTitle: 'Confira a lista de Newsletter cadastradas na Mundo Gamer.',
		},
		dedup: {
			button: 'Remover duplicados',
			title: 'Remover e-mails duplicados',
			mode: 'Escopo',
			modeSamePlatform: 'Mesma plataforma (duplicatas reais)',
			modeCrossPlatform: 'Entre plataformas (um registro por e-mail)',
			crossPlatformWarning: 'Atenção: consolidar entre plataformas perde a segmentação por origem.',
			stats: '{groups} grupos duplicados — {rows} registros redundantes serão removidos',
			email: 'E-mail',
			entries: 'Registros',
			keeper: 'Registro mantido (riscado = removido)',
			optedOut: 'descadastrado',
			none: 'Nenhuma duplicata encontrada.',
			run: 'Limpar duplicados',
			done: '{deleted} registros removidos, {merged} preferências mescladas. Descadastros foram preservados.',
		},
		create: {
			title: 'Nova Newsletter',
			subTitle: 'Newsletter',
		},
		update: {
			title: 'Editar Newsletter',
			subTitle: 'Newsletter',
		},
		delete: {
			title: 'A Newsletter foi deletada com sucesso.',
		},
		duplicates: {
			button: 'Localizar Duplicados',
			title: 'E-mails Duplicados',
			subTitle: 'Os e-mails abaixo aparecem mais de uma vez. Selecione os registros que deseja excluir, revisando as categorias e periodicidades antes de remover.',
			noneFound: 'Nenhum e-mail duplicado encontrado.',
			records: 'registros',
			selectedToDelete: 'selecionados para exclusão',
			deleteSelected: 'Excluir Selecionados',
			deleteSuccess: 'Registros selecionados excluídos com sucesso.',
			modeSamePlatform: 'Duplicatas Reais',
			modeCrossPlatform: 'Entre Plataformas',
			modeSamePlatformDesc: 'Mesmo e-mail cadastrado mais de uma vez na mesma plataforma — são bugs e devem ser excluídos, mantendo apenas um.',
			modeCrossPlatformDesc: 'Mesmo e-mail inscrito em múltiplas plataformas (MGC, MGJ, MGA…) — geralmente é legítimo. Exclua apenas se realmente indesejado.',
		},
	},
	notificationsPage: {
		list: {
			title: 'Lista de Notificações do Mundo Gamer',
			subTitle: 'Confira a lista de Notificações cadastradas na Mundo Gamer.',
		},
		tabs: {
			all: 'Todas',
			yourNotifications: 'Suas Notificações',
		},
		create: {
			title: 'Nova Notificação',
			subTitle: 'Notificação',
		},
		delete: {
			title: 'A Notificação foi deletada com sucesso.',
		},
		timezoneRequired: 'O fuso horário é obrigatório para agendamentos.',
		saveError: 'Erro ao salvar notificação.',
		invalidPlatform: 'Plataforma inválida.',
	},
	notificationTemplatesPage: {
		list: {
			title: 'Templates de Notificação',
			subTitle: 'Gerencie os templates de notificação e suas traduções.',
		},
		create: {
			title: 'Novo Template',
			success: 'Template criado com sucesso.',
		},
		edit: {
			title: 'Editar Template',
			success: 'Template atualizado com sucesso.',
		},
		delete: {
			confirm: 'Tem certeza que deseja excluir este template?',
			success: 'Template excluído com sucesso.',
		},
		translations: 'Traduções',
		test: 'Testar',
		testTitle: 'Testar Notificação',
		testDescription: 'Envie uma notificação de teste para este template.',
		selectPlatform: 'Selecionar Plataforma',
		selectLanguage: 'Selecionar Idioma',
		sendTest: 'Enviar Teste',
		testSent: 'Notificação de teste enviada!',
		fields: {
			platform: 'Plataforma',
			category: 'Categoria',
			channels: 'Canais',
			userCanDisable: 'Usuário pode desativar',
			notifyRolesHint: 'Deixe em branco para notificar apenas o admin_master (padrão). Selecione um ou mais papéis para delegar esta notificação.',
			notifyUsers: 'Notificar usuários específicos',
			previewRecipients: 'Pré-visualizar destinatários',
			noRecipients: 'Nenhum destinatário receberia esta notificação hoje.',
			audience: 'Público',
			adminOnly: 'Somente voltadas à equipe',
			customerOnly: 'Somente voltadas ao cliente',
			audienceBadgeAdmin: 'Equipe',
			audienceBadgeCustomer: 'Cliente',
			isAdminNotification: 'Notificação voltada à equipe',
			isAdminNotificationHint: 'Alcança a equipe interna/admin em vez de clientes ou criadores (ex.: "Steam Prospects Synced"). Controla quem este template pode notificar, junto com os papéis/usuários abaixo.',
		},
	},
	faqs: {
		list: {
			title: 'Lista de FAQS',
			subTitle: 'Verifique a lista de FAQS registrados nas plataformas da Indústria Mundo Gamer',
		},
		create: {
			title: 'Nova Questão de FAQ',
			subTitle: 'FAQ',
		},
		delete: {
			title: 'O FAQ foi deletado com sucesso.',
		},
	},

	themes: {
		list: {
			title: 'Lista de Temas',
			subTitle: 'Verifique a lista de Temas registrados nas plataformas da Indústria Mundo Gamer',
		},
		create: {
			title: 'Novo Tema',
			subTitle: 'Tema',
		},
	},
	projectsVariables: {
		list: {
			title: 'Lista de Variáveis de Projetos',
			subTitle: 'Verifique a lista de Variáveis de Projetos registradas nas plataformas da Indústria Mundo Gamer',
		},
		create: {
			title: 'Nova Variável de Projeto',
			subTitle: 'Variável de Projeto',
		},
	},

	companies: {
		list: {
			title: 'Lista de Empresas da Mundo Gamer',
			subTitle: 'Confira a lista de Empresas cadastradas na Mundo Gamer.',
		},
		create: {
			title: 'Nova Empresa',
			subTitle: 'Preencha os campos abaixo para cadastrar uma nova Empresa',
		},
		update: {
			title: 'Editar Empresa',
		},
		companyClaims: {
			title: 'Reivindicações de Empresa',
			subtitle: 'Revise reivindicações de propriedade de empresas do catálogo importadas sem administrador.',
			tabs: {
				pending: 'Pendentes',
				approved: 'Aprovadas',
				rejected: 'Rejeitadas',
			},
			table: {
				company: 'Empresa',
				user: 'Usuário',
				status: 'Status',
				submittedAt: 'Enviado em',
				actions: 'Ações',
				fromCatalog: 'Importada do catálogo',
			},
			status: {
				pending: 'Pendente',
				approved: 'Aprovada',
				rejected: 'Rejeitada',
			},
			actions: {
				view: 'Ver detalhes',
					},
			dialog: {
				titleApprove: 'Aprovar Reivindicação',
				titleReject: 'Rejeitar Reivindicação',
				company: 'Empresa',
				note: 'Nota de Revisão',
				noteRequired: 'Nota de Revisão (obrigatória)',
				notePlaceholder: 'Nota para o solicitante…',
			},
			details: {
				title: 'Detalhes da reivindicação',
				user: 'Usuário',
				proof: 'Prova de propriedade',
				submittedAt: 'Enviado em',
				note: 'Nota de revisão',
				proposed: 'Página proposta',
				fields: {
					name: 'Razão social',
					fantasyName: 'Nome fantasia',
					description: 'Descrição',
					website: 'Site',
					email: 'E-mail',
				},
			},
			feedback: {
				loadError: 'Falha ao carregar as reivindicações.',
				approveSuccess: 'Reivindicação aprovada com sucesso.',
				rejectSuccess: 'Reivindicação rejeitada.',
				actionError: 'Ocorreu um erro. Tente novamente.',
			},
		},
	},

	deletionRequests: {
		title: 'Pedidos de Exclusão',
		subtitle: 'Revise pedidos de usuários para excluir uma empresa ou jogo que eles gerenciam. Aprovar remove a entidade da plataforma.',
		tabs: {
			pending: 'Pendentes',
			approved: 'Aprovados',
			rejected: 'Rejeitados',
		},
		table: {
			entity: 'Entidade',
			user: 'Solicitado por',
			status: 'Status',
			submittedAt: 'Enviado em',
			actions: 'Ações',
		},
		entityTypes: {
			company: 'Empresa',
			game: 'Jogo',
		},
		status: {
			pending: 'Pendente',
			approved: 'Aprovado',
			rejected: 'Rejeitado',
		},
		actions: {
			view: 'Ver detalhes',
			approve: 'Aprovar',
			reject: 'Rejeitar',
		},
		dialog: {
			titleApprove: 'Aprovar Exclusão',
			titleReject: 'Rejeitar Exclusão',
			entity: 'Entidade',
			approveWarning: 'A empresa será anonimizada: nome, contatos e dados são apagados, a equipe perde o acesso e ela some da plataforma e das contas dos usuários. Registros que apontam para ela (keys, faturas...) são mantidos. Isso não pode ser desfeito por aqui.',
			note: 'Nota de Revisão',
			noteRequired: 'Nota de Revisão (obrigatória)',
			notePlaceholder: 'Nota para o solicitante…',
		},
		impact: {
			team: 'Equipe vinculada a esta empresa',
			owner: 'responsável',
			records: 'Registros vinculados a esta empresa',
			none: 'Nada vinculado.',
			action: {
				removed: 'será removido',
				closed: 'será encerrado',
				kept: 'mantido (a empresa fica anônima)',
			},
		},
		details: {
			title: 'Detalhes do pedido',
			entity: 'Entidade',
			user: 'Solicitado por',
			reason: 'Motivo',
			submittedAt: 'Enviado em',
			note: 'Nota de revisão',
		},
		feedback: {
			loadError: 'Falha ao carregar os pedidos de exclusão.',
			approveSuccess: 'Pedido de exclusão aprovado.',
			rejectSuccess: 'Pedido de exclusão rejeitado.',
			actionError: 'Ocorreu um erro. Tente novamente.',
		},
	},

	companiesType: {
		list: {
			title: 'Lista de Tipos de Empresas da Mundo Gamer',
			subTitle: 'Confira a lista de Tipos de Empresas cadastradas na Mundo Gamer.',
		},
		create: {
			title: 'Novo Tipo de Empresa',
			subTitle: 'Tipo de Empresa',
		},
		delete: {
			title: 'O Tipo de Empresa foi deletado com sucesso.',
		},
	},

	companiesSize: {
		list: {
			title: 'Lista de Tamanhos de Empresas da Mundo Gamer',
			subTitle: 'Confira a lista de Tamanhos de Empresas cadastradas na Mundo Gamer.',
		},
		create: {
			title: 'Novo Tamanho de Empresa',
			subTitle: 'Tamanho de Empresa',
		},
		delete: {
			title: 'O Tamanho de Empresa foi deletado com sucesso.',
		},
	},

	companiesStage: {
		list: {
			title: 'Lista de Tamanhos de Estágios da Mundo Gamer',
			subTitle: 'Confira a lista de Tamanhos de Estágios cadastradas na Mundo Gamer.',
		},
		create: {
			title: 'Novo Estágio de Empresa',
			subTitle: 'Estágio de Empresa',
		},
		delete: {
			title: 'O Estágio de Empresa foi deletado com sucesso.',
		},
	},

	companiesRole: {
		list: {
			title: 'Lista de Cargos de Empresa da Mundo Gamer',
			subTitle: 'Confira a lista de Cargos de Empresa cadastrados na Mundo Gamer.',
		},
		create: {
			title: 'Novo Cargo de Empresa',
			subTitle: 'Cargo de Empresa',
		},
		save: {
			title: 'O Cargo de Empresa foi salvo com sucesso.',
		},
		delete: {
			title: 'O Cargo de Empresa foi deletado com sucesso.',
		},
		isSystem: 'Cargo do Sistema',
	},

	accountBenefits: {
		list: {
			title: 'Lista de Benefícios da Conta',
			subTitle: 'Verifique a lista de Benefícios da Conta registrados nas plataformas da Indústria Mundo Gamer',
		},
		create: {
			title: 'Novo Benefício da Conta',
			subTitle: 'Benefício da Conta',
		},
		delete: {
			title: 'O Benefício da Conta foi deletado com sucesso.',
		},
	},
	institutions: {
		list: {
			title: 'Lista de Instituições de Ensino mais recentes do Mundo Gamer',
			subTitle: 'Confira a lista de Instituições de Ensino cadastrados na Mundo Gamer.',
		},
		create: {
			title: 'Nova Instituição de Ensino',
			subTitle: 'Instituição de Ensino',
		},
		update: {
			title: 'Editar Instituição de Ensino',
			subTitle: 'Instituição de Ensino',
		},
		delete: {
			title: 'A Instituição de Ensino foi deletada com sucesso.',
		},
	},
	academy: {
		moderation: {
			rejectTitle: 'Rejeitar produto',
			rejectHint: 'Explique ao criador por que este produto está sendo rejeitado:',
		},
		courses: {
			courses: {
				rejectionReason: 'Motivo da rejeição',
				rejectionReasonHint: 'Exibido ao criador. Obrigatório ao rejeitar.',
				rejectionReasonRequired: 'Informe o motivo da rejeição.',
				rejectionReasonTooLong: 'O motivo deve ter no máximo 2000 caracteres.',
				list: {
					title: 'Lista de Cursos mais recentes do Mundo Gamer Academy',
					subTitle: 'Confira a lista de Cursos cadastradas na Mundo Gamer Academy.',
				},
				create: {
					title: 'Novo Curso',
					subTitle: 'Curso',
				},
				update: {
					title: 'Editar Curso',
					subTitle: 'Curso',
				},
				delete: {
					title: 'O Curso foi deletado com sucesso.',
				},
			},
			categories: {
				list: {
					title: 'Lista de Categorias de Cursos mais recentes do Mundo Gamer Academy',
					subTitle: 'Confira a lista de Categorias de Cursos cadastradas na Mundo Gamer Academy.',
				},
				create: {
					title: 'Nova Categoria de Curso',
					subTitle: 'Categoria',
				},
				typeLabel: 'Tipo de categoria',
				typeHint: 'Jogo: coaching de gameplay para um jogo específico (Estratégia, Mecânica...). Geral: disciplinas profissionais da indústria de jogos (Desenvolvimento, Marketing...).',
				typeGeneral: 'Geral (disciplina da indústria)',
				typeGame: 'Jogo (coaching de gameplay)',
			},
			subcategories: {
				list: {
					title: 'Lista de SubCategorias de Cursos mais recentes do Mundo Gamer Academy',
					subTitle: 'Confira a lista de SubCategorias de Cursos cadastradas na Mundo Gamer Academy.',
				},
				create: {
					title: 'Nova SubCategoria de Curso',
					subTitle: 'SubCategoria',
				},
			},
			levels: {
				list: {
					title: 'Lista de Níveis de Cursos mais recentes do Mundo Gamer Academy',
					subTitle: 'Confira a lista de Níveis de Cursos cadastradas na Mundo Gamer Academy.',
				},
				create: {
					title: 'Novo Nível de Curso',
					subTitle: 'Nível',
				},
				update: {
					title: 'Editar Nível de Curso',
					subTitle: 'Nível de Curso.',
				},
				delete: {
					title: 'O Nível de Curso foi deletado com sucesso.',
				},
			},
			formats: {
				list: {
					title: 'Lista de Formatos de Cursos mais recentes do Mundo Gamer Academy',
					subTitle: 'Confira a lista de Formatos de Cursos cadastrados na Mundo Gamer Academy.',
				},
				create: {
					title: 'Novo Formato de Curso',
					subTitle: 'Formato de Curso.',
				},
				update: {
					title: 'Editar Formato de Curso',
					subTitle: 'Formato de Curso.',
				},
				delete: {
					title: 'O Formato de Curso foi deletado com sucesso.',
				},
			},
		},
		creatorApplications: {
			expertisesPanel: {
				title: 'Especialidades Propostas',
				empty: 'Nenhuma especialidade cadastrada (perfil legado, migrado antes da nova estrutura).',
				generalExpertise: 'Especialidade geral',
				offeringsAndCourses: '{offerings} oferta(s) · {courses} curso(s)',
			},
		},
	},

	ai: {
		profiles: {
			list: {
				title: 'Lista de Perfis',
				subTitle: 'Verifique a lista de Perfis registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Perfil',
				subTitle: 'Perfil',
			},
			update: {
				title: 'Editar Perfil',
			},
			delete: {
				title: 'O Perfil foi deletada com sucesso.',
			},
		},
		profilesCategories: {
			list: {
				title: 'Lista de Categorias de Perfis',
				subTitle:
					'Verifique a lista de Categorias de Perfis registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Categoria de Perfil',
				subTitle: 'Categoria de Perfil',
			},
			update: {
				title: 'Editar Categoria de Perfil',
			},
			delete: {
				title: 'A Categoria de Perfil foi deletada com sucesso.',
			},
		},
		ugcPersonas: {
			list: {
				title: 'Lista de Personas UGC',
				subTitle:
					'Apresentadoras/apresentadores de vídeo com IA reutilizáveis (avatar + voz), disponíveis para qualquer pipeline de conteúdo que gere vídeo com avatar — ofertas, notícias, curiosidades da indústria — em qualquer marca ou canal da Mundo Gamer Network',
			},
			create: {
				title: 'Nova Persona UGC',
				subTitle: 'Persona UGC',
			},
			update: {
				title: 'Editar Persona UGC',
			},
			delete: {
				title: 'A Persona UGC foi deletada com sucesso.',
			},
			form: {
				description: 'Descrição (tom, personalidade, notas de roteiro — uso interno)',
				thumbnailUrl: 'URL da miniatura',
				heygenAvatarId: 'ID do Avatar (HeyGen)',
				heygenVoiceId: 'ID da Voz (HeyGen)',
				defaultLocale: 'Idioma padrão',
			},
		},
		languageModel: {
			list: {
				title: 'Lista de Modelos de Idioma',
				subTitle: 'Verifique a lista de Modelos de Idioma registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Modelo de Idioma',
				subTitle: 'Modelo de Idioma',
			},
			update: {
				title: 'Editar Modelo de Idioma',
			},
			delete: {
				title: 'O Modelo de Idioma foi deletado com sucesso.',
			},
		},
		services: {
			list: {
				title: 'Lista de Serviços',
				subTitle: 'Verifique a lista de Serviços registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Serviço',
				subTitle: 'Serviço',
			},
			update: {
				title: 'Editar Serviço',
			},
			delete: {
				title: 'O Serviço foi deletado com sucesso.',
			},
		},
		tokens: {
			list: {
				title: 'Lista de Configurações de Token',
				subTitle:
					'Verifique a lista de Configurações de Token registrados nas plataformas da Indústria Mundo Gamer',
			},
			update: {
				title: 'Editar Configuração de Token',
			},
		},
		communityProfiles: {
			list: {
				title: 'Perfis da Comunidade',
				subTitle: 'Gerencie e modere perfis de IA enviados pela comunidade',
				official: 'Oficial',
				community: 'Comunidade',
				approve: 'Aprovar',
				reject: 'Rejeitar',
				toggleFeatured: 'Alternar Destaque',
				rejectTitle: 'Rejeitar Perfil',
				approvedMsg: 'Perfil aprovado.',
				rejectedMsg: 'Perfil rejeitado.',
				deletedMsg: 'Perfil excluído.',
			},
		},
		insights: {
			list: {
				title: 'Insights do Setor',
				subTitle: 'Visualize insights do setor gerados por IA por plataforma e categoria',
				emptyState: 'Nenhum insight disponível ainda.',
				errorState: 'Os dados de insights não estão disponíveis no momento.',
				platform: 'Plataforma',
				category: 'Categoria',
			},
		},
		marketplace: {
			list: {
				title: 'Marketplace',
				subTitle: 'Visualize perfis publicados, preços, compras e ganhos dos criadores',
			},
		},
		quickPrompts: {
			list: {
				title: 'Lista de Quick Prompts',
				subTitle: 'Gerencie os prompts rápidos exibidos na tela de boas-vindas do chat AI',
			},
			create: {
				title: 'Novo Quick Prompt',
				subTitle: 'Quick Prompt',
			},
			update: {
				title: 'Editar Quick Prompt',
			},
			delete: {
				title: 'O Quick Prompt foi deletado com sucesso',
			},
		},
	},

	agency: {
		reports: {
			title: 'Denúncias',
			searchLabel: 'Buscar por motivo, denunciante, jogo, estúdio ou pessoa',
			status: 'Status',
			type: 'Tipo',
			statuses: { pending: 'Pendente', reviewed: 'Revisado', dismissed: 'Descartado' },
			total: 'Total: {n}',
			onlyThisTarget: 'Só: {target}',
			loading: 'Carregando...',
			empty: 'Nenhuma denúncia encontrada.',
			columns: { reporter: 'Denunciante', target: 'Sobre', category: 'Categoria', reason: 'Motivo', date: 'Data', actions: 'Ações' },
			reporterGone: 'Conta removida',
			reportedByStudio: 'Denunciado pelo estúdio',
			reportedByMember: 'Denunciado por um membro',
			person: 'Pessoa',
			studio: 'Estúdio',
			game: 'Jogo',
			message: 'Mensagem',
			targetReports: '1 denúncia sobre isto | {n} denúncias sobre isto',
			viewTarget: 'Ver todas as denúncias sobre isto',
			detailsTitle: 'Denúncia nº {id}',
			aboutLabel: 'Sobre',
			reasonLabel: 'O que foi relatado',
			noReason: 'Sem descrição.',
			decision: 'Decisão',
			decisionReviewed: 'Revisado — ação tomada',
			decisionDismissed: 'Descartado — sem ação',
			notes: 'Notas internas (opcional)',
			reviewedBy: 'Revisado por {name} em {date}',
			confirm: 'Confirmar',
			cancel: 'Cancelar',
			close: 'Fechar',
			reviewedToast: 'Denúncia revisada.',
			reviewError: 'Não foi possível revisar a denúncia.',
			types: {
				creator_network_member: 'Rede de Creators: pessoa',
				creator_network_studio: 'Rede de Creators: estúdio',
				proposal: 'Proposta',
				company: 'Empresa',
				influencer_professional_information: 'Criador',
				journalist_professional_information: 'Jornalista',
				user: 'Usuário',
				gig_listing: 'Anúncio de serviço',
				gig_proposal: 'Proposta de serviço',
			},
		},
		reportCategories: {
			title: 'Categorias de denúncia',
			intro: 'Os motivos que as pessoas podem escolher ao denunciar algo. O inglês é o texto-base; um idioma deixado em branco mostra o texto em inglês.',
			search: 'Buscar por nome ou descrição',
			new: 'Nova categoria',
			newTitle: 'Nova categoria',
			editTitle: 'Editar categoria',
			edit: 'Editar',
			appliesTo: 'Vale para',
			anyType: 'Qualquer tipo de denúncia',
			shownOn: 'Aparece em',
			thisPlatform: 'Esta plataforma ({name})',
			allPlatforms: 'Todas as plataformas',
			universalWarning: 'Esta categoria aparece em todas as plataformas: alterá-la altera em todas.',
			nameEn: 'Nome (inglês)',
			descriptionEn: 'Descrição (inglês)',
			statusLabel: 'Status',
			order: 'Ordem',
			statuses: { active: 'Ativa', inactive: 'Inativa' },
			columns: { name: 'Categoria', appliesTo: 'Vale para', platform: 'Plataforma', languages: 'Idiomas', reports: 'Denúncias', active: 'Ativa' },
			translationsTitle: 'Traduções',
			translationsHint: 'Deixe um campo em branco para mostrar o texto em inglês nesse idioma.',
			nameIn: 'Nome ({language})',
			descriptionIn: 'Descrição ({language})',
			languages: { en: 'Inglês', ptBR: 'Português (Brasil)', es: 'Espanhol', de: 'Alemão', ro: 'Romeno' },
			state: { complete: 'traduzida', partial: 'parcialmente traduzida', missing: 'sem tradução' },
			required: 'Obrigatório',
			save: 'Salvar',
			cancel: 'Cancelar',
			saved: 'Categoria salva.',
			orderRange: 'Use um número inteiro de 0 a {max}.',
			saveError: 'Não foi possível salvar a categoria.',
			statusError: 'Não foi possível alterar o status.',
			loading: 'Carregando...',
			empty: 'Nenhuma categoria encontrada.',
			delete: {
				action: 'Excluir',
				title: 'Excluir categoria',
				text: 'Excluir "{name}"? Isso não pode ser desfeito.',
				confirm: 'Excluir',
				done: 'Categoria excluída.',
				error: 'Não foi possível excluir a categoria.',
				inUse: 'Esta categoria tem {n} denúncia(s) registrada(s), por isso não pode ser excluída. Deixe-a inativa: ela sai do formulário de denúncia e o histórico permanece.',
				setInactive: 'Deixar inativa',
			},
		},
		programs: {
			title: 'Partner Programs',
			subtitle: 'Programas publicados por empresas para creators e parceiros.',
			program: 'Programa',
			views: 'Visualizações',
			externalClicks: 'Cliques (externos)',
			applications: 'Candidaturas',
			accepted: 'Aceitas',
			featured: 'Destaque',
			updatedAt: 'Atualizado',
			view: 'Ver',
			edit: 'Editar',
			feature: 'Destacar',
			unfeature: 'Remover destaque',
			featuredUntil: 'Destaque até (opcional)',
			pause: 'Pausar',
			archive: 'Arquivar',
			pauseConfirm: 'Pausar "{title}"? Ele deixa de receber novas candidaturas.',
			archiveConfirm: 'Arquivar "{title}"? Ele sai das listagens públicas.',
			confirm: 'Confirmar',
			send: 'Enviar',
			create: 'Criar',
			recommend: 'Recomendar creators',
			recommendHint: 'Os creators selecionados recebem um convite para este programa (máx. 25).',
			searchCreators: 'Buscar creators',
			recommendSent: '{n} convite(s) enviado(s).',
			viewAnalytics: 'Ver analytics',
			createOrganization: 'Criar organização',
			applicationsSummary: 'Resumo de candidaturas',
			analyticsHint: 'Apenas métricas medidas.',
			noAudit: 'Nenhum registro de auditoria.',
			types: {
				affiliate: 'Afiliado',
				creator_program: 'Programa de creators',
				ambassador: 'Embaixador',
				sponsorship: 'Patrocínio',
				paid_campaign: 'Campanha paga',
				brand_campaign: 'Campanha de marca',
				game_keys: 'Chaves de jogo',
				event: 'Evento',
				developer: 'Desenvolvedor',
				technology_partnership: 'Parceria tecnológica',
			},
			statuses: {
				draft: 'Rascunho',
				active: 'Ativo',
				paused: 'Pausado',
				closed: 'Encerrado',
				archived: 'Arquivado',
			},
			tabs: {
				overview: 'Visão geral',
				analytics: 'Analytics',
				audit: 'Auditoria',
			},
			stats: {
				applications: 'Candidaturas',
				accepted: 'Aceitas',
				declined: 'Recusadas',
				invitations_sent: 'Convites enviados',
				invitations_responded: 'Convites respondidos',
				members_active: 'Membros ativos',
			},
			fields: {
				title: 'Título',
				summary: 'Resumo',
				description: 'Descrição',
				requirements: 'Requisitos',
				benefits: 'Benefícios',
				rewardSummary: 'Recompensa',
				visibility: 'Visibilidade',
				applicationMode: 'Modo de candidatura',
				externalUrl: 'URL externa',
				followers: 'Seguidores (mín – máx)',
				startsAt: 'Início',
				endsAt: 'Fim',
				publishedAt: 'Publicado em',
				audiences: 'Públicos',
				countries: 'Países',
				platforms: 'Plataformas',
			},
			org: {
				companyName: 'Nome da empresa',
				ownerEmail: 'E-mail do responsável',
				country: 'País (opcional)',
				website: 'Site (opcional)',
			},
		},
		bannerModeration: {
			imageUnavailable: 'Imagem indisponível',
			title: 'Moderação de banner',
			subtitle: 'Todo banner passa por aqui antes de ser servido. Aprovar coloca ele no ar nas plataformas compradas; recusar registra o motivo e mantém a campanha para o estúdio corrigir a arte.',
			reviewStatus: 'Estado da revisão',
			searchLabel: 'Buscar por título ou destino',
			preview: 'Prévia',
			banner: 'Banner',
			platforms: 'Plataformas',
			details: 'Detalhes',
			approve: 'Aprovar',
			reject: 'Recusar',
			noArtwork: 'Sem arte',
			noArtworkHint: 'Este banner ainda não tem criativo — foi comprado com a MGN fazendo a arte, e não pode ser aprovado até ela ser entregue.',
			mobileCreative: 'Arte mobile',
			advertiser: 'Anunciante',
			destination: 'Destino',
			budget: 'Orçamento',
			period: 'Período',
			openEnded: 'roda até o orçamento acabar',
			placements: 'Posicionamentos',
			active: 'ativo',
			inactive: 'inativo',
			rejectionReason: 'Motivo',
			rejectHint: 'O motivo chega ao anunciante na notificação e fica registrado no banner.',
			approveConfirm: 'Isto coloca o banner no ar em todas as plataformas e páginas compradas.',
			approveSuccess: 'Banner aprovado e no ar.',
			rejectSuccess: 'Banner recusado — o anunciante foi notificado.',
			empty: 'Nada aguardando revisão.',
			statuses: {
				pending: 'Aguardando revisão',
				awaiting_artwork: 'Aguardando arte',
				approved: 'Aprovado',
				rejected: 'Recusado',
				unreviewed: 'Sem revisão',
			},
		},
		creatorHub: {
			title: 'Creator Hub',
		},
		dashboard: {
			resultsQuickAccess: {
				title: 'Resultados de campanha',
				subtitle: 'Vá direto para cadastrar cobertura ou abrir o relatório que o cliente vê.',
				logResults: 'Cadastrar resultados',
				publicPage: 'Página pública',
				viewAll: 'Ver todas',
				empty: 'Nenhuma campanha ainda.',
			},
			latestOnboardingSubmissions: {
				title: 'Envios de Onboarding',
				viewAll: 'Ver todas',
			},
			latestVideoSubmissionsQueue: {
				title: 'Fila de Distribuição de Vídeo',
				viewAll: 'Ver todas',
			},
			deviceTokenUsers: {
				search: 'Buscar',
				platform: 'Plataforma',
			},
			pressRelease: {
				submission: 'Inscrição',
				heroImageUrl: 'URL da Imagem Hero',
				templatesTitle: 'Modelos de Press Release',
				useTemplate: 'Usar Modelo',
				saveAsTemplateTitle: 'Salvar como Modelo',
				templateName: 'Nome do modelo',
			},
			latestKeyRequests: {
				title: 'Últimas Solicitações de Key',
			viewAll: 'Ver Todas',
				approve: 'Aprovar',
				refuse: 'Recusar',
				viewDetails: 'Ver detalhes',
				requestDetails: 'Detalhes da Solicitação',
			},
			latestInfluencers: {
				title: 'Últimos Influenciadores',
			},
			activeWalls: {
				title: 'Murais Indie',
			},
			latestKeyMaterials: {
				title: 'Materiais Entregues',
			},
			recentReviews: {
				title: 'Avaliações Recentes',
			},
			recentCampaignOrders: {
				title: 'Campanhas Recentes',
			},
			latestShowcases: {
				title: 'Últimos Showcases',
			},
			recentProposals: {
				title: 'Propostas Recentes',
			},
			onboardingFunnel: {
				title: 'Funil de captação',
				subtitle: 'Estúdios convidados nos últimos {days} dias e até onde cada etapa chegou.',
				byStudio: 'Por estúdio',
				error: 'Não foi possível carregar o funil.',
				weakest: 'Maior queda',
				ofPrevious: 'da etapa anterior',
				perDay: 'Por dia',
				intentTitle: 'Intenção declarada no formulário',
				budgetDeclared: 'Declararam orçamento',
				withInterest: 'Escolheram onde investiriam',
				intentNotBought: 'Declararam intenção e não compraram',
				waitingTitle: 'Enviaram e aguardam a conta',
				waitingTotal: 'Sem conta',
				waitingBuckets: 'Esperando mais de 1 dia: {d1} · 3 dias: {d3} · 7 dias: {d7}',
				revenueTitle: 'Receita dos pedidos deste fluxo',
				stages: {
					offer_item_added: 'Colocaram item no carrinho',
					payment_started: 'Iniciaram o pagamento',
					invited: 'Estúdios convidados',
					email_sent: 'E-mail de abertura enviado',
					email_opened: 'Abriram o e-mail',
					email_clicked: 'Clicaram no link',
					form_opened: 'Abriram o formulário',
					form_submitted: 'Enviaram o formulário',
					account_created: 'Criaram conta',
					purchased: 'Compraram',
				},
				ranges: {
					'upto_50': 'Até 50',
					'50_150': '50 a 150',
					'150_300': '150 a 300',
					'300_600': '300 a 600',
					'600_1k': '600 a 1k',
					'over_1k': 'Acima de 1k',
					under_1k: 'Até 1k',
					'1k_5k': '1k a 5k',
					'5k_20k': '5k a 20k',
					over_20k: 'Acima de 20k',
				},
				interests: {
					showcase: 'Showcase',
					article: 'Artigo',
					review: 'Review',
					press_release: 'Press release',
					creator_content: 'Criadores',
					key_distribution: 'Keys',
					undecided: 'Não sabe',
				},
			},
			proposalFinanceOverview: {
				title: 'Visão Financeira de Propostas',
				subtitle: 'Dinheiro movimentado via "Pagar via MG" e a comissão retida pela plataforma, por moeda.',
				viewProposals: 'Ver Propostas →',
				empty: 'Nenhum pagamento via MG ainda.',
				currency: 'Moeda',
				grossMoved: 'Total Movimentado',
				commissionRetained: 'Comissão MGN',
				transactions: 'Pagamentos',
			},
			latestShowcaseApplications: {
				title: 'Últimas Inscrições de Showcase',
			},
			usersList: {
				details: 'Detalhes',
			},
		},
		results: {
			clientLink: 'Link do cliente',
			viewAsClient: 'Ver como cliente',
			sendReport: 'Enviar relatório',
			sendReportHint: 'Usa o e-mail do cliente vinculado por padrão. Substitua para um cliente sem conta na plataforma.',
			reportSent: 'Relatório enviado por e-mail ao cliente.',
			exportCsv: 'Exportar CSV',
			importToCase: 'Importar para Case',
			linkCopied: 'Link do relatório do cliente copiado.',
			linkError: 'Não foi possível gerar o link do cliente.',
			caseImported: 'Campanha importada para um case (rascunho).',
			caseError: 'Não foi possível importar a campanha para um case.',
		},
		settings: {
			title: 'Configurações da Agency',
			subtitle: 'Configure os padrões globais de comissões, contratos e campanhas.',
			commissions: 'Comissões',
			commissionFree: 'Comissão Plano Free (%)',
			commissionPro: 'Comissão Plano Pro (%)',
			commissionBusiness: 'Comissão Plano Business (%)',
			operational: 'Padrões Operacionais',
			proposalExpiryHours: 'Expiração de Proposta (horas)',
			contractExpiryDays: 'Expiração de Contrato (dias)',
			defaultMarkup: 'Markup Padrão (%)',
			defaultServiceModel: 'Modelo de Serviço Padrão',
			autoGenerateContracts: 'Gerar contratos automaticamente ao aprovar campanha',
			showcaseReminders: {
				title: 'Lembrete de cadastro do Showcase',
				desc: 'Email para inscrições pagas da edição ativa que ainda não criaram conta na plataforma. O envio manual fica na tab de materiais da edição.',
				auto: 'Enviar automaticamente (diário, 10h)',
				cooldownDays: 'Intervalo mínimo entre lembretes (dias)',
				maxAuto: 'Máximo de lembretes automáticos por inscrição',
			},
			serviceModels: {
				fullManagement: 'Gestão Completa',
				intermediation: 'Intermediação',
				rosterOnly: 'Só Roster',
			},
		},
		contractTemplates: {
			title: 'Templates de Contrato',
			template: 'Template',
			name: 'Nome',
			system: 'Sistema',
			language: 'Idioma',
			category: 'Categoria',
			serviceModel: 'Modelo de Serviço',
			bodyTemplate: 'Corpo do Template (HTML)',
			variablesHint: 'Use {{nome_variavel}} para campos dinâmicos. Ex.: {{creator_name}}, {{amount}}, {{agency_name}}',
			translationsHint: 'Salve o template primeiro para adicionar traduções em outros idiomas.',
			new: 'Novo Template',
			edit: 'Editar Template',
			confirmDelete: 'Tem certeza que deseja excluir este template? Esta ação não pode ser desfeita.',
		},
		documents: {
			title: 'Documentos & Contratos',
		},
		contracts: {
			title: 'Contratos',
			new: 'Novo Contrato',
			generate: 'Gerar',
			generated: 'Contrato gerado.',
			contractType: 'Tipo de Contrato',
			rosterMember: 'Membro do Roster',
			template: 'Template (opcional)',
			templateHint: 'Deixe em branco para usar o template padrao para este tipo.',
			grantorName: 'Nome do Cedente',
			grantorEmail: 'E-mail do Cedente',
			grantorCpf: 'CPF do Cedente (opcional)',
			campaign: 'Campanha',
			category: 'Categoria',
			partyA: 'Parte A (Agencia)',
			partyB: 'Parte B (Contraparte)',
			partyBEmail: 'E-mail Parte B',
			amount: 'Valor',
			signed: 'Assinado em',
			signUrl: 'URL de Assinatura',
			send: 'Enviar Contrato',
			resend: 'Reenviar Contrato',
			reminder: 'Enviar Lembrete',
			preview: 'Visualizar',
			editBody: 'Editar Corpo',
			history: 'Historico',
			pdf: 'Exportar PDF',
			sentSuccess: 'Contrato enviado com sucesso.',
			reminderSent: 'Lembrete enviado com sucesso.',
			fullySignedAlert: 'Este contrato foi assinado por ambas as partes.',
			signedCannotEdit: 'Contratos assinados nao podem ser editados.',
			noEvents: 'Nenhum evento registrado ainda.',
			status: {
				draft: 'Rascunho',
				sent: 'Enviado',
				viewed: 'Visualizado',
				signed: 'Assinado',
				cancelled: 'Cancelado',
			},
			categories: {
				client_contract: 'Contrato com Cliente',
				creator_contract: 'Contrato com Criador',
				image_rights: 'Direitos de Imagem',
			},
			event: {
				created: 'Criado',
				sent: 'Enviado para a parte B',
				viewed: 'Visualizado',
				signed_a: 'Assinado pela parte A',
				signed_b: 'Assinado pela parte B',
				exported: 'Exportado como PDF',
				reminder: 'Lembrete enviado',
			},
		},
		roster: {
			title: 'Roster de Campanha',
			campaign: 'Campanha',
			type: 'Tipo',
			creator: 'Criador',
			status: {
				em_avaliacao: 'Em Avaliação',
				selecionado: 'Selecionado',
				descartado: 'Descartado',
				sondagem: 'Sondagem',
				convidado: 'Convidado',
				aceito: 'Aceito',
				recusado: 'Recusado',
				contrato_pendente: 'Contrato Pendente',
				contrato_assinado: 'Contrato Assinado',
			},
			creatorValue: 'Valor do Criador',
			casting: 'Casting',
			fromCasting: 'Adicionado via prospecção de casting',
			source: 'Origem',
			clientValue: 'Valor do Cliente',
			agencyMargin: 'Margem Agência',
			autoCalc: 'Valor cliente automático',
			margin: 'margem',
			selectCasting: 'Selecionar casting (criador interno)',
			castingHint: 'Busque pelo nome. Redes e engajamento vêm do perfil dele.',
			noCasting: 'Nenhum criador encontrado',
			estimatedReach: 'Alcance estimado (seguidores)',
			externalSocialHint: 'Para criadores externos, informe o alcance manualmente (sem perfil vinculado).',
			markupFromCampaign: 'Vem do markup da campanha — ajuste por criador se precisar.',
			autoMatch: 'Auto-combinar',
			rerankAi: 'Re-ranquear com IA',
			reranked: 'Roster reordenado pela IA.',
			addCreator: 'Adicionar Criador',
			kindInfluencer: 'Casting (interno)',
			kindExternal: 'Externo',
			influencerId: 'ID do Influenciador',
			influencerIdHint: 'ID numérico do perfil profissional do influenciador.',
			externalName: 'Nome',
			externalContact: 'E-mail / Contato',
			externalUrl: 'URL / Canal',
			creatorsAdded: 'criadores adicionados',
			sendBrief: 'Enviar Brief',
			generateContract: 'Contrato',
			editValues: 'Editar Valores',
			markupHint: 'Deixe o valor cliente vazio para calcular pelo markup.',
			briefSent: 'Brief enviado ao criador.',
			contractGenerated: 'Contrato gerado, link copiado.',
			changeStatus: 'Alterar Status',
			campaignOrderId: 'ID da Campanha',
		},
		campaignOrders: {
			subtitle: 'Gerenciar campanhas',
			orphanOnly: 'Somente órfãs (sem cliente ou empresa vinculada)',
			campaign: 'Campanha',
			unnamed: 'Campanha sem nome',
			origin: 'Origem',
			agencyManaged: 'Gerenciado pela Agência',
			selfServe: 'Autoatendimento',
		},
		pressReleaseAssignments: {
			artworkBoardTitle: 'Arte de banner — fila de criação da MGN',
			artworkBoardSubtitle: 'Campanhas de banner que o estúdio pagou pedindo que a MGN faça a arte. Entregar a arte manda o banner para a moderação; não publica.',
			artworkDelivered: 'Arte entregue',
			artworkMissing: 'Sem arte',
			uploadArtwork: 'Subir arte',
			replaceArtwork: 'Trocar arte',
			deliverArtwork: 'Entregar arte',
			artworkDeliveredSuccess: 'Arte entregue — o banner está aguardando a moderação.',
			artworkNote: 'O estúdio já pagou por esta campanha. Entregar a arte a coloca no banner e manda para revisão; não publica nada por conta própria.',
			artworkDesktop: 'Arte desktop',
			artworkMobile: 'Arte mobile',
			artworkMobileHint: 'Opcional. Servida em telas estreitas quando existe.',
			artworkSizeHint: 'Recorte em {width}x{height}px, o tamanho que o estúdio comprou.',
			artworkSizeUnknown: 'Este banner não tem tamanho registrado — recorte livre e siga o briefing.',
			leadsTitle: 'PR Profissional — Leads Pendentes',
			leadsSubtitle: 'Cote e confirme pedidos de clientes para um press release profissional gerenciado pela equipe.',
			leadsBackendNotice: 'Esta fila varre os pedidos recentes no navegador — ainda não existe um filtro dedicado no backend. Se um lead não aparecer aqui, confira o pedido diretamente.',
			noLeads: 'Nenhum lead pendente no momento.',
			status: 'Status',
			quotePrice: 'Cotação (preço unitário)',
			confirmed: 'Confirmado',
			awaitingQuote: 'Aguardando cotação',
			saveQuote: 'Salvar cotação',
			confirmLead: 'Confirmar e enviar para pagamento',
			confirmLeadSuccess: 'Pedido movido para aguardando pagamento.',
			markPaidAndProvision: 'Marcar como pago e provisionar',
			markPaidAndProvisionSuccess: 'Pedido aprovado — press release e atribuição de redator criados.',
			assignWriter: 'Atribuir redator',
			quoteSaved: 'Cotação salva.',
			boardTitle: 'PR Profissional — Atribuições de Redação',
			boardSubtitle: 'Acompanhe quem está escrevendo/operando cada press release profissional pago.',
			newAssignment: 'Nova atribuição',
			newAssignmentWarning: 'Uso apenas em contingência — use somente se o pedido já foi aprovado e nenhuma atribuição foi criada automaticamente. Criar uma antes da aprovação pode gerar duplicidade quando o pedido for aprovado.',
			itemId: 'ID do item do pedido',
			assignTo: 'Atribuir a',
			contentType: 'Tipo de conteúdo',
			filterAssignedUser: 'Filtrar por responsável',
			onlyMine: 'Somente minhas',
			noAssignments: 'Nenhuma atribuição encontrada.',
			statuses: {
				assigned: 'Atribuído',
				in_progress: 'Em Progresso',
				draft_ready: 'Rascunho Pronto',
				published: 'Publicado',
			},
			contentTypes: {
				banner_creative: 'Arte de banner',
				article: 'Artigo',
				review: 'Review',
				press_release: 'Press Release',
				magazine: 'Revista',
			},
			openOrder: 'Abrir pedido',
			deadline: 'Prazo',
			guaranteed: 'Garantido',
			overdue: 'Atrasado',
			noSlaFree: 'Pedido gratuito — sem data de entrega garantida',
			details: 'Detalhes',
			reassign: 'Reatribuir a',
			assignToMe: 'Atribuir a mim',
			advance: 'Avançar status',
			briefingNotes: 'Notas de briefing',
			editorNotes: 'Notas do editor',
			unassigned: 'Não atribuído',
			assignSuccess: 'Atribuição atualizada.',
			statusUpdateSuccess: 'Status atualizado.',
		},
		campaignDetail: {
			notFound: 'Esta campanha não foi encontrada, ou você não tem acesso a ela.',
			forbidden: 'Sua conta não tem permissão para abrir esta campanha. Peça a um administrador o acesso de admin da Agency.',
			editCampaign: 'Editar Campanha',
			viewPressRelease: 'Ver Press Release',
			newPressRelease: 'Novo Press Release',
			newPressReleaseTitle: 'Título do novo press release',
			newPressReleaseHint: 'Este release será criado e vinculado à mesma campanha do pedido atual.',
			prDate: 'Data',
			prSent: 'Enviados',
			prFollowup: 'Follow-up',
			prOpens: 'Aberturas',
			prClicks: 'Cliques',
			prScheduled: 'Agendado',
			prNotSent: 'Ainda não enviado',
			budget: 'Orçamento Total',
			campaigns: 'Campanhas',
			newCampaign: 'Nova Campanha',
			assembleInBudgetBuilder: 'Montar no Budget Builder',
			markup: 'Markup',
			contracts: 'Contratos',
			noContracts: 'Nenhum contrato ainda.',
			copyLink: 'Copiar link',
			linkCopied: 'Link de assinatura copiado.',
			financials: 'Financeiro',
			creatorCost: 'Custo do Criador',
			clientValue: 'Valor Cliente',
			agencyFee: 'Taxa da Agência',
			margin: 'Margem',
			brief: 'Brief',
			period: 'Período da campanha',
			startsAt: 'Data de início',
			endsAt: 'Data de término',
			deadline: 'Prazo de entrega',
			briefing: 'Briefing',
			briefingHint: 'Descreva objetivos, público, jogos, entregáveis e restrições. A IA usa isso para sugerir segmentação e KPIs.',
			briefingRequired: 'Escreva um briefing primeiro.',
			analyzeWithAi: 'Analisar com IA',
			aiSuggested: 'Sugestões da IA aplicadas.',
			targeting: 'Segmentação',
			minFollowers: 'Mín. seguidores',
			objectives: 'Objetivos / KPIs',
			addObjective: 'Adicionar KPI',
			noObjectives: 'Nenhum objetivo definido.',
			kpi: 'KPI',
			target: 'Meta',
			items: 'Itens / Serviços',
			addItem: 'Adicionar item',
			generateProposal: 'Gerar proposta',
			results: 'Resultados',
			actual: 'Realizado',
			kind: {
				label: 'Tipo de campanha',
				hint: 'Define quais seções este relatório oferece.',
				influencer: 'Influenciador',
				press: 'Imprensa',
				keys: 'Distribuição de chaves',
				organic: 'Orgânica / interna',
				mixed: 'Mista (todas as seções)',
			},
			coverage: 'Cobertura',
			noCoverage: 'Sem cobertura ainda.',
			addCoverage: 'Adicionar cobertura',
			viewOnCommunity: 'Ver na Community',
			releaseTba: 'Data de lançamento a anunciar',
			publishedAt: 'Data de publicação',
			publishedAtHint: 'Quando a matéria saiu. É o que ordena o relatório do cliente.',
			pressKitAssociation: 'Press kit da campanha',
			pressKitAssociationHint: 'Escolha o item da campanha e vincule o press kit existente do jogo. Kits publicados aparecem no relatório do cliente.',
			campaignItem: 'Item da campanha',
			pressKit: 'Press kit',
			detach: 'Desvincular',
			coverageDeleted: 'Cobertura removida.',
			kpiNeedsCategory: 'Defina primeiro a categoria da campanha — a lista de KPIs vem dela.',
			noKpisForCategory: 'Nenhum KPI está vinculado a esta categoria de campanha ainda.',
			coverageTitle: 'Título',
			editCoverage: 'Editar cobertura',
			coverageOutlet: 'Veículo',
			coverageAuthor: 'Autor',
			coverageAuthorRole: 'Perfil do autor',
			coveragePlatform: 'Plataforma',
			coverageStatus: 'Status da revisão',
			coverageStatusHint: 'Só coberturas verificadas entram no relatório do cliente.',
			coverageRating: 'Nota',
			coverageRatingScale: 'Escala',
			coverageQuote: 'Citação',
			coverageAutoDetected: 'Detectada automaticamente',
			coverageLanguage: 'Idioma do conteúdo',
			coverageCountry: 'País do conteúdo',
			coverageLocaleMissing: 'Sem país/idioma — não entra na estatística',
			coverageStatCountries: '{count} país(es)',
			coverageStatLanguages: '{count} idioma(s)',
			coverageStatPending: '{count} sem país/idioma',
			coverageVerify: 'Verificar cobertura',
			coverageReject: 'Rejeitar cobertura',
			coverageDiscoverTitle: 'Busca automática de cobertura',
			coverageDiscoverHint: 'Procura no Google quem publicou sobre esta campanha e traz os links para você aprovar.',
			coverageDiscoverRun: 'Buscar agora',
			coverageDiscoverQueued: 'Busca iniciada. Os resultados aparecem aqui em alguns minutos.',
			coverageNoSuggestions: 'Nenhuma sugestão pendente.',
			coverageSuggestionApprove: 'Aprovar como cobertura',
			coverageSuggestionDismiss: 'Descartar sugestão',
			coverageTypes: {
				article: 'Matéria',
				video: 'Vídeo',
				stream: 'Live',
				review: 'Review',
				social_post: 'Post social',
				podcast: 'Podcast',
				other: 'Outro',
			},
			coverageStatuses: {
				pending_review: 'Aguardando revisão',
				verified: 'Verificada',
				rejected: 'Rejeitada',
			},
			authorRoles: {
				streamer: 'Streamer',
				journalist: 'Jornalista',
				influencer: 'Influenciador',
				other: 'Outro',
			},
			coverageMetrics: {
				views: 'visualizações',
				likes: 'curtidas',
				comments: 'comentários',
				shares: 'compartilhamentos',
				clicks: 'cliques',
				impressions: 'impressões',
			},
			attach: 'Anexar',
			pressReleases: 'Press Releases',
			attachPressRelease: 'Anexar press release existente',
			associatedResources: 'Recursos associados',
			associatedResourcesHint: 'Vincule os materiais existentes que pertencem a esta campanha. As configurações de broadcast permanecem na campanha de chaves.',
			associate: 'Associar',
			resourceAssociated: 'Recurso associado com sucesso.',
			noAssociatedResources: 'Nenhuma campanha de chaves ou banner associado ainda.',
			broadcast: 'Broadcast',
			resourceTypes: {
				pressRelease: 'Press release',
				keyCampaign: 'Campanha de chaves',
				banner: 'Banner',
				article: 'Artigo',
				push: 'Notificação push',
			},
			noPressReleases: 'Nenhum press release anexado ainda.',
			keyCampaigns: 'Campanhas de Chaves',
			attachKeyCampaign: 'Anexar campanha de chaves existente',
			noKeyCampaigns: 'Nenhuma campanha de chaves anexada ainda.',
			keyTotal: 'Total',
			keyRedeemed: 'Resgatadas',
			keyAvailable: 'Disponíveis',
			keyDispatch: 'Disparos',
			keyDispatchSent: 'Disparado',
			keyDispatchPending: 'Pendente',
			pushNotifications: 'Notificações Push',
			addPushNotification: 'Registrar notificação push',
			noPushNotifications: 'Nenhuma notificação push registrada ainda.',
			pushDate: 'Enviada em',
			pushTitle: 'Título do push',
			pushDescription: 'Descrição',
			thumbnail: 'Imagem de capa',
			pushReached: 'Alcance',
			pushOpened: 'Abertas',
			grandTotal: 'Total geral',
			proposalGenerated: 'Documento de proposta gerado.',
			proposalToken: 'Token da proposta',
			itemKind: 'Tipo',
			qty: 'Qtd',
			unitPrice: 'Preço unit.',
			noItems: 'Nenhum item ainda.',
			catalog: 'Catálogo (Produto/Bundle)',
			kinds: {
				product: 'Produto',
				bundle: 'Bundle',
				magazine: 'Revista',
				press_release: 'Press release',
				key_distribution: 'Distribuição de chaves',
				custom: 'Personalizado',
				ad: 'Anúncio',
			},
		},
		prospects: {
			title: 'Prospecção de Casting',
			subTitle: 'Descubra criadores externos e convide-os para o casting.',
			discover: 'Descobrir (Apify)',
			add: 'Adicionar prospect',
			editProspect: 'Editar prospect',
			size: 'Porte',
			invite: 'Convidar',
			sendInvite: 'Enviar convite',
			inviteSent: 'Convite enviado.',
			handles: 'Perfis',
			sourceUrl: 'URL de origem',
			platform: 'Plataforma',
			terms: 'Termos de busca',
			maxResults: 'Máx. resultados',
			platformRequired: 'Selecione ao menos uma plataforma.',
			termsRequired: 'Informe ao menos um termo de busca — YouTube/Twitch/TikTok/Instagram exigem isso para buscar.',
			tag: 'Tag / termo de busca',
			sendSelected: 'Enviar selecionados ({count})',
			selectAllFiltered: 'Selecionar todos os {count} resultados filtrados',
			selectedFiltered: '{count} prospects selecionados',
			followersByPlatform: 'Seguidores por plataforma',
			emailSignature: 'Assinatura',
			emailMergeTags: 'Tags disponíveis: {{nickname}}, {{handle}}, {{platform}}, {{content}}',
			bulkInviteResult: '{sent} convite(s) enviado(s), {failed} falharam.',
			bulkInviteResultsTitle: 'Resultado do envio',
			editEmail: 'Editar e-mail',
			discoverQueued: 'Descoberta iniciada em segundo plano — você será avisado quando terminar.',
			discoverBusy: 'Já existe uma descoberta em andamento. Aguarde terminar.',
			minFollowers: 'Mín. seguidores',
			addToRoster: 'Adicionar ao roster',
			addedToRoster: 'Adicionado ao roster.',
			alreadyInRoster: 'Já está no roster.',
			discoverHint: 'Requer configuração do Apify. Caso contrário, use entrada manual.',
			countryNote: 'YouTube e TikTok filtram por país/idioma diretamente (gl/hl/proxy). No Instagram/Twitch refinam a busca. Roda uma execução por vez para controlar o custo.',
			discovered: 'descobertos',
			apifyUsage: 'Consumo Apify',
			apifyNotConfigured: 'Apify não configurado',
			apifyActive: 'ativa',
			details: 'Detalhes',
			openProfile: 'Abrir perfil',
			followers: 'seguidores',
			discoveredVia: 'Descoberto via',
			notes: 'Notas',
			enrich: 'Achar redes',
			enriched: 'Redes enriquecidas.',
			findEmail: 'Localizar e-mail',
			emailFound: 'E-mail encontrado',
			emailNotFound: 'Nenhum e-mail encontrado.',
			emailLanguage: 'Idioma do e-mail',
			emailSubject: 'Assunto',
			emailBody: 'Mensagem',
			emailBodyHint: 'Deixe uma linha em branco entre parágrafos. O último parágrafo aparece em destaque, logo antes do botão.',
			emailPreview: 'Pré-visualização',
			email: 'E-mail',
			hasEmail: 'Com e-mail',
			noEmail: 'Sem e-mail',
			creatorType: 'Tipo',
			opens: 'Aberturas',
			firstOpenedAt: 'Aberto pela primeira vez em {date}',
			unsubscribed: 'Descadastrado — não pode mais ser convidado',
			funnel: {
				total: 'Prospects',
				invited: 'Convidados',
				opened: 'Abriram',
				clicked: 'Clicaram',
				registered: 'Cadastraram',
				bounced: 'Não chegou',
				unsubscribed: 'Descadastraram',
				openRate: 'Abertura',
				conversionRate: 'Conversão',
			},
			bulkInviteQueued: '{queued} convite(s) na fila, {skipped} ignorado(s). O envio é escalonado e continua mesmo se você sair da tela.',
		},

		paymentOrders: {
			title: 'Ordens de Pagamento',
			campaign: 'Campanha',
			influencer: 'Influenciador',
			amount: 'Valor',
			paidAt: 'Pago em',
			markPaid: 'Marcar como Pago',
			receipt: 'Comprovante (opcional)',
			confirm: 'Confirmar Pagamento',
		},
		showcaseImages: {
			cover: {
				label: 'Imagem de capa',
				hint: 'Banner opaco usado como fundo da página. JPEG serve aqui.',
			},
			logo: {
				label: 'Logo da edição',
				hint: 'PNG com transparência. Os cards de showcase do Visual Engine sobrepõem ele em fundo escuro, então fundo chapado vira um quadrado visível.',
			},
		},
		showcaseDeliverables: {
			reminders: {
				button: 'Lembrete de cadastro',
				title: 'Lembrete: criar conta para enviar materiais',
				desc: 'Inscrições pagas da edição ativa que ainda não têm conta vinculada na plataforma. O email leva o link para criar a conta e para a página de envio de material.',
				empty: 'Ninguém pendente: todos os pagos já têm conta ou entregaram.',
				email: 'Email',
				lastSent: 'Último envio',
				never: 'Nunca',
				cooldown: 'Aguardando intervalo',
				sendAll: 'Enviar para {count}',
				sent: '{sent} enviado(s), {skipped} aguardando intervalo, {failed} com falha.',
				error: 'Não foi possível concluir o envio.',
			},
			manual: {
				title: 'Enviar em nome do estúdio',
				desc: 'Para quem mandou o material por email ou não consegue entrar. O arquivo entra como entregue, o tempo do trailer é medido e, com os itens obrigatórios completos, a entrega é marcada como concluída.',
				file: 'Arquivo',
				link: 'Ou link do trailer',
				linkHint: 'WeTransfer, Drive etc. Um link não tem o tempo medido.',
				slot: 'Identificador (slot)',
				slotHint: 'Só letras minúsculas, números, - e _. Ex.: key_art, screenshot_1',
				send: 'Enviar',
				done: 'Material registrado como entregue.',
				error: 'Não foi possível enviar o material.',
			},
			tab: {
				downloadFolder: 'Pasta (ZIP)',
				downloadEdition: 'Baixar tudo (ZIP)',
				title: 'Materiais',
				desc: 'O que cada estúdio desta edição já entregou.',
				refresh: 'Atualizar',
				studio: 'Estúdio',
				files: 'Arquivos',
				socialReleased: 'Social liberado',
				open: 'Abrir',
				empty: 'Nenhum estúdio inscrito nesta edição ainda.',
				noGrant: 'A situação das entregas exige a concessão do módulo "showcase-production". Peça a um admin para conceder na tela de módulos.',
			},
			list: {
				title: 'Entregas por edição',
				desc: 'Quem já entregou o quê, e qual item obrigatório ainda está faltando.',
				delivered: 'Entregue',
				missing: 'Faltando',
				complete: 'Completo',
				partial: 'Parcial',
				nothing: 'Nada entregue',
				extended: 'Prazo estendido',
				manage: 'Gerenciar materiais',
			},
			detail: {
				title: 'Materiais do showcase',
				empty: 'Este estúdio ainda não entregou nada.',
				embargoWarning: 'Este jogo ainda não foi ao ar ({date}). Trate o trailer como embargado até lá.',
			},
			fields: {
				kind: 'Material',
				file: 'Arquivo',
				size: 'Tamanho',
				status: 'Situação',
				actions: 'Ações',
				reviewNotes: 'Por que precisa ser substituído?',
			},
			kinds: {
				trailer: 'Trailer',
				pre_showcase: 'Pré-showcase',
				post_showcase: 'Pós-showcase',
				press_kit: 'Press kit',
				questionnaire: 'Questionário',
			},
			status: {
				pending: 'Não iniciado',
				in_progress: 'Em andamento',
				ready_to_submit: 'Pronta para enviar',
				submitted: 'Entregue',
				approved: 'Aprovado',
				rejected: 'Precisa substituir',
				overdue: 'Atrasado',
			},
			actions: {
				download: 'Baixar',
				downloadAll: 'Baixar tudo ({count})',
				approve: 'Aprovar',
				reject: 'Recusar',
				cancel: 'Cancelar',
			},
			social: {
				title: 'Peças de rede social produzidas para este jogo',
				empty: 'Ainda não produzimos nada para este jogo.',
				draft: 'Rascunho',
				released: 'Liberado',
				releaseAll: 'Liberar {count} para o estúdio',
				releasedCount: '{count} liberado(s) para o estúdio.',
				releaseAllEdition: 'Liberar para todos os estúdios',
				releasedAllCount: '{released} asset(s) liberado(s), {notified} estúdio(s) notificado(s).',
			},
			publish: {
				title: 'Agendar e publicar',
				desc: 'O agendamento acontece no Visual Engine, onde ficam as contas de rede social e a fila de publicação.',
				openEngine: 'Abrir no Visual Engine',
				notConfigured: 'VUE_APP_VISUAL_ENGINE_URL não está configurada, então não dá para linkar o Visual Engine daqui.',
			},
			deadline: {
				title: 'Prazo de entrega',
				current: 'Atual',
				open: 'Aberto',
				closed: 'Encerrado',
				extendTo: 'Estender até',
				extend: 'Conceder prorrogação',
				extended: 'Prazo estendido.',
			},
			extension: {
				pending: 'Prorrogação solicitada',
				approved: 'Prorrogação concedida',
				rejected: 'Prorrogação recusada',
				reject: 'Recusar',
			},
			errors: {
				load: 'Não foi possível carregar os materiais deste estúdio.',
				review: 'Não foi possível salvar a revisão.',
				extend: 'Não foi possível estender o prazo.',
				release: 'Não foi possível liberar as peças.',
				downloadAll: 'Não foi possível gerar o zip. Tente novamente.',
			},
		},
		showcaseRundown: {
			tabTitle: 'Rundown',
			title: 'Ordem de exibição',
			desc: 'Arraste para definir a ordem em que a edição vai ao ar. O segmento de jogo puxa a duração do trailer entregue, então o total reflete o que os estúdios realmente mandaram.',
			addSegment: 'Adicionar segmento',
			editSegment: 'Editar segmento',
			totalRuntime: 'Minutagem total',
			segments: 'Segmentos',
			unknown: 'Sem duração',
			unknownSegments: '{count} sem duração',
			unknownWarning: 'Segmentos sem duração medida ou contratada não entram no total, e os horários de início depois deles deixam de ser confiáveis.',
			overContract: '{count} acima do contratado',
			empty: 'Nenhum segmento nesta ordem de exibição ainda.',
			notScheduled: '{count} participante(s) fora da ordem de exibição:',
			types: {
				game: 'Jogo',
				ad: 'Break de anunciante',
				intro: 'Abertura',
				outro: 'Encerramento',
				interstitial: 'Vinheta',
				media_partners: 'Media partners',
				team: 'Equipe',
				text: 'Bloco de texto',
			},
			fields: {
				segment: 'Segmento',
				type: 'Tipo',
				participant: 'Participante',
				sponsor: 'Anunciante',
				label: 'Rótulo',
				labelHint: 'Deixe vazio para usar o nome do jogo ou do anunciante.',
				duration: 'Duração',
				durationInput: 'Duração (m:ss)',
				durationHintGame: 'Deixe vazio para usar a duração do trailer entregue.',
				durationHintFixed: 'Informe a duração deste break ou vinheta.',
				startsAt: 'Começa em',
				notes: 'Observações',
				body: 'Texto / descrição do bloco',
				bodyHint: 'O que o editor precisa saber: roteiro de introdução, texto de conclusão, do que se trata o bloco.',
				links: 'Materiais (links)',
				linkTitle: 'Título',
				linkUrl: 'URL',
				addLink: 'Adicionar link',
			},
			source: {
				manual: 'informado manualmente',
				measured: 'do trailer',
				measuredOver: 'do trailer · contratado {contracted}',
				contracted: 'contratado',
			},
			packages: {
				title: 'Minutagem dos pacotes pagos',
				paid: 'Pagos: {count}',
				contracted: 'Contratado',
				delivered: 'Entregue',
				remaining: 'Falta entregar',
				trailersMissing: '{count} sem trailer',
				unknownPackage: '{count} sem pacote definido',
				tiers: { starter: 'Starter', pro: 'Pro', premium: 'Premium', ultimate: 'Ultimate' },
				table: {
					package: 'Pacote',
					trailer: 'Trailer',
					folder: 'Pasta',
				},
				downloadAllTrailers: 'Baixar todos os trailers (ZIP)',
				downloadAllFolders: 'Baixar todas as pastas (ZIP)',
				downloadFolder: 'Pasta (ZIP)',
				noSubmissions: 'Nenhuma inscrição paga nesta edição ainda.',
			},
			review: {
				title: 'Avaliação e checklist',
				desc: 'Assista aos trailers sem baixar, dê uma nota de qualidade para ajudar a ordenar e marque o que já entrou na edição.',
				game: 'Jogo',
				trailer: 'Trailer',
				rating: 'Qualidade',
				notes: 'Observação',
				inserted: 'Na edição',
				watch: 'Assistir',
				links: 'Links',
				steam: 'Steam',
				website: 'Site',
				presskit: 'Press kit',
				onlyTrailers: 'Só com trailer',
				onlyPending: 'Só pendentes',
				editorNote: 'Nota p/ editor',
				editorNotePlaceholder: 'Recado que o editor vê',
				notifyStudio: 'Avisar estúdio',
				studioNotified: 'Estúdio avisado por email.',
				filterLabel: 'Mostrar',
				searchLabel: 'Buscar jogo ou estúdio',
				filter: {
					withTrailer: 'Com trailer',
					toInsert: 'A inserir (trailer entregue, fora da edição)',
					inserted: 'Já na edição',
					noTrailer: 'Sem trailer',
					all: 'Todos',
				},
				status: {
					noTrailer: 'Sem trailer',
					received: 'Trailer recebido',
					inserted: 'Inserido',
				},
				summary: '{inserted} de {total} na edição',
				pendingInsert: '{count} a inserir',
				saved: 'Salvo.',
				saveError: 'Não foi possível salvar. Tente novamente.',
			},
			ai: {
				suggest: 'Sugerir ordem (IA)',
				title: 'Ordem sugerida pela IA',
				desc: 'É só uma sugestão: nada muda até você aplicar.',
				apply: 'Aplicar ordem',
				applied: 'Ordem aplicada.',
				notScheduled: '{count} jogo(s) sugerido(s) ainda não estão na ordem de exibição e foram ignorados.',
				notConfigured: 'A IA não está configurada (credencial Anthropic).',
				unavailable: 'Não foi possível gerar a sugestão agora. Tente novamente.',
			},
			editor: {
				sortBy: 'Ordenar por',
				sort: { rating: 'Avaliação', order: 'Ordem no show', updated: 'Última atualização', duration: 'Duração', studio: 'Jogo' },
				updated: 'Atualizado',
				new: 'Novo',
				staleInserted: 'Atualizado após inserir',
				overPackage: '+{seconds}s',
				materials: 'Materiais',
				preShowcase: 'Pré-showcase',
				downloadPreShowcase: 'Baixar pré-showcase (ZIP)',
				downloadAllPreShowcase: 'Baixar todos os pré-showcase (ZIP)',
				downloadLogo: 'Baixar logo',
				noLogoConsent: 'Sem autorização de logo',
				dragHint: 'Clique e arraste uma linha para definir a ordem no ar.',
				dragEmptyHint: 'Antes de arrastar, adicione os jogos pagos ao show.',
				addPaid: 'Adicionar jogos pagos ao show',
				addBlock: 'Adicionar bloco',
				editBlock: 'Editar bloco',
				deleteConfirm: 'Remover este bloco do show?',
			},
			addPaid: {
				button: 'Adicionar jogos pagos',
				done: '{count} jogo(s) adicionado(s) à ordem.',
			},
			mail: {
				button: 'Enviar ao editor',
				title: 'Enviar resumo ao editor',
				desc: 'Email com o link da página do editor e o estado da edição: entregues, pendentes, sem trailer e acima do pacote.',
				emails: 'Emails do editor',
				emailsHint: 'Separe vários com vírgula.',
				locale: 'Idioma do email',
				message: 'Mensagem (opcional)',
				send: 'Enviar',
				sent: 'Email enviado para {count} endereço(s).',
				error: 'Não foi possível enviar o email.',
			},
			share: {
				title: 'Link do editor',
				copy: 'Copiar',
				copied: 'Link copiado.',
				rotate: 'Gerar novo link',
				rotated: 'Novo link gerado. O anterior deixou de funcionar.',
			},
			public: {
				noOrderYet: 'A ordem de exibição ainda não foi montada, então não há tempo total do show. O tempo dos trailers entregues está no resumo dos pacotes abaixo.',
				subtitle: 'Ordem de exibição',
				embargo: 'Esta edição ainda não foi ao ar. Trate todos os arquivos aqui como embargados.',
				invalid: 'Este link não é mais válido. Peça um novo para a equipe.',
				noTrailer: 'Trailer não entregue',
				externalLink: 'Link externo',
				linkExpiry: 'Os links de download têm validade curta. Recarregue a página se algum parar de funcionar.',
			},
			errors: {
				load: 'Não foi possível carregar a ordem de exibição.',
				reorder: 'Não foi possível salvar a nova ordem.',
				save: 'Não foi possível salvar o segmento.',
			},
		},
		showcaseMediaPartnerApplication: {
			detail: {
				title: 'Aplicação de Media Partner #{id}',
			},
			tabs: {
				contact: 'Contato',
				profile: 'Perfil',
				preferences: 'Preferências',
				authorizations: 'Autorizações',
				coverages: 'Coberturas ({count})',
			},
			actions: {
				approve: 'Aprovar',
				reject: 'Rejeitar',
				cancel: 'Cancelar',
				saveChanges: 'Salvar alterações',
				downloadLogo: 'Baixar logo',
				bulkApprove: 'Aprovar Selecionados',
				bulkReject: 'Rejeitar Selecionados',
				edit: 'Editar',
				cancelEdit: 'Cancelar Edição',
				addSocialNetwork: 'Adicionar',
				addPortfolio: 'Adicionar',
				releaseAllAssets: 'Liberar Assets para Todos os Parceiros',
			},
			bulkModal: {
				titleApprove: 'Aprovar Aplicações',
				titleReject: 'Rejeitar Aplicações',
				body: 'Você está prestes a alterar o status de {count} aplicação(ões). Tem certeza?',
			},
			dashboard: {
				title: 'Últimas Aplicações de Media Partner',
				viewAll: 'Ver Todas',
			},
			status: {
				pending: 'Pendente',
				approved: 'Aprovada',
				rejected: 'Rejeitada',
				withdrawn: 'Retirada',
			},
			applicantTypes: {
				journalist: 'Jornalista',
				outlet: 'Veículo',
				podcaster: 'Podcaster',
				streamer: 'Streamer',
				community_leader: 'Líder de Comunidade',
			},
			contentFormats: {
				written_articles: 'Artigos escritos',
				news_posts: 'Notícias',
				video: 'Vídeo',
				live_streams: 'Lives / Transmissões',
				podcast: 'Podcast',
				social_media: 'Redes Sociais',
			},
			fields: {
				types: 'Tipos',
				name: 'Nome',
				email: 'E-mail',
				phone: 'Telefone',
				country: 'País',
				communicationLanguage: 'Idioma de Comunicação',
				status: 'Status',
				coverages: 'Coberturas',
				outletChannel: 'Veículo / Canal',
				url: 'URL',
				publicLink: 'Link Público',
				avatar: 'Avatar',
				avatarHint: 'Ajuste o recorte aqui se a imagem enviada precisar de um enquadramento melhor.',
				returning: 'Retornando',
				applied: 'Aplicado em',
				languagesCovered: 'Idiomas que cobre',
				contentFormats: 'Formatos de Conteúdo',
				gameGenres: 'Gêneros de Interesse',
				mainPlatform: 'Plataforma Principal',
				coveragePlan: 'Plano de Cobertura',
				audienceSize: 'Tamanho de Audiência',
				pitch: 'Pitch',
				platform: 'Plataforma',
				followers: 'Seguidores',
				label: 'Rótulo',
				receivesPressReleases: 'Recebe Press Releases',
				openForInterviews: 'Aberto a Entrevistas',
				acceptsReviewKeys: 'Aceita Chaves para Review',
				keyPlatforms: 'Plataformas das Chaves',
				interviewPreference: 'Preferência de Entrevista',
				interviewFormat: 'Formato de Entrevista',
				allowPublicListing: 'Permitir Listagem Pública',
				authorizationEcosystem: 'Autorizar Perfil no Ecossistema',
				openForProposals: 'Aberto a Propostas',
				broadcastLogoConsent: 'Consentimento de Logo na Transmissão',
				adminNotes: 'Notas Internas',
			},
			sections: {
				socialNetworks: 'Redes Sociais',
				portfolio: 'Portfólio',
			},
			empty: {
				socialNetworks: 'Nenhuma rede social informada',
				portfolio: 'Nenhum link de portfólio informado',
			},
			coverages: {
				summary: '{count}/5 coberturas',
				logoEligible: 'Logo elegível',
				notEligible: 'Ainda não elegível',
				managedHint: 'As submissões de cobertura são gerenciadas na tela de Submissões de Cobertura.',
			},
			approveModal: {
				title: 'Aprovar Aplicação',
				body: 'Aprovar {name} como media partner? Isso vai criar um registro de ShowcaseMediaPartner e enviar e-mail de aprovação.',
			},
			rejectModal: {
				title: 'Rejeitar Aplicação',
				reasonLabel: 'Motivo da rejeição (enviado ao aplicante)',
			},
			deleteModal: {
				title: 'Excluir aplicação',
				body: 'Excluir a aplicação de media partner de {name}?',
				warning: 'Essa ação não pode ser desfeita.',
			},
			statusChangeModal: {
				titleApprove: 'Aprovar Aplicação',
				titleReject: 'Rejeitar Aplicação',
				body: 'Alterar o status da aplicação de {name}?',
			},
			common: {
				yes: 'Sim',
				no: 'Não',
				depends: 'Depende / Apenas relevante',
			},
			emailModal: {
				title: 'Enviar E-mail',
				description: 'Você está prestes a enviar um e-mail para {count} aplicante(s) selecionado(s).',
				variablesTitle: 'Variáveis disponíveis: ',
				variablesDescription: 'Use os placeholders abaixo para personalizar cada e-mail por destinatário.',
				subjectLabel: 'Assunto',
				bodyLabel: 'Corpo (HTML permitido)',
				signatureLabel: 'Assinatura',
				editor: 'Editor',
				preview: 'Pré-visualização',
				previewEmpty: 'Digite o corpo para ver a pré-visualização...',
				send: 'Enviar',
				skipAppliedLabel: 'Não enviar para quem já se inscreveu em',
				skipAppliedHint: 'Cada endereço recebe uma só mensagem, mesmo que tenha se inscrito em várias edições.',
				result: '{count} e-mail(s) na fila de envio.',
				resultSkipped: 'Pulados: {duplicates} repetido(s), {applied} já inscrito(s), {noEmail} sem e-mail.',
			},
			duplicateModal: {
				button: 'Duplicar para Edição',
				title: 'Duplicar para Outra Edição',
				description: 'Copiar {count} aplicação(ões) selecionada(s) para outra edição do showcase como novas aplicações pendentes. Nenhum e-mail ou notificação é enviado, a menos que você marque a opção abaixo.',
				targetShowcase: 'Edição de destino',
				sendNotification: 'Notificar os aplicantes por e-mail de que foram transferidos',
				confirm: 'Duplicar',
				resultCreated: '{count} aplicação(ões) criada(s).',
				resultSkipped: ' {count} ignorada(s) (já existem na edição de destino).',
			},
			errors: {
				saveFailed: 'Falha ao salvar as alterações. Verifique o formulário e tente novamente.',
				releaseAllFailed: 'Não foi possível liberar os assets.',
				approveFailed: 'Falha ao aprovar a aplicação. Tente novamente.',
				rejectFailed: 'Falha ao rejeitar a aplicação. Tente novamente.',
			},
			releasedAllCount: '{released} asset(s) liberado(s), {notified} parceiro(s) notificado(s).',
			selectShowcaseToRelease: 'Selecione uma edição do showcase acima para liberar os assets.',
			stats: {
				total: 'Total de Aplicações',
				byType: 'Por Tipo',
				totalFollowers: 'Total de Seguidores',
			},
		},
		studioMessages: {
			tab: 'Mensagens',
			sendTitle: 'Enviar mensagem',
			historyTitle: 'Mensagens enviadas sobre esta campanha',
			empty: 'Nenhuma mensagem enviada ainda.',
			historyError: 'Não foi possível carregar as mensagens.',
			recipientsError: 'Não foi possível carregar quem pode receber esta mensagem.',
			audience: 'Enviar para',
			audienceClient: 'O cliente',
			audienceCreators: 'Todas as pessoas do elenco',
			audienceAll: 'Cliente e elenco',
			audienceRoster: 'Pessoas escolhidas',
			rosterPeople: 'Pessoas',
			pickPeople: 'Escolha ao menos uma pessoa',
			body: 'Mensagem',
			required: 'Obrigatório',
			channels: 'Canais',
			channelInApp: 'No app (web e mobile)',
			channelEmail: 'E-mail',
			channelPush: 'Notificação push',
			channel_in_app: 'No app',
			channel_email: 'E-mail',
			channel_push: 'Push',
			pickChannel: 'Escolha ao menos um canal',
			role_client: 'Cliente',
			role_creator: 'Elenco',
			kind_creator: 'criador',
			kind_journalist: 'jornalista',
			emailSent: 'e-mail enviado',
			sent: 'Mensagem enviada para {n} destinatário(s)',
			sendError: 'Não foi possível enviar a mensagem',
			noCampaign: 'Esta proposta não faz parte de uma campanha gerida',
		},
		proposalsModeration: {
			title: 'Propostas',
			subtitle: 'Gerencie propostas entre usuários e influenciadores',
			forceComplete: 'Forçar Conclusão',
			proposalTitle: 'Proposta: {title}',
			senderUser: 'Usuário Remetente',
			receiverInfluencer: 'Influenciador Destinatário',
			commissionRate: 'Taxa de Comissão',
			lastCounterAmount: 'Última Contraproposta',
			counterBy: 'por',
			paymentStatus: 'Status do Pagamento',
			paidAt: 'Pago em {date}',
			notPaid: 'Não pago (fora da plataforma)',
			invoiceId: 'ID da Fatura',
			commissionAmount: 'Valor da Comissão',
		},
		coverageSuggestions: {
			pending: 'pendente(s)',
			approveTitle: 'Aprovar Sugestão',
			approveHint: 'Selecione o idioma e o tipo de conteúdo para criar uma cobertura a partir de:',
			dismissTitle: 'Descartar Sugestão',
			dismissConfirm: 'Descartar "{title}"? Será marcado como descartado e excluído de resultados futuros.',
			dismissButton: 'Descartar',
		},
		reviewsModeration: {
			title: 'Moderação de Avaliações',
			subtitle: 'Gerencie e modere as avaliações dos usuários',
			searchByReviewerUserId: 'Buscar por ID do Usuário Avaliador',
		},
		journalists: {
			outlet: 'Veículo',
			websiteUrl: 'URL do Site',
			addUrl: 'adicionar url...',
			addRole: 'adicionar cargo...',
			emailBody: 'Corpo do E-mail',
			signature: 'Assinatura',
			copyEmail: 'Copiar E-mail',
			allContactsSelected: 'Todos os {count} contatos selecionados (todas as páginas)',
			import: {
				title: 'Importar Jornalistas',
				subtitle: 'Envie um arquivo CSV exportado do ClickUp para importar jornalistas para o banco de imprensa.',
				selectCsvFile: 'Selecionar arquivo CSV',
				resolved: 'Resolvido',
			},
		},
		influencers: {
			list: {
				title: 'Lista de Influenciadores mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Influenciadores cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Influenciador',
				subTitle: 'Influenciador',
			},
			update: {
				title: 'Editar Influenciador',
				subTitle: 'Influenciador',
			},
			delete: {
				title: 'O Influenciador foi deletado com sucesso.',
			},
			sendOnboarding: 'Enviar Email de Onboarding',
			onboardingSent: 'Email de onboarding enviado com sucesso.',
			onboardingError: 'Falha ao enviar o email de onboarding. Tente novamente.',
			sendProfileCompletionInvite: 'Enviar Link de Completar Perfil',
			profileCompletionInviteSent: 'Link de completar perfil enviado com sucesso.',
			profileCompletionInviteError: 'Falha ao enviar o link de completar perfil. Tente novamente.',
			profileCompletionAlreadyComplete: 'Este perfil já está completo — nada para enviar.',
			profileComplete: 'Perfil Completo',
			profileIncomplete: 'Perfil Incompleto',
			submittedBrands: 'Marcas enviadas pelo influencer',
			brandName: 'Marca',
			brandCampaignType: 'Tipo de campanha',
			favoriteGenres: 'Gêneros Favoritos',
			contentPlatforms: 'Plataformas de Conteúdo',
			engagementRatePerPlatform: 'Taxa de engajamento por plataforma',
			regionsCoverage: 'Regiões Cobertas',
			streamer: 'Streamer',
			tvChannel: 'Canal de TV',
			selectedGames: 'Jogos Selecionados',
			searchGamesByName: 'Buscar jogos por nome',
			avgViews: 'Média de visualizações',
			avgLikes: 'Média de curtidas',
			businessSignals: 'Sinais de Negócio',
			availableForCampaigns: 'Disponível para campanhas',
			acceptsProposals: 'Aceita propostas',
			participatedInCampaigns: 'Já participou de campanhas',
			hasStaff: 'Tem equipe de apoio',
			openForCollab: 'Aberto a colaborações',
			hasLogo: 'Tem logo/kit de marca',
			hasStaffNo: 'Não',
			hasStaffYes: 'Sim',
			hasStaffSearching: 'Buscando apoio',
			openForCollabNotAtMoment: 'No momento não',
			openForCollabFullyAvailable: 'Sim, totalmente disponível',
			openForCollabDependsOnProposal: 'Depende da proposta',
			openForCollabOneOff: 'Prefere campanhas pontuais',
			hasLogoNo: 'Não',
			hasLogoYes: 'Sim, pode enviar',
			hasLogoDeveloping: 'Ainda desenvolvendo',
			audienceReach: 'Audiência e Alcance',
			audienceProfile: 'Perfil de audiência',
			totalReach: 'Alcance total',
			avgViewsPerContent: 'Média de views por conteúdo',
			avgMonthlyViews: 'Média de views mensal',
			contactAvailability: 'Contato e Disponibilidade',
			contactType: 'Contato preferido',
			availabilityHours: 'Horários disponíveis',
			availabilityDays: 'Dias disponíveis',
			materials: 'Materiais',
			hasMediaKit: 'Já tem media kit próprio',
			mediaKitUrl: 'URL do media kit',
			observations: 'Observações',
			rateCards: 'Tabela de Preços',
			ratesPublic: 'Preços públicos (visível sem login)',
			addRateCard: 'Adicionar Preço',
			rateCardLabel: 'Rótulo',
			contentFormat: 'Formato de conteúdo',
			priceMin: 'Preço (mín)',
			priceMax: 'Preço (máx)',
			currency: 'Moeda',
			rateCardBundles: 'Pacotes',
			addBundle: 'Adicionar Pacote',
			bundleName: 'Nome do pacote',
			bundleDescription: 'Descrição',
			originalPrice: 'Preço original',
			bundlePrice: 'Preço do pacote',
			deliveryDays: 'Entrega (dias)',
			portfolioLinks: 'Links de Portfólio',
			addPortfolioLink: 'Adicionar Link',
			linkUrl: 'URL',
			linkLabel: 'Rótulo',
			review: {
				column: 'Revisão',
				all: 'Todos',
				pending: 'Pendente',
				approved: 'Aprovado',
				rejected: 'Rejeitado',
				approve: 'Aprovar',
				reject: 'Rejeitar',
				approvedMsg: 'Cadastro aprovado.',
				rejectedMsg: 'Cadastro rejeitado.',
				error: 'Falha ao atualizar o status de revisão. Tente novamente.',
			},
			officialCasting: {
				column: 'Casting Oficial',
				filterRequested: 'Solicitou Casting Oficial',
				official: 'Oficial',
				requested: 'Solicitou',
				approve: 'Aprovar',
				reject: 'Recusar',
				aliasLabel: 'E-mail @mundogamer.agency',
				approvedMsg: 'Creator marcado como Casting Oficial.',
				rejectedMsg: 'Solicitação de Casting Oficial recusada.',
				aliasSavedMsg: 'E-mail da agência salvo.',
				error: 'Falha ao atualizar o status de Casting Oficial. Tente novamente.',
				generateContract: 'Gerar Contrato',
				contractSentMsg: 'Contrato de representação gerado e enviado para assinatura.',
				contractError: 'Falha ao gerar o contrato. Verifique se o creator tem perfil fiscal completo.',
			},
			availability: {
				label: 'Disponibilidade',
				all: 'Todos',
				available: 'Disponível',
				unavailable: 'Indisponível',
				no_proposals: 'Sem propostas',
			},
			bulkDeleteConfirm: 'Tem certeza que deseja deletar {count} influenciador(es)? Esta ação não pode ser desfeita.',
			bulkDeleted: '{count} influenciador(es) deletado(s) com sucesso.',
			bulkUpdated: 'Atualizado com sucesso.',
			notFound: 'Não foi possível carregar este influenciador. O link pode estar desatualizado ou o registro não existe mais.',
			setActive: 'Ativar',
			setInactive: 'Desativar',
			setVisible: 'Tornar Visível',
			setHidden: 'Ocultar',
		},
		marketing: {
			highlights: {
				list: {
					title: 'Lista de Destaques mais recentes no Mundo Gamer Community',
					subTitle: 'Confira a lista de Destaques cadastrados na Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Destaque',
					subTitle: 'Preencha os campos abaixo para cadastrar um Destaque.',
				},
				update: {
					title: 'Editar Destaque',
				},
			},
			highlightBanners: {
				list: {
					title: 'Lista de Banners Rotativos mais recentes do Mundo Gamer Community App',
					subTitle: 'Confira a lista de Banners Rotativos cadastrados no aplicativo Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Banner Rotativo',
					subTitle: 'Preencha os campos abaixo para cadastrar um Banner Rotativo.',
				},
				update: {
					title: 'Editar Banner Rotativo',
					subTitle: 'Banner Rotativo',
				},
				delete: {
					title: 'O Banner Rotativo foi deletada com sucesso.',
				},
			},
			tvBanners: {
				list: {
					title: 'Lista de Banners da Mundo Gamer TV',
					subTitle: 'Confira a lista dos últimos Banners ADS cadastrados na Mundo Gamer TV.',
				},
				create: {
					title: 'Novo Modelo de Banner TV',
					subTitle: 'Preencha os campos abaixo para cadastrar um Banner TV.',
				},
				update: {
					title: 'Editar Modelo de Banner TV',
					subTitle: 'Modelo de Banner TV',
				},
				delete: {
					title: 'O Banner TV foi deletado com sucesso.',
				},
			},
			providers: {
				list: {
					title: 'Lista de Provedores mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Provedores cadastrados na Mundo Gamer Agency.',
				},
				create: {
					title: 'Novo Provedor',
					subTitle: 'Provedor',
				},
				update: {
					title: 'Editar Provedor',
				},
				delete: {
					title: 'O Provedor foi deletado com sucesso.',
				},
			},
			cases: {
				list: {
					title: 'Lista de Casos de marketing mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Casos de marketing cadastrados na Mundo Gamer Agency.',
				},
				create: {
					title: 'Novo Caso de marketing',
					subTitle: 'Caso de marketing',
				},
				update: {
					title: 'Editar Caso de marketing',
				},
				delete: {
					title: 'O Caso de marketing foi deletado com sucesso.',
				},
				resyncFromCampaign: 'Ressincronizar da campanha',
				resyncSuccess: 'Entregáveis, resultados, KPIs e materiais foram atualizados a partir da campanha.',
				resyncError: 'Não foi possível ressincronizar este case com a campanha.',
				form: {
					overview: 'Visão Geral',
					challenge: 'Desafio',
					strategy: 'Estratégia',
					ctaText: 'Texto do CTA',
					ctaUrl: 'URL do CTA',
					shortGoal: 'Objetivo Resumido',
					headlineMetrics: 'Métricas Principais',
					metricName: 'Nome da métrica',
					valueInt: 'Valor (inteiro)',
					valueText: 'Valor (texto)',
				},
			},
			campaigns: {
				list: {
					title: 'Lista de Campanhas mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Campanhas cadastradas na Mundo Gamer Agency.',
				},
				create: {
					title: 'Nova Campanha',
					subTitle: 'Campanha',
				},
				update: {
					title: 'Editar Campanha',
				},
				delete: {
					title: 'A Campanha foi deletada com sucesso.',
				},
			},
			presentations: {
				list: {
					title: 'Lista de Apresentações mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Apresentações cadastradas na Mundo Gamer Agency.',
				},
				create: {
					title: 'Nova Apresentação',
					subTitle: 'Apresentação',
				},
				update: {
					title: 'Editar Apresentação',
				},
				delete: {
					title: 'A Apresentação foi deletada com sucesso.',
				},
			},
		},
		pressRelease: {
			generate: {
				title: 'Gerador de Press Release',
				selectShowcase: 'Showcase (filtrar submissions)',
				selectSubmission: 'Submission',
				heroImageUrl: 'URL da Imagem Hero',
				generate: 'Gerar Press Release',
				regenerate: 'Regerar',
				saveAsTemplate: 'Salvar como Modelo',
				approve: 'Aprovar',
				back: 'Voltar',
				edit: 'Editar',
				newRelease: 'Novo',
				manageTemplates: 'Gerenciar Modelos',
				exportPdf: 'Exportar PDF',
				exportDocx: 'Exportar DOCX',
				translate: 'Traduzir',
				approved: 'Press Release aprovado.',
				translations: 'Traduções',
				templateSelector: 'Selecionar Modelo',
				newTemplate: 'Novo Modelo',
				useTemplate: 'Usar Modelo',
				cancel: 'Cancelar',
				save: 'Salvar',
				deleteTemplate: 'Excluir Modelo',
				deleteTemplateConfirm: 'Deseja excluir o modelo',
				delete: 'Excluir',
				templateName: 'Nome do modelo',
				defaultTemplate: 'Modelo Padrão',
				htmlTab: 'HTML',
				previewTab: 'Preview',
				nextReview: 'Próximo: Revisar dados',
				nextEdit: 'Próximo: Editar HTML',
				nextExport: 'Próximo: Exportar',
				nextDistribute: 'Próximo: Distribuir',
				stepSelect: 'Selecionar',
				stepReview: 'Revisar dados',
				stepEdit: 'Editar HTML',
				stepExport: 'Exportar',
				stepDistribute: 'Distribuir',
				distTitle: 'Selecione os contatos que receberão o press release.',
				distSubtitle: 'O envio será criado como campanha com rastreamento completo.',
				distAttachCampaign: 'Anexar a campanha existente (opcional)',
				distAttachCampaignHint: 'Deixe em branco para criar uma campanha nova. Selecione uma existente para anexar este envio a ela em vez de criar uma nova campanha órfã.',
				distSource: 'Fonte',
				distAll: 'Todos',
				distJournalists: 'Jornalistas',
				distInfluencers: 'Influenciadores',
				distUsers: 'Usuários',
				distNewsletter: 'Newsletter',
				distSearch: 'Buscar',
				distNewsletterTag: 'Tag Newsletter',
				distDelay: 'Intervalo entre envios',
				distSeconds: 'segundos',
				distMinute: 'minuto',
				distMinutes: 'minutos',
				distContactsSelected: 'contatos selecionados',
				distEachLang: 'Cada contato receberá no seu idioma',
				distSendTo: 'Enviar para {count} contatos',
				distNewPR: 'Novo Press Release',
				distCampaignCreated: 'Campanha #{id} criada! {count} contatos provisionados.',
				variables: {
					reviewHint: 'Revise e complemente os dados abaixo antes de gerar o email. Campos vazios ficarão em branco no resultado final.',
					gameTitle: 'Título do jogo',
					developerStudio: 'Desenvolvedor / Estúdio',
					studioCountry: 'País do estúdio',
					releaseDate: 'Data de lançamento',
					platforms: 'Plataformas',
					genres: 'Gêneros',
					heroImageUrl: 'URL da imagem hero',
					steamLink: 'Link Steam',
					trailerLink: 'Link Trailer / YouTube',
					pressKitLink: 'Link Press Kit',
					contactName: 'Nome do contato',
					gameDescription: 'Descrição do jogo',
					gameHighlights: 'Destaques do jogo (um por linha)',
					gameHighlightsPlaceholder: 'Destaque 1&#10;Destaque 2&#10;Destaque 3',
					studioDescription: 'Descrição do estúdio',
					mediaPartners: 'Media Partners',
					promotionalFocus: 'Foco promocional (opcional)',
					promotionalFocusPlaceholder: 'Ex: Destacar que o jogo ganhou prêmio no BIG Festival, ou que tem demo disponível na Steam Next Fest...',
					promotionalFocusHint: 'Se preenchido, a IA dará ênfase a este ponto no corpo do press release.',
					generateEmailButton: 'Gerar email (PT-BR)',
					regenerateThisLanguage: 'Regerar este idioma',
					pulseTitle: 'Título do Pulse',
				},
			},
			unsubscribeReasons: {
				title: 'Motivos de Cancelamento',
				hint: 'Mostrado ao destinatário depois que ele cancela a inscrição numa campanha de press release, como um complemento opcional — nunca uma barreira pro cancelamento em si.',
				new: 'Novo Motivo',
				editTitle: 'Editar Motivo',
				fieldLabel: 'Rótulo',
				fieldLabelHint: 'Texto canônico, exibido quando não existe tradução pro idioma do destinatário.',
				fieldSlug: 'Slug',
				fieldSortOrder: 'Ordem',
				translateTitle: 'Traduções',
				canonicalHint: 'Deixe um idioma em branco para usar o rótulo canônico acima.',
			},
			campaigns: {
				title: 'Campanhas de PR',
				new: 'Nova Campanha',
				fieldTitle: 'Título da Campanha',
				contentType: 'Tipo de Conteúdo',
				approvalRequired: 'Exigir Aprovação',
				deleteConfirm: 'Tem certeza que deseja excluir esta campanha?',
				sendApproval: 'Enviar para Aprovação',
				dispatch: 'Disparar Agora',
				sendPreview: 'Enviar E-mail de Teste',
				translations: 'Traduções',
				addTranslation: 'Gerar Tradução',
				noTranslations: 'Nenhuma tradução ainda. Gere uma para disparar.',
				audience: 'Audiência',
				buildAudience: 'Montar Audiência',
				includeMediaPartners: 'Media Partners',
				includeLogo: 'Incluir Logo',
				includeKeyOffer: 'CTA de Chave de Review',
				recipients: 'destinatários',
				scheduling: 'Agendamento',
				scheduledAt: 'Agendado para',
				sentOrScheduledAt: 'Enviado / Agendado em',
				embargoTitle: 'Embargo',
				embargoDate: 'Data de Embargo',
				embargoNote: 'Nota de Embargo',
				scheduleBtn: 'Salvar e Agendar',
				sendTiming: 'Quando enviar',
				sendTimingNow: 'Enviar agora',
				sendTimingSchedule: 'Agendar pra depois',
				scheduleNow: 'Agendar',
				scheduledConfirmTitle: 'Agendar esse release?',
				scheduledConfirmBody: 'Vai ser enviado automaticamente pra {count} destinatários no horário escolhido.',
				insights: 'Resultados',
				sent: 'Enviados',
				opened: 'Abertos',
				openedHint: 'Outlook/Hotmail subestima aberturas: esses clientes só carregam a imagem de rastreamento depois que o destinatário clica em "Baixar imagens", então aberturas reais lá muitas vezes não são registradas. Cliques são um sinal mais confiável para esses destinatários.',
				openRate: 'Taxa de Abertura',
				clicked: 'Cliques',
				coverages: 'Coberturas',
				briefing: 'Briefing',
				briefingLink: 'Link do Briefing',
				sendBriefingLink: 'Enviar Link de Briefing ao Estúdio',
				metrics: 'Métricas',
				leadsColumn: 'Leads',
				languagesColumn: 'Idiomas',
				dispatchNow: 'Disparar Agora',
				dispatchNowConfirmBody: 'Envia imediatamente, cancelando qualquer agendamento existente. Isso não pode ser desfeito.',
				metricSent: 'enviados',
				metricDelivered: 'entregues',
				metricOpens: 'aberturas',
				metricClicks: 'cliques',
				preview: 'Visualizar',
				copyEmail: 'Copiar e-mail',
				downloadReport: 'Baixar relatório',
				downloadReportFailed: 'Falha ao baixar o relatório.',
				copyCampaignId: 'Copiar ID da campanha',
				campaignIdCopied: 'ID da campanha copiado',
				tabDashboard: 'Painel',
				tabClicks: 'Cliques',
				tabRecipientBehaviour: 'Comportamento dos destinatários',
				deliveredRate: 'Taxa de Entrega',
				clickRate: 'Taxa de Clique',
				complained: 'Denúncias de spam',
				unsubscribedLabel: 'Descadastrados',
				visitedLinks: 'Links visitados',
				noLinksYet: 'Nenhum clique em link registrado ainda.',
				downloadClickReport: 'Baixar relatório de cliques',
				deviceBreakdown: 'Dispositivos',
				deviceDesktop: 'Desktop',
				deviceMobile: 'Celular',
				deviceTablet: 'Tablet',
				deviceUnknown: 'Desconhecido',
				deviceShareOfOpensHint: 'Participação nas aberturas, não nos destinatários — um cliente que bloqueia imagens remotas nunca dispara uma abertura e fica invisível aqui.',
				activityOverTime: 'Dinâmica da campanha ao longo do tempo',
				noActivityYet: 'Parece que ninguém interagiu com seu e-mail ainda.',
				refresh: 'Atualizar',
				generate: 'Gerar',
				tabContent: 'Conteúdo',
				tabAudience: 'Audiência',
				tabReview: 'Revisão e Agendamento',
				tabInsights: 'Métricas',
				subject: 'Assunto',
				heroImage: 'URL da Imagem de Destaque',
				uploadHeroImage: 'Enviar imagem de destaque',
				youtubeUrl: 'URL do YouTube',
				introText: 'Texto de Introdução',
				generateWithAi: 'Gerar com IA',
				generating: 'Gerando...',
				copyHtml: 'Copiar HTML',
				htmlCopied: 'HTML copiado para a área de transferência',
				copyHtmlFailed: 'Ainda não há conteúdo para copiar. Salve o corpo primeiro.',
				pasteRawHtml: 'Colar HTML puro',
				rawHtmlHint: 'Cole aqui o conteúdo do e-mail (não um documento completo — sem cabeçalho/rodapé próprios). Opcional: {{first_name}} / {{name}} são trocados pelo nome de cada destinatário (vazio se não souber o nome).',
				rawHtmlFooterWarning: 'O link de descadastro e o pixel de rastreio são sempre adicionados abaixo do seu conteúdo e não podem ser removidos (compliance). Não inclua seu próprio banner de cabeçalho ou rodapé neste HTML — o sistema já adiciona o padrão, e colar o seu vai aparecer duplicado.',
				rawToRichWarning: 'Trocar para o editor visual vai reformatar seu HTML colado e remover o que ele não entende (como blocos <style>) — isso não pode ser desfeito voltando pro modo raw. Continuar?',
				includeHeaderBanner: 'Incluir banner de cabeçalho padrão',
				plainMode: 'Texto puro (sem identidade visual)',
				plainModeHint: 'Remove logo, layout colorido e a caixa de CTA da press room — fica com cara de e-mail pessoal. O link de descadastro e o pixel de rastreio continuam no rodapé.',
				includeHeaderBannerHint: 'Mostra o cabeçalho padrão com o logo da Mundo Gamer Agency acima do conteúdo. Desative apenas se o HTML colado já incluir esse mesmo cabeçalho — senão ele aparece duplicado.',
				headerPlatform: 'Plataforma do cabeçalho',
				headerPlatformHint: 'De qual plataforma da MG Network vem o logo e nome exibidos no cabeçalho. O rodapé sempre mostra "Mundo Gamer Network".',
				aiModel: 'Modelo de IA',
				aiModelAuto: 'Automático (primeiro disponível)',
				dispatchMode: 'Modo de Disparo',
				dispatchSystem: 'Sistema (automático)',
				dispatchManual: 'Manual (n8n / ClickUp)',
				logHistoricalSend: 'Registrar Envio Histórico',
				importSent: 'Registrar Envio Histórico',
				importSentHint: 'Registre um press release que já foi enviado fora deste sistema — o HTML enviado fica salvo como prova, e os resultados podem ser preenchidos manualmente depois.',
				importHtmlContent: 'HTML enviado',
				importHtmlContentHint: 'Cole o HTML que foi realmente enviado — fica salvo como prova do envio e pode ser visto depois na prévia de tradução desta campanha.',
				saveAsDraft: 'Salvar como Rascunho',
				logAsSent: 'Registrar como Enviado',
				recipientsPaste: 'Colar destinatários',
				recipientsPasteHint: 'Um por linha: e-mail, nome opcional, origem opcional (ex: journalist@outlet.com, Jane Doe, journalist).',
				recipientsPasteSourceLabel: 'Origem',
				recipientsRecognized: '{count} destinatários reconhecidos.',
				manualResultsTitle: 'Resultados Manuais',
				manualResultsHint: 'Essa campanha foi registrada manualmente — não há rastreamento automático, então informe os números agregados à mão.',
				duplicate: 'Duplicar campanha',
				suggestSubjects: 'Sugerir assuntos',
				pickSubject: 'Clique em uma variação para usar como assunto:',
				collectiveNew: 'Novo Press Release Coletivo',
				collectiveNewHint: 'Selecione jogos de submissões ou briefings, confirme os dados e crie a campanha.',
				collectiveSelectGamesTitle: 'Projetos disponíveis',
				collectiveSelected: 'selecionados',
				collectiveFilterEdition: 'Filtrar por edição',
				collectiveFilterSource: 'Origem',
				collectiveIncluded: 'Incluídos neste PR',
				collectiveNoneSelected: 'Nenhum projeto selecionado. Escolha à esquerda.',
				collectiveGameNotHere: 'Projeto não está na lista?',
				collectiveNewBriefing: 'Criar briefing',
				collectiveNewBriefingHint: 'Crie um briefing para qualquer projeto que não está no showcase. Você mesmo pode preencher os dados ou enviar um link para o criador preencher.',
				collectiveGameName: 'Projeto / nome do jogo',
				collectiveStudioName: 'Empresa / estúdio / criador',
				collectiveSendTo: 'E-mail do contato (opcional)',
				collectiveSendToHint: 'Se informado, um link de briefing será enviado para que ele preencha os dados.',
				collectiveCreateBriefing: 'Criar e preencher dados',
				collectiveRemove: 'Remover da seleção',
				collectiveAdd: 'Adicionar à seleção',
				studio: 'Empresa / Estúdio',
				genres: 'Gêneros',
				platforms: 'Plataformas',
				releaseDate: 'Data de lançamento / estreia',
				developerQuote: 'Citação do criador',
				collectiveStep1: 'Escolher fonte',
				collectiveStep2: 'Selecionar jogos',
				collectiveStep3: 'Configurar campanha',
				collectiveChooseSource: 'Como deseja selecionar os jogos para este press release coletivo?',
				collectiveSourceShowcase: 'Submissões do showcase',
				collectiveSourceShowcaseHint: 'Escolha jogos de uma edição do showcase que já enviaram suas informações.',
				collectiveSourceBriefing: 'Briefings',
				collectiveSourceBriefingHint: 'Selecione briefings existentes para agrupar em um release coletivo.',
				collectiveSelectEdition: 'Selecione uma edição do showcase para carregar os jogos inscritos.',
				collectiveSelectBriefings: 'Busque e selecione os briefings a incluir.',
				collectiveCampaignSettings: 'Configure os detalhes da campanha.',
				collectiveCreate: 'Criar campanha coletiva',
				noGameName: '(projeto sem nome)',
				description: 'Descrição',
				highlights: 'Destaques principais',
				collectiveTitle: 'Press Release Coletivo',
				collectiveSetup: 'Configurar coletivo',
				collectiveEdit: 'Editar coletivo',
				collectiveType: 'Tipo de coletivo',
				collectiveMultiStudio: 'Seleção multi-studio',
				collectiveEdition: 'Edição completa (institucional)',
				collectiveEditionSelect: 'Edição do showcase',
				collectiveSelectGames: 'Selecionar jogos a incluir',
				collectiveSelectAll: 'Selecionar todos',
				collectiveDeselectAll: 'Desmarcar todos',
				collectiveGames: 'jogos selecionados',
				collectiveNone: 'Campanha individual (sem coletivo)',
				collectiveNoGames: 'Nenhum jogo aprovado encontrado para esta edição.',
				collectiveSaved: 'Configuração coletiva salva.',
				segments: 'Segmentos',
				segmentsHint: 'Ative cada fonte que você quer incluir. Use "Ver candidatos" dentro de uma fonte para ver e escolher manualmente quem recebe.',
				mediaPartnersHint: 'Parceiros de mídia aprovados vinculados a esta submissão do showcase.',
				mediaPartnersAllEditions: 'Todas as edições (reconvite: cada endereço recebe uma vez)',
				mediaPartnersExclude: 'Deixar de fora quem já se inscreveu em',
				mediaPartnersNeedsEdition: 'Esta campanha não tem jogo do Showcase: marque Todas as edições para incluir parceiros.',
				journalistsHint: 'Jornalistas cadastrados na plataforma que aceitaram receber press releases.',
				influencersHint: 'Criadores de conteúdo cadastrados e disponíveis para campanhas.',
				newsletterHint: 'Pessoas inscritas na newsletter da Mundo Gamer.',
				platformUsersHint: 'Usuários cadastrados na plataforma que consentiram receber comunicações de estúdios/publishers.',
				jobsCandidatesHint: 'Candidatos que preencheram o perfil profissional no Mundo Gamer Jobs.',
				streamersHint: 'Streamers da MGTV com aplicação aprovada.',
				showcaseStudiosHint: 'Estúdios que submeteram um jogo a uma edição do showcase — enviado pro contato que preencheu a submissão.',
				onlyApprovedHint: 'Ativado por padrão. Desative para incluir também jornalistas ainda pendentes de revisão — ou use "Ver candidatos" para ver todos, independente deste filtro.',
				mediaPartners: 'Parceiros de Mídia',
				journalists: 'Jornalistas',
				influencers: 'Influenciadores',
				newsletter: 'Newsletter',
				matchGenres: 'Combinar automaticamente por gênero do jogo',
				genres: 'Gêneros de Jogo',
				niches: 'Nichos',
				mediaTypes: 'Tipos de Mídia',
				audienceProfiles: 'Perfis de Audiência',
				reachRanges: 'Faixas de Alcance',
				onlyAvailableForCampaigns: 'Só influencers marcados "disponível para campanhas" (desmarcado = todos cadastrados)',
				languages: 'Idiomas',
				newsletterCategories: 'Categorias de Newsletter',
				platform: 'Plataforma',
				onlyApproved: 'Apenas com status de avaliação aprovado',
				onlyReviews: 'Apenas jornalistas que fazem reviews',
				onlyEmbargo: 'Apenas jornalistas que respeitam embargo',
				customEmails: 'E-mails Personalizados',
				customEmailsHint: 'Digite um e-mail e pressione enter',
				importRecipientsFile: 'Importar lista (CSV ou JSON)',
				importRecipientsFileHint: 'CSV com colunas "email" e "name", ou uma lista JSON com email e nome por destinatário. Soma aos e-mails personalizados acima, mantendo o nome pra personalização funcionar.',
				importRecipientsParsed: '{count} destinatários lidos do arquivo, prontos pra adicionar',
				importRecipientsEmpty: 'Nenhum e-mail válido encontrado nesse arquivo',
				importRecipientsReadError: 'Não foi possível ler o arquivo',
				importRecipientsParseError: 'Não foi possível processar esse arquivo',
				importRecipientsJsonShape: 'Esperado um array JSON ou um objeto com um array "recipients"',
				editRecipient: 'Editar destinatário',
				editRecipientError: 'Não foi possível salvar esse destinatário',
				viewCandidates: 'Ver candidatos',
				candidatesTitle: 'Candidatos',
				outlet: 'Veículo',
				candidatesFilterHint: '{filtered} correspondem aos seus filtros atuais, de {base} elegíveis no total. Afrouxe os filtros acima (ou selecione individualmente abaixo) para incluir mais.',
				candidatesNoneHint: 'Ainda ninguém é elegível para esta fonte — verifique o cadastro (ex.: jornalistas precisam ter "recebe press releases" ativado e e-mail profissional).',
				candidatesSelectedCount: '{selected} selecionados de {total} encontrados',
				clearSelection: 'Limpar seleção',
				loadCandidates: 'Carregar contatos',
				selectAllMatching: 'Selecionar todos ({count})',
				selectAllActiveSegments: 'Selecionar tudo dos segmentos ativos',
				selectAllActiveSegmentsDone: 'Todos os segmentos ativos foram carregados para a seleção',
				clearAllRecipients: 'Limpar todos os destinatários',
				clearAllRecipientsConfirm: 'Remover todos os {count} destinatários desta campanha? Isso não pode ser desfeito.',
				addSelectedN: 'Adicionar {n} selecionados',
				audienceSummary: 'Resumo da Audiência',
				audiencePreview: 'Prévia dos filtros',
				audiencePreviewHint: 'Atualiza automaticamente e não altera a campanha. Um mesmo e-mail pode aparecer em mais de uma fonte; os duplicados são removidos ao montar a audiência.',
				previewMatches: 'Correspondências potenciais',
				audienceSummaryHint: 'Destinatários já adicionados à campanha. Alterar filtros não remove contatos existentes.',
				deleteSelected: 'Excluir selecionados ({count})',
				deleteSelectedConfirm: 'Remover {count} destinatários selecionados desta campanha? Isso não pode ser desfeito.',
				totalUnique: 'Total Único',
				suppressed: 'Suprimidos',
				invalid: 'Inválidos',
				duplicatesSkipped: 'Duplicados Ignorados',
				suppressedSkipped: 'Suprimidos Ignorados',
				recipientsAdded: 'destinatários adicionados',
				addRecipient: 'Adicionar Destinatário',
				recipientEmail: 'E-mail do Destinatário',
				recipientName: 'Nome do Destinatário',
				filterBySource: 'Filtrar por Origem',
				searchByEmail: 'Buscar por e-mail ou nome',
				source: 'Origem',
				removeRecipient: 'Remover Destinatário',
				removeRecipientConfirm: 'Remover este destinatário da campanha?',
				readiness: 'Prontidão',
				hasContent: 'Possui conteúdo em inglês',
				hasRecipients: 'Possui ao menos um destinatário',
				isApproved: 'Aprovado (ou aprovação não exigida)',
				noBriefingLinked: 'Nenhum briefing vinculado a esta campanha.',
				aiFailed: 'A geração de conteúdo por IA falhou. Tente novamente.',
				contentGenerated: 'Conteúdo gerado com sucesso.',
				contentSaved: 'Conteúdo salvo.',
				dispatchDisabledHint: 'O envio exige conteúdo em inglês, ao menos um destinatário e status aprovado ou agendado.',
				sourceJournalist: 'Jornalista',
				sourceInfluencer: 'Influenciador',
				sourceMediaPartner: 'Parceiro de Mídia',
				sourceNewsletter: 'Newsletter',
				sourceCustom: 'Personalizado',
				tabBriefing: 'Briefing',
			briefingNoSubmission: 'Vincule uma submissão do showcase a esta campanha para enviar o briefing ao participante.',
			briefingContext: 'O briefing é um questionário opcional que coleta os detalhes do jogo (pitch, recursos, citações) para a IA redigir o release. Só é necessário quando você quer conteúdo gerado por IA a partir de um participante do showcase.',
			briefingGoContent: 'Escrever o conteúdo direto',
			resendBriefing: 'Reenviar Briefing',
			briefingHint: 'Veja os detalhes do briefing na aba',
			showcaseEdition: 'Edição do Showcase',
			requiredOutreachTemplate: 'Precisa já ter recebido',
			requiredOutreachTemplateHint: 'Só inclui prospects que já receberam este e-mail (ex. montar um follow-up a partir de um envio anterior)',
			excludedOutreachTemplate: 'Excluir se já recebeu',
			excludedOutreachTemplateHint: 'Remove quem já foi convidado por este template (ex. impedir que uma campanha recorrente reconvide os mesmos prospects)',
			alreadySentSkipped: '{count} contato(s) retidos — já receberam outro press release nos últimos {days} dias',
			addRecipientsTitle: 'Adicionar destinatários',
			addRecipientsHint: 'Para contatos encontrados ou importados depois que esta campanha saiu. Quem já está na lista mantém o status e não recebe de novo.',
			addRecipientsOpen: 'Escolher destinatários',
			pendingRecipients: '{count} destinatário(s) adicionados e ainda não enviados',
			sendPendingOnly: 'Enviar aos {count} pendentes',
			sendPendingTitle: 'Enviar aos destinatários pendentes',
			sendPendingBody: 'Isto envia apenas para os {count} destinatário(s) ainda pendentes. Quem já recebeu é pulado.',
			sendPendingConfirm: 'Enviar para {count}',
			onlyUncontacted: 'Somente criadores nunca contatados',
			onlyUncontactedHint: 'Pula quem já recebeu e-mail, inclusive contatos feitos fora da plataforma (importados do ClickUp)',
			releaseFrom: 'Lançado a partir de',
			releaseTo: 'Lançado até',
				showcaseSubmission: 'Submissão do Showcase',
				linkShowcaseHelp: 'Vincule um jogo do showcase para gerar o release automaticamente',
				body: 'Corpo',
				saveBody: 'Salvar Corpo',
				editTranslation: 'Editar Tradução',
				platformUsers: 'Usuários da Plataforma',
				profileTypes: 'Tipos de Perfil',
				countries: 'Países',
				consentNote: 'Apenas usuários que aceitaram receber comunicações de publishers/estúdios são incluídos (LGPD).',
				jobsCandidates: 'Candidatos de Vagas',
				streamers: 'Streamers',
				showcaseStudios: 'Estúdios do Showcase',
				onlyCompletedProfile: 'Apenas candidatos com perfil completo',
				sourceJobsCandidate: 'Candidato de Vaga',
				sourceStreamer: 'Streamer',
				sourceShowcaseStudio: 'Estúdio do Showcase',
				steamProspects: 'Prospects do Steam',
				steamProspectsHint: 'Leads de estúdios descobertos no catálogo da Steam para o funil de outreach de onboarding — não são contatos de imprensa.',
				sourceSteamProspect: 'Prospect do Steam',
				creatorProspects: 'Prospects de Creators',
				creatorProspectsHint: 'Criadores de conteúdo descobertos para outreach mas ainda não cadastrados na plataforma.',
				sourceCreatorProspect: 'Prospect de Creator',
				companyContacts: 'Contatos de Empresas',
				companyContactsHint: 'Agenda interna de BD, compartilhada entre verticais — as mesmas empresas podem ser contatadas para Imprensa, Jobs ou outro tipo de outreach, só trocando o canal.',
				sourceCompanyContact: 'Contato de Empresa',
				contactChannel: 'Canal de contato',
				contactChannelHint: 'Cai para o e-mail geral quando o canal escolhido está vazio para a empresa',
				contactChannel_general: 'Geral',
				contactChannel_pitch: 'Pitch',
				contactChannel_press: 'Imprensa',
				contactChannel_careers: 'Carreiras',
				steamProspectGame: 'Jogo',
				profileType_developer: 'Desenvolvedor',
				profileType_gamer: 'Jogador',
				profileType_journalist: 'Jornalista',
				profileType_streamer: 'Streamer',
				profileType_publisher: 'Publisher',
				profileType_investor: 'Investidor',
				profileType_student: 'Estudante',
				profileType_professional: 'Profissional',
				save: 'Salvar',
				tabResults: 'Resultados',
				resultStatus: 'Status de Entrega',
				searchRecipient: 'Buscar e-mail ou nome',
				exportCsv: 'Exportar CSV',
				email: 'E-mail',
				sentAt: 'Enviado em',
				openedAt: 'Aberto em',
				unsubscribedAt: 'Cancelado em',
				unsubscribeReason: 'Motivo do cancelamento',
				orderNumber: 'Pedido',
				recipientsChip: '{count} destinatários prontos',
				sendingChip: 'Enviando…',
				sentChip: 'Enviado para {count}',
				dispatchStuckChip: 'Disparo travado?',
				dispatchStuckTooltip: 'O envio foi pedido às {time}, mas a campanha nunca saiu de "approved" — o worker da fila pode estar fora do ar. Verifique o Horizon.',
				dispatchConfirmTitle: 'Confirmar disparo',
				dispatchConfirmBody: 'Você está prestes a enviar este press release para {count} destinatários. Isso não pode ser desfeito.',
				dispatchConfirmAction: 'Enviar para {count} agora',
				dispatchStartedToast: 'Disparo iniciado — enviando para {count} destinatários.',
				dispatchStartedBanner: 'Disparo iniciado para {count} destinatários. Acompanhe a entrega na aba Resultados.',
				status_pending: 'Pendente',
				status_sent: 'Enviado',
				status_delivered: 'Entregue',
				status_opened: 'Aberto',
				status_bounced: 'Devolvido',
				status_unsubscribed: 'Descadastrado',
				status_suppressed: 'Suprimido',
				status_failed: 'Falhou',
				status_cancelled: 'Cancelado',
				finalPreviewTitle: 'Preview Final',
				finalPreviewHint: 'Exatamente o que o destinatário vai receber — cabeçalho, rodapé, assinatura e pixel de rastreio incluídos. Use as setas para conferir cada idioma antes de enviar.',
				finalPreviewNoTranslations: 'Nenhuma tradução pronta ainda — gere ou escreva o conteúdo primeiro.',
				previewFrom: 'De',
				desktop: 'Desktop',
				mobile: 'Celular',
				senderAccount: 'Conta Remetente',
				senderAccountEmptyHint: 'Nenhuma caixa remetente configurada ainda — o envio vai usar o padrão da plataforma.',
				senderName: 'Assinado por (nome no De)',
				senderSignature: 'Assinatura do E-mail',
				delivered: 'Entregues',
				deliveredZeroHint: 'Mostrar 0 apesar de envios reais geralmente significa que o Configuration Set do AWS SES ainda não está publicando eventos de Delivery/Bounce/Complaint — só Enviados/Aberturas têm garantia de estarem corretos até isso ser ativado.',
				bounced: 'Devolvidos',
				followupTitle: 'Reenvio (follow-up para quem não abriu)',
				followupHint: 'Reenvia automaticamente o release para quem não abriu, com o conteúdo original, um novo assunto ou uma versão alternativa.',
				followupMode: 'Modo de reenvio',
				followupMode_none: 'Sem reenvio',
				followupMode_original: 'Conteúdo original',
				followupMode_subject: 'Apenas assunto novo',
				followupMode_variant: 'Versão alternativa (B)',
				followupDelay: 'Enviar após',
				followupManual: 'Manualmente',
				followupSubject: 'Assunto do reenvio',
				followupGenerateVariant: 'Gerar versão B com IA',
				followupSendNow: 'Reenviar agora para não-abridores',
				followupEligible: '{count} destinatários elegíveis',
				followupSentAt: 'Reenvio enviado',
				followupScheduledAt: 'Reenvio agendado',
				followupSubjectOptional: 'Novo assunto (opcional)',
				followupSubjectHint: 'Deixe em branco pra reenviar com o mesmo assunto e conteúdo.',
				spamScore: 'Score de Entregabilidade',
				spamScoreHint: 'Pré-check heurístico de conteúdo, remetente, SPF/DMARC e histórico de bounces. Ajuda a evitar problemas, mas não garante entrada na caixa de entrada.',
				spamWarn: 'Score baixo — revise os problemas antes de enviar',
				spamBlock: 'Score muito baixo — o disparo será bloqueado',
				spam_subject_missing: 'Assunto ausente',
				spam_subject_all_caps: 'Assunto quase todo em MAIÚSCULAS',
				spam_subject_excess_punctuation: 'Pontuação excessiva no assunto',
				spam_subject_too_long: 'Assunto muito longo',
				spam_content_empty: 'Conteúdo vazio',
				spam_spam_trigger_words: 'Contém palavras que disparam filtros de spam',
				spam_image_heavy_low_text: 'Muitas imagens e pouco texto',
				spam_too_many_links: 'Links em excesso',
				spam_url_shortener: 'Usa encurtador de URL',
				spam_html_too_heavy: 'HTML muito pesado',
				spam_images_missing_alt: 'Imagens sem texto alternativo',
				spam_unsubscribe_not_in_content: 'Link de descadastro vem do rodapé padrão',
				spam_sender_account_missing: 'Nenhuma conta remetente selecionada',
				spam_dmarc_missing: 'Domínio do remetente sem registro DMARC',
				spam_spf_missing: 'Domínio do remetente sem registro SPF',
				spam_high_historical_bounce_rate: 'Conta remetente com histórico alto de devoluções',
				publishPulse: 'Publicar como Pulse na Community',
				editContent: 'Editar conteúdo',
				editContentHint: 'Corrige um erro de texto no conteúdo já enviado — vale pra quem for adicionado depois, não pra quem já recebeu.',
				editContentWarning: 'Isso não reenvia pra quem já recebeu esta campanha, e não atualiza um Community Pulse já publicado. Só afeta destinatários adicionados a partir de agora.',
				opensOverTime: 'Aberturas ao longo do tempo',
				noEventsYet: 'Nenhum evento de e-mail registrado ainda.',
				coverageTitle: 'Cobertura gerada por este release',
				coverageType: 'Tipo',
				coveragePlatform: 'Plataforma',
				coverageOutlet: 'Veículo / Creator',
				coverageLanguage: 'Idioma',
				coverageCountry: 'País',
				coverageEditTitle: 'Editar cobertura',
				coverageReach: 'Alcance',
				coverageViews: 'Visualizações',
				coverageImpressions: 'Impressões',
				coverageLikes: 'Curtidas',
				coverageComments: 'Comentários',
				coverageShares: 'Compartilhamentos',
				coverageAdd: 'Adicionar cobertura',
				discoverTitle: 'Busca automática de cobertura',
				discoverHint: 'Procura no Google quem publicou sobre este release e traz os links para você aprovar.',
				discoverRun: 'Buscar agora',
				discoverQueued: 'Busca iniciada. Os resultados aparecem aqui em alguns minutos.',
				noSuggestions: 'Nenhuma sugestão pendente.',
				suggestionApprove: 'Aprovar como cobertura',
				suggestionDismiss: 'Descartar sugestão',
				verifyList: 'Verificar lista (duplicados e descadastros)',
				verifyResult: '{dups} duplicados, {supp} suprimidos e {invalid} inválidos removidos — {total} destinatários prontos.',
				verifyHint: 'Esta mesma verificação roda automaticamente logo antes de cada disparo e reenvio.',
			},
			blocks: {
				palette: 'Blocos',
				empty: 'Adicione blocos à esquerda para montar o e-mail.',
				modeBlocks: 'Blocos',
				modeHtml: 'HTML avançado',
				modeRich: 'Editor rich',
				livePreview: 'Preview ao vivo — exatamente o que o destinatário vai receber',
				previewDesktop: 'Desktop',
				previewMobile: 'Celular',
				previewExpand: 'Expandir preview',
				expand: 'Expandir',
				draftSavedAt: 'Rascunho salvo às {time}',
				text: 'Texto',
				author: 'Autor',
				label: 'Rótulo',
				linkOptional: 'Link (opcional)',
				imageUrl: 'URL da imagem',
				addImage: 'Adicionar imagem',
				removeImage: 'Remover imagem',
				uploadImage: 'Enviar imagem',
				browseLibrary: 'Ver imagens enviadas',
				libraryEmpty: 'Nenhuma imagem enviada para esta campanha ainda.',
				uploadFailed: 'Falha ao enviar a imagem.',
				unrecognizedType: 'Tipo de bloco não reconhecido: {type}',
				type_heading: 'Título',
				type_paragraph: 'Parágrafo',
				type_image: 'Imagem',
				type_button: 'Botão / CTA',
				type_youtube: 'YouTube',
				type_divider: 'Divisor',
				type_quote: 'Citação',
				type_assets: 'Assets / Screenshots',
			},
			briefings: {
				title: 'Briefings',
				send: 'Enviar Briefing',
				sendTitle: 'Enviar Briefing ao Participante',
				resend: 'Reenviar',
				resendConfirm: 'Reenviar o link do briefing ao participante? Um novo e-mail será enviado.',
				participant: 'Submissão do Participante',
				contactEmail: 'E-mail de Contato',
				contactName: 'Nome do Contato',
				templateType: 'Tipo de Template',
				game: 'Jogo / Contato',
				sentAt: 'Enviado',
				filledAt: 'Preenchido',
				status_pending: 'Pendente',
				status_sent: 'Enviado',
				status_filled: 'Preenchido',
				status_reviewed: 'Revisado',
				briefingLink: 'Link do Briefing',
				filledContent: 'Respostas do Participante',
				elevatorPitch: 'Elevator Pitch',
				originStory: 'História de Origem',
				keyFeatures: 'Funcionalidades Principais',
				gameplayInnovation: 'Inovação no Gameplay',
				targetAudience: 'Público-Alvo',
				comparableTitles: 'Títulos Comparáveis',
				developerQuote: 'Citação do Desenvolvedor',
				launchInfo: 'Data de Lançamento e Plataformas',
				links: 'Links',
				trailer: 'Trailer',
				demo: 'Demo',
				pressKit: 'Press Kit',
				additionalNotes: 'Notas Adicionais',
				awaitingFill: 'Aguardando o participante preencher este briefing.',
				markReviewed: 'Marcar como Revisado',
				createCampaign: 'Criar Campanha',
				createAndGenerate: 'Criar e gerar release',
				editBriefing: 'Editar briefing',
				editorialBrief: 'Briefing editorial do release',
				editorialBriefHint: 'Defina o jogo, o ângulo e os fatos que a IA deve respeitar. O release será montado a partir destas respostas e seguirá o padrão editorial existente.',
				gameName: 'Jogo',
				studioName: 'Estúdio',
				elevatorPitchHint: 'Explique o jogo em 1–2 frases, sem linguagem genérica.',
				editorialDirection: 'Ângulo / objetivo da pauta',
				editorialDirectionHint: 'Ex.: anunciar a demo, destacar a história do estúdio ou apresentar um diferencial de gameplay.',
				keyInsights: 'Fatos e insights obrigatórios',
				launchDate: 'Data de lançamento',
				platforms: 'Plataformas confirmadas',
				saveBriefing: 'Salvar briefing',
				briefingSaved: 'Briefing salvo.',
				generationFailed: 'A campanha foi criada, mas a geração automática falhou. Tente novamente na aba Conteúdo.',
				sendBatch: 'Enviar para edição',
				batchSelectHint: 'Selecione os estúdios para enviar o briefing:',
				selectAll: 'Selecionar todos',
				sendToSelected: 'Enviar para {n} estúdio(s)',
			},
			templates: {
				title: 'Modelos de Press Release',
				newTemplate: 'Novo Modelo',
				noCustomTemplates: 'Nenhum modelo personalizado criado ainda.',
				default: 'Padrão',
				inactive: 'Inativo',
				updatedAt: 'Atualizado em',
				createdAt: 'Criado em',
				deleteTemplate: 'Excluir Modelo',
				deleteConfirm: 'Deseja excluir o modelo',
				delete: 'Excluir',
				cancel: 'Cancelar',
				edit: 'Editar Modelo',
				new: 'Novo Modelo',
				name: 'Nome do modelo',
				category: 'Categoria',
				description: 'Descrição',
				thumbnailUrl: 'URL da miniatura',
				locale: 'Idioma',
				scope: 'Visibilidade',
				scopeGlobal: 'Global (todas as empresas)',
				scopeCompany: 'Uma empresa específica',
				sortOrder: 'Ordem',
				isDefault: 'Modelo padrão',
				isActive: 'Ativo',
				content: 'Conteúdo HTML — use {{placeholder}} para variáveis dinâmicas',
				back: 'Voltar',
				useDefault: 'Usar Modelo Padrão',
				save: 'Salvar',
				htmlTab: 'HTML',
				previewTab: 'Preview',
			},
			calendar: {
				today: 'Hoje',
				legendScheduled: 'Agendado',
				legendSent: 'Enviado',
				backToList: 'Voltar pra lista',
				dragHint: 'Arraste um release agendado pra outro dia pra reagendar. Releases já enviados e envios pausados/cancelados não podem ser arrastados.',
				rescheduled: '"{title}" reagendado pra {date}.',
				rescheduleFailed: 'Não deu pra reagendar — tenta de novo.',
				cancelledFromCalendar: 'Envio de "{title}" cancelado.',
				noSubject: 'Sem assunto definido',
				scheduledFor: 'Agendado para',
				sentAt: 'Enviado em',
				recipients: 'Destinatários',
				status: 'Status',
				viewCampaign: 'Ver campanha',
			},
			wizard: {
				step1Title: 'Modelo',
				step2Title: 'Gerar com IA',
				step3Title: 'Revisar e Editar',
				step4Title: 'Idiomas',
				step5Title: 'Audiência',
				step6Title: 'Enviar',
				continue: 'Continuar',
				advancedSettings: 'Configurações avançadas',
				contentSettings: 'Configurações de conteúdo',
				createHint: 'Dê um nome — o resto (modelo, conteúdo, idiomas, audiência) você configura nas próximas telas.',
				createAndContinue: 'Criar e continuar',
				templateHint: 'Escolha um ponto de partida para o e-mail, ou comece do zero.',
				blankTemplate: 'Em branco',
				blankTemplateHint: 'Comece com uma tela em branco e monte o e-mail do zero.',
				noTemplatesYet: 'Nenhum modelo ainda — comece do zero ou crie um em Gerenciar Modelos.',
				generateHint: 'Conte pra IA sobre o lançamento e ela escreve o primeiro rascunho. Você pode editar tudo depois.',
				productName: 'Nome do produto / jogo',
				writingLanguage: 'Escrevendo em',
				writingLanguageHint: 'Os outros idiomas são gerados A PARTIR deste no próximo passo.',
				subjectHint: 'Dica de assunto (opcional)',
				pitch: 'Pitch',
				pitchHint: 'Algumas frases descrevendo do que se trata.',
				highlights: 'Destaques (opcional)',
				highlightsHint: 'Digite um destaque e pressione enter para adicionar.',
				generateWithAi: 'Gerar com IA',
				generatingHint: 'Isso pode levar um tempinho — a IA está escrevendo seu press release.',
				aiGenerationFailed: 'A geração com IA falhou. Tente novamente, ou pule para escrever manualmente.',
				skipToManual: 'Pular e escrever manualmente',
				useRawHtml: 'Avançado: colar HTML bruto',
				mergeTagsTitle: 'Variáveis de personalização',
				mergeTagsHint: 'Use estes tokens exatamente assim no assunto ou no conteúdo. O primeiro nome usa underline. Variáveis desconhecidas não são substituídas.',
				mergeTagFirstName: '— primeiro nome do destinatário',
				mergeTagName: '— nome completo do destinatário',
				mergeTagDeveloper: '— alias do nome do destinatário',
				mergeTagGame: '— jogo associado ao destinatário',
				useBlockEditor: 'Voltar ao editor de blocos',
				languagesHint: 'Selecione os idiomas para gerar. O inglês já está pronto desde a etapa anterior.',
				langStatus_pending: 'Pendente',
				langStatus_generating: 'Gerando…',
				langStatus_ready: 'Pronto',
				langStatus_error: 'Falhou',
				generateTranslations: 'Gerar traduções',
				previewByLanguage: 'Prévia por idioma',
				previewUnavailable: 'Prévia indisponível para este idioma.',
				regenerate: 'Gerar novamente',
				editTranslation: 'Editar tradução',
				translateWithAi: 'Traduzir com IA',
				save: 'Salvar',
				translationFailed: 'Falha ao traduzir: {languages}. Tente de novo, ou edite manualmente.',
				translationSaved: 'Tradução salva.',
				translationSaveFailed: 'Não foi possível salvar a tradução.',
				audienceHint: 'Ative cada fonte, expanda para ajustar os filtros e selecionar destinatários, depois confirme para adicioná-los à campanha.',
				matches: 'correspondências',
				confirmAudience: 'Confirmar audiência',
				sendSummary: 'Pronto para enviar',
				languagesReady: 'Idiomas prontos',
				sendNotReady: 'É preciso ter pelo menos um idioma pronto e um destinatário antes de enviar.',
				sendTestToMe: 'Enviar teste pra mim',
				sendNow: 'Enviar agora',
				sendingTitle: 'Enviando…',
				sendingHint: 'Seu press release está sendo entregue. Esta página atualiza automaticamente.',
				dispatchPaused: 'Pausado',
				dispatchCancelled: 'Cancelado',
				pauseDispatch: 'Pausar',
				resumeDispatch: 'Retomar',
				cancelDispatch: 'Cancelar envio',
				cancelDispatchConfirm: 'Quem já recebeu continua tendo recebido. Todo mundo ainda pendente será marcado como cancelado e NÃO vai receber esse e-mail. Isso não pode ser desfeito.',
			},
			funnels: {
				title: 'Funis',
				new: 'Novo funil',
				fieldName: 'Nome',
				fieldDescription: 'Descrição',
				stepsColumn: 'Etapas',
				activeContactsColumn: 'Contatos ativos',
				stepsTab: 'Etapas',
				contactsTab: 'Contatos',
				noSteps: 'Nenhuma etapa ainda — adicione a primeira pra começar.',
				addStep: 'Adicionar etapa',
				configureContent: 'Configurar conteúdo',
				noSubjectYet: 'Sem assunto ainda',
				delayLabel: '{hours}h depois da etapa anterior',
				recipientsLabel: 'destinatários',
				pause: 'Pausar',
				resume: 'Retomar',
				firstStepHint: 'A primeira etapa usa a montagem de audiência normal ao abrir — sem atraso ou modo de repasse pra configurar aqui.',
				delayDaysLabel: 'Esperar (dias) depois da etapa anterior',
				delayDaysHint: 'Quanto tempo esperar depois que a etapa anterior for enviada antes desta disparar sozinha.',
				audienceModeLabel: 'Quem recebe essa etapa',
				audienceModeAllActive: 'Todo mundo ainda ativo',
				audienceModeAllActiveHint: 'Funil clássico — envia pra quem não foi excluído/cancelou inscrição, tenha aberto a etapa anterior ou não.',
				audienceModeNonOpeners: 'Só quem não abriu',
				audienceModeNonOpenersHint: 'Espelha o follow-up de uma etapa só — reenvia só pra quem recebeu mas não abriu a etapa anterior.',
				currentStepColumn: 'Etapa atual',
				excludedReasonColumn: 'Motivo da exclusão',
				exclude: 'Excluir',
				reactivate: 'Reativar',
				excludeReasonLabel: 'Motivo',
				reasonNegotiating: 'Em negociação',
				reasonClosedWon: 'Fechado — ganho',
				reasonClosedLost: 'Fechado — perdido',
				reasonManual: 'Outro (manual)',
			},
		},
		sponsorApplications: {
			list: {
				title: 'Inscrições de Patrocinadores',
				searchByCompanyOrContact: 'Buscar por empresa ou contato',
			},
			detail: {
				applicationTitle: 'Inscrição de Patrocinador #{id}',
				company: 'Empresa',
				website: 'Site',
				logo: 'Logo',
				downloadLogo: 'Baixar logo',
				contact: 'Contato',
				preShowcaseQuotas: 'Cotas Pré-Showcase',
				annualPartner: 'Parceiro Anual',
				editions: 'Edições',
				totalAmount: 'Valor Total',
				invoiceId: 'ID da Fatura',
				applied: 'Inscrito em',
				confirmed: 'Confirmado em',
				actionsTitle: 'Ações',
				markAsPaid: 'Marcar como Pago',
				confirmSponsorship: 'Confirmar Patrocínio',
				cancelApplication: 'Cancelar Inscrição',
				backToList: 'Voltar para a Lista',
				adminNotesTitle: 'Notas do Administrador',
				internalNotes: 'Notas internas',
				notesPlaceholder: 'Adicione notas sobre esta inscrição...',
				saveNotes: 'Salvar Notas',
			},
		},
		showcaseClaims: {
			title: 'Claims Vinculados',
			studio: 'Estúdio',
			method: 'Método de Claim',
			date: 'Data',
			grantedBy: 'Realizado por',
			grantManual: 'Grant Manual',
			empty: 'Nenhum claim vinculado ainda.',
			noEnrollment: 'Nenhum enrollment vinculado a esta aplicação.',
			grantDialogTitle: 'Grant Manual de Claim',
			grantDialogSelectStudio: 'Selecionar Estúdio',
			grantDialogConfirm: 'Confirmar Grant',
			grantSuccess: 'Claim concedido com sucesso',
			grantError: 'Falha ao conceder claim',
		},
		commercialAccounts: {
			board: {
				title: 'Quadro do Funil',
				subTitle: 'Onde está hoje cada conta que você já tocou. Arraste um cartão para mover; quem decide a próxima a abrir é a fila.',
				loadMore: 'Carregar mais',
				moved: 'Conta movida.',
				moveFailed: 'Não foi possível mover a conta.',
			},
			account: 'Conta',
			accountType: 'Tipo',
			band: 'Banda de capital',
			signals: 'Sinais',
			contact: 'Contato',
			priority: 'Prioridade',
			status: 'Status',
			titles: 'Títulos',
			employees: 'Funcionários',
			vacancies: 'Vagas abertas',
			correspondence: 'Contatos que já nos escrevem',
			noContact: 'Sem contato cadastrado',
			list: {
				title: 'Contas Comerciais',
				subTitle: 'Publishers, estúdios, agências e marcas, com os jogos consolidados sob a conta. É a conta que uma pessoa trabalha — não o jogo isolado.',
				search: 'Nome, domínio ou contato',
				todayQueue: 'Fila de hoje',
				conversion: 'Conversão',
				warmOnly: 'Já nos escrevem',
				hiringOnly: 'Contratando agora',
			},
			worklist: {
				title: 'Contas de Hoje',
				subTitle: 'A fila curta e ordenada de contas que valem uma conversa hoje. Contas sem verba plausível seguem no caminho self-serve em vez de consumir tempo de vendas.',
				allAccounts: 'Todas as contas',
				refresh: 'Atualizar',
				empty: 'Nada pendente hoje. As contas voltam para a fila após o período de espera, ou quando o próximo refresh encontrar sinais novos.',
				bestOffers: 'Melhores ofertas para esta conta',
				noOffers: 'Ainda sem recomendação de oferta — rode a geração de oportunidades para esta conta.',
				guaranteed: 'Garantido',
				outcome: 'O que aconteceu',
				followUpDays: 'Retomar em (dias)',
				record: 'Registrar',
				recorded: 'Conta atualizada e colocada em espera.',
				recordFailed: 'Não foi possível registrar o resultado.',
				needsClassification: 'Classificar',
			},
			conversion: {
				title: 'Relatório de Conversão',
				subTitle: 'Qual oferta realmente paga, e para que tipo de conta. Até isto existir, as conversões eram registradas e nunca lidas de volta, então os scores nunca podiam melhorar.',
				period: 'Período',
				allTime: 'Todo o período',
				last30: 'Últimos 30 dias',
				last90: 'Últimos 90 dias',
				last365: 'Últimos 12 meses',
				byBand: 'Por banda de capital',
				byOffer: 'Por oferta',
				offer: 'Oferta',
				recommended: 'Recomendadas',
				contacted: 'Contatadas',
				activated: 'Ativadas (grátis)',
				paid: 'Pagas',
				lost: 'Perdidas',
				paidRate: 'Taxa de pagamento',
				activationRate: 'Taxa de ativação',
				revenue: 'Receita',
				rateNote: 'As taxas são medidas sobre as contas efetivamente contatadas — uma recomendação em que ninguém agiu não diz nada sobre a oferta converter. O traço significa que ainda não há dado, o que não é a mesma coisa que 0%.',
			},
			bands: {
				enterprise: 'Enterprise',
				high: 'Alta',
				medium: 'Média',
				low: 'Baixa',
				none: 'Sem sinal',
			},
			types: {
				publisher: 'Publisher',
				studio: 'Estúdio',
				agency: 'Agência',
				brand: 'Marca',
				unknown: 'Não classificada',
			},
			contactKinds: {
				named: 'Pessoa nomeada',
				generic: 'Caixa compartilhada',
				none: 'Nenhum',
			},
			statuses: {
				discovered: 'Descoberta',
				queued: 'Na fila',
				contacted: 'Contatada',
				engaged: 'Em conversa',
				proposed: 'Proposta enviada',
				won: 'Ganha',
				lost: 'Perdida',
				not_eligible: 'Não elegível',
				do_not_contact: 'Não contatar',
			},
			reasons: {
				publisher_portfolio: 'Publisher com catálogo',
				portfolio_revenue: 'Cenário de receita do portfólio',
				large_headcount: 'Time grande',
				actively_hiring: 'Contratando agora',
				warm_correspondence: 'Já nos escreve',
				agency_domain: 'Agência de marketing/PR',
				declared_budget: 'Declarou verba',
				named_contact: 'Contato nomeado',
				generic_contact_only: 'Só caixa compartilhada',
				no_contact: 'Sem contato cadastrado',
				network_partner: 'Parceiro da rede',
			},
		},
		studioProspects: {
			list: {
				title: 'Prospectos Steam para Showcase',
				subTitle: 'Jogos upcoming descobertos via Steam. Sincronize e convide estúdios para participar do Showcase.',
				commercialTier: 'Nível comercial',
				releaseFrom: 'Lançamento de',
				releaseTo: 'Lançamento até',
			},
			card: {
				select: 'Selecionar',
				viewOnSteam: 'Ver na Steam',
				deleteProspect: 'Excluir prospecto',
				alreadySentStage: 'E-mail deste estágio já enviado',
				sendOutreach: 'Enviar contato',
				linkedToClickUp: 'Vinculado ao ClickUp',
				pushToClickUp: 'Enviar para o ClickUp',
				noEmail: 'sem e-mail',
				generateCommissionLink: 'Gerar link de encomenda de conteúdo',
			},
			board: {
				selectAllInColumn: 'Selecionar todos nesta coluna',
				newLeadsColumn: 'Novos Leads',
				confirmedColumn: 'Confirmados',
				rejectedColumn: 'Rejeitados',
				optedOutColumn: 'Descadastrados',
				optedOutHint: 'Prospectos que se descadastraram / pediram para não receber mais e-mails',
				alreadyEmailed: '{n} já contatados por e-mail',
				loadMore: 'Carregar mais',
				moreCount: '({count} a mais)',
				filterHasEmail: 'Com e-mail',
				filterNoEmail: 'Sem e-mail',
				sendOutreachTitle: 'Enviar Contato',
				emailTemplate: 'Modelo de E-mail',
				subjectPreview: 'Prévia do assunto:',
				sendToEmail: 'Enviar para o e-mail',
				senderIdentityHint: 'Identidade do remetente (opcional — usa central@mundogamer.agency / Mundo Gamer Agency por padrão)',
				fromName: 'Nome do remetente',
				fromEmail: 'E-mail do remetente',
				newProspectTitle: 'Novo prospecto',
				gameNameRequired: 'Nome do jogo *',
				developer: 'Desenvolvedor',
				headerImageUrl: 'URL da imagem do cabeçalho',
				startInColumn: 'Iniciar na coluna',
				newLeadsNoStage: 'Novos Leads (sem estágio)',
				createButton: 'Criar',
				account: 'Conta',
				offer: 'Oferta',
				fit: 'Fit',
				budget: 'Orçamento',
				revenue: 'Receita',
				templateColumn: 'Modelo',
				sentTo: 'Enviado para',
				by: 'Por',
				when: 'Quando',
			},
			opportunities: {
				column: 'Oportunidades',
				filter: 'Oportunidade',
				dialogTitle: 'Conversão da oportunidade',
				pipelineStatus: 'Status no funil',
				nextAction: 'Próxima ação',
				paidAmount: 'Valor pago',
				currency: 'Moeda',
				optionalIncentives: 'Incentivos opcionais de conversão',
				incentives: 'Incentivos',
				communityWarning: 'Podemos oferecer a titularidade da wiki e os caminhos de submissão. Publicação editorial, destaque no feed e avaliações positivas nunca são garantidos. Os usuários da comunidade publicam opiniões independentes segundo as regras da plataforma.',
				guaranteeNotice: 'Somente os entregáveis contratados são garantidos. Resultados de mercado nunca são prometidos.',
				save: 'Salvar conversão',
				saved: 'Oportunidade atualizada.',
				saveFailed: 'Não foi possível atualizar a oportunidade.',
			},
			offers: {
				onboarding: 'Onboarding',
				platform_free_plan: 'Plano grátis da plataforma',
				community_presence: 'Presença na comunidade',
				agency_basic_plan: 'Plano básico da agência',
				contact_database_setup: 'Montagem da base de contatos',
				marketing_planning: 'Planejamento de marketing',
				press_kit: 'Press kit',
				press_release: 'Press release',
				individual_game_launch: 'Lançamento de jogo individual',
				playtest_recruitment: 'Recrutamento para playtest',
				playtest_localization: 'Playtest de localização',
				key_campaign: 'Campanha de keys',
				creator_campaign: 'Campanha com criadores',
				multilingual_content: 'Conteúdo multilíngue',
				editorial_review: 'Análise editorial',
				youtube_trailer: 'Trailer no YouTube',
				showcase: 'Showcase',
				showcase_publisher_portfolio: 'Showcase — portfólio de publisher',
				showcase_marketing_agency_partnership: 'Showcase — parceria com agência',
				jobs: 'Vagas',
				ventures: 'Ventures',
				market_entry_latam: 'Entrada no mercado LATAM',
				market_entry_europe: 'Entrada no mercado europeu',
				publisher_portfolio: 'Portfólio de publisher',
			},
			opportunityStatuses: {
				recommended: 'Recomendada',
				review_required: 'Requer revisão',
				contacted: 'Contatado',
				interested: 'Interessado',
				proposed: 'Proposta enviada',
				accepted: 'Aceita',
				activated: 'Ativada (grátis)',
				paid: 'Paga',
				lost: 'Perdida',
				not_eligible: 'Não elegível',
			},
			review: {
				title: 'Prospectos em revisão',
				subTitle: 'Prospectos cujo contato foi pulado porque o endereço está malformado ou suprimido. Corrija o endereço para devolvê-los à fila diária ou descarte.',
				backToProspects: 'Prospectos',
				openButton: 'Em revisão',
				sourceReviewsButton: 'Revisão de fontes',
				reasonFilter: 'Motivo',
				reasons: { malformed_email: 'Endereço malformado', suppressed: 'Suprimido' },
				game: 'Jogo',
				email: 'Endereço atual',
				reason: 'Motivo',
				since: 'Em revisão desde',
				daysRepeated: 'Dias pulado',
				website: 'Site',
				actions: 'Ações',
				suppressionReason: 'Motivo da supressão: {reason}',
				editEmail: 'Corrigir endereço',
				newEmail: 'Novo endereço',
				emailHint: 'O prospecto volta para New Leads e entra na próxima rodada diária, dentro do limite diário. Nada é enviado agora.',
				save: 'Salvar e reenfileirar',
				discard: 'Descartar',
				discardTitle: 'Descartar este prospecto?',
				discardText: 'Ele deixa de ser enfileirado e de aparecer aqui. O registro é mantido.',
				cancel: 'Cancelar',
				saved: 'Endereço salvo. O prospecto voltou para a fila diária.',
				discarded: 'Prospecto descartado.',
				suppressedAddress: 'Este endereço está na lista de supressão.',
				failed: 'Não foi possível concluir a ação.',
				empty: 'Nenhum prospecto aguardando revisão.',
			},
			sourceReviews: {
				title: 'Revisão de fontes de oportunidade',
				subTitle: 'Resolva registros ambíguos de fornecedores antes que virem prospectos duplicados ou contato duplicado.',
				backToProspects: 'Prospectos',
				search: 'Jogo, desenvolvedora ou publisher',
				matchStatus: 'Status do casamento',
				supplier: 'Fornecedor',
				refresh: 'Atualizar',
				source: 'Fonte',
				game: 'Jogo / conta',
				release: 'Lançamento',
				identifiers: 'Identificadores',
				match: 'Casamento',
				actions: 'Ações',
				unknownDeveloper: 'Desenvolvedora desconhecida',
				unknown: 'Desconhecida',
				openSupplierPage: 'Abrir página do fornecedor',
				linkExisting: 'Vincular existente',
				createNew: 'Criar novo',
				dismiss: 'Descartar',
				linkDialogTitle: 'Vincular a um prospecto existente',
				searchProspect: 'Buscar prospecto canônico',
				confirmIdentityWarning: 'Confirme a loja, a desenvolvedora e a data de lançamento. Nome parecido sozinho não basta.',
				cancel: 'Cancelar',
				confirmLink: 'Confirmar vínculo',
				resolved: 'Revisão de fonte resolvida.',
				resolveFailed: 'Não foi possível resolver a fonte.',
				matchStatuses: {
					review_required: 'Requer revisão',
					matched: 'Casado',
					dismissed: 'Descartado',
					observed: 'Observado',
				},
				providers: {
					community_igdb: 'community.games / IGDB',
					steam: 'Steam via ITAD',
					community_publisher: 'Catálogos de publisher',
				},
			},
			commercialAccounts: {
				title: 'Prospectos de Patrocínio — Showcase e Revista',
				subTitle: 'Oportunidades de marca revisadas por humano. O valor do Showcase é o programa de oito semanas com criadores, parceiros de mídia e conteúdo — não uma promessa baseada no tamanho da audiência da live.',
				backToGames: 'Jogos',
				search: 'Empresa ou e-mail',
				accountType: 'Tipo de conta',
				property: 'Propriedade',
				status: 'Status',
				company: 'Empresa',
				type: 'Tipo',
				opportunity: 'Oportunidade',
				fit: 'Aderência',
				confidence: 'Confiança',
				noContactEmail: 'Sem e-mail de contato',
				updated: 'Oportunidade comercial atualizada.',
				updateFailed: 'Não foi possível atualizar a oportunidade.',
				offers: {
					showcase_sponsorship: 'Patrocínio do Showcase',
					magazine_sponsorship: 'Patrocínio da revista',
					showcase_marketing_agency_partnership: 'Parceria com agência de marketing',
				},
				accountTypes: {
					brand_or_company: 'Marca ou empresa',
					marketing_agency: 'Agência de marketing',
				},
			},
			gameName: 'Jogo',
			developer: 'Desenvolvedor',
			releaseDate: 'Data de Lançamento',
			status: 'Status',
			sync: 'Sincronizar Steam',
			syncDispatched: 'Sincronização iniciada — novos prospectos aparecerão em breve.',
			syncDaysAhead: 'Dias à frente (opcional)',
			syncToClickUp: 'Exportar para ClickUp',
			syncToClickUpDispatched: 'Exportação para General Studios disparada — os leads aparecerão no ClickUp em breve.',
			onlyNotSynced: 'Não exportados',
			clickupSynced: 'Sincronizado no ClickUp General Studios',
			clickupNotSynced: 'Ainda não exportado para o ClickUp',
			invite: 'Convidar',
			inviteSent: 'Convite enviado com sucesso.',
			inviteSelected: 'Convidar selecionados ({n})',
			markConfirmed: 'Confirmar',
			markRejected: 'Não convidar',
			onlyWithEmail: 'Somente com e-mail',
			onlyNeverEmailed: 'Nunca contatado',
			sendAllMatching: 'Enviar para todos que batem o filtro ({n})',
			progress: {
				title: 'Enviando convites...',
				sending: 'Enviando, aguarde...',
				done: 'Concluído! {sent} de {total} convites enviados.',
				failedCount: '{n} não puderam ser enviados:',
				genericError: 'Falha ao enviar.',
			},
			releaseStatus: {
				filter: 'Status de lançamento',
				upcoming: 'Futuro / a definir',
				released: 'Já lançado',
				alreadyReleased: 'Já lançado',
				alreadyReleasedHint: 'Esse jogo já foi lançado — templates que prometem um lançamento futuro ficam bloqueados para ele.',
			},
			inviteDialog: {
				title: 'Enviar Convite para o Showcase',
				titleBulk: 'Enviar convite para {n} estúdios',
				from: 'De',
				to: 'Para (e-mail)',
				subject: 'Assunto',
				coupon: 'Cupom de Desconto (opcional)',
				couponHint: 'Deixe em branco para enviar sem cupom',
				discountPercent: '% de Desconto (opcional)',
				preview: 'Visualizar e-mail',
				sendBulk: 'Enviar para {n} estúdios',
			},
			statuses: {
				pending: 'Pendente',
				invited: 'Convidado',
				confirmed: 'Confirmado',
				rejected: 'Recusado',
			},
			sendEmail: 'Enviar E-mail',
			sendSelected: 'Enviar E-mail para {n} selecionados',
			generateInvites: 'Gerar convites ({n})',
			generateInvitesResult: '{created} criados, {reused} reaproveitados, {skipped} pulados',
			generateInvitesError: 'Falha ao gerar convites de onboarding.',
			viewHistory: 'Histórico de contatos',
			sendDialog: {
				title: 'Enviar E-mail para Prospecto',
				titleBulk: 'Enviar E-mail para {n} prospectos',
				template: 'Template de E-mail',
				locale: 'Idioma',
				fromHint: 'Identidade do remetente (opcional — padrão é central@mundogamer.agency / Mundo Gamer Agency)',
				fromName: 'Nome do remetente',
				fromEmail: 'E-mail do remetente',
				send: 'Enviar',
				sendBulk: 'Enviar para {n} prospectos',
			},
			filterSendDialog: {
				title: 'Enviar para {n} prospectos que batem o filtro',
				subtitle: 'Isso vai enfileirar o e-mail para todo mundo que corresponde aos filtros ativos na tela agora — não só o que está selecionado.',
				send: 'Enviar para {n}',
				queued: '{n} e-mail(s) enfileirado(s). Envio em segundo plano — atualize a lista para ver o progresso.',
				error: 'Falha ao enviar por filtro.',
			},
			history: {
				title: 'Histórico de Contatos',
				empty: 'Nenhum e-mail enviado para este prospecto ainda.',
			},
		},
		studioOnboarding: {
			generateLink: 'Gerar link de onboarding',
			inviteStatus: {
				pending: 'Pendente',
				opened: 'Aberto',
				submitted: 'Enviado',
				expired: 'Expirado',
				revoked: 'Revogado',
			},
			followups: {
				title: 'Funil de follow-up',
				subtitle: 'Em qual e-mail cada estúdio está, quem abriu, o que clicou e o que foi oferecido.',
				steps: {
					opening: 'Abertura · 1º e-mail',
					welcome: 'Dia 0 · Boas-vindas',
					value: 'Dia 1 · Por que importa',
					launch: 'Dia 3 · Oferta de lançamento',
					momentum: 'Dia 10 · Depois do hype',
				},
				controls: {
					title: 'Passos',
					on: 'Ligado: envia na próxima execução das 11:00',
					off: 'Desligado: nada é enviado',
					window: 'Estúdios de {from} a {to} dias após enviar',
					sentOnSubmit: 'Enviado quando o formulário é enviado',
					offer: 'Código: {percent}% de desconto, válido por {hours}h',
					reach: 'Alcançaria agora',
					preview: 'Ver quem',
					noTemplate: 'Este passo ainda não tem template',
					confirmOnTitle: 'Ligar {step}?',
					confirmOffTitle: 'Desligar {step}?',
					confirmOnBody: '{count} estúdio(s) estão na janela deste passo e receberão o e-mail na próxima execução diária (11:00).',
					confirmOffer: 'Cada um recebe um código pessoal de {percent}% válido por {hours} horas.',
					confirmOffBody: 'Os estúdios na janela deste passo deixam de receber. O que já foi enviado não é recolhido.',
					cancel: 'Cancelar',
					confirm: 'Confirmar',
					close: 'Fechar',
					previewTitle: 'Quem {step} alcançaria',
					age: 'Dias desde o envio',
				},
				pause: {
					action: 'Pausar follow-ups',
					resume: 'Retomar follow-ups',
					title: 'Pausar os follow-ups deste estúdio',
					body: 'Use quando o estúdio respondeu ou pediu para parar. Nada automático sai até você retomar.',
					reason: 'Motivo (opcional)',
				},
				filters: {
					lastStep: 'Está no e-mail',
					engagement: 'Engajamento',
					paused: 'Sequência',
					search: 'Buscar estúdio, jogo ou e-mail',
					form: 'Formulário',
					formOpened: 'Abriu o formulário',
					formNotOpened: 'Não abriu o formulário',
					formSubmitted: 'Enviou o formulário',
					opened: 'Abriu pelo menos um',
					neverOpened: 'Nunca abriu',
					clicked: 'Clicou em um link',
					pausedYes: 'Pausada',
					pausedNo: 'Rodando',
					awaitingForm: 'Aguardando o formulário',
				},
				summary: {
					studios: 'Estúdios na sequência',
					formOpened: 'Abriram o formulário',
					submitted: 'Enviaram',
					paused: 'Pausados',
					withAccount: 'Criaram conta',
					purchased: 'Compraram',
					sent: 'Enviados',
					openRate: 'Abertos',
					clickRate: 'Cliques',
					coupons: 'Códigos usados',
					conversion: 'Compraram com o código',
					revenue: 'Receita',
				},
				columns: {
					studio: 'Estúdio',
					current: 'Está no e-mail',
					opens: 'Aberturas',
					clicks: 'Cliques',
					account: 'Conta',
					purchased: 'Comprou',
					budget: 'Verba',
					interest: 'Investiria em',
					activity: 'Última atividade',
				},
				detail: {
					sentAt: 'Enviado',
					bought: 'Comprou',
					subject: 'Assunto',
					notSent: 'Ainda não enviado',
					firstOpen: 'Primeira abertura',
					lastOpen: 'Última abertura',
					neverOpened: 'Nunca abriu',
					clickedLinks: 'Links acessados',
					noClicks: 'Nenhum link acessado',
					code: 'Oferta',
					codeUsed: 'usado',
					codeExpired: 'expirado',
					codeActive: 'ativo',
					expires: 'expira',
					yes: 'Sim',
					no: 'Não',
					pausedWhy: 'Pausado',
					noAnswer: '—',
				},
			},
			submissionStatus: {
				submitted: 'Enviada',
				awaiting_activation: 'Aguardando Ativação',
				activated: 'Ativada',
				converted: 'Convertida',
				rejected: 'Rejeitada',
			},
			sources: {
				steam_prospect: 'Prospecto Steam',
				manual: 'Manual',
				referral: 'Indicação',
				event: 'Evento',
				self_serve: 'Autoatendimento',
			},
			filters: {
				status: 'Status',
				source: 'Origem',
				search: 'Buscar',
			},
			linkDialog: {
				title: 'Link de Onboarding',
				contact: 'Contato',
				link: 'Link',
				copy: 'Copiar link',
				copied: 'Link copiado para a área de transferência.',
				error: 'Não foi possível gerar o link de onboarding.',
			},
			commissionLinkDialog: {
				title: 'Link de Encomenda de Conteúdo',
				contact: 'Contato',
				link: 'Link',
				copy: 'Copiar link',
				copied: 'Link copiado para a área de transferência.',
				error: 'Não foi possível gerar o link de encomenda de conteúdo.',
			},
			invites: {
				title: 'Convites de Onboarding',
				subtitle: 'Convide estúdios para responder à entrevista de onboarding. Cada convite carrega seu próprio conjunto de perguntas e um link compartilhável.',
				new: 'Novo Convite',
				searchPlaceholder: 'E-mail, jogo ou estúdio…',
				table: {
					game: 'Jogo',
					contact: 'Contato',
					expiresAt: 'Expira em',
				},
				copyLink: 'Copiar link de onboarding',
				view: 'Ver detalhes',
				resend: 'Reenviar e-mail',
				revoke: 'Revogar',
				viewSubmission: 'Ver submissão',
				empty: 'Nenhum convite de onboarding encontrado.',
				createTitle: 'Novo Convite de Onboarding',
				form: {
					contactEmail: 'E-mail de Contato',
					gameName: 'Nome do Jogo',
					studioName: 'Nome do Estúdio',
					steamUrl: 'URL da Steam',
					steamAppId: 'Steam App ID',
					steamAppIdInvalid: 'Use apenas dígitos, de 1 a {max}.',
					locale: 'Idioma',
					expiresAt: 'Expira em',
					sendEmail: 'Enviar e-mail de convite agora',
					sendEmailHint: 'Se desativado, apenas o link é gerado — compartilhe manualmente.',
					createAndSend: 'Criar e Enviar',
					createOnly: 'Gerar Link',
				},
				openedAt: 'Aberto em',
				submittedAt: 'Enviado em',
				questionsTitle: 'Conjunto de Perguntas',
				editQuestions: 'Editar perguntas',
				questionsLocked: 'As perguntas só podem ser editadas enquanto o convite está pendente ou aberto.',
				noQuestions: 'Nenhuma pergunta neste convite.',
				addQuestion: 'Adicionar pergunta',
				revokeTitle: 'Revogar Convite',
				revokeMessage: 'Revogar o convite de onboarding de "{email}"? O link deixará de funcionar.',
				resendTitle: 'Reenviar Convite',
				resendMessage: 'Reenviar o e-mail de convite de onboarding para "{email}"?',
			},
			questions: {
				title: 'Perguntas de Onboarding',
				subtitle: 'Banco de perguntas usado para montar a entrevista de onboarding dos estúdios.',
				new: 'Nova Pergunta',
				empty: 'Nenhuma pergunta cadastrada ainda.',
				createTitle: 'Nova Pergunta',
				editTitle: 'Editar Pergunta',
				translate: 'Traduções',
				translateTitle: 'Traduções da Pergunta',
				deleteTitle: 'Excluir Pergunta',
				deleteMessage: 'Tem certeza de que deseja excluir esta pergunta?',
				categories: {
					editorial: 'Editorial',
					operational_extra: 'Operacional Extra',
				},
				inputTypes: {
					textarea: 'Texto longo',
					text: 'Texto curto',
				},
				table: {
					sortOrder: 'Ordem',
					text: 'Pergunta',
					category: 'Categoria',
					inputType: 'Tipo de Campo',
					isDefault: 'Padrão',
					isActive: 'Ativa',
				},
				form: {
					text: 'Pergunta (inglês)',
					textHint: 'Texto base em inglês. Adicione outros idiomas pela ação de traduções.',
					helperText: 'Texto de Apoio',
					category: 'Categoria',
					inputType: 'Tipo de Campo',
					sortOrder: 'Ordem',
					isDefault: 'Incluída por padrão',
					isActive: 'Ativa',
				},
			},
			submissions: {
				title: 'Submissões de Onboarding',
				subtitle: 'Entrevistas enviadas pelos estúdios através dos convites de onboarding.',
				view: 'Ver detalhes',
				empty: 'Nenhuma submissão encontrada.',
				wantsPaidReview: 'Quer análise paga',
				steamPage: 'Página na Steam',
				filters: {
					releaseStage: 'Estágio de Lançamento',
					wantsPaidReview: 'Análise Paga',
					marketingBudget: 'Budget de Marketing',
					investmentInterest: 'Interesse de investimento',
				},
				table: {
					submittedAt: 'Enviada em',
				},
				detail: {
					summary: 'Resumo',
					transcript: 'Transcrição da Entrevista',
					noAnswers: 'Nenhuma resposta registrada nesta submissão.',
					consents: 'Consentimentos',
					origin: 'Origem',
					invite: 'Convite',
					prospect: 'Prospecto',
					locale: 'Idioma',
					updatedAt: 'Atualizada em',
					selectedOfferings: 'Itens Pagos Selecionados',
					noSelectedOfferings: 'Nenhum item pago selecionado.',
					selectedOfferingsHint: 'Intenção de compra capturada na etapa "Monte seu Pacote". Confira a tela de Faturas pelo e-mail de contato para confirmar se isso foi pago de fato.',
					game: 'Jogo',
					studio: 'Estúdio',
					helpNeeded: 'Como a Mundo Gamer pode ajudar',
					keysAndPress: 'Keys e Imprensa',
					platforms: 'Plataformas',
					genres: 'Gêneros',
					targetAudience: 'Público-alvo',
					launchDate: 'Data de lançamento',
					launchWindow: 'Janela de lançamento',
					studioSize: 'Tamanho da equipe',
					foundedIn: 'Fundado em',
					studioStory: 'História do estúdio',
					website: 'Site',
					marketingBudget: 'Verba de marketing',
					investmentInterest: 'Onde investiria',
					keyCommitment: 'Fornece keys',
					keyCount: 'Keys estimadas',
					keyPlatforms: 'Plataformas das keys',
					pressKitUrl: 'Press kit',
					trailerUrl: 'Trailer',
					pressEmail: 'E-mail de imprensa',
					notAnswered: 'Não respondido',
					fulfillment: 'Entregáveis',
					fulfillmentDone: 'Concluído',
					fulfillmentPending: 'Pendente',
					fulfillmentAwaitingActivation: 'Aguardando ativação do estúdio',
					noFulfillment: 'Nenhum entregável se aplica a esta submissão.',
				},
				actions: {
					reject: 'Rejeitar',
					activateManually: 'Ativar Manualmente',
					cancel: 'Cancelar',
					rejectTitle: 'Rejeitar Submissão',
					rejectMessage: 'Isso marcará a submissão como rejeitada. Essa ação não pode ser desfeita por esta tela.',
					rejectReasonLabel: 'Motivo (opcional, nota interna)',
					rejectedAt: 'Rejeitada em {date}',
					activateTitle: 'Ativar Submissão Manualmente',
					activateMessage: 'Isso ativará a submissão em nome do estúdio e a converterá imediatamente em um pedido de campanha real — exatamente o mesmo resultado de quando o próprio estúdio se ativa. Requer uma conta na plataforma já cadastrada com o e-mail de contato ou de imprensa da submissão.',
				},
				enums: {
					releaseStage: {
						in_development: 'Em desenvolvimento',
						demo_available: 'Demo disponível',
						early_access: 'Acesso antecipado',
						released: 'Lançado',
						tba: 'A anunciar',
					},
					help: {
						article: 'Matéria editorial',
						review: 'Review do jogo',
						key_distribution: 'Distribuição de keys',
						press_kit: 'Press kit',
						community_presence: 'Presença na comunidade',
						consulting: 'Consultoria de marketing',
					},
					investment: {
						showcase: 'Showcase',
						article: 'Artigo',
						review: 'Review',
						press_release: 'Press release',
						creator_content: 'Live ou vídeo com criadores',
						key_distribution: 'Distribuição de keys',
						undecided: 'Não sabe, quer uma recomendação',
					},
					budget: {
						none: 'Ainda sem verba',
						'upto_50': 'Até 50',
						'50_150': '50 a 150',
						'150_300': '150 a 300',
						'300_600': '300 a 600',
						'600_1k': '600 a 1k',
						'over_1k': 'Acima de 1k',
						under_1k: 'Até 1k',
						'1k_5k': 'De 1k a 5k',
						'5k_20k': 'De 5k a 20k',
						over_20k: 'Acima de 20k',
					},
					keyCommitment: {
						yes_now: 'Sim, já disponíveis',
						yes_later: 'Sim, mais perto do lançamento',
						no: 'Não',
					},
			},
				},
			feedback: {
				loadError: 'Falha ao carregar os dados.',
				loadDetailError: 'Falha ao carregar os detalhes.',
				actionError: 'Ocorreu um erro. Tente novamente.',
				created: 'Convite criado. Compartilhe o link de onboarding.',
				createdAndSent: 'Convite criado e e-mail enviado.',
				questionsSaved: 'Perguntas do convite atualizadas.',
				revoked: 'Convite revogado.',
				resent: 'E-mail de convite enfileirado.',
				questionCreated: 'Pergunta criada com sucesso.',
				questionUpdated: 'Pergunta atualizada com sucesso.',
				questionDeleted: 'Pergunta excluída.',
				translationsSaved: 'Traduções salvas com sucesso.',
				translationsLoadError: 'Falha ao carregar as traduções.',
				rejected: 'Submissão rejeitada.',
				rejectError: 'Falha ao rejeitar a submissão.',
				activated: 'Submissão ativada manualmente.',
				activateError: 'Falha ao ativar a submissão.',
			},
		},
		showcase: {
			list: {
				title: 'Lista de Showcases mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Showcases cadastrados na Mundo Gamer Agency.',
				viewReport: 'Ver Relatório',
				mediaPartnerApplications: 'Inscrições de parceiros de mídia',
			},
			create: {
				title: 'Nova Vitrine',
				subTitle: 'Vitrine',
			},
			update: {
				title: 'Editar Vitrine',
			},
			delete: {
				title: 'A Vitrine foi deletada com sucesso.',
			},
			filterLabel: 'Showcase',
			report: {
				viewOnSteam: 'Ver na Steam',
				eventDetails: 'Detalhes do Evento',
				metric: 'Métrica',
				showcaseLive: 'Showcase Ao Vivo',
				coverageByPhase: 'Cobertura por Fase',
				byContentType: 'Por Tipo de Conteúdo',
				pressReleasesTitle: 'Press Releases',
				recipients: 'Destinatários',
				globalReach: 'Alcance Global',
				coverageBySource: 'Cobertura por Fonte',
				mediaPartnersTitle: 'Parceiros de Mídia',
				influencersTitle: 'Influenciadores',
				campaignName: 'Nome da Campanha',
				accessTier: 'Nível de Acesso',
				requiresApproval: 'Requer Aprovação',
				phase: 'Fase',
				liveDay: 'Dia Ao Vivo',
				partner: 'Parceiro',
			},
			form: {
				worldwide: 'Mundial',
				youtubeVideoId: 'ID do Vídeo do Youtube',
				year: 'Ano',
				maxSlots: 'Vagas máximas',
				steamEventUrl: 'URL do Evento Steam',
				steamStartDate: 'Data de Início na Steam',
				steamEndDate: 'Data de Término na Steam',
				steamEventViews: 'Visualizações do Evento Steam',
				steamEventImpressions: 'Impressões do Evento Steam',
				submissionStart: 'Início das Inscrições',
				submissionEnd: 'Fim das Inscrições',
				liveAt: 'Ao Vivo em',
				materialDeadline: 'Prazo de Materiais',
			},
			assetsFolder: 'Pasta de Assets de Cobertura',
			assetsFolderLabel: 'Nome da pasta (ex: "Assets Showcase 2026")',
			assetsFolderUrl: 'URL da pasta (Google Drive, Dropbox, etc.)',
			mediaPartnerApplications: 'Inscrições de parceiros de mídia',
			extraMeta: 'Metadados Extras',
			mediaType: 'Tipo de Mídia',
			tier: 'Nível',
			games: {
				list: {
					title: 'Lista de Jogos do Showcase mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Jogos do Showcase cadastrados na Mundo Gamer Agency.',
				},
				create: {
					title: 'Novo Jogo do Showcase',
					subTitle: 'Jogo do Showcase',
				},
				update: {
					title: 'Editar Jogo do Showcase',
				},
				delete: {
					title: 'O Jogo do Showcase foi deletado com sucesso.',
				},
			},
			studios: {
				list: {
					title: 'Lista de Studios do Showcase mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Studios do Showcase cadastrados na Mundo Gamer Agency.',
				},
				create: {
					title: 'Novo Studio do Showcase',
					subTitle: 'Studio do Showcase',
				},
				update: {
					title: 'Editar Studio do Showcase',
				},
				delete: {
					title: 'O Studio do Showcase foi deletado com sucesso.',
				},
			},
			influencers: {
				list: {
					title: 'Lista de Influencers do Showcase mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Influencers do Showcase cadastrados na Mundo Gamer Agency.',
				},
				create: {
					title: 'Novo Influencer do Showcase',
					subTitle: 'Influencer do Showcase',
				},
				update: {
					title: 'Editar Influencer do Showcase',
				},
				delete: {
					title: 'O Influencer do Showcase foi deletado com sucesso.',
				},
			},
			medias: {
				list: {
					title: 'Lista de Parceiros de Mídias do Showcase mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Parceiros de Mídias do Showcase cadastrados na Mundo Gamer Agency.',
				},
				create: {
					title: 'Novo Parceiro de Mídia do Showcase',
					subTitle: 'Parceiro de Mídia do Showcase',
				},
				update: {
					title: 'Editar Parceiro de Mídia do Showcase',
				},
				delete: {
					title: 'O Parceiro de Mídia do Showcase foi deletado com sucesso.',
				},
			},
			sponsors: {
				list: {
					title: 'Lista de Patrocinadores do Showcase mais recentes no Mundo Gamer Agency',
					subTitle: 'Confira a lista de Patrocinadores do Showcase cadastrados na Mundo Gamer Agency.',
				},
				create: {
					title: 'Novo Patrocinador do Showcase',
					subTitle: 'Patrocinador do Showcase',
				},
				update: {
					title: 'Editar Patrocinador do Showcase',
				},
				delete: {
					title: 'O Patrocinador do Showcase foi deletado com sucesso.',
				},
			},
		},
		submission: {
			list: {
				title: 'Lista de Inscrições da Vitrine mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Inscrições da Vitrine cadastradas na Mundo Gamer Agency.',
				aiDeclaration: 'Declaração de IA',
			},
			create: {
				title: 'Nova Inscrição',
				subTitle: 'Inscrição',
			},
			update: {
				title: 'Editar Inscrição',
			},
			delete: {
				title: 'A Inscrição foi deletada com sucesso.',
			},
			access: {
				viaPaid: 'Acesso liberado por pagamento (is_paid)',
				viaComplimentary: 'Acesso liberado por vaga cortesia',
				grantedManually: 'Acesso liberado manualmente pela equipe — pagamento ainda pendente',
				notGranted: 'Sem acesso ainda — clique para liberar manualmente enquanto o pagamento não credita',
			},
			linkUser: {
				column: 'Usuário vinculado',
				notLinked: 'Não vinculado',
				action: 'Vincular a um usuário',
				title: 'Vincular inscrição a um usuário',
				description: 'Use quando o vínculo automático por e-mail falhar (e-mail diferente entre compras, erro de digitação, etc.). Busque pelo nome ou e-mail da conta correta.',
				searchLabel: 'Nome ou e-mail',
				noResults: 'Nenhum usuário encontrado.',
				searchError: 'Falha ao buscar usuários. Tente novamente.',
				linkError: 'Falha ao vincular o usuário. Tente novamente.',
			},
			paymentEmailDialog: {
				title: 'Enviar e-mail de confirmação de pagamento?',
				message: 'O status de pagamento foi alterado para pago. Deseja enviar um e-mail de agradecimento para o contato cadastrado?',
				sent: 'E-mail de confirmação de pagamento enviado com sucesso!',
				error: 'Falha ao enviar o e-mail. Tente novamente.',
			},
			emailModal: {
				title: 'Escrever E-mail',
				description: 'Este e-mail será enviado para os {count} contatos selecionados.',
				variablesTitle: 'Variáveis disponíveis:',
				variablesDescription: 'Use no assunto ou corpo para personalizar por destinatário. O envio será individual quando variáveis forem detectadas.',
				varName: 'Nome do contato',
				varEmail: 'E-mail',
				varStudio: 'Estúdio',
				varGame: 'Jogo',
				subjectLabel: 'Assunto do E-mail',
				subjectPlaceholder: 'Ex: Olá {{name}}, atualização sobre o Showcase',
				editor: 'Editor',
				preview: 'Preview',
				bodyLabel: 'Corpo da Mensagem (aceita HTML)',
				bodyPlaceholder: '<p>Olá <strong>{{name}}</strong>,</p>',
				signatureLabel: 'Assinatura',
				previewEmpty: 'O preview aparecerá aqui...',
				send: 'Enviar',
			},
			tabs: {
				social: 'Social',
				consents: 'Consentimentos',
			},
			form: {
				materialStatus: 'Status do Material',
				websiteUrl: 'URL do Site',
				presskitUrl: 'URL do Presskit',
				buildLink: 'Link do Build',
				allowPublishMaterials: 'Autorizo a publicação de materiais promocionais',
				agreeEmailUpdates: 'Concordo em receber atualizações por e-mail',
				liabilityDisclaimerAccepted: 'Termo de responsabilidade aceito',
				aiContentDeclaration: 'Declaração de conteúdo por IA — Nenhum conteúdo gerado por IA nos materiais',
				aiContentDeclarationHelp: 'Este campo registra apenas a declaração atual sobre os materiais enviados; ele não substitui o futuro questionário de uso de IA no jogo.',
				aiUsageDisclosure: 'Questionário de uso de IA',
				aiRisk: 'Risco editorial',
				aiTools: 'Ferramentas/modelos',
				aiGuardrails: 'Salvaguardas',
				aiHumanReview: 'Revisão humana',
				aiRights: 'Direitos/licenças',
				aiRiskReasons: 'Motivos do risco',
				aiUnassessed: 'Esta inscrição ainda não possui questionário estruturado de IA; exige revisão manual.',
				materialAccuracyCommitment: 'Precisão do material — Compromisso com prazo e informações corretas',
				refundPolicyAccepted: 'Política de reembolso aceita',
			},
		},
		coverage: {
			list: {
				title: 'Lista de Coberturas da Vitrine mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Coberturas da Vitrine cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Cobertura',
				subTitle: 'Cobertura',
			},
			update: {
				title: 'Editar Cobertura',
			},
			delete: {
				title: 'A Cobertura foi deletada com sucesso.',
			},
			form: {
				link: 'Link',
				linkAvailable: 'Link disponível',
				officialTrailer: 'Trailer Oficial',
				sourceName: 'Nome da Fonte',
				sourceType: 'Tipo de Fonte',
			},
			bulkImport: {
				pasteHint: 'Cole uma URL por linha (máximo 50). Título, imagem, fonte e data são obtidos automaticamente.',
				urlsLabel: 'URLs',
				previewButton: 'Pré-visualizar URLs',
				selectShowcaseFirst: 'Selecione uma Vitrine primeiro',
				editRowsHint: 'Edite cada linha conforme necessário. Defina <strong>Idioma</strong> e <strong>Tipo de Conteúdo</strong> em cada item antes de importar. Imagem, Parceiro de Mídia e Jogo são opcionais.',
				tableImage: 'Imagem',
				tableUrl: 'URL',
				tableTitle: 'Título',
				tableSource: 'Fonte',
				tablePublishedOn: 'Publicado em',
				tableLanguage: 'Idioma *',
				tableContentType: 'Tipo de Conteúdo *',
				tableMediaPartner: 'Parceiro de Mídia',
				removeImage: 'Remover imagem',
				restoreImage: 'Restaurar imagem',
				selectPlaceholder: 'Selecionar',
				duplicate: 'Duplicado',
				error: 'Erro',
				incomplete: 'Incompleto',
				ok: 'OK',
				importSummary: '{created} criado(s), {skipped} ignorado(s) (duplicado).',
				startOver: 'Recomeçar',
				importSelected: 'Importar Selecionados ({count})',
				missingLanguageOrType: '{count} item(ns) sem Idioma ou Tipo de Conteúdo',
			},
		},
		coverageFeedSources: {
			entityName: 'Fonte de cobertura',
			add: 'Adicionar fonte',
			editTitle: 'Editar fonte',
			list: {
				title: 'Fontes de cobertura',
				subTitle: 'Feeds de veículos, canais do YouTube (criadores) e streamers da Twitch que o Monitor de Cobertura lê atrás de menções a jogos. Canais de criadores e streamers valem tanto quanto grandes portais.',
			},
			kind: 'Tipo',
			kinds: { outlet: 'Veículo', youtube: 'YouTube', twitch: 'Twitch' },
			origins: { manual: 'Manual', directory: 'Diretório', discovered: 'Descoberta' },
			results: { ok: 'OK', empty: 'Vazio', offline: 'Offline', unreachable: 'Inacessível' },
			result: 'Resultado',
			lastCheck: 'Última verificação',
			never: 'Nunca',
			paused: 'Pausadas',
			notes: 'Observações',
			nameOptional: 'Nome (opcional)',
			urlLabel: { youtube: 'Endereço do canal do YouTube', twitch: 'Login ou endereço da Twitch', outlet: 'Endereço do site' },
			urlPlaceholder: { youtube: 'https://www.youtube.com/@canal', twitch: 'login ou https://twitch.tv/login', outlet: 'https://site.com' },
			urlHint: {
				youtube: 'Use o endereço do canal: /@handle ou /channel/UC...',
				twitch: 'Apenas o login do streamer, ou o endereço twitch.tv.',
				outlet: 'Qualquer página do site; o feed é descoberto automaticamente.',
			},
			importDirectory: 'Importar do diretório',
			importResult: '{created} novas, {existing} já cadastradas',
			directoryDeleteHint: 'Fontes do diretório não podem ser apagadas. Pause-a em vez disso.',
			deleteConfirm: 'Apagar "{name}"?',
			deleted: 'Fonte apagada.',
			created: 'Fonte adicionada.',
			updated: 'Fonte atualizada.',
			test: {
				title: 'Testar fonte',
				running: 'Verificando a fonte...',
				ok: 'A fonte respondeu e tem conteúdo.',
				notOk: 'A fonte não devolveu conteúdo utilizável.',
				notLive: 'Fora do ar agora. É normal para um streamer que está offline.',
				empty: 'A fonte respondeu, mas não tem itens recentes.',
				action: 'Testar fonte',
				items: 'Itens encontrados',
				feedUrl: 'Endereço do feed',
				sample: 'Títulos de exemplo',
			},
		},
		coverageSourceTypes: {
			entityName: 'Tipo de Fonte de Cobertura',
			list: {
				title: 'Tipos de Fonte de Cobertura',
				subTitle: 'Gerencie as categorias de tipos de fonte de cobertura das vitrines.',
			},
		},
		coverageSubmissions: {
			title: 'Envios de Cobertura (Auto-relato)',
			searchByTitleOrLink: 'Buscar por título ou link',
			approveTitle: 'Aprovar Cobertura',
			approveConfirm: 'Aprovar "{title}"? Isso vai criar um registro real de Cobertura de Vitrine e notificar o parceiro de mídia por e-mail.',
			rejectTitle: 'Rejeitar Cobertura',
			rejectHint: 'O motivo será enviado ao parceiro de mídia por e-mail.',
			reasonOptional: 'Motivo (opcional)',
			detail: {
				link: 'Link',
				published: 'Publicado',
				contentType: 'Tipo de Conteúdo',
				submittedBy: 'Enviado por',
				backupMaterial: 'Material de Backup',
				screenshots: 'Capturas de Tela ({count})',
				submitterNotes: 'Notas do Remetente',
				adminNotes: 'Notas do Administrador',
			},
			statusPending: 'Pendente',
			statusApproved: 'Aprovado',
			statusRejected: 'Rejeitado',
			colApplicant: 'Solicitante',
			colExtras: 'Extras',
		},
		audiences: {
			list: {
				title: 'Lista de Público-alvo mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Público-alvo cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Público-alvo',
				subTitle: 'Público-alvo',
			},
			update: {
				title: 'Editar Público-alvo',
			},
			delete: {
				title: 'O Público-alvo foi deletado com sucesso.',
			},
		},
		brands: {
			list: {
				title: 'Lista de Marcas mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Marcas cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Marca',
				subTitle: 'Marca',
			},
			update: {
				title: 'Editar Marca',
			},
			delete: {
				title: 'A Marca foi deletada com sucesso.',
			},
			website: 'Site',
		},
		ranges: {
			list: {
				title: 'Lista de Faixas etárias mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Faixas etárias cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Faixa etária',
				subTitle: 'Faixa etária',
			},
			update: {
				title: 'Editar Faixa etária',
			},
			delete: {
				title: 'A Faixa etária foi deletada com sucesso.',
			},
		},
		adChannels: {
			list: {
				title: 'Lista de Canais de Anúncios mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Canais de Anúncios cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Canal de Anúncio',
				subTitle: 'Canal de Anúncio',
			},
			update: {
				title: 'Editar Canal de Anúncio',
			},
			delete: {
				title: 'O Canal de Anúncio foi deletado com sucesso.',
			},
		},
		adFormats: {
			list: {
				title: 'Lista de Formatos de Anúncios mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Formatos de Anúncios cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Formato de Anúncio',
				subTitle: 'Formato de Anúncio',
			},
			update: {
				title: 'Editar Formato de Anúncio',
			},
			delete: {
				title: 'O Formato de Anúncio foi deletado com sucesso.',
			},
		},
		adSizes: {
			list: {
				title: 'Lista de Tamanhos de Anúncios mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Tamanhos de Anúncios cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Tamanho de Anúncio',
				subTitle: 'Tamanho de Anúncio',
			},
			update: {
				title: 'Editar Tamanho de Anúncio',
			},
			delete: {
				title: 'O Tamanho de Anúncio foi deletado com sucesso.',
			},
		},
		adTypes: {
			list: {
				title: 'Lista de Tipos de Anúncios mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Tipos de Anúncios cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Tipo de Anúncio',
				subTitle: 'Tipo de Anúncio',
			},
			update: {
				title: 'Editar Tipo de Anúncio',
			},
			delete: {
				title: 'O Tipo de Anúncio foi deletado com sucesso.',
			},
		},
		kpiGroups: {
			list: {
				title: 'Lista de Grupos de KPI mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Grupos de KPI cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Grupo de KPI',
				subTitle: 'Grupo de KPI',
			},
			update: {
				title: 'Editar Grupo de KPI',
			},
			delete: {
				title: 'O Grupo de KPI foi deletado com sucesso.',
			},
		},
		kpiOptions: {
			list: {
				title: 'Lista de Opções de KPI mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Opções de KPI cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Opção de KPI',
				subTitle: 'Opção de KPI',
			},
			update: {
				title: 'Editar Opção de KPI',
			},
			delete: {
				title: 'A Opção de KPI foi deletada com sucesso.',
			},
		},
		campaignsCategories: {
			list: {
				title: 'Lista de Categorias de Campanhas mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Categorias de Campanhas cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Categoria de Campanha',
				subTitle: 'Categoria de Campanha',
			},
			update: {
				title: 'Editar Categoria de Campanha',
			},
			delete: {
				title: 'A Categoria de Campanha foi deletada com sucesso.',
			},
		},
		campaignsTypes: {
			list: {
				title: 'Lista de Tipos de Campanhas mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Tipos de Campanhas cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Tipo de Campanha',
				subTitle: 'Tipo de Campanha',
			},
			update: {
				title: 'Editar Tipo de Campanha',
			},
			delete: {
				title: 'O Tipo de Campanha foi deletado com sucesso.',
			},
		},
		casesTypes: {
			list: {
				title: 'Lista de Tipos de Casos mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Tipos de Casos cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Tipo de Caso',
				subTitle: 'Tipo de Caso',
			},
			update: {
				title: 'Editar Tipo de Caso',
			},
			delete: {
				title: 'O Tipo de Caso foi deletado com sucesso.',
			},
		},
		niches: {
			list: {
				title: 'Lista de Nichos mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Nichos cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Nicho',
				subTitle: 'Nicho',
			},
			update: {
				title: 'Editar Nicho',
			},
			delete: {
				title: 'O Nicho foi deletado com sucesso.',
			},
		},
		trackings: {
			list: {
				title: 'Lista de Plataformas de rastreamento mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Plataformas de rastreamento cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Plataforma de rastreamento',
				subTitle: 'Plataforma de rastreamento',
			},
			update: {
				title: 'Editar Plataforma de rastreamento',
			},
			delete: {
				title: 'A Plataforma de rastreamento foi deletada com sucesso.',
			},
		},
		styles: {
			list: {
				title: 'Lista de Estilos de conteúdo mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Estilos de conteúdo cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Estilo de conteúdo',
				subTitle: 'Estilo de conteúdo',
			},
			update: {
				title: 'Editar Estilo de conteúdo',
			},
			delete: {
				title: 'O Estilo de conteúdo foi deletado com sucesso.',
			},
		},
		genders: {
			list: {
				title: 'Lista de Gêneros Dominantes mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Gêneros Dominantes cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Gênero Dominantes',
				subTitle: 'Gênero Dominantes',
			},
			update: {
				title: 'Editar Gênero Dominantes',
			},
			delete: {
				title: 'O Gênero Dominantes foi deletado com sucesso.',
			},
		},
		tiers: {
			list: {
				title: 'Lista de Níveis mais recentes no Mundo Gamer Agency',
				subTitle: 'Confira a lista de Níveis cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Nível',
				subTitle: 'Nível',
			},
			update: {
				title: 'Editar Nível',
			},
			delete: {
				title: 'O Nível foi deletado com sucesso.',
			},
		},
		workflows: {
			list: {
				title: 'Lista de Status dos fluxos de trabalho mais recentes no Mundo Indie',
				subTitle: 'Confira a lista de Status dos fluxos de trabalho cadastrados na Mundo Indie.',
			},
			create: {
				title: 'Novo Status de fluxo de trabalho',
				subTitle: 'Status de fluxo de trabalho',
			},
			update: {
				title: 'Editar Status de fluxo de trabalho',
			},
			delete: {
				title: 'O Status de fluxo de trabalho foi deletado com sucesso.',
			},
		},
		games: {
			list: {
				title: 'Lista de Status dos jogos mais recentes no Mundo Indie',
				subTitle: 'Confira a lista de Status dos jogos cadastrados na Mundo Indie.',
			},
			create: {
				title: 'Novo Status de jogo',
				subTitle: 'Status de Status de jogo',
			},
			update: {
				title: 'Editar Status de jogo',
			},
			delete: {
				title: 'O Status de jogo foi deletado com sucesso.',
			},
		},
		goals: {
			list: {
				title: 'Lista de Metas mais recentes no Mundo Indie',
				subTitle: 'Confira a lista de Metas cadastradas na Mundo Indie.',
			},
			create: {
				title: 'Nova Meta',
				subTitle: 'Meta',
			},
			update: {
				title: 'Editar Meta',
			},
			delete: {
				title: 'A Meta foi deletada com sucesso.',
			},
		},
		projects: {
			list: {
				title: 'Lista de Projetos mais recentes no Mundo Indie',
				subTitle: 'Confira a lista de Projetos cadastrados na Mundo Indie.',
			},
			create: {
				title: 'Novo Projeto',
				subTitle: 'Projeto',
			},
			update: {
				title: 'Editar Projeto',
			},
			delete: {
				title: 'O Projeto foi deletado com sucesso.',
			},
			onboarding: {
				title: 'Onboarding',
				auto: {
					label: 'Enviar o e-mail de agradecimento automaticamente',
					hint: 'Ligado, o estúdio que preenche o formulário do Mundo Indie recebe na hora o e-mail de agradecimento com o link opcional da entrevista. Desligado, nada é enviado sozinho e você ainda pode enviar manualmente em cada projeto.',
					templateInactive: 'Template de e-mail inativo',
					notifyOn: 'Agradecimento automático ligado.',
					notifyOff: 'Agradecimento automático desligado.',
				},
				hint: 'O link que o estúdio recebe para contar sobre o jogo. O e-mail agradece o contato e diz que o nosso time analisa a mensagem; a entrevista é opcional.',
				state: {
					none: 'Sem link',
					created: 'Link criado',
					queued: 'E-mail na fila',
					sent: 'E-mail enviado',
					opened: 'Link aberto',
					answered: 'Respondido',
					revoked: 'Revogado',
				},
				send: 'Enviar link de onboarding',
				resend: 'Reenviar link de onboarding',
				revoke: 'Revogar link',
				createAndSend: 'Criar link e enviar e-mail',
				createOnly: 'Criar apenas o link',
				link: 'Link de onboarding',
				emailSent: 'E-mail enviado em {date}.',
				emailQueued: 'E-mail na fila desde {date}, aguardando entrega.',
				emailNotSent: 'Nenhum e-mail enviado ainda.',
				emailOpened: 'O estúdio abriu o e-mail em {date}.',
				confirmRevoke: 'Revogar o link de onboarding de {name}? O link deixa de funcionar.',
				notifySent: 'Link de onboarding criado e e-mail na fila.',
				notifyCreated: 'Link de onboarding criado.',
				notifyRevoked: 'Link de onboarding revogado.',
				notifyCopied: 'Link copiado.',
				notifyError: 'Não foi possível concluir a ação. Tente novamente.',
			},
		},
		testimonials: {
			list: {
				title: 'Lista de Depoimentos mais recentes no Mundo Indie',
				subTitle: 'Confira a lista de Depoimentos cadastrados na Mundo Indie.',
			},
			create: {
				title: 'Novo Depoimento',
				subTitle: 'Depoimento',
			},
			update: {
				title: 'Editar Depoimento',
			},
			delete: {
				title: 'O Depoimento foi deletado com sucesso.',
			},
		},
		userTestimonials: {
			list: {
				requestPhoto: 'Pedir foto',
				photoRequestedAgain: 'Foto pedida em {date}. Enviar de novo',
				photoRequestSent: 'Pedido de foto enviado',
				photoRequestFailed: 'Não foi possível enviar o pedido de foto',
				subject: 'Assunto',
				receivedAt: 'Recebido em',
				title: 'Lista de Depoimentos de usuários mais recentes na Mundo Gamer Agency',
				subTitle: 'Confira a lista de Depoimentos de usuários cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Depoimento',
				subTitle: 'Depoimento',
			},
			update: {
				title: 'Editar Depoimento',
			},
			delete: {
				title: 'O Depoimento foi deletado com sucesso.',
			},
			consentPublish: 'Usuário autorizou publicação nos sites da MG Network',
			isPublic: 'Visível nos sites públicos',
		},
		testimonialRequests: {
			saveFailed: 'Não foi possível salvar a alteração',
			title: 'Pedidos de depoimento',
			subTitle: 'E-mails automáticos que pedem um depoimento alguns dias depois de algo que a pessoa fez com a gente. Cada gatilho começa DESLIGADO até você ligar. Quem já deu depoimento sobre um assunto não é chamado de novo sobre ele, o mesmo assunto não se repete em menos de 180 dias (dez campanhas contam como uma) e assuntos diferentes ficam separados por pelo menos 30 dias.',
			delayDays: 'Dias após o evento',
			responseRate: 'Taxa de resposta',
			origin: 'Gatilho',
			statusLabel: 'Status',
			person: 'Pessoa',
			scheduledFor: 'Agendado para',
			sentAt: 'Enviado em',
			respondedAt: 'Respondido em',
			status: {
				scheduled: 'Agendado',
				sent: 'Enviado',
				responded: 'Respondido',
				skipped: 'Ignorado',
			},
			origins: {
				assessment_completed: 'Teste concluído',
				key_request_approved: 'Chave entregue (criador)',
				key_campaign_depleted: 'Campanha de chaves esgotada (estúdio)',
				press_kit_published: 'Press kit publicado',
				playtest_completed: 'Campanha de playtest concluída',
				podcast_guest_published: 'Convidado do podcast (episódio publicado)',
				ebook_downloaded: 'Ebook baixado',
				showcase_participant: 'Participante do Showcase (edição exibida)',
				course_completed: 'Curso concluído (Academy)',
			},
			skipReasons: {
				already_submitted: 'Já enviou um depoimento',
				pending_request: 'Havia outro pedido pendente',
				cooldown: 'Chamado recentemente (intervalo entre assuntos)',
				same_topic_recently: 'Já foi chamado sobre este assunto recentemente',
				origin_disabled: 'O gatilho foi desligado',
			},
		},
		testimonialInitiatives: {
			title: 'Iniciativas',
			subTitle: 'Gerencie as iniciativas disponíveis para submissão de depoimentos.',
			create: 'Nova Iniciativa',
			update: 'Editar Iniciativa',
		},
		services: {
			list: {
				title: 'Lista de Serviços mais recentes no Mundo Gamer Community',
				subTitle: 'Confira a lista de Serviços cadastrados na Mundo Gamer Community.',
			},
			create: {
				title: 'Novo Serviço',
				subTitle: 'Serviço',
			},
			update: {
				title: 'Editar Serviço',
			},
			delete: {
				title: 'O Serviço foi deletado com sucesso.',
			},
		},
		magazines: {
			list: {
				title: 'Lista de Revistas mais recentes',
				subTitle: 'Confira a lista de Revistas cadastradas da MGN Magazine.',
			},
			create: {
				title: 'Nova Revista',
				subTitle: 'Revista',
			},
			update: {
				title: 'Editar Revista',
				subTitle: 'Revista',
			},
			delete: {
				title: 'A Revista foi deletada com sucesso.',
			},
			hotspot: {
				url: 'URL',
				target: 'Destino',
				analyticsEvent: 'Evento de analytics',
				metadataJson: 'JSON de Metadados',
			},
			noPagesGenerated: 'Nenhuma página gerada ainda. Vá para a aba <strong>Gerar</strong> para gerar as páginas do flipbook.',
			captureLeads: 'Capturar Leads',
		},
		magazineSections: {
			list: {
				title: 'Lista de Editorias das revista MGN Magazine',
				subTitle: 'Confira a lista de editorias cadastradas no sistema.',
			},
			create: {
				title: 'Nova Editoria',
				subTitle: 'Editoria',
			},
			update: {
				title: 'Editar Editoria',
				subTitle: 'Editoria',
			},
			delete: {
				title: 'A Editoria foi deletada com sucesso.',
			},
		},
		servicesCategories: {
			list: {
				title: 'Lista de Categorias de Serviços mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Categorias de Serviços cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Categoria de Serviço',
				subTitle: 'Categoria de Serviço',
			},
			delete: {
				title: 'A Categoria de Serviço foi deletada com sucesso.',
			},
		},
		mgNetworkSystem: 'Sistema MG Network',
		newsletterCampaigns: {
			list: {
				title: 'Lista de Campanhas mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Campanhas cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Campanha',
				subTitle: 'Campanha',
			},
			update: {
				title: 'Editar Campanha',
				subTitle: 'Campanha',
			},
			delete: {
				title: 'A Campanha foi deletada com sucesso.',
			},
		},
		newsletterResults: {
			list: {
				title: 'Lista de Resultados de Newsletters mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Resultados de Newsletters cadastradas na Mundo Gamer Agency.',
			},
		},
		newsletterCategories: {
			list: {
				title: 'Lista de Categorias de Newsletters mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Categorias de Newsletters cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Categoria de Newsletter',
				subTitle: 'Categoria de Newsletter',
			},
			update: {
				title: 'Editar Categoria de Newsletter',
				subTitle: 'Categoria de Newsletter',
			},
			delete: {
				title: 'A Categoria de Newsletter foi deletada com sucesso.',
			},
		},
		newsletterPeriodicities: {
			list: {
				title: 'Lista de Frequências de Newsletters mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Frequências de Newsletters cadastradas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Frequência de Newsletter',
				subTitle: 'Frequência de Newsletter',
			},
			update: {
				title: 'Editar Frequência de Newsletter',
				subTitle: 'Frequência de Newsletter',
			},
			delete: {
				title: 'A Frequência de Newsletter foi deletada com sucesso.',
			},
		},
		keys: {
			list: {
				title: 'Lista de Chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Chave',
				subTitle: 'Chave',
			},
			update: {
				title: 'Editar Chave',
				subTitle: 'Chave',
			},
			delete: {
				title: 'A Chave foi deletada com sucesso.',
			},
			validation: {
				summary: 'Corrija os seguintes erros antes de salvar:',
				name_required: 'Nome é obrigatório (mínimo 3 caracteres)',
				name_min: 'Nome deve ter pelo menos 3 caracteres',
				type_required: 'Tipo de Key é obrigatório',
				requires_approval_required: 'Requer Aprovação deve ser selecionado',
				start_date_required: 'Data de início é obrigatória',
			},
			notify: {
				message: '{count} chaves disponíveis para {game}. Resgate a sua agora!',
			},
			sections: {
				basicInfo: 'Informações Básicas',
				distribution: 'Distribuição',
				period: 'Período da Campanha',
				pressMaterials: 'Materiais de Imprensa',
				coverImage: 'Imagem de Capa',
				coverCropHint: 'Imagem de capa, recortada para',
				bannerPosition: 'Posição do banner',
				visibility: 'Visibilidade',
				accessControl: 'Controle de Acesso',
				management: 'Gerenciamento',
				platformVisibility: 'Visibilidade por Plataforma',
				keyItems: 'Chaves',
				promote: 'Divulgação & Alertas',
			},
			labels: {
				platformTvDesc: 'Streamers e criadores de conteúdo no MG TV que fazem live de jogos.',
				platformCommunityDesc: 'Membros da comunidade e jogadores gerais no MG Community.',
				platformAgencyDesc: 'Jornalistas, influenciadores e contatos de imprensa via MG Agency.',
				platformVisibilityHint: 'Selecione onde esta campanha de chaves ficará visível. Deixe todos marcados para aparecer em todas as plataformas.',
				countriesHint: 'Países dos quais esta campanha aceita pedidos. Deixe vazio para aceitar de qualquer lugar.',
				visibilityAlwaysActive: 'Campanhas de chaves criadas por este fluxo sempre são públicas e ativas.',
				embargoLocalPreview: 'Isso também é {value} no seu horário local ({zone}).',
			},
			steps: {
				info: 'Informações Básicas',
				settings: 'Configurações',
				keys: 'Adicionar Chaves',
				promote: 'Divulgar',
				next: 'Próximo',
				back: 'Voltar',
				finish: 'Concluir',
				keys_hint: 'Cole um código por linha. Você pode adicionar mais chaves depois na tela de detalhes da campanha.',
				keys_placeholder: 'CHAVE-XXXX-XXXX\nCHAVE-YYYY-YYYY\n...',
				confirm_codes: 'Confirmar Códigos',
				codes_ready: 'códigos prontos para inserir',
				edit_codes: 'Editar',
				key_meta: 'Plataforma e Região',
				key_block: 'Bloco de chaves',
				combination_hint: 'Cada bloco representa uma única combinação de plataforma, região e plataforma MG. Para combinações diferentes, adicione um novo bloco.',
				add_combination: 'Adicionar outra combinação',
				complete_all_blocks: 'Confirme os códigos e preencha plataforma, região e plataforma MG em todos os blocos com códigos.',
				no_saveable_blocks: 'Adicione ao menos um bloco com códigos confirmados antes de adicionar chaves.',
				save_keys: 'Adicionar Chaves',
				keys_added_success: 'Chaves adicionadas com sucesso.',
				no_keys_yet: 'Nenhuma chave adicionada ainda. Adicione ao menos uma chave antes de divulgar esta campanha.',
				keys_added_count: '{count} chave(s) já adicionada(s) a esta campanha.',
				promote_hint: 'Broadcast e alertas por email só podem ser enviados depois que a campanha estiver salva e tiver ao menos uma chave.',
				email_blast: 'Email Blast',
				broadcast_email_on_publish: 'Enviar email blast ao publicar',
				trigger_email_blast: 'Disparar email blast agora',
				email_blasted_at: 'Último email blast enviado em',
				email_blast_queued: 'Email blast enfileirado com sucesso.',
				campaign_links_title: 'Links da Campanha',
				campaign_links_hint: 'Um link para cada plataforma em que esta campanha está visível — compartilhe o que combina com onde você vai divulgar.',
				campaign_links_none: 'Selecione ao menos uma plataforma em Settings para gerar o link da campanha.',
				copy_link: 'Copiar',
				copy_all_links: 'Copiar tudo',
				link_copied: 'Link copiado para a área de transferência.',
				links_copied: 'Links copiados para a área de transferência.',
				copy_failed: 'Não foi possível copiar.',
			},
			form: {
				pressKitLink: 'Link do press kit',
				reviewGuideline: 'Diretriz de avaliação',
				accessTier: 'Nível de Acesso',
				accessPolicy: 'Quem pode solicitar',
				accessPolicyHint: "Quem pode solicitar esta campanha. Qualquer usuário logado pode solicitar; se o pedido é analisado depende da opção 'requer aprovação' da campanha.",
				policyOpen: 'Qualquer pessoa',
				policyAuthenticated: 'Qualquer usuário logado',
				policyCampaignCreators: 'Criadores aprovados na campanha',
				earlyAccessHours: 'Horas de Acesso Antecipado',
				managedBy: 'Gerenciado Por',
				tierLocked: 'Nível bloqueado (somente o nível selecionado e acima)',
				exclusive: 'Exclusivo (somente streamers oficiais)',
				tierNoEffectWarning: '"{tier}" não vai restringir nada a menos que você também marque "Nível bloqueado" (permanente) ou defina Horas de Acesso Antecipado (temporário).',
				tierFree: 'Grátis',
				tierPro: 'Pro',
				tierBusiness: 'Business',
				tierOfficial: 'Oficial',
				managementPlatform: 'Gerenciado pela Plataforma',
				managementStudioPublic: 'Estúdio Público',
				managementStudioPrivate: 'Estúdio Privado',
			},
		},
		keysItems: {
			codePerLine: 'Um código por linha',
			searchByCode: 'Localizar por código (suporte)',
			searchByCodeHint: 'Busca interna de suporte — os códigos nunca são exibidos na lista.',
			regionRequired: 'Selecione ao menos uma região',
			store: 'Loja',
			externalRelease: 'Liberação externa',
			externalReleaseHint: 'Use quando a chave for para alguém que não tem cadastro na plataforma.',
			externalRecipientName: 'Destinatário externo',
			externalRecipientContact: 'Contato (e-mail, @, canal)',
			externalChip: 'Externo',
			releasedBy: 'Liberado por',
			recipientRequired: 'Selecione um usuário ou preencha o destinatário externo',
			filterRecipient: 'Destinatário',
			recipientAll: 'Todos',
			recipientInternal: 'Usuários da plataforma',
			recipientExternal: 'Somente externos',
			itemsTab: 'Itens',
			followersTab: 'Seguidores',
			followers: {
				user: 'Usuário',
				email: 'E-mail',
				followedAt: 'Seguindo desde',
			},
			list: {
				title: 'Lista de Chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Nova Chave',
				subTitle: 'Chave',
			},
			update: {
				title: 'Editar Chave',
				subTitle: 'Chave',
			},
			delete: {
				title: 'A Chave foi deletada com sucesso.',
			},
		},
		keysContents: {
			list: {
				title: 'Lista de Tipo de conteúdo de chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Tipo de conteúdo de chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Tipo de conteúdo de chave',
				subTitle: 'Tipo de conteúdo de chave',
			},
			update: {
				title: 'Editar Tipo de conteúdo de chave',
				subTitle: 'Tipo de conteúdo de chave',
			},
			delete: {
				title: 'O Tipo de conteúdo de chave foi deletado com sucesso.',
			},
		},
		keysTypes: {
			list: {
				title: 'Lista de Tipos de chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Tipos de chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Tipo de chave',
				subTitle: 'Tipo de chave',
			},
			update: {
				title: 'Editar Tipo de chave',
				subTitle: 'Tipo de chave',
			},
			delete: {
				title: 'O Tipo de chave foi deletado com sucesso.',
			},
		},
		keysStatus: {
			list: {
				title: 'Lista de Status de chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Status de chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Status de chave',
				subTitle: 'Status de chave',
			},
			update: {
				title: 'Editar Status de chave',
				subTitle: 'Status de chave',
			},
			delete: {
				title: 'O Status de chave foi deletado com sucesso.',
			},
		},
		keysRequestsStatus: {
			list: {
				title: 'Lista de Status de Solicitações de chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Status de Solicitações de chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Status de Solicitação de chave',
				subTitle: 'Status de Solicitação de chave',
			},
			update: {
				title: 'Editar Status de Solicitação de chave',
				subTitle: 'Status de Solicitação de chave',
			},
			delete: {
				title: 'O Status de Solicitação de chave foi deletado com sucesso.',
			},
		},
		keysSuppliers: {
			list: {
				title: 'Lista de Fornecedores de chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Fornecedores de chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Fornecedor de chave',
				subTitle: 'Fornecedor de chave',
			},
			update: {
				title: 'Editar Fornecedor de chave',
				subTitle: 'Fornecedor de chave',
			},
			delete: {
				title: 'O Fornecedor de chave foi deletado com sucesso.',
			},
		},
		keysPrs: {
			list: {
				title: 'Lista de PRS mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de PRS cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo PR',
				subTitle: 'PRS',
			},
			update: {
				title: 'Editar Fornecedores de RP',
				subTitle: 'PRS',
			},
			delete: {
				title: 'O PR foi deletado com sucesso.',
			},
		},
		keysRequests: {
			decisionRecorded: 'Decisão já registrada',
			automaticDecision: 'Aprovado automaticamente pelo sistema',
			unknownDecisionActor: 'Aprovado anteriormente; responsável não registrado',
			networkAdminDecision: 'Network Admin',
			studioDecision: 'Estúdio',
			manualDecision: 'Ação manual',
			refuseNotesRequired: 'É obrigatório informar o motivo ao recusar uma solicitação.',
			originPlatform: 'Solicitado em',
			requesterContext: 'Solicitante',
			requesterMediaPartner: 'Parceiro de mídia da edição',
			keyCampaign: 'Campanha de Chave',
			list: {
				title: 'Lista de Solicitações de chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Solicitações de chaves cadastrados na Mundo Gamer Agency.',
				deepLinked: 'Mostrando apenas a solicitação #{id}, aberta por uma notificação.',
				deepLinkedClear: 'Ver todas as solicitações',
			},
			create: {
				title: 'Nova Solicitação de chave',
				subTitle: 'Solicitação de chave',
			},
			update: {
				title: 'Editar Solicitação de chave',
				subTitle: 'Solicitação de chave',
			},
			delete: {
				title: 'A Solicitação de chave foi deletada com sucesso.',
			},
			assignedCode: 'Código de Chave Atribuído',
			revealed: 'Revelada',
			notRevealed: 'Não revelada',
			channel: 'Canal',
			followers: 'Seguidores',
			viewers: 'Espectadores',
			noChannel: 'Sem canal conectado — verifique o criador antes de liberar a chave.',
			creatorProfile: 'Perfil de criador (Agency)',
			influencer: 'Influenciador',
			journalist: 'Jornalista',
			outlet: 'Veículo',
			reach: 'Alcance',
			reviewStatus: {
				approved: 'Aprovado',
				pending: 'Pendente de revisão',
				rejected: 'Rejeitado',
			},
			performanceScore: 'Nota geral',
			deliveryRate: 'Taxa de entrega',
			responseRate: 'Taxa de resposta',
			contentApprovalRate: 'Conteúdo aprovado',
			keyHistory: 'Histórico de chaves nesta plataforma',
			totalRequests: 'Total de pedidos',
			delivered: 'Entregues',
			overdue: 'Atrasados agora',
			openRequestsElsewhere: 'Outros pedidos abertos agora',
			materials: 'Materiais Enviados',
			material: 'Material',
			noMaterials: 'Nenhum material enviado ainda.',
			materialApproved: 'Material aprovado com sucesso.',
			materialRejected: 'Material reprovado.',
			addMaterial: 'Adicionar material',
			addAnotherMaterial: 'Adicionar outro material',
			removeMaterial: 'Remover',
			materialUrl: 'URL do material',
			submittedAt: 'Enviado em',
			saveMaterials: 'Salvar {count} material(is)',
			materialsAdded: '{count} material(is) adicionado(s). Aprove abaixo após revisar.',
			materialsAddedAndUnblocked: '{count} material(is) adicionado(s) — isso também desbloqueou o acesso a pedidos de chave.',
			keyBlocked: 'Bloqueado para novos pedidos de chave',
			keyBlockedReason: 'Motivo',
			unblockKeyAccess: 'Desbloquear',
			keyAccessRestored: 'Acesso a pedidos de chave restaurado.',
		},
		keysMaterials: {
			publishesOn: 'Publica em',
			list: {
				title: 'Lista de Materiais de chaves mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Materiais de chaves cadastrados na Mundo Gamer Agency.',
			},
			create: {
				title: 'Novo Material de chave',
				subTitle: 'Material de chave',
			},
			update: {
				title: 'Editar Material de chave',
				subTitle: 'Material de chave',
			},
			delete: {
				title: 'O Material de chave foi deletado com sucesso.',
			},
			campaign: 'Campanha',
			requestId: 'Solicitação',
			filterCampaign: 'Filtrar por campanha',
			exportCsv: 'Exportar CSV',
		},
		contactMessages: {
			list: {
				title: 'Lista de Solicitações de Contato mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Solicitações de Contato enviadas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Solicitação de Contato',
			},
		},
		requestMessages: {
			list: {
				title: 'Lista de Pedidos mais recentes do Mundo Gamer Agency',
				subTitle: 'Confira a lista de Pedidos enviadas na Mundo Gamer Agency.',
			},
			create: {
				title: 'Pedido',
			},
			sourcePage: 'Página de Origem',
		},
		pressRoomKeyRequest: {
			list: {
				title: 'Solicitações de Chave - Press Room',
				subTitle: 'Gerencie e revise as solicitações de chave de jogo dos media partners no Press Room.',
			},
			fields: {
				game: 'Jogo',
				platform: 'Plataforma',
				mediaPartner: 'Media Partner',
				status: 'Status',
				requestedAt: 'Data da Solicitação',
			},
			status: {
				pending: 'Pendente',
				approved: 'Aprovado',
				rejected: 'Rejeitado',
			},
			actions: {
				approve: 'Aprovar',
				reject: 'Rejeitar',
				cancel: 'Cancelar',
				bulkApprove: 'Aprovar Selecionados',
				bulkReject: 'Rejeitar Selecionados',
			},
			statusChangeModal: {
				titleApprove: 'Aprovar Solicitação de Chave',
				titleReject: 'Rejeitar Solicitação de Chave',
				body: 'Tem certeza que deseja {action} a solicitação de chave de {name}?',
			},
			bulkModal: {
				titleApprove: 'Aprovar Solicitações de Chave',
				titleReject: 'Rejeitar Solicitações de Chave',
				body: 'Você está prestes a alterar o status de {count} solicitação(ões) de chave. Tem certeza?',
			},
		},
		pressKits: {
			list: {
				title: 'Press Kits',
				subTitle: 'Todos os press kits criados pelos usuários',
				name: 'Nome',
				type: 'Tipo',
				status: 'Status',
				user: 'Usuário',
				createdAt: 'Criado em',
				statusDraft: 'Rascunho',
				statusPublished: 'Publicado',
				statusArchived: 'Arquivado',
				publish: 'Publicar',
				archive: 'Arquivar',
				unpublish: 'Despublicar (voltar a rascunho)',
				deleteConfirm: 'Tem certeza que deseja excluir este press kit?',
				viewPublic: 'Ver press kit público',
				sendInsights: 'Enviar insights atualizados por e-mail',
				sendInsightsTitle: 'Enviar insights do Press Kit',
				sendInsightsConfirm: 'Enviar agora os insights atualizados de “{name}” para {email}? O relatório compara os últimos 7 dias com o período anterior.',
				sendNow: 'Enviar agora',
				cancel: 'Cancelar',
				sendInsightsSuccess: 'Insights enviados para {email}.',
				sendInsightsError: 'Não foi possível enviar o e-mail de insights.',
				startPressKit: 'Criar press kit',
				ownerUser: 'Usuário dono',
				pressKitName: 'Nome do press kit',
				ownerSearchPlaceholder: 'Buscar por nome, e-mail ou ID do usuário',
				ownerHint: 'O estúdio é opcional; o press kit pode pertencer diretamente a este usuário.',
				noUsersFound: 'Nenhum usuário encontrado',
				typeAtLeast2Chars: 'Digite ao menos 2 caracteres para buscar',
			},
			show: {
				title: 'Detalhe do Press Kit',
				slug: 'Slug',
				type: 'Tipo',
				user: 'Usuário',
				preview: 'Visualizar',
				hidePreview: 'Ocultar Visualização',
				changeStatus: 'Alterar Status',
				theme: 'Tema',
				layout: 'Layout',
				pressContact: 'Contato de Imprensa',
				price: 'Preço',
				notFound: 'Press kit não encontrado.',
				info: 'Informações',
				description: 'Descrição',
				keyFeatures: 'Recursos Principais',
				releaseDate: 'Data de Lançamento',
				developer: 'Desenvolvedor',
				publisher: 'Publisher',
				links: 'Links',
				website: 'Site',
				socialLinks: 'Redes Sociais',
				media: 'Mídia',
				logo: 'Logo',
				hero: 'Imagem Hero',
				cover: 'Imagem de Capa',
				assets: 'Assets',
				assetType: 'Tipo',
				assetTitle: 'Título',
				featured: 'Destaque',
				sortOrder: 'Ordem',
				videos: 'Vídeos',
				primary: 'Principal',
				credits: 'Créditos',
				awards: 'Prêmios',
				quotes: 'Citações',
				ecosystem: 'Ecossistema',
				articles: 'Artigos',
				coverage: 'Cobertura',
				showcases: 'Showcases',
				magazineFeature: 'Destaque na Revista',
				pressKitPreview: 'Prévia do press kit',
			},
		},
		mediaKits: {
			list: {
				title: 'Media Kits',
				subTitle: 'Todos os media kits criados pelos usuários',
				kitName: 'Nome do Kit',
				user: 'Usuário',
				template: 'Template',
				theme: 'Tema',
				createdAt: 'Criado em',
				deleteConfirm: 'Tem certeza que deseja excluir este media kit?',
				viewPublic: 'Ver media kit público',
				takeOffline: 'Tirar do ar',
				putOnline: 'Colocar no ar',
				startMediaKit: 'Criar media kit',
				professionalProfile: 'Perfil profissional',
			},
			show: {
				title: 'Detalhe do Media Kit',
				slug: 'Slug',
				user: 'Usuário',
				template: 'Template',
				theme: 'Tema',
				preview: 'Visualizar',
				hidePreview: 'Ocultar Visualização',
				settings: 'Configurações',
				bundles: 'Pacotes',
				rateCards: 'Tabela de Preços',
				label: 'Rótulo',
				format: 'Formato',
				channel: 'Canal',
				priceRange: 'Faixa de Preço',
				deliveryDays: 'Dias de Entrega',
				active: 'Ativo',
				notFound: 'Media kit não encontrado ou não pôde ser carregado.',
				mediaKitPreview: 'Prévia do media kit',
			},
		},
		walls: {
			list: {
				filterByStatus: 'Filtrar por status',
				openMural: 'Abrir Mural',
				delete: 'Excluir',
				slug: 'Slug',
				muralUrl: 'URL do Mural',
				tiers: 'Níveis',
				pixels: 'Pixels',
				sold: 'Vendidos',
				max: 'Máximo',
				pixelsSold: 'Pixels vendidos',
				anonymous: 'Anônimo',
				guest: 'Convidado',
			},
		},
	},

	club: {
		clubs: {
			list: {
				title: 'Clubs do Mundo Gamer Club',
				subTitle: 'Clubs criados pelos usuários. Suspenda, reative ou marque um club; toda decisão exige um motivo por escrito e fica no histórico.',
			},
			status: {
				draft: 'Rascunho',
				published: 'Publicado',
				suspended: 'Suspenso',
			},
			action: {
				suspended: 'Suspenso',
				reactivated: 'Reativado',
				sensitive_on: 'Marcado como sensível',
				sensitive_off: 'Marca de sensível removida',
				post_removed: 'Post removido',
				refund_requested: 'Reembolso solicitado',
			},
			postsTitle: 'Posts',
			noPosts: 'Nenhum post.',
			untitled: '(sem título)',
			removePost: 'Remover post',
			onlySensitive: 'Só conteúdo sensível',
			owner: 'Dono',
			members: 'Membros',
			subscriptionsTitle: 'Assinaturas',
			noSubscriptions: 'Nenhuma assinatura paga.',
			mode: {
				destination_charge: 'Dividido na origem',
				separate_transfer: 'Plataforma recebe',
			},
			refund: 'Reembolsar',
			refundTitle: 'Reembolsar a última cobrança',
			refundSplitNote: 'Esta venda foi dividida: a parte do criador é retirada da conta de pagamento dele no mesmo passo.',
			refundPlainNote: 'A plataforma recebeu esta venda: o reembolso sai do saldo do criador na plataforma.',
			refundAmount: 'Valor a reembolsar',
			refundAmountHint: 'Deixe vazio para reembolsar tudo o que foi cobrado. No máximo o preço de um ciclo.',
			refundReason: 'Motivo',
			refundConfirm: 'Reembolsar',
			refundRequested: 'Reembolso solicitado. O acesso e o saldo são atualizados quando o provedor de pagamento confirmar.',
			payingSupporters: 'Apoiadores pagantes',
			posts: 'Posts',
			openDeliveries: 'Entregas abertas',
			sensitive: 'Sensível',
			reason: 'Motivo da decisão',
			reasonHint: 'Mínimo de 5 caracteres. Fica salvo no histórico do club.',
			history: 'Histórico',
			noHistory: 'Nenhuma decisão ainda.',
			suspend: 'Suspender club',
			reactivate: 'Reativar club',
			markSensitive: 'Marcar como sensível',
			unmarkSensitive: 'Remover marca de sensível',
			loadFailed: 'Não foi possível carregar os clubs.',
			actionFailed: 'Não foi possível salvar a decisão.',
		},
		franchiseModels: {
			list: {
				title: 'Lista de Modelos de Franquias mais recentes do Mundo Gamer Club',
				subTitle: 'Confira a lista de Modelos de Franquias cadastrados na Mundo Gamer Club.',
			},
			create: {
				title: 'Novo Modelo de Franquia',
				subTitle: 'Preencha os campos abaixo para cadastrar um Modelo de Franquia.',
			},
			update: {
				title: 'Editar Modelo de Franquia',
			},
		},
		contactFranchise: {
			list: {
				title: 'Lista de Contato de Franquias mais recentes do Mundo Gamer Club',
				subTitle: 'Confira a lista de Contato de Franquias cadastrados na Mundo Gamer Club.',
			},
		},
	},

	community: {
		pulses: {
			pulses: {
				list: {
					title: 'Lista de Notícias mais recentes do Mundo Gamer Community',
					subTitle: 'Confira a lista de Últimas Notícias cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Nova Notícia',
					subTitle: 'Preencha os campos abaixo para publicar uma notícia.',
					notification: 'Nova notícia salva com sucesso',
				},
				delete: {
					title: 'Notícia excluída com sucesso',
				},
				update: {
					notification: 'Nova notícia atualizada com sucesso',
				},
			},
			category: {
				list: {
					title: 'Lista de Categorias de Notícias',
					subTitle: 'Confira a lista de Categorias de Notícias cadastradas na Mundo Gamer Community',
				},
				create: {
					title: 'Nova Categoria de Notícia',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Categoria de Notícia.',
				},
				update: {
					title: 'Editar Categoria de Notícia',
					subTitle: 'Categoria de Notícia',
				},
			},
			pending: {
				list: {
					title: 'Lista de Revisão de Notícias da Mundo Gamer',
					subTitle: 'Confira a lista de Revisão de Notícias cadastradas na Mundo Gamer Community',
				},
			},
			source: {
				list: {
					title: 'Lista de Fontes de Notícias da Mundo Gamer',
					subTitle: 'Confira a lista de Fontes de Notícias cadastradas na Mundo Gamer Community',
				},
				create: {
					title: 'Nova Fonte de Notícia',
					subTitle: 'Fonte de Notícia',
				},
				update: {
					title: 'Editar Fonte de Notícia',
					subTitle: 'Fonte de Notícia',
				},
			},
			status: {
				list: {
					title: 'Lista de Últimos Status de Notícias da Mundo Gamer',
					subTitle: 'Confira a lista dos Últimos Status de Notícias na Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Status de Notícia',
					subTitle: 'Preencha os campos abaixo para cadastrar um Status de Notícia.',
				},
			},
		},
		reviews: {
			list: {
				title: 'Lista dos Reviews do Mundo Gamer',
				subTitle: 'Confira a lista dos Últimos Reviews na Mundo Gamer Community',
				untitled: '(sem título)',
			},
			create: {
				title: 'Novo Review',
				subTitle: 'Preencha os campos abaixo para publicar uma review.',
			},
			importDocument: {
				button: 'Importar de Word / PDF',
				hint: 'Preenche título, introdução, corpo e conclusão a partir do documento. Revise tudo antes de salvar. As notas não são preenchidas.',
				success: 'Documento importado. Revise os campos antes de salvar.',
				overwriteConfirm: 'Isso substitui o título, a introdução, o corpo e a conclusão que já estão no formulário. Continuar?',
				warnings: {
					title_not_found: 'Nenhum título foi encontrado no topo do documento.',
					introduction_not_found: 'Nenhuma introdução foi encontrada antes do primeiro título de seção.',
					conclusion_not_found: 'Nenhuma seção de conclusão separada foi identificada.',
					pdf_structure_guessed: 'A estrutura foi deduzida de um PDF; confira título, seções e conclusão.',
				},
			},
			createAi: {
				title: 'Gerar Review com IA',
				subTitle:
					'Escolha um jogo, cole até 5 links de reviews de referência e deixe a IA redigir a review completa para revisão.',
				selectGame: 'Selecione um Jogo',
				selectWriterProfile: 'Selecione um Perfil de Redator',
				selectReviewRequest: 'Vincular a um Pedido de Review (opcional)',
				referenceLinks: 'Links de Referência',
				referenceLink: 'Link de referência',
				submit: 'Gerar Review com IA',
				statusQueued: 'Na fila',
				statusScraping: 'Coletando links de referência',
				statusGenerating: 'Gerando conteúdo da review',
				statusCompleted: 'Concluído',
				statusFailed: 'Falhou',
				openForReview: 'Abrir para revisão',
				refreshStatus: 'Atualizar status',
				jobsListTitle: 'Jobs de Review com IA',
				jobsListSubtitle: 'Acompanhe os jobs de review gerados por IA e seus status',
				noJobFound: 'Job não encontrado.',
				noWriterProfile:
					'Nenhum perfil de redator está disponível para reviews com IA. O perfil precisa ser um agente e ter um slug na AI API (ex.: "Game Reviewer") para poder ser usado aqui.',
				columns: {
					status: 'Status',
					game: 'Jogo',
					writerProfile: 'Perfil de Redator',
					createdAt: 'Criado em',
					createdBy: 'Criado por',
				},
			},
			rating: {
				title: 'Avaliações',
				gameplay: 'Avaliação da jogabilidade',
				story: 'Avaliação da história',
				graphics: 'Avaliação dos gráficos',
				controls: 'Avaliação dos controles',
				audio: 'Avaliação do aúdio',
			},
			delete: {
				title: 'Avaliação deletada com sucesso.',
			},
			notification: {
				create: 'Nova avaliação criada com sucesso.',
				update: 'Avaliação atualizada com sucesso',
				delete: 'Avaliação excluida com sucesso',
			},
		},
		videos: {
			sources: {
				origin: 'Origem',
				originAll: 'Todas as origens',
				originManual: 'Manual',
				originImported: 'Importados do YouTube',
				title: 'Canais do YouTube',
				subTitle: 'Canais de publishers, estúdios e franquias que o site monitora para importar trailers e vídeos oficiais (a cada 30 minutos).',
				create: 'Novo canal',
				edit: 'Editar canal',
				channelId: 'ID do canal no YouTube',
				channelIdHint: 'Começa com UC, por exemplo UC44qgwxGNPbfaAGQV1K6kVg (youtube.com/channel/...)',
				handle: '@handle do canal',
				handleHint: 'Ex.: @PlayStation. Basta o handle: o ID do canal é buscado no YouTube na primeira importação.',
				pending: 'ID ainda não resolvido',
				kind: 'Tipo',
				kinds: { publisher: 'Publisher', studio: 'Estúdio', franchise: 'Franquia', own: 'Canal próprio' },
				author: 'ID do usuário autor',
				authorHint: 'Conta que assina os vídeos importados deste canal',
				trusted: 'Canal confiável: publica direto',
				trustedHint: 'Desligado: os vídeos entram em revisão e só vão ao ar depois de aprovados',
				active: 'Ativo',
				mode: 'Publicação',
				publishes: 'Publica direto',
				review: 'Vai para revisão',
				videos: 'Vídeos',
				lastChecked: 'Última checagem',
				confirmDelete: 'Remover o canal {name}? Os vídeos já importados continuam no site.',
				loadError: 'Não foi possível carregar os canais.',
				saveError: 'Não foi possível salvar o canal.',
			},
			list: {
				title: 'Lista dos Vídeos do Mundo Gamer',
				subTitle: 'Confira a lista dos Últimos Vídeos na Mundo Gamer Community',
			},
			create: {
				title: 'Novo Vídeo',
				subTitle: 'Preencha os campos abaixo para publicar um vídeo.',
			},
			delete: {
				title: 'Remover vídeo',
			},
			notification: {
				delete: 'Deseja excluir esse vídeo?',
			},
			category: {
				list: {
					title: 'Lista de Categorias de Vídeos',
					subTitle: 'Confira a lista de Vídeos de Notícias cadastradas na Mundo Gamer Community',
				},
				create: {
					title: 'Nova Categoria de Vídeo',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Categoria de Vídeo.',
				},
				update: {
					title: 'Editar Categoria de Vídeo',
					subTitle: 'Categoria de Vídeo',
				},
			},
		},
		schedulers: {
			list: {
				title: 'Lista de Agendamentos mais recentes do Mundo Gamer Community',
				subTitle: 'Confira a lista de Últimos Agendamentos cadastrados na Mundo Gamer Community.',
			},
			delete: {
				title: 'Agendamento excluído com sucesso',
			},
		},
		awards: {
			list: {
				title: 'Lista das Premiações do Mundo Gamer',
				subTitle: 'Confira a lista das Últimas Premiações na Mundo Gamer Community',
				emptyList: 'Em breve...',
			},
			create: {
				title: 'Nova Premiação',
				subTitle: 'Preencha os campos abaixo para publicar uma Premiação.',
			},
			delete: {
				title: 'Premiação deletada com sucesso.',
			},
		},
		awardsCategories: {
			list: {
				title: 'Lista das Categorias de Premiações do Mundo Gamer',
				subTitle: 'Confira a lista das Últimas Categorias de Premiações na Mundo Gamer Community',
			},
			create: {
				title: 'Nova Categoria de Premiação',
				subTitle: 'Preencha os campos abaixo para publicar uma Categoria de Premiação.',
			},
			delete: {
				title: 'Categoria de Premiação deletada com sucesso.',
			},
		},
		awardsCompetitors: {
			list: {
				title: 'Lista dos Competidores de Premiações do Mundo Gamer',
				subTitle: 'Confira a lista dos Últimos Competidores de Premiações na Mundo Gamer Community',
			},
			create: {
				title: 'Novo Competidor',
				subTitle: 'Preencha os campos abaixo para publicar um Competidor.',
			},
			delete: {
				title: 'Competidor deletado com sucesso.',
			},
		},

		quizzes: {
			list: {
				title: 'Lista dos Quizzes do Mundo Gamer',
				subTitle: 'Confira a lista dos Últimos Quizzes na Mundo Gamer Community',
			},
			create: {
				title: 'Novo Quiz',
				subTitle: 'Preencha os campos abaixo para publicar um Quiz.',
			},
		},
		questions: {
			list: {
				title: 'Lista das Perguntas dos Quizzes do Mundo Gamer',
				subTitle: 'Confira a lista de Perguntas dos Últimos Quizzes na Mundo Gamer Community',
			},
			create: {
				title: 'Nova Pergunta',
				subTitle: 'Preencha os campos abaixo para publicar uma Pergunta.',
			},
		},
		ratings: {
			list: {
				title: 'Lista das Avaliações do Mundo Gamer',
				subTitle: 'Confira a lista de Avaliações na Mundo Gamer Community',
			},
			create: {
				title: 'Avaliação',
				subTitle: 'Preencha os campos abaixo para publicar uma nova Avaliação.',
			},
		},
		releases: {
			list: {
				title: 'Lista dos Lançamentos de Jogos do Mundo Gamer',
				subTitle: 'Confira a lista de Lançamentos na Mundo Gamer Community',
			},
		},
		dashboard: {
			latestFeed: {
				title: 'Últimos Conteúdos do Feed',
				viewAll: 'Ver Todos',
				empty: 'Nenhum conteúdo recente para revisar.',
			},
			latestStories: {
				title: 'Últimos Stories',
				empty: 'Nenhum story para revisar.',
			},
		},
		moderation: {
			title: 'Moderação de Conteúdo',
			subtitle: 'Monitore, analise e gerencie todo o conteúdo publicado pelos usuários da plataforma.',
			stats: {
				total: 'Total de Conteúdos',
				withReports: 'Com Denúncias',
				removedToday: 'Removidos Hoje',
				publishedToday: 'Publicados Hoje',
			},
			tabs: {
				feed: 'Feed Social',
				list: 'Listagem',
				blocked: 'Bloqueados',
			},
			blocked: {
				search: 'Buscar por nickname ou e-mail',
			},
			filters: {
				contentType: 'Tipo de Conteúdo',
				reports: 'Denúncias',
				search: 'Buscar por texto ou usuário',
				filter: 'Filtrar',
				withReports: 'Com denúncias',
				withoutReports: 'Sem denúncias',
			},
			contentTypes: {
				pulse: 'Pulse',
				post: 'Post',
				video: 'Vídeo',
				comment: 'Comentário',
				review: 'Review',
				quiz: 'Quiz',
				story: 'Story',
			},
			table: {
				media: 'Mídia',
				author: 'Autor',
				type: 'Tipo',
				content: 'Conteúdo',
				reports: 'Denúncias',
				publishedAt: 'Publicado em',
				actions: 'Ações',
			},
			card: {
				viewOnSite: 'Ver no site',
				remove: 'Remover',
				unknownAuthor: 'Desconhecido',
				unknownDate: 'Data desconhecida',
				noText: 'Sem prévia de texto.',
				report: 'denúncia',
				reports: 'denúncias',
			},
			removeDialog: {
				title: 'Remover Conteúdo',
				confirm: 'Tem certeza que deseja remover este conteúdo do ar?',
				type: 'Tipo',
				author: 'Autor',
				titleLabel: 'Título',
				warning: 'Esta ação irá remover o conteúdo imediatamente da plataforma.',
				cancel: 'Cancelar',
				remove: 'Remover',
			},
			feedback: {
				removeSuccess: 'Conteúdo removido com sucesso.',
				removeError: 'Erro ao remover conteúdo.',
				notifySent: 'Notificação enviada ao usuário.',
				userBlocked: 'Usuário bloqueado de publicar novos conteúdos.',
				userUnblocked: 'Usuário desbloqueado para publicar conteúdos.',
			},
			action: {
				title: 'Ação de Moderação',
				publishingBlocked: 'Bloqueado',
				strikes: 'Strikes',
				removedTotal: '{total} remoções no total',
				loadingStrikes: 'Carregando histórico do usuário...',
				strikeHigh: 'Alto risco',
				strikeMedium: 'Risco médio',
				strikeLow: 'Baixo risco',
				reason: 'Motivo da remoção',
				reasonPlaceholder: 'Descreva o motivo da remoção...',
				reasonRequired: 'O motivo é obrigatório.',
				notifySection: 'Notificações',
				notifyWebSocket: 'Notificação in-app (tempo real)',
				notifyFirebase: 'Push notification (Firebase)',
				notifyPreviewLabel: 'Prévia da mensagem',
				notifyPreview: 'Olá {author}, seu conteúdo foi removido pela equipe de moderação. Motivo: {reason}.',
				blockSection: 'Bloqueio de publicação',
				blockPublishing: 'Bloquear usuário de publicar',
				unblockPublishing: 'Desbloquear publicação',
				blockWarning: 'O usuário não conseguirá publicar novos conteúdos na plataforma até ser desbloqueado.',
				removeAndNotify: 'Remover e Notificar',
				removeAndBlock: 'Remover, Notificar e Bloquear',
				strikeSection: 'Strike',
				applyStrike: 'Aplicar strike ao usuário',
				noStrikeHint: 'O conteúdo será removido sem registrar um strike no perfil do usuário.',
				presets: {
					hate: 'Discurso de ódio',
					spam: 'Spam',
					violence: 'Violência',
					adult: 'Conteúdo adulto',
					misinformation: 'Desinformação',
					harassment: 'Assédio',
				},
			},
			endOfFeed: 'Todos os conteúdos foram carregados',
			noContent: 'Nenhum conteúdo encontrado com os filtros aplicados.',
				feedUnavailable: 'O feed de moderação está temporariamente indisponível. Os endpoints da API ainda não foram implementados no backend.',
			noImage: 'Sem imagem',
				reportNoCategory: 'Denúncia',
		},
		reports: {
			list: {
				title: 'Lista de Relatórios do Mundo Gamer Community',
				subTitle: 'Confira a lista de Relatórios cadastrados na Mundo Gamer Community.',
			},
			create: {
				title: 'Novo Relatório',
				subTitle: 'Relatório',
			},
			update: {
				title: 'Editar Relatório',
				subTitle: 'Relatório',
			},
		},
		reportsCategories: {
			list: {
				title: 'Lista de Categorias de relatórios do Mundo Gamer Community',
				subTitle: 'Confira a lista de Categorias de relatórios cadastrados na Mundo Gamer Community.',
			},
			create: {
				title: 'Nova Categoria de relatório',
				subTitle: 'Categoria de relatório',
			},
			update: {
				title: 'Editar Categoria de relatório',
				subTitle: 'Categoria de relatório',
			},
		},
		reportsSubcategories: {
			list: {
				title: 'Lista de Subcategorias de relatórios do Mundo Gamer Community',
				subTitle: 'Confira a lista de Subcategorias de relatórios cadastrados na Mundo Gamer Community.',
			},
			create: {
				title: 'Nova Subcategoria de relatório',
				subTitle: 'Subcategoria de relatório',
			},
			update: {
				title: 'Editar Subcategoria de relatório',
				subTitle: 'Subcategoria de relatório',
			},
		},
		pushNotifications: {
			list: {
				title: 'Lista de Notificações Push mais recentes do Mundo Gamer Community',
				subTitle: 'Confira a lista de Notificações Push cadastradas na Mundo Gamer Community.',
			},
			create: {
				title: 'Nova Notificação Push',
				subTitle: 'Notificação Push',
			},
		},
		polls: {
			new: 'Nova Enquete',
			list: {
				title: 'Enquetes',
				subTitle: 'Gerencie as enquetes interativas do feed da comunidade.',
				empty: 'Nenhuma enquete encontrada.',
			},
			create: {
				title: 'Nova Enquete',
			},
			edit: {
				title: 'Editar Enquete',
			},
			tabs: {
				details: 'Detalhes',
				translate: 'Traduzir',
			},
			translate: {
				hint: 'As traduções são salvas pelo sistema de Translatables. Elas substituem o texto padrão para cada idioma.',
				translated: 'traduzido',
			},
			fields: {
					image: 'Imagem',
				question: 'Pergunta',
				description: 'Descrição',
				options: 'Opções',
				option: 'Opção',
				status: 'Status',
				language: 'Idioma',
				global: 'Global (todos os idiomas)',
				globalSwitch: 'Global (todos os idiomas)',
				globalPlaceholder: 'Todos os idiomas',
				languageHint: 'Se definido, enquetes não-globais aparecem só nesse idioma',
					languageGlobalHint: 'Enquete global — exibida para todos os idiomas',
				category: 'Categoria',
				startsAt: 'Data de início',
				endsAt: 'Data de término',
				maxVotes: 'Máximo de votos',
				maxVotesPlaceholder: 'Ilimitado',
				votes: 'Votos',
				videoUrl: 'URL do vídeo (opcional)',
				videoDisabled: 'Remova a imagem para adicionar um URL de vídeo',
				imageDisabled: 'Remova o URL do vídeo para enviar uma imagem',
				platforms: 'Plataformas (deixe vazio para todas)',
			},
			status: {
				draft: 'Rascunho',
				active: 'Ativa',
				closed: 'Encerrada',
			},
			actions: {
				addOption: 'Adicionar opção',
				close: 'Encerrar enquete',
				closeConfirm: 'Tem certeza que deseja encerrar esta enquete? Esta ação não pode ser desfeita.',
				deleteConfirm: 'Tem certeza que deseja excluir esta enquete?',
			},
			results: {
				title: 'Resultados',
				votes: 'votos',
			},
			categories: {
				title: 'Categorias de Enquetes',
				new: 'Nova Categoria',
				edit: 'Editar Categoria',
				deleteConfirm: 'Excluir categoria?',
				deleteText: 'Tem certeza que deseja excluir "{name}"?',
				fields: {
					name: 'Nome',
					slug: 'Slug',
					slugHint: 'Gerado automaticamente a partir do nome se deixado vazio',
				},
			},
		},
		esports: {
			list: {
				title: 'Lista dos Times de E-Sports do Mundo Gamer',
				subTitle: 'Confira a lista de Times de E-Sports cadastrados na Mundo Gamer Community',
			},
			create: {
				title: 'Novo Time',
				subTitle: 'Preencha os campos abaixo para cadastrar um Time.',
			},
		},

		communities: {
			list: {
				title: 'Lista de Comunidades do Mundo Gamer Community',
				subTitle: 'Confira a lista de Comunidades cadastradas na Mundo Gamer Community.',
			},
			update: {
				title: 'Editar Comunidade',
				subTitle: 'Preencha os campos abaixo para editar uma Comunidade.',
			},
			table: {
				owner: 'Dono',
				members: 'Membros',
				tier: 'Nível',
				status: 'Status',
			},
			tier: {
				official: 'Oficial',
				premium: 'Premium',
				promoted: 'Promovida',
				free: 'Gratuita',
			},
			actions: {
				transferOwnership: 'Transferir Propriedade',
				transferOwnershipConfirm: 'Transferir Propriedade',
				transferOwnershipText: 'Tornar {name} o novo dono? O dono atual será rebaixado a admin.',
			},
			feedback: {
				deleted: 'Comunidade excluída',
				deleteFailed: 'Falha ao excluir a comunidade',
				transferred: 'Propriedade transferida',
				transferFailed: 'Falha ao transferir a propriedade',
			},
		},
		gameClaims: {
			title: 'Reivindicações de Jogos',
			subtitle: 'Revise e modere as reivindicações de propriedade de estúdios sobre jogos.',
			tabs: {
				pending: 'Pendentes',
				approved: 'Aprovadas',
				rejected: 'Rejeitadas',
			},
			table: {
				game: 'Jogo',
				user: 'Usuário',
				company: 'Estúdio',
				proof: 'Prova',
				status: 'Status',
				submittedAt: 'Enviado em',
				actions: 'Ações',
			},
			status: {
				pending: 'Pendente',
				approved: 'Aprovado',
				rejected: 'Rejeitado',
			},
			actions: {
				view: 'Ver detalhes',
				approve: 'Aprovar',
				reject: 'Rejeitar',
			},
			dialog: {
				titleApprove: 'Aprovar Reivindicação',
				titleReject: 'Rejeitar Reivindicação',
				game: 'Jogo',
				note: 'Nota de Revisão',
				notePlaceholder: 'Nota opcional para o estúdio…',
			},
			details: {
				title: 'Detalhes da reivindicação',
				user: 'Usuário',
				studio: 'Estúdio',
				proof: 'Prova de propriedade',
				submittedAt: 'Enviado em',
				note: 'Nota de revisão',
			},
			feedback: {
				loadError: 'Falha ao carregar reivindicações.',
				approveSuccess: 'Reivindicação aprovada com sucesso.',
				rejectSuccess: 'Reivindicação rejeitada.',
				actionError: 'Ocorreu um erro. Tente novamente.',
			},
		},
		gameContributions: {
			title: 'Contribuições de Jogos',
			subtitle: 'Revise edições enviadas por usuários nas páginas de jogos. Aprovar credita MGC ao contribuidor.',
			tabs: { pending: 'Pendentes', approved: 'Aprovadas', rejected: 'Rejeitadas' },
			table: {
				game: 'Jogo', user: 'Usuário', field: 'Campo', change: 'Alteração',
				reward: 'Recompensa', status: 'Status', submittedAt: 'Enviado em', actions: 'Ações',
			},
			status: { pending: 'Pendente', approved: 'Aprovada', rejected: 'Rejeitada' },
			actions: { approve: 'Aprovar', reject: 'Rejeitar' },
			dialog: {
				titleApprove: 'Aprovar Contribuição', titleReject: 'Rejeitar Contribuição',
				game: 'Jogo', note: 'Nota de Revisão', reward: 'Recompensa MGC',
			},
			feedback: {
				loadError: 'Falha ao carregar contribuições.',
				approveSuccess: 'Contribuição aprovada e MGC creditado.',
				rejectSuccess: 'Contribuição rejeitada.',
				actionError: 'Ocorreu um erro. Tente novamente.',
			},
		},
		gameCreationSuggestions: {
			title: 'Sugestões de Jogos Novos',
			subtitle: 'Revise jogos sugeridos pela comunidade que estão faltando no catálogo. Aprovar cria o jogo e credita MGC a quem enviou.',
			tabs: { pending: 'Pendentes', approved: 'Aprovadas', rejected: 'Rejeitadas' },
			table: {
				name: 'Nome', user: 'Usuário', summary: 'Resumo',
				reward: 'Recompensa', status: 'Status', submittedAt: 'Enviado em', actions: 'Ações',
			},
			status: { pending: 'Pendente', approved: 'Aprovada', rejected: 'Rejeitada' },
			actions: { view: 'Ver Detalhes', approve: 'Aprovar', reject: 'Rejeitar' },
			dialog: {
				titleApprove: 'Aprovar Sugestão', titleReject: 'Rejeitar Sugestão',
				game: 'Jogo', note: 'Nota de Revisão', reward: 'Recompensa MGC',
				gameType: 'Tipo de Jogo', gameStatus: 'Status do Jogo', releaseDate: 'Data de Lançamento',
				platformIds: 'IDs de Plataformas', genreIds: 'IDs de Gêneros', submitterNote: 'Nota de quem enviou',
			},
			feedback: {
				loadError: 'Falha ao carregar sugestões.',
				approveSuccess: 'Sugestão aprovada, jogo criado e MGC creditado.',
				rejectSuccess: 'Sugestão rejeitada.',
				actionError: 'Ocorreu um erro. Tente novamente.',
			},
		},
		contentRequests: {
			title: 'Demandas de Conteúdo',
			widget: {
				title: 'Fila de Demandas de Conteúdo',
				viewAll: 'Ver fila',
				openQueue: 'Fila aberta',
				paidOpen: 'Oportunidades pagas',
				unassigned: 'Sem responsável',
				empty: 'Nenhuma demanda aberta.',
			},
			subtitle: 'Gerencie as demandas de produção de artigos e análises enviadas pela Agência para a Mundo Gamer Community.',
			types: {
				pulse: 'Artigo',
				review: 'Análise',
			},
			paid: 'Paga',
			unpaid: 'Não paga',
			status: {
				pending: 'Pendente',
				assigned: 'Atribuída',
				in_production: 'Em Produção',
				ready: 'Pronta',
				published: 'Publicada',
				canceled: 'Cancelada',
			},
			transitions: {
				pending: 'Voltar para Pendente',
				assigned: 'Marcar como Atribuída',
				in_production: 'Iniciar Produção',
				ready: 'Marcar como Pronta',
				published: 'Publicar',
				canceled: 'Cancelar Demanda',
			},
			filters: {
				type: 'Tipo',
				status: 'Status',
				source: 'Origem',
				assignedUser: 'Jornalista Atribuído',
				search: 'Buscar',
				searchPlaceholder: 'Nome do jogo ou estúdio…',
			},
			table: {
				game: 'Jogo',
				type: 'Tipo',
				status: 'Status',
				assignedUser: 'Jornalista',
				requestedAt: 'Solicitada em',
				actions: 'Ações',
			},
			actions: {
				view: 'Ver detalhes',
			},
			emptyState: 'Nenhuma demanda de conteúdo encontrada.',
			detail: {
				steamPage: 'Página na Steam',
				tabs: {
					briefing: 'Briefing',
					production: 'Produção',
				},
			},
			briefing: {
				pitch: 'Pitch',
				interview: 'Entrevista Editorial',
				operational: 'Dados Operacionais',
				empty: 'Nenhum briefing disponível para esta demanda.',
				releaseStage: 'Estágio de Lançamento',
				launchDate: 'Data de Lançamento',
				launchWindow: 'Janela de Lançamento',
				platforms: 'Plataformas',
				genres: 'Gêneros',
				targetAudience: 'Público-alvo',
				helpNeeded: 'Ajuda Necessária',
				keyCommitment: 'Compromisso Principal',
				studio: 'Estúdio',
				studioSize: 'Tamanho da Equipe',
				foundedYear: 'Fundado em',
				studioStory: 'História',
				press: 'Imprensa',
				pressEmail: 'E-mail de Imprensa',
				pressKit: 'Press Kit',
			},
			production: {
				assignTitle: 'Atribuir Jornalista',
				currentlyAssigned: 'Atribuída atualmente a',
				searchJournalist: 'Buscar jornalista pelo nome…',
				assign: 'Atribuir',
				assignDisabledHint: 'A atribuição só é permitida enquanto a demanda está pendente ou atribuída.',
				linkGameTitle: 'Vincular Jogo',
				currentlyLinked: 'Vinculado atualmente',
				searchGame: 'Buscar jogo pelo nome…',
				linkGame: 'Vincular',
				reviewNeedsGameHint: 'Análises exigem um jogo vinculado antes de entrar em produção.',
				linkContentTitle: 'Vincular Conteúdo',
				currentlyLinkedContent: 'Conteúdo vinculado atualmente',
				pulseId: 'ID do Pulse',
				reviewId: 'ID da Análise',
				linkContent: 'Vincular',
				linkContentHint: 'Se o conteúdo vinculado já estiver publicado, a demanda passa automaticamente para publicada.',
				createDraft: 'Criar Rascunho de Matéria',
				createDraftHint: 'Cria uma matéria em rascunho pré-preenchida a partir do briefing e vincula a esta demanda. Você ainda pode vincular manualmente uma matéria já existente.',
				editorialTitle: 'Notas Editoriais',
				titleSuggestion: 'Sugestão de Título',
				notes: 'Notas',
				save: 'Salvar',
				transitionsTitle: 'Transições de Status',
				terminalStatus: 'Esta demanda chegou a um status final e não pode ser alterada.',
				timelineTitle: 'Linha do Tempo',
				requestedAt: 'Solicitada em',
				assignedAt: 'Atribuída em',
				publishedAt: 'Publicada em',
			},
			transitionDialog: {
				title: 'Alterar Status',
				message: 'Tem certeza de que deseja mover esta demanda para "{status}"?',
				confirm: 'Confirmar',
			},
			feedback: {
				loadError: 'Falha ao carregar as demandas de conteúdo.',
				loadDetailError: 'Falha ao carregar os detalhes da demanda.',
				assignSuccess: 'Jornalista atribuído com sucesso.',
				linkGameSuccess: 'Jogo vinculado com sucesso.',
				linkContentSuccess: 'Conteúdo vinculado com sucesso.',
				createDraftSuccess: 'Rascunho criado e vinculado. Abrindo o editor…',
				saveSuccess: 'Demanda atualizada com sucesso.',
				transitionSuccess: 'Status atualizado com sucesso.',
				actionError: 'Ocorreu um erro. Tente novamente.',
			},
		},
		guestWriterInvites: {
			title: 'Redatores Convidados',
			subtitle: 'Convide redatores externos para o creator mode de autoatendimento, com escopo por tipo de conteúdo.',
			newInvite: 'Novo Convite',
			filters: {
				all: 'Todos',
				pending: 'Pendentes',
				active: 'Ativos',
			},
			table: {
				email: 'E-mail',
				contentTypes: 'Tipos de Conteúdo',
				status: 'Status',
				invitedBy: 'Convidado Por',
				date: 'Data',
				actions: 'Ações',
			},
			status: {
				pending: 'Pendente',
				active: 'Ativo',
				expired: 'Expirado',
				revoked: 'Revogado',
			},
			contentTypes: {
				article: 'Artigo',
				review: 'Review',
				video: 'Vídeo',
			},
			form: {
				email: 'E-mail',
				contentTypes: 'Tipos de Conteúdo',
				send: 'Enviar Convite',
				cancel: 'Cancelar',
			},
			actions: {
				cancelInvite: 'Cancelar convite',
				revokeAccess: 'Revogar acesso',
			},
			confirmRevoke: 'Revogar o acesso deste redator convidado? Ele não poderá mais criar novo conteúdo.',
			confirmCancel: 'Cancelar este convite pendente?',
			emptyState: 'Nenhum convite de redator convidado ainda.',
			feedback: {
				loadError: 'Falha ao carregar os convites de redator convidado.',
				inviteSuccess: 'Convite enviado com sucesso.',
				inviteError: 'Falha ao enviar o convite.',
				cancelSuccess: 'Convite cancelado.',
				revokeSuccess: 'Acesso revogado.',
				actionError: 'Ocorreu um erro. Tente novamente.',
			},
		},
		wikigamer: {
			games: {
				achievements: {
					list: {
						title: 'Lista de Conquistas de Jogos do Mundo Gamer Community',
						subTitle: 'Confira a lista de Conquistas de Jogos cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Nova Conquista de Jogo',
						subTitle: 'Conquista de Jogo',
					},
				},
				types: {
					list: {
						title: 'Lista de Tipos de Jogos do Mundo Gamer Community',
						subTitle: 'Confira a lista de Tipos de Jogos cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Tipo de Jogo',
						subTitle: 'Tipo de Jogo',
					},
					update: {
						title: 'Editar Tipo de Jogo',
						subTitle: 'Tipo de Jogo',
					},
				},
				engines: {
					list: {
						title: 'Lista de Motores de Jogos do Mundo Gamer Community',
						subTitle: 'Confira a lista de Motores de Jogos cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Motor de Jogo',
						subTitle: 'Motor de Jogo',
					},
					update: {
						title: 'Editar Motor de Jogo',
						subTitle: 'Motor de Jogo',
					},
				},
				games: {
					list: {
						title: 'Lista de Jogos do Mundo Gamer Community',
						subTitle: 'Confira a lista de Jogos cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Jogo',
						subTitle: 'Preencha os campos abaixo para cadastrar um Jogo.',
					},
					Update: {
						title: 'Editar Jogo',
						subTitle: 'Preencha os campos abaixo para editar um Jogo.',
					},
				},
				genres: {
					list: {
						title: 'Lista de Gêneros de Jogos do Mundo Gamer Community',
						subTitle: 'Confira a lista de Gêneros de Jogos cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Gênero',
						subTitle: 'Gênero',
					},
					update: {
						title: 'Editar Gênero',
						subTitle: 'Gênero',
					},
				},
				modes: {
					list: {
						title: 'Lista de Modos de Jogos do Mundo Gamer Community',
						subTitle: 'Confira a lista de Modos de Jogos cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Modo de Jogo',
						subTitle: 'Modo de Jogo',
					},
					update: {
						title: 'Editar Modo de Jogo',
						subTitle: 'Modo de Jogo',
					},
				},
				perspectives: {
					list: {
						title: 'Lista de Perspectivas dos jogadores da Mundo Gamers',
						subTitle: 'Confira a lista de Perspectivas dos jogadores cadastradas na Mundo Gamer Community',
					},
					create: {
						title: 'Nova Perspectiva',
						subTitle: 'Perspectiva',
					},
					update: {
						title: 'Editar Perspectiva de Jogo',
						subTitle: 'Perspectiva de Jogo',
					},
				},
				status: {
					list: {
						title: 'Lista de Status de Jogos da Mundo Gamers',
						subTitle: 'Confira a lista de Status de Jogos cadastradas na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Status',
						subTitle: 'Status',
					},
					update: {
						title: 'Editar Status de Jogo',
						subTitle: 'Status de Jogo',
					},
				},

				themes: {
					list: {
						title: 'Lista de Temas de Jogos do Mundo Gamer Community',
						subTitle: 'Confira a lista de Temas de Jogos cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Tema',
						subTitle: 'Tema',
					},
				},
				websites: {
					list: {
						title: 'Lista de Websites do Mundo Gamer Community',
						subTitle: 'Confira a lista de Websites cadastrados na Mundo Gamer Community.',
					},
					create: {
						title: 'Novo Website',
						subTitle: 'Website',
					},
					update: {
						title: 'Editar Website',
						subTitle: 'Website',
					},
				},
				ratings: {
					esrb: {
						list: {
							title: 'Lista de ESRB do Mundo Gamer Community',
							subTitle: 'Confira a lista de ESRB cadastrados na Mundo Gamer Community.',
						},
						create: {
							title: 'Novo ESRB',
							subTitle: 'ESRB',
						},
					},
					pegi: {
						list: {
							title: 'Lista de Pegi do Mundo Gamer Community',
							subTitle: 'Confira a lista de Pegi cadastrados na Mundo Gamer Community.',
						},
						create: {
							title: 'Nova Pegi',
							subTitle: 'Pegi',
						},
					},
				},
				priceWatchlist: {
					list: {
						title: 'Lista de Preços de Consoles',
						subTitle: 'Jogos cadastrados manualmente para rastreamento de preço na Xbox, PSN ou Nintendo.',
					},
					create: {
						title: 'Adicionar à Lista de Preços',
						subTitle: 'Cadastre um jogo para rastreamento de preço em console.',
					},
					update: {
						title: 'Editar Item da Lista de Preços',
						subTitle: 'Item da Lista de Preços',
					},
					game: 'Jogo',
					secretStored: 'Salvo com segurança. Digite um novo valor só para substituir.',
				provider: 'Loja',
					externalId: 'ID do produto na loja',
					externalTitle: 'Título personalizado',
					externalTitleHint: 'Opcional — usa o nome do jogo por padrão',
					deleteConfirm: 'Remover este item da lista de preços?',
					noGameSelected: 'Busque e selecione um jogo primeiro',
					help: {
						xbox: 'ID do produto na Microsoft Store — o código no final de uma URL microsoft.com/store/productId/<id>.',
						psn: 'ID do produto na PS Store — o final de uma URL store.playstation.com/.../product/<id>.',
						nintendo: 'Slug do produto na Nintendo Store — o final de uma URL nintendo.com/.../store/products/<slug>/.',
					},
				},
			},
			eventsCategories: {
				list: {
					title: 'Lista de Categorias de Eventos da Mundo Gamer',
					subTitle: 'Confira a lista de Categorias de Eventos cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Nova Categoria de Evento',
					subTitle: 'Categoria de Evento',
				},
				update: {
					title: 'Editar Categoria de Evento',
					subTitle: 'Categoria de Evento',
				},
			},
			events: {
				list: {
					title: 'Lista de Eventos da Mundo Gamer',
					subTitle: 'Confira a lista de Eventos cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Evento',
					subTitle: 'CPreencha os campos abaixo para cadastrar um Evento.',
				},
			},
			regions: {
				list: {
					title: 'Lista de Regiões da Mundo Gamer',
					subTitle: 'Confira a lista de Regiões cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Nova Região',
					subTitle: 'Região',
				},
			},
			mediaTypes: {
				list: {
					title: 'Lista de Tipos de Mídia da Mundo Gamer',
					subTitle: 'Confira a lista de Tipos de Mídia cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Tipo de Mídia',
					subTitle: 'Tipo de Mídia',
				},
				update: {
					title: 'Atualizar Tipo de Mídia',
					subTitle: 'Atualizar de Tipo de Mídia',
				},
			},
			franchises: {
				list: {
					title: 'Lista de Franquias do Mundo Gamer Community',
					subTitle: 'Confira a lista de Franquias cadastrados na Mundo Gamer Community.',
				},
				create: {
					title: 'Nova Franquia',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Franquia.',
				},
				update: {
					title: 'Atualizar Franquia',
					subTitle: 'Preencha os campos abaixo para atualizar uma Franquia.',
				},
			},
			collections: {
				list: {
					title: 'Lista de Coleções do Mundo Gamer Community',
					subTitle: 'Confira a lista de Coleções cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Nova Coleção',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Coleção.',
				},
				update: {
					title: 'Editar Coleção',
					subTitle: 'Preencha os campos abaixo para editar uma Coleção.',
				},
			},

			genders: {
				list: {
					title: 'Lista de Gêneros da Mundo Gamer',
					subTitle: 'Confira a lista de Gêneros cadastrados na Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Gênero',
					subTitle: 'Gênero',
				},
				update: {
					title: 'Atualizar Gênero',
					subTitle: 'Gênero',
				},
			},

			phrases: {
				list: {
					title: 'Lista de Frases da Mundo Gamer',
					subTitle: 'Confira a lista de Frases cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Nova Frase',
					subTitle: 'Frase',
				},
				update: {
					title: 'Atualizar Frase',
					subTitle: 'Frase',
				},
			},
			species: {
				list: {
					title: 'Lista de Espécies da Mundo Gamer',
					subTitle: 'Confira a lista de Espécies cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Nova Espécie',
					subTitle: 'Espécie',
				},
				update: {
					title: 'Atualizar Espécie',
					subTitle: 'Espécie',
				},
			},
			characters: {
				list: {
					title: 'Lista de Personagens do Mundo Gamer Community',
					subTitle: 'Confira a lista de Personagens cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Personagem',
					subTitle: 'Preencha os campos abaixo para cadastrar um Personagem.',
				},
				update: {
					title: 'Atualizar Personagem',
					subTitle: 'Preencha os campos abaixo para atualizar Personagens',
				},
			},
			characterStatus: {
				list: {
					title: 'Lista de Status dos Personagens da Mundo Gamer',
					subTitle: 'Confira a lista de Status dos Personagens cadastrados na Mundo Gamer Community.',
				},
				create: {
					title: 'Novo Status de Personagens',
					subTitle: 'Status de Personagens',
				},
				update: {
					title: 'Atualizar Status de Personagens',
					subTitle: 'Status de Personagens',
				},
			},
			characterStatusWebsite: {
				list: {
					title: 'Lista de Status dos Personagens no site da Mundo Gamer',
					subTitle: 'Confira a lista de Status dos Personagens no site cadastrados na Mundo Gamer Community.',
				},
				create: {
					title: 'Status dos Personagens no site',
				},
			},
			achievements: {
				list: {
					title: 'Lista de Conquistas da Mundo Gamer',
					subTitle: 'Confira a lista de Conquistas cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Adicionar nova Conquista',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Conquista.',
				},
				update: {
					title: 'Atualizar Conquista',
					subTitle: 'Conquista',
				},
				delete: {
					title: 'A Conquista foi deletada com sucesso.',
				},
			},
			platforms: {
				list: {
					title: 'Lista de Plataformas da Mundo Gamer',
					subTitle: 'Confira a lista de Plataformas cadastradas na Mundo Gamer Community.',
				},
				create: {
					title: 'Adicionar nova Plataforma',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Plataforma.',
				},
			},
			platformsType: {
				list: {
					title: 'Lista de Tipos de Plataformas da Mundo Gamer',
					subTitle: 'Confira a lista de Tipos de Plataformas cadastradas na Mundo Gamer Community.',
				},
				update: {
					title: 'Atualizar Tipo de Plataforma',
				},
				create: {
					title: 'Novo Tipo de Plataforma',
					subTitle: 'Tipo de Plataforma',
				},
			},
			platformsFamily: {
				list: {
					title: 'Lista de Famílias de Plataformas da Mundo Gamer',
					subTitle: 'Confira a lista de Famílias de Plataformas cadastradas na Mundo Gamer Community.',
				},
				update: {
					title: 'Atualizar Família de Plataforma',
				},
				create: {
					title: 'Nova Família de Plataforma',
					subTitle: 'Família de Plataforma',
				},
			},
			platformsGenerations: {
				list: {
					title: 'Lista de Gerações de Plataformas da Mundo Gamer',
					subTitle: 'Confira a lista de Gerações de Plataformas cadastradas na Mundo Gamer Community.',
				},
				update: {
					headLine: 'Atualização de geração de plataformas',
					title: 'Item atualizado com sucesso',
				},
				create: {
					title: 'Nova Geração de Plataforma',
					subTitle: 'Geração de Plataforma',
					notification: 'Nova geração salva com sucesso',
				},
				delete: {
					title: 'Item Excluido com sucesso.',
				},
			},
		},

		translationQueue: {
			contentType: 'Tipo de conteudo',
			contentTypeId: 'Id do conteudo',
			list: {
				title: 'Lista de Traduções na Fila',
				subTitle: 'Verifique a lista de Traduções na Fila',
			},
			create: {
				title: 'Adicionar Tradução à Fila',
				subTitle: 'Tradução',
			},
			update: {
				title: 'Atualizar Tradução na Fila',
				subTitle: 'Tradução',
			},
			refresh: {
				button: 'Retraduzir',
			},
			modal: {
				title: 'Erro da Tradução',
			},
			notification: {
				create: 'Tradução adicionada à fila com sucesso',
				update: 'Tradução na fila atualizada com sucesso',
				reset: 'Tradução na fila reiniciada com sucesso',
				run: 'Tradução executada com sucesso',
				delete: 'Tradução foi removida da fila com sucesso',
			},
		},
	},

	network: {
		marketing: {
			campaignsBanners: {
				list: {
					title: 'Banners de Campanha',
					subTitle: 'Gerencie banners promocionais nas plataformas da Mundo Gamer Network.',
				},
				create: {
					title: 'Novo Banner de Campanha',
				},
				update: {
					title: 'Editar Banner de Campanha',
				},
				delete: {
					title: 'Banner de Campanha excluído com sucesso.',
				},
				approve: {
					title: 'Banner de Campanha aprovado com sucesso.',
				},
				reject: {
					title: 'Banner de Campanha reprovado.',
					reasonLabel: 'Motivo da reprovação',
					reasonPlaceholder: 'Explique o motivo da reprovação deste banner...',
				},
				fields: {
					imageWeb: 'Imagem Web (horizontal)',
					imageMobile: 'Imagem Mobile (opcional)',
					imageWebShort: 'Web',
					imageMobileShort: 'Mobile',
					title: 'Título',
					altText: 'Texto alternativo',
					destinationLink: 'Link de destino',
					utmSource: 'UTM Source',
					utmMedium: 'UTM Medium',
					utmCampaign: 'UTM Campaign',
					platforms: 'Plataformas',
					pageTags: 'Tags de página',
					targeting: 'Segmentação',
					worldwide: 'Mundial',
					byCountry: 'Por país',
					byLanguage: 'Por idioma',
					startDate: 'Data de início',
					endDate: 'Data de término',
					noDueDate: 'Sem prazo',
					priority: 'Prioridade',
					views: 'Visualizações',
					clicks: 'Cliques',
					type: 'Tipo',
					period: 'Período',
					pendingApproval: 'Aguardando aprovação',
				},
				pageTags: {
					home: 'Home',
					highlights: 'Destaques',
					sidebar: 'Sidebar',
				},
				types: {
					web: 'Web',
					app: 'App',
					both: 'Ambos (Web + App)',
				},
				platforms: {
					tv: 'TV',
					community: 'Community',
					jobs: 'Jobs',
					academy: 'Academy',
				},
			},
		},
		wall: {
			blocks: {
				list: {
					title: 'Lista de Blocos da Wall mais recentes no Mundo Gamer Network',
					subTitle: 'Confira a lista de Blocos da Wall cadastradas na Mundo Gamer Network.',
				},
				create: {
					title: 'Novo Bloco',
					subTitle: 'Preencha os campos abaixo para cadastrar um Bloco.',
				},
				update: {
					title: 'Editar Bloco',
				},
				delete: {
					title: 'O Bloco foi deletado com sucesso.',
				},
			},
			categories: {
				list: {
					title: 'Lista de Categorias da Wall mais recentes no Mundo Gamer Network',
					subTitle: 'Confira a lista de Categorias da Wall cadastradas na Mundo Gamer Network.',
				},
				create: {
					title: 'Nova Categoria',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Categoria.',
				},
				update: {
					title: 'Editar Categoria',
				},
				delete: {
					title: 'A Categoria foi deletada com sucesso.',
				},
			},
			maps: {
				list: {
					title: 'Lista de Mapas da Wall mais recentes no Mundo Gamer Network',
					subTitle: 'Confira a lista de Mapas da Wall cadastradas na Mundo Gamer Network.',
				},
				create: {
					title: 'Novo Mapa',
					subTitle: 'Preencha os campos abaixo para cadastrar um Mapa.',
				},
				update: {
					title: 'Editar Mapa',
				},
				delete: {
					title: 'O Mapa foi deletado com sucesso.',
				},
			},
			rewards: {
				list: {
					title: 'Lista de Recompensas da Wall mais recentes no Mundo Gamer Network',
					subTitle: 'Confira a lista de Recompensas da Wall cadastradas na Mundo Gamer Network.',
				},
				create: {
					title: 'Nova Recompensa',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Recompensa.',
				},
				update: {
					title: 'Editar Recompensa',
				},
				delete: {
					title: 'O Recompensa foi deletado com sucesso.',
				},
				fields: {
					pixels: 'Pixels',
				},
				addPixels: {
					title: 'Adicionar Pixels',
				},
			},
			grants: {
				list: {
					title: 'Pixels Gratuitos',
					subTitle: 'Envie pixels gratuitos para criadores, media partners, streamers e influencers.',
				},
				modal: {
					title: 'Enviar Pixels Gratuitos',
					send_pixels: 'Enviar Pixels',
					send: 'Enviar',
					email: 'E-mail do destinatário',
					name: 'Nome do destinatário (opcional)',
					pixel_count: 'Quantidade de Pixels',
					reward_optional: 'Recompensa para apoiar (opcional)',
					message: 'Mensagem pessoal (opcional)',
					origin_label: 'Tipo de destinatário',
					search_user: 'Buscar por nome ou e-mail',
					showcase: 'Showcase',
					select_showcase_first: 'Selecione um showcase primeiro',
					from_name: 'Enviado por (nome)',
					from_name_placeholder: 'Mundo Gamer Network',
					lang: 'Idioma do e-mail',
				},
				actions: {
					resend: 'Reenviar e-mail',
					resend_success: 'E-mail reenviado com sucesso.',
					cancel: 'Cancelar',
					cancel_title: 'Cancelar concessão',
					cancel_body: 'Cancelar a concessão de pixels para {email}? O link deixará de ser resgatável.',
					cancel_success: 'Concessão cancelada.',
				},
			},
			pixels: {
				sendGrant: {
					title: 'Enviar Pixels Gratuitos',
					action: 'Enviar Pixels Gratuitos',
					bulkAction: 'Enviar Pixels para Selecionados',
					bulkConfirm: 'Enviar pixels gratuitos para {count} influenciador(es) selecionado(s)?',
					bulkSuccess: 'Pixels enviados para {count} influenciador(es).',
					recipient: 'Destinatário',
					pixelCount: 'Quantidade de pixels',
					message: 'Mensagem (opcional)',
					send: 'Enviar',
					defaultMessages: {
						users: 'Você foi selecionado para receber pixels gratuitos no Wall of Legends!',
						influencers: 'Como influenciador parceiro, você recebeu pixels gratuitos no Wall of Legends!',
						mediaPartners: 'Como Media Partner, você recebeu pixels exclusivos no Wall of Legends!',
						gameContributions: 'Obrigado pela sua contribuição! Você ganhou pixels no Wall of Legends.',
						jobs: 'Você foi selecionado como candidato destaque e ganhou pixels no Wall of Legends!',
						gigs: 'Seu serviço foi destaque pela Mundo Gamer e você ganhou pixels gratuitos no Wall of Legends!',
						podcastGuests: 'Obrigado por ser convidado em nosso podcast! Você recebeu pixels gratuitos no Wall of Legends.',
					},
				},
			},
			complimentary: {
				sendEmail: {
					title: 'Enviar E-mail de Participação Wall of Legends',
					studio: 'Estúdio',
					recipient: 'Destinatário',
					hint: 'Este e-mail informará ao estúdio que sua participação é apoiada pela comunidade do Wall of Legends e os incentivará a ajudar outros no futuro.',
					message: 'Mensagem adicional (opcional)',
					messagePlaceholder: 'Adicione uma nota pessoal para o estúdio...',
					send: 'Enviar E-mail',
				},
			},
		},
		pipelines: {
			list: {
				title: 'Lista de Venda Pipelines mais recentes no Mundo Gamer Network',
				subTitle: 'Confira a lista de Venda Pipelines cadastrados na Mundo Gamer Network.',
			},
			create: {
				title: 'Nova Venda Pipeline',
				subTitle: 'Venda Pipeline',
			},
			update: {
				title: 'Editar Venda Pipeline',
			},
			delete: {
				title: 'A Venda Pipeline foi deletada com sucesso.',
			},
			fields: {
				final: 'Final',
			},
		},
		achievements: {
			list: {
				title: 'Conquistas',
				subTitle: 'Gerencie as conquistas de todas as plataformas Mundo Gamer',
			},
			create: {
				title: 'Nova Conquista',
			},
			update: {
				title: 'Editar Conquista',
			},
			tabs: {
				general: 'Geral',
				translations: 'Traduções',
			},
			fields: {
				category: 'Categoria',
				tier: 'Nível',
				triggerEvent: 'Evento Gatilho',
				triggerThreshold: 'Limite do Gatilho',
				xpReward: 'Recompensa em XP',
				mgcReward: 'Recompensa em MGC',
				idPrefix: 'ID:',
			},
		},
		translatables: {
			list: {
				title: 'Translatables',
				subTitle: 'Registros da tabela',
				create: 'Nova Tradução',
			},
			fields: {
				translatableType: 'Tipo Traduzível',
				translatableId: 'ID Traduzível',
				attribute: 'Atributo',
				translation: 'Tradução',
			},
			modal: {
				editTitle: 'Editar Traduções',
				createTitle: 'Novas Traduções',
				loadExisting: 'Carregar traduções existentes',
				loadingLanguages: 'Carregando idiomas...',
				save: 'Salvar Traduções',
				saved: 'Traduções salvas com sucesso.',
				saveError: 'Erro ao salvar traduções.',
			},
		},
		institutional: {
			mgCompanies: {
				list: {
					title: 'Lista de Empresas da Mundo Gamer',
					subTitle: 'Confira a lista de Empresas cadastradas na Mundo Gamer Network',
				},
				create: {
					title: 'Adicionar nova Empresa',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Empresa.',
				},
				update: {
					title: 'Atualize as informações da empresa',
					subTitle: 'Preencha os campos abaixo para atualizar esta Empresa.',
				},
				accounts: {
					noData: 'Não existe contas cadastradas nessa empresa :(',
					list: {
						title: 'Listagem de contas bancárias',
						subtitle: 'Confira a lista de Contas bancárias registradas na sua empresa',
					},
					update: {
						title: 'Atualize sua conta bancaria',
					},
					create: {
						title: 'Nova Conta',
						subTitle: 'Conta',
					},
					notification: 'Ação realizada com sucesso',
				},
			},
			apis: {
				list: {
					title: 'Lista de APIs',
					subTitle: 'Confira a lista de APIs cadastradas na Rede Mundo Gamer',
				},
				create: {
					title: 'Adicionar nova credencial API',
					subTitle: 'Credenciais',
				},
				fields: {
					docUrl: 'URL da Documentação',
					status: 'Status',
				},
			},
			credentials: {
				list: {
					title: 'Lista de Credenciais',
					subTitle: 'Confira a lista de Credenciais cadastradas na Rede Mundo Gamer',
				},
				paymentGuide: {
					title: 'Guia de Configuracao de Gateways de Pagamento',
					accountAbrev: 'account_abrev — Deve ser minusculo: paypal, stripe ou mercadopago. E o que o frontend envia para identificar o gateway.',
					defaultField: 'Default — Determina qual conta esta ativa para este gateway. Apenas UMA credencial por gateway pode ser default. Marcar uma como default desmarca a anterior automaticamente.',
					production: 'Production — OFF = Modo Sandbox/Teste, ON = Modo Producao. Para alternar ambientes, crie duas credenciais (sandbox + producao) e alterne qual e Default.',
					planProcessor: 'Plan Processor — Habilita esta credencial para pagamentos de assinatura. Pode ter uma por gateway. PayPal e Stripe podem processar assinaturas simultaneamente — o usuario escolhe no checkout.',
					status: 'Status — ON = Gateway aparece como opcao de pagamento em todos os frontends. OFF = Oculto dos usuarios. Desativar todas as credenciais de um gateway remove ele do checkout.',
					clientId: 'client_id — PayPal: Client ID / Stripe: Publishable Key (pk_...) / MercadoPago: Public Key',
					accessToken: 'access_token — PayPal: Secret / Stripe: Secret Key (sk_...) / MercadoPago: Access Token',
					important: 'Alterar a credencial Default afeta instantaneamente TODAS as plataformas (Jobs, TV, Community, Agency, AI, Academy, Wall of Legends). Sem necessidade de deploy.',
				},
				create: {
					title: 'Adicionar nova Credencial',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Credencial.',
				},
				update: {
					title: 'Atualize de credencial',
				},
				fields: {
					token: 'Token',
					pixelId: 'Pixel ID',
					url: 'URL',
					productionKeys: 'Chaves de Produção',
					defaultCredential: 'Credencial Padrão',
					planProcessor: 'Processador de Plano',
				},
				notification: {
					create: 'Nova credencial criada com sucesso.',
					update: 'Credencial atualizada com sucesso',
					delete: 'Credencial excluida com sucesso',
				},
			},
			companiesType: {
				list: {
					title: 'Lista de Tipos de Categorias de Empresas da Mundo Gamer',
					subTitle: 'Confira a lista de Tipos de Categorias de Empresas cadastradas na Mundo Gamer.',
				},
				create: {
					title: 'Novo Tipo de Categoria de Empresa',
					subTitle: 'Tipo de Categoria de Empresa',
				},
				delete: {
					title: 'O Tipo de Categoria de Empresa foi deletado com sucesso.',
				},
			},
		},
		contentBriefs: {
			templates: {
				title: 'Templates de Pauta',
				create: 'Novo Template',
				edit: 'Editar Template',
				confirmDelete: 'Tem certeza que deseja excluir este template?',
			},
			suggestions: {
				title: 'Pautas Semanais',
				detail: 'Detalhes das Sugestoes',
				generate: 'Gerar Sugestoes',
				generated: 'Sugestoes geradas com sucesso!',
				enrichAI: 'Enriquecer com IA',
				enriched: 'Sugestoes enriquecidas com contexto de tendencias!',
				currentWeek: 'Semana Atual',
				noSuggestions: 'Sem sugestoes para esta semana. Clique em "Gerar Sugestoes" para criar novas.',
				confirmSelection: 'Confirmar Selecao',
				selectionSaved: 'Pautas selecionadas salvas com sucesso!',
				history: 'Historico de Sugestoes',
			},
			pendingDrafts: {
				suggestTopic: 'Sugerir tema',
				suggestTitle: 'Sugerir um tema para o blog',
				suggestHint: 'Conte o que a Mundo Gamer fez: lancamento, parceria, nova plataforma, feature, atualizacao ou numeros. A IA escreve o artigo e os posts sociais a partir disso, sem inventar fatos.',
				suggestFieldTitle: 'Titulo do tema',
				suggestFieldDescription: 'O que aconteceu (fatos, numeros, datas)',
				suggestFieldCategory: 'Plataforma',
				suggestFieldAudience: 'Publico',
				suggestSubmit: 'Gerar rascunho',
				suggestSent: 'Tema enviado. O rascunho aparece aqui em instantes.',
				audAll: 'Todos',
				audCreators: 'Criadores',
				audStudios: 'Estudios',
				audGamers: 'Gamers',
				title: 'Rascunhos Pendentes',
				subtitle: 'Tela de apoio para revisar rascunhos de blog institucional gerados por IA, caso a notificacao de aprovacao no Telegram passe despercebida.',
				filterStatus: 'Status do Rascunho',
				statusPendingApproval: 'Aguardando Aprovacao',
				statusRejected: 'Rejeitado',
				statusPublished: 'Publicado',
				statusGenerating: 'Gerando',
				refresh: 'Atualizar',
				empty: 'Nenhum rascunho pendente',
				emptyHint: 'Os rascunhos gerados por IA aguardando revisao aparecerao aqui.',
				generatedAt: 'Gerado em',
				platformTarget: 'Plataforma',
				generating: 'O conteudo ainda esta sendo gerado...',
				socialPostTitle: 'Post social relacionado',
				noSocialPost: 'Nenhum post social foi gerado para este rascunho.',
				publish: 'Publicar',
				rewrite: 'Reescrever',
				reject: 'Rejeitar',
				confirmPublishTitle: 'Publicar este rascunho?',
				confirmPublishText: 'Isso ira publicar o post do blog imediatamente. Esta acao nao pode ser desfeita por aqui.',
				confirmPublishTextWithSocial: 'Isso ira publicar o post do blog E o post social acima imediatamente, em todas as plataformas listadas. Esta acao nao pode ser desfeita por aqui.',
				confirmRejectTitle: 'Rejeitar este rascunho?',
				confirmRejectText: 'O rascunho sera marcado como rejeitado e removido desta lista.',
				publishing: 'Publicando... o post ficara no ar em instantes.',
				rewriting: 'Reescrevendo... uma nova versao sera gerada em instantes.',
				rejected: 'Rascunho rejeitado com sucesso.',
			},
		},
		blog: {
			posts: {
				list: {
					title: 'Lista de postagens',
					subTitle: 'Confira a lista de posts cadastrados na Rede Mundo Gamer',
					institutionalGeneratorOn: 'Geração institucional por IA: LIGADA',
					institutionalGeneratorOff: 'Geração institucional por IA: DESLIGADA',
					institutionalGeneratorUnknown: 'Nao foi possivel ler o estado da geracao institucional.',
					institutionalGeneratorRetry: 'Tentar de novo',
					institutionalGeneratorEnabledNotice: 'Geração de conteúdo institucional ativada — a partir de agora vai consumir tokens ao selecionar rascunhos.',
					institutionalGeneratorDisabledNotice: 'Geração de conteúdo institucional desativada — nenhum token será consumido.',
				},
				create: {
					title: 'Nova postagem do Blog',
					subTitle: 'Preencha os campos abaixo para publicar uma postagem.',
				},
				update: {
					title: 'Atualizar postagem do Blog',
					subTitle: 'Atualize os campos abaixo para editar esta postagem.',
				},
				ai: {
					title: 'Gerar com IA',
					topic: 'Tema / Ideia',
					topicPlaceholder: 'Descreva o tema ou ideia para o post do blog...',
					tone: 'Tom',
					length: 'Tamanho do Conteudo',
					generate: 'Gerar Conteudo',
					generating: 'Gerando conteudo com IA...',
					generated: 'Conteudo gerado com sucesso!',
					suggest: 'Sugerir Topicos',
					suggestions: 'Sugestoes de Topicos',
				},
			},
			categories: {
				list: {
					title: 'Lista de Categorias',
					subTitle: 'Confira a lista de categorias cadastradas na Rede Mundo Gamer',
				},
				create: {
					title: 'Nova categoria do Blog',
					subTitle: 'Preencha os campos abaixo para cadastrar uma categoria.',
				},
			},
			tags: {
				list: {
					title: 'Lista Tags',
					subTitle: 'Confira a lista de Tags cadastradas no Mundo Gamer',
				},
				create: {
					title: 'Nova Tag',
				},
				update: {
					title: 'Editar Tag',
				},
				fields: {
					seoHeading: 'Otimização para Motores de Busca',
				},
			},
		},
		careers: {
			list: {
				title: 'Lista de Carreiras',
				subTitle: 'Confira a lista de carreiras cadastradas nas plataformas da Mundo Gamer Network',
			},
			create: {
				title: 'Nova Carreira',
				subTitle: 'Preencha os campos abaixo para cadastrar uma Carreira.',
			},
			applications: {
				list: {
					title: 'Lista de Candidaturas de Carreiras',
					subTitle: 'Confira a lista de candidaturas cadastradas nas plataformas da Mundo Gamer Network',
				},
				create: {
					title: 'Nova Candidatura',
					subTitle: 'Preencha os campos abaixo para publicar uma Candidatura.',
				},
				filter: {
					show: {
						label: 'Filtrar por',
						all: 'Todos',
						favorite: 'Favoritos',
						notFavorite: 'Não Favoritos',
						career: 'Carreira',
						city: 'Cidade',
						name: 'Nome',
						email: 'Email',
					},
				},
				detail: {
					personalInfo: 'Informações Pessoais',
					personalLinks: 'Links Pessoais',
					fullName: 'Nome Completo',
					pronoun: 'Pronome',
				},
			},
			skills: {
				list: {
					title: 'Lista de Habilidades de Carreiras',
					subTitle: 'Confira a lista de habilidades cadastradas nas plataformas da Mundo Gamer Network',
				},
				create: {
					title: 'Nova Habilidade',
					subTitle: 'Preencha os campos abaixo para cadastrar uma Habilidade.',
				},
			},
		},
		industrySectors: {
			list: {
				title: 'Lista de Categorias do Setor da Indústria Mundo Gamer',
				subTitle: 'Verifique a lista de Categorias do Setor registradas no Mundo Gamer.',
			},
			create: {
				title: 'Nova Categoria do Setor',
				subTitle: 'Categoria do Setor',
			},
			delete: {
				title: 'A Categoria do Setor foi deletada com sucesso.',
			},
		},

		socialiteProviders: {
			list: {
				title: 'Lista de Provedores de Socialites mais recentes do Mundo Gamer Network',
				subTitle: 'Confira a lista de Provedores de Socialites cadastrados na Mundo Gamer Network.',
			},
			create: {
				title: 'Novo Provedor de Socialite',
				subTitle: 'Preencha os campos abaixo para cadastrar um Provedor de Socialite.',
			},
			update: {
				title: 'Editar Provedor de Socialite',
			},
		},

		languages: {
			list: {
				title: 'Lista de Idiomas',
				subTitle: 'Verifique a lista de idiomas registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Idioma',
				subTitle: 'Idioma',
			},
			update: {
				title: 'Atualize um idioma',
			},
			delete: {
				title: 'Idioma Deletado com sucesso.',
			},
			notification: {
				create: 'Novo idioma cadastrado com sucesso.',
				update: 'Idioma atualizado com sucesso.',
				delete: 'Você tem certeza que deseja excluir este idioma?',
			},
		},
		cities: {
			list: {
				title: 'Lista de Cidades',
				subTitle: 'Verifique a lista de Cidades registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Cidade',
				subTitle: 'Preencha os campos abaixo para cadastrar uma nova Cidade.',
			},
			delete: {
				title: 'A Cidade foi deletada com sucesso.',
			},
		},
		countries: {
			list: {
				title: 'Lista de Países',
				subTitle: 'Verifique a lista de Países registrados nas plataformas da Indústria Mundo Gamer',
				usersFilter: {
					label: 'Filtro de usuários',
					all: 'Todos os países',
					with: 'Com usuários',
					without: 'Sem usuários',
					count: 'países',
				},
				taxMin: 'Imposto mín.',
				taxMax: 'Imposto máx.',
			},
			create: {
				title: 'Novo País',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo País.',
			},
		},
		nationalities: {
			list: {
				title: 'Lista de Nacionalidades',
				subTitle: 'Verifique a lista de Nacionalidades registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Nacionalidade',
				subTitle: 'Nacionalidade',
			},
		},
		regions: {
			list: {
				title: 'Lista de Regiões',
				subTitle: 'Verifique a lista de Regiões registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Região',
				subTitle: 'Preencha os campos abaixo para cadastrar uma nova Região.',
			},
			delete: {
				title: 'A Região foi deletada com sucesso.',
			},
		},
		states: {
			list: {
				title: 'Lista de Estados',
				subTitle: 'Verifique a lista de Estados registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Estado',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo Estado.',
			},
			delete: {
				title: 'O Estado foi deletado com sucesso.',
			},
		},
		timezones: {
			list: {
				title: 'Lista de Fusos Horários',
				subTitle: 'Verifique a lista de Fusos Horários registradas nas plataformas da Indústria Mundo Gamer',
			},
		},
		operationalArea: {
			list: {
				title: 'Lista de Áreas Operacionais',
				subTitle:
					'Verifique a lista de Áreas Operacionais registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Área Operacional',
				subTitle: 'Área Operacional',
			},
			update: {
				title: 'Atualize uma Área Operacional',
			},
			delete: {
				title: 'A área operacional: {item}, foi deletada com sucesso.',
			},
			notification: {
				create: 'Nova área operacional: {item}. Foi criada com sucesso!',
				update: 'Área Operacional: {item}. Atualizada com sucesso!',
				delete: 'Deseja excluir essa área operacional?',
			},
		},
		networkPlatforms: {
			list: {
				title: 'Lista de Plataformas do Mundo Gamer',
				subTitle: 'Verifique a lista de Plataformas registradas no Mundo Gamer Network',
			},
			create: {
				title: 'Nova Plataforma',
				subTitle: 'MG Plataforma',
			},
			delete: {
				title: 'A Plataforma foi deletada com sucesso.',
			},
			fields: {
				relevantText: 'Texto Relevante',
				badge: 'Selo',
			},
		},
		workflows: {
			list: {
				title: 'Lista de Status dos fluxos de trabalho mais recentes no Mundo Gamer Community',
				subTitle: 'Confira a lista de Status dos fluxos de trabalho cadastrados na Mundo Gamer Community.',
			},
			create: {
				title: 'Novo Status de fluxo de trabalho',
				subTitle: 'Status de fluxo de trabalho',
			},
			update: {
				title: 'Editar Status de fluxo de trabalho',
			},
			delete: {
				title: 'O Status de fluxo de trabalho foi deletado com sucesso.',
			},
		},
		editorialCalculationRules: {
			list: {
				title: 'Lista de modelos de precificação para níveis de jornalistas',
				subTitle: 'Confira a lista de itens cadastrados',
			},
			create: {
				title: 'Nova Regra de cálculo',
				subTitle: 'Regra de cálculo',
			},
			update: {
				title: 'Editar Regra de cálculo',
			},
			delete: {
				title: 'A Regra de cálculo foi deletada com sucesso.',
			},
		},
		editorialJournalistCategories: {
			list: {
				title: 'Lista de Categorias cadastradas de níveis de jornalistas',
				subTitle: 'Confira a lista de itens cadastrados',
			},
			create: {
				title: 'Nova Categoria',
				subTitle: 'Categoria',
			},
			update: {
				title: 'Editar Categoria',
			},
			delete: {
				title: 'A Categoria foi deletada com sucesso.',
			},
		},
		editorialContentTypes: {
			list: {
				title: 'Lista de tipos de conteúdo editorial',
				subTitle: 'Confira a lista de itens cadastrados',
			},
			create: {
				title: 'Novo tipo de conteúdo',
				subTitle: 'Tipo de conteúdo',
			},
			update: {
				title: 'Editar Tipo de conteúdo',
			},
			delete: {
				title: 'O tipo de conteúdo foi deletado com sucesso.',
			},
		},
		faqsCategories: {
			list: {
				title: 'Lista de Categorias de FAQS',
				subTitle:
					'Verifique a lista de Categorias de FAQS registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Categoria de FAQ',
				subTitle: 'Categoria de FAQ',
			},
			delete: {
				title: 'A Categoria de FAQ foi deletada com sucesso.',
			},
		},
		benefits: {
			list: {
				title: 'Lista de Benefícios de Planos',
				subTitle:
					'Verifique a lista de Benefícios de Planos registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Benefício',
				subTitle: 'Benefício de Plano',
			},
			delete: {
				title: 'O Benefício de Plano foi deletado com sucesso.',
			},
		},
		plans: {
			list: {
				title: 'Lista de Planos',
				subTitle: 'Verifique a lista de Planos registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Plano',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo Plano.',
			},
			fields: {
				selectBenefits: 'Selecione os benefícios do plano:',
				mgcValue: 'Valor em MGC',
				alias: 'Apelido',
				featureLimitsTab: 'Limites de Funcionalidades',
				configureFeatureLimits: 'Configure os limites de funcionalidades para este plano:',
				featureKey: 'Chave da Funcionalidade',
				limitValue: 'Valor Limite',
				enabled: 'Habilitado',
				tierLabel: 'Rótulo do Nível',
				popularHint: 'Selecione se este é um plano Popular.',
				businessHint: 'Selecione se este é um plano Empresarial.',
				saveFirstForLimits: 'Salve o plano primeiro antes de adicionar limites de funcionalidades.',
			},
			gatewaySync: {
				gatewaysColumn: 'Gateways',
				gatewayFilter: 'Gateways alvo',
				syncSelected: 'Sincronizar Selecionados',
				syncAll: 'Sincronizar Todos',
				refreshStatus: 'Atualizar status de sincronização',
				viewDetail: 'Ver detalhe da sincronização',
				syncThisPlan: 'Sincronizar este plano',
				confirmTitle: 'Confirmar sincronização com gateway',
				confirmAllText: 'Você está prestes a disparar jobs de sincronização para todos os {total} planos. Pode demorar um pouco. Continuar?',
				confirmSelectedText: 'Você está prestes a disparar jobs de sincronização para {count} plano(s) selecionado(s). Continuar?',
				targetGateways: 'Gateways alvo',
				targetAllGateways: 'Todos os gateways ativos serão alvo.',
				confirmDispatch: 'Disparar sincronização',
				detailTitle: 'Detalhe de sincronização com gateway',
				pricings: 'Preços',
				attempts: 'Tentativas de sincronização',
				gateway: 'Gateway',
				pricing: 'Preço',
				currency: 'Moeda',
				value: 'Valor',
				period: 'Período',
				statusLabel: 'Status',
				attemptedAt: 'Tentado em',
				completedAt: 'Concluído em',
				error: 'Erro',
				lastSyncedAt: 'Última sincronização',
				lastAttemptAt: 'Última tentativa em',
				awaitingExternal: 'Aguardando confirmação externa',
				skipped: 'Grátis (ignorado)',
				synced: 'Sincronizado',
				failed: 'Falhou',
				pending: 'Pendente',
				noAttempts: 'Sem tentativas de sincronização para este plano.',
				noCredentials: 'Nenhuma credencial de gateway ativa com sincronização de planos habilitada.',
				status: {
					synced: 'Sincronizado',
					partial: 'Parcial',
					pending: 'Pendente',
					failed: 'Falhou',
					missing: 'Ausente',
					skipped: 'Ignorado',
					free: 'Grátis',
					no_pricings: 'Sem preços',
					success: 'Sucesso',
				},
			},
		},
		members: {
			list: {
				title: 'Lista de Membros da Equipe',
				subTitle: 'Verifique a lista de Membros da Equipe registrados nas plataformas da Indústria Mundo Gamer',
				allMembers: 'Todos os Membros',
			},
			create: {
				title: 'Novo Membro da Equipe',
				subTitle: 'Membro da Equipe',
			},
			update: {
				title: 'Editar Membro da Equipe',
			},
		},
		listProject: {
			list: {
				title: 'Lista de Projetos do Mundo Gamer',
				subTitle: 'Verifique a lista de Projetos registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Projeto',
				subTitle: 'Projeto',
			},
			notification: {
				create: 'Novo projeto cadastrado com sucesso.',
				update: 'Projeto atualizado com sucesso.',
			},
		},
		creatorOutreach: {
			create: {
				title: 'Novo envio',
			},
			fields: {
				originPlatform: 'Plataforma de origem',
				audienceType: 'Tipo',
				listSource: 'Origem da lista',
				recipients: 'Destinatários',
				platform: 'Plataforma',
				conversion: 'Conversão',
			},
			list: {
				title: 'Base de convites',
			},
		},
		liveAnalytics: {
			demoMode: 'Modo demo',
			fullscreen: 'Tela cheia',
			backToAdmin: 'Voltar ao admin',
			removeFilter: 'Remover filtro',
			onlineNow: 'online agora',
		},
		emailLogs: {
			list: {
				title: 'Logs de Email',
			},
			fields: {
				previewEmail: 'Pré-visualizar email',
			},
		},
		finance: {
			executionMode: {
				title: 'Modo de execução de repasse',
				separateTransfer: 'Transferência separada',
				atomicSplit: 'Split atômico',
				description: {
					intro: 'Por vertical: ',
					middle: ' cobra o bruto na conta da MG e transfere depois, após a janela de maturação — é o único caminho hoje real para Gigs e Campanhas de Agência. ',
					middle2: ' divide o dinheiro no ato da cobrança via Stripe Connect (',
					tail: ') — sem saldo a solicitar depois. A mudança tem efeito imediato na próxima cobrança, sem deploy.',
				},
				loading: 'Carregando...',
				verticalColumn: 'Vertical',
				modeColumn: 'Modo',
				confirmDialog: {
					title: 'Confirmação',
					bodyIntro: 'Ativar ',
					bodyMiddle: ' para ',
					bodyTail: '? A partir da próxima cobrança, o dinheiro do criador já sai dividido no ato — não vai mais existir saldo pendente pra essa venda no fluxo de transferência.',
					no: 'Não',
					yes: 'Sim',
				},
				messages: {
					loadError: 'Não foi possível carregar os modos de execução.',
					modeUpdated: 'Modo de {vertical} atualizado.',
					modeUpdateError: 'Não foi possível atualizar o modo de execução.',
				},
			},
			payouts: {
				alert: {
					liveWarning: 'Dinheiro real pode sair da plataforma agora, para qualquer vertical marcada abaixo.',
					offInfo: 'Desligado hoje — nenhum criador é pago automaticamente em nenhuma vertical, mesmo que uma vertical individual esteja marcada abaixo. Ligar isto é o primeiro passo irreversível do programa de payouts: depende de uma conta Connect real configurada para a entidade legal da plataforma.',
				},
				masterSwitch: {
					title: 'Switch mestre',
					description: 'Controla se dinheiro pode sair da plataforma, para qualquer vertical. Antes controlado só por {envVar} no .env — agora aqui, com efeito imediato, sem deploy.',
					off: 'Desligado',
					on: 'Ligado',
				},
				perVertical: {
					title: 'Payout por vertical',
					description: 'Mesmo com uma vertical marcada, nada é pago enquanto o switch mestre acima estiver desligado.',
					loading: 'Carregando...',
					verticalColumn: 'Vertical',
					payoutColumn: 'Payout',
				},
				pilot: {
					title: 'Piloto (allowlist)',
					description: 'IDs de usuário liberados para receber payout de verdade enquanto o programa é validado. Lista vazia significa todo mundo — só some a restrição quando o piloto acabar, não é o ponto de partida recomendado.',
					inputLabel: 'IDs de usuário (Enter para adicionar)',
					save: 'Salvar allowlist',
					unsavedChanges: 'Alterações não salvas',
				},
				confirmDialog: {
					title: 'Confirmação',
					body: 'Ligar o switch mestre de payouts? A partir de agora, qualquer vertical marcada abaixo pode enviar dinheiro real para fora da plataforma, para os usuários na allowlist (ou para todo mundo, se a allowlist estiver vazia). Confirme que a conta Connect da entidade legal correta já está configurada antes de continuar.',
					no: 'Não',
					yesEnable: 'Sim, ligar',
				},
				messages: {
					loadError: 'Não foi possível carregar os payout flags.',
					masterOn: 'Switch mestre de payouts ligado.',
					masterOff: 'Switch mestre de payouts desligado.',
					masterUpdateError: 'Não foi possível atualizar o switch mestre.',
					verticalUpdated: 'Payout de {vertical} atualizado.',
					verticalUpdateError: 'Não foi possível atualizar a vertical.',
					allowlistUpdated: 'Allowlist atualizada.',
					allowlistUpdateError: 'Não foi possível atualizar a allowlist.',
				},
			},
		},
		keysList: {
			filter: {
				show: {
					label: 'Mostrar',
					all: 'Todos',
					missing: 'Chaves com traduções faltando',
				},
				organize: {
					label: 'Ordenar por',
					all: 'Todos',
					newest: 'Novos',
				},
				project: {
					all: 'Todos projetos',
					label: 'Projeto',
				},
			},
			list: {
				title: 'Lista de Chaves do Mundo Gamer',
				subTitle: 'Verifique a lista de Chaves registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Chave',
				subTitle: 'Chave',
			},
			update: {
				title: 'Atualize uma Chave',
			},
			delete: {
				title: 'Chave deletada com sucesso.',
			},
			notification: {
				create: 'Nova chave cadastrado com sucesso.',
				update: 'Chave atualizada com sucesso.',
				delete: 'Você tem certeza que deseja excluir esta chave?',
			},
		},
		partners: {
			list: {
				title: 'Lista de Parceiros',
				subTitle: 'Verifique a lista de Parceiros registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Parceiro',
			},
			update: {
				title: 'Editar Parceiro',
			},
			delete: {
				title: 'O Parceiro foi deletado com sucesso.',
			},
		},
		podcasts: {
			shows: {
				list: { title: 'Programas de Podcast', subTitle: 'Gerencie programas, apresentadores e agendas' },
				create: { title: 'Novo Programa' },
				update: { title: 'Editar Programa' },
				delete: { title: 'Programa deletado com sucesso' },
			},
			episodes: {
				list: { title: 'Episódios de Podcast', subTitle: 'Gerencie episódios, agendamento e publicação' },
				create: { title: 'Novo Episódio' },
				update: { title: 'Editar Episódio' },
				delete: { title: 'Episódio deletado com sucesso' },
				audio_section: 'Áudio (Feed RSS)',
				audio_url: 'URL do áudio (MP3)',
				audio_url_hint: 'Arquivo MP3 hospedado usado como enclosure no feed RSS (Spotify/Apple/Amazon)',
				audio_upload: 'Enviar MP3',
				audio_upload_hint: 'Envia o arquivo para o storage e preenche a URL do áudio e a duração. Substitui o arquivo anterior.',
				audio_save_first: 'Salve o episódio primeiro e depois envie o MP3.',
				audio_uploaded: 'Áudio enviado',
				audio_upload_error: 'Não foi possível enviar o áudio',
				audio_remove: 'Remover áudio',
				audio_remove_confirm: 'Remover o arquivo de áudio deste episódio? Ele sai do feed RSS.',
				audio_removed: 'Áudio removido',
				audio_approve: 'Aprovar para o feed',
				audio_unapprove: 'Tirar do feed',
				audio_approved: 'Áudio aprovado: já está no feed RSS',
				audio_unapproved: 'Áudio retirado do feed RSS',
				audio_status_approved: 'Aprovado (no feed)',
				audio_status_pending: 'Aguardando aprovação',
				duration_seconds: 'Duração (segundos)',
				chapters: 'Capítulos',
				add_chapter: 'Adicionar capítulo',
				chapter_start: 'Início',
				chapter_title: 'Título do capítulo',
			},
			guests: {
				list: { title: 'Convidados de Podcast', subTitle: 'Gerencie convites, status de consentimento e participação' },
				create: { title: 'Novo Convidado' },
				update: { title: 'Editar Convidado' },
				delete: { title: 'Convidado deletado com sucesso' },
				invite: { title: 'Convite enviado com sucesso', button: 'Enviar Convite' },
				consent: { title: 'Termo de cessão enviado. O convidado tem 48h para assinar.', button: 'Enviar Termo', failed: 'Falha ao enviar o termo de cessão.' },
			},
			hosts: {
				list: { title: 'Apresentadores de Podcast', subTitle: 'Gerencie apresentadores e suas atribuições' },
				create: { title: 'Novo Apresentador' },
				update: { title: 'Editar Apresentador' },
				delete: { title: 'Apresentador deletado com sucesso' },
			},
			sponsors: {
				list: { title: 'Espaços de Patrocínio', subTitle: 'Gerencie espaços de patrocínio para programas e episódios' },
				create: { title: 'Novo Espaço de Patrocínio' },
				update: { title: 'Editar Espaço de Patrocínio' },
				delete: { title: 'Espaço de patrocínio deletado com sucesso' },
			},
			consents: {
				list: { title: 'Termos de Cessão Digital', subTitle: 'Visualize termos assinados e documentos PDF' },
				revoke: { title: 'Termo revogado com sucesso' },
			},
			calendar: {
				today: 'Hoje',
				new_episode: 'Novo Episódio',
				new_episode_on_date: 'Novo episódio nesta data',
				episodes_tab: 'Episódios',
				guests_tab: 'Convidados',
				filter_by_show: 'Filtrar por Podcast',
				all_shows: 'Todos os Podcasts',
				recent_episodes: 'Últimos Episódios',
				upcoming_episodes: 'Próximos Episódios',
				no_recent: 'Nenhum episódio recente.',
				no_upcoming: 'Nenhum episódio programado.',
				day_detail: 'Episódios em',
				no_episodes_day: 'Nenhum episódio agendado para este dia.',
				create_episode_here: 'Criar episódio nesta data',
			},
		shows: {
				create: { title: 'Novo Programa' },
				update: { title: 'Editar Programa' },
				status: {
					active: 'Ativo',
					inactive: 'Inativo',
				},
				project_form: {
					yes: 'Sim',
					no: 'Não',
				},
				explicit: {
					yes: 'Sim',
					no: 'Não',
				},
				form: {
					name: 'Nome',
					short_description: 'Descrição Curta',
					description: 'Descrição',
					schedule_description: 'Descrição da Programação',
					schedule_description_placeholder: 'Ex: Toda segunda-feira às 20h',
					timezone: 'Fuso Horário',
					youtube_playlist_id: 'ID da Playlist do YouTube',
					status: 'Status',
					requires_project_form: 'Requer Formulário de Projeto',
					author: 'Autor / Nome do Responsável',
					email: 'E-mail do Responsável',
					itunes_category: 'Categoria no Apple Podcasts',
					explicit: 'Conteúdo Explícito',
					feed_url_label: 'URL do Feed RSS',
					feed_url_hint: 'Envie esta URL uma vez no Apple Podcasts Connect e no Spotify for Podcasters. Depois disso, episódios publicados aparecem automaticamente — sem nenhuma ação por episódio.',
					feed_url_copied: 'URL do feed copiada',
					save: 'Salvar Programa',
					update: 'Atualizar Programa',
					back_to_list: 'Voltar para a Lista',
				},
				sections: {
					schedule_playlist: 'Programação e Playlist',
					links: 'Links',
					translations: 'Traduções',
					cover_image: 'Imagem de Capa',
					distribution: 'Distribuição / Metadados Apple & Spotify',
					feed: 'Feed RSS',
				},
				links: {
					youtube: 'URL do YouTube',
					twitch: 'URL da Twitch',
					spotify: 'URL do Spotify',
					apple_podcasts: 'URL do Apple Podcasts',
					amazon_music: 'URL do Amazon Music',
					deezer: 'URL do Deezer',
				},
				list: {
					title: 'Shows de Podcast',
					loading: 'Carregando... Por favor aguarde',
					delete_confirm: 'Tem certeza que deseja excluir {name}?',
					no: 'Não',
					yes: 'Sim',
					col_name: 'Nome',
					col_slug: 'Slug',
					col_active: 'Ativo',
					col_requires_project_form: 'Form. de Projeto',
					col_schedule: 'Agenda',
					col_episodes: 'Episódios',
					col_actions: 'Ações',
				},
			},
			episodes: {
				create: { title: 'Novo Episódio' },
				update: { title: 'Editar Episódio' },
				audio_section: 'Áudio (Feed RSS)',
				audio_url: 'URL do áudio (MP3)',
				audio_url_hint: 'Arquivo MP3 hospedado usado como enclosure no feed RSS (Spotify/Apple/Amazon)',
				audio_upload: 'Enviar MP3',
				audio_upload_hint: 'Envia o arquivo para o storage e preenche a URL do áudio e a duração. Substitui o arquivo anterior.',
				audio_save_first: 'Salve o episódio primeiro e depois envie o MP3.',
				audio_uploaded: 'Áudio enviado',
				audio_upload_error: 'Não foi possível enviar o áudio',
				audio_remove: 'Remover áudio',
				audio_remove_confirm: 'Remover o arquivo de áudio deste episódio? Ele sai do feed RSS.',
				audio_removed: 'Áudio removido',
				audio_approve: 'Aprovar para o feed',
				audio_unapprove: 'Tirar do feed',
				audio_approved: 'Áudio aprovado: já está no feed RSS',
				audio_unapproved: 'Áudio retirado do feed RSS',
				audio_status_approved: 'Aprovado (no feed)',
				audio_status_pending: 'Aguardando aprovação',
				duration_seconds: 'Duração (segundos)',
				chapters: 'Capítulos',
				add_chapter: 'Adicionar capítulo',
				chapter_start: 'Início',
				chapter_title: 'Título do capítulo',
				status: {
					draft: 'Rascunho',
					scheduled: 'Agendado',
					live: 'Ao Vivo',
					recorded: 'Gravado',
					published: 'Publicado',
					cancelled: 'Cancelado',
				},
				yes_no: {
					yes: 'Sim',
					no: 'Não',
				},
				form: {
					podcast_show: 'Programa de Podcast',
					mundo_indie_project: 'Projeto Mundo Indie',
					mundo_indie_project_placeholder: 'Selecione um projeto para vincular o jogo...',
					game: 'Jogo',
					game_placeholder: 'Buscar um jogo...',
					guests: 'Convidados',
					guests_placeholder: 'Selecione os convidados para este episódio...',
					title: 'Título',
					title_placeholder: 'Título',
					description: 'Descrição',
					description_placeholder: 'Descrição',
					episode_number: 'Número do Episódio',
					season_number: 'Número da Temporada',
					overall_number: 'Nº geral do episódio',
					overall_number_hint: 'Numeração corrida entre temporadas, ex.: #43. Preenchido pelo título se ficar vazio.',
					placeholder_title_warning: 'Este ainda é o título provisório do agendamento. Dê o título real ao episódio antes de publicar.',
					duration_minutes: 'Duração',
					tags: 'Tags',
					tags_placeholder: 'Adicionar tags',
					status: 'Status',
					featured: 'Destaque',
					scheduled_at: 'Agendado Para',
					save: 'Salvar Episódio',
					update: 'Atualizar Episódio',
					back_to_list: 'Voltar à Lista',
				},
				sections: {
					links: 'Links',
					tags: 'Tags',
					thumbnail: 'Miniatura',
				},
				links: {
					youtube: 'URL do YouTube',
					twitch_vod: 'URL do VOD no Twitch',
					spotify: 'URL do Spotify',
					apple_podcasts: 'URL do Apple Podcasts',
					amazon_music: 'URL do Amazon Music',
					deezer: 'URL do Deezer',
				},
				list: {
					title: 'Episódios de Podcast',
					filter_by_show: 'Filtrar por Programa',
					filter_by_season: 'Temporada',
					filter_by_status: 'Status',
					search_hint: 'Buscar título, convidado, jogo, #44 ou T4E8',
					quick_upcoming: 'Próximos agendados',
					quick_overdue: 'Atrasados (ainda agendados)',
					gaps_title: 'Episódios gravados/publicados sem:',
					gaps: {
						thumbnail: 'Capa',
						youtube: 'Link do YouTube',
						spotify: 'Link do Spotify',
						audio: 'Áudio (RSS)',
						game: 'Jogo',
						guests: 'Convidados',
						duration: 'Duração',
						chapters: 'Capítulos',
						description: 'Descrição',
						overall_number: 'Nº geral',
						generic_title: 'Título provisório',
					},
					seasons_title: 'Temporadas ({count})',
					seasons_episodes: 'Episódios',
					seasons_games: 'Jogos',
					seasons_period: 'Período',
					loading: 'Carregando... Aguarde',
					delete_confirm: 'Tem certeza que deseja excluir {title}?',
					delete_no: 'Não',
					delete_yes: 'Sim',
					col_cover: 'Capa',
					col_audio: 'Áudio',
					play_audio: 'Ouvir o áudio do episódio',
					close_player: 'Fechar player',
					col_number: 'Nº · Temp. · Ep.',
					col_title: 'Título',
					col_show: 'Programa',
					col_game: 'Jogo',
					col_guests: 'Convidados',
					col_status: 'Status',
					col_scheduled_at: 'Agendado para',
					col_published_at: 'Publicado em',
					col_actions: 'Ações',
				},
			},
			guests: {
				create: { title: 'Novo Convidado' },
				update: { title: 'Editar Convidado' },
				status: {
					pending: 'Pendente',
					form_completed: 'Formulário preenchido',
					otp_verified: 'OTP verificado',
					consent_signed: 'Termo assinado',
					confirmed: 'Confirmado',
					scheduled: 'Agendado',
					completed: 'Concluído',
					cancelled: 'Cancelado',
					no_show: 'Não compareceu',
				},
				source: {
					admin: 'Admin',
					invite: 'Convite',
					self_submission: 'Inscrição direta',
				},
				consent: {
					title: 'Termo de cessão enviado. O convidado tem 48h para assinar.',
					button: 'Enviar Termo',
					confirm_name_email: 'Enviar termo de cessão para {name} ({email})?',
					confirm_hint: 'Um e-mail será enviado com o formulário de cessão para assinatura digital.',
				},
				invite: {
					title: 'Convite enviado com sucesso',
					button: 'Enviar Convite',
					confirm_name_email: 'Enviar convite para {name} ({email})?',
					confirm_hint: 'Um e-mail será enviado com o link para preencher o formulário de participação.',
				},
				action: {
					send_failed: 'Falha ao enviar e-mail.',
				},
				form: {
					full_name: 'Nome Completo',
					public_name: 'Nome público',
					public_name_hint: 'Aparece no site e no player. Vazio mostra só o primeiro e o último nome. O nome completo continua privado.',
					email: 'E-mail',
					email_placeholder: 'email@exemplo.com',
					phone: 'Telefone',
					birth_date: 'Data de Nascimento',
					company_name: 'Nome da Empresa',
					job_title: 'Cargo',
					bio: 'Biografia',
					notes_placeholder: 'Notas internas',
					source: 'Origem',
					invite_token: 'Token de Convite',
					tags_placeholder: 'Adicionar tags',
				},
				sections: {
					episodes: 'Episódios',
					notes: 'Notas',
					translatable_fields: 'Campos Traduzíveis',
					consent_status: 'Status de Consentimento',
					avatar: 'Avatar',
					photos: 'Fotos',
					status: 'Status',
				},
				consents: {
					type: 'Tipo',
					version: 'Versão',
					active: 'Ativo',
					active_label: 'Ativo',
					inactive_label: 'Revogado',
					granted_at: 'Concedido Em',
					pdf: 'PDF',
					download_pdf: 'Baixar PDF',
					none: 'Nenhum consentimento registrado.',
				},
				photos: {
					none: 'Nenhuma foto enviada.',
					upload: 'Enviar Fotos',
					upload_count: 'Enviar {count} foto(s)',
				},
				actions: {
					close: 'Fechar',
					save: 'Salvar Convidado',
					update: 'Atualizar Convidado',
					back_to_list: 'Voltar para Lista',
				},
				validation: {
					required: 'Este campo é obrigatório',
					email_invalid: 'Informe um e-mail válido',
				},
				messages: {
					saved: 'Salvo com sucesso',
					error_saving: 'Erro ao salvar convidado',
					error_invite: 'Erro ao enviar convite',
					photos_uploaded: 'Fotos enviadas com sucesso',
					error_photos: 'Erro ao enviar fotos',
					photo_removed: 'Foto removida',
					error_remove_photo: 'Erro ao remover foto',
					token_copied: 'Token copiado para a área de transferência',
				},
				list: {
					title: 'Convidados de Podcast',
					filter_status: 'Filtrar por Status',
					loading: 'Carregando... Aguarde',
					delete_confirm: 'Tem certeza que deseja excluir {name}?',
					col_full_name: 'Nome',
					col_email: 'E-mail',
					col_company: 'Empresa',
					col_source: 'Origem',
					col_status: 'Status',
					col_consent: 'Termo',
					col_created_at: 'Criado em',
					col_actions: 'Ações',
				},
				thankyou: {
					button: 'Obrigado',
					confirm_name_email: 'Enviar e-mail de agradecimento para {name} ({email})?',
					confirm_hint: 'Inclui link para compartilhar experiência, grupo do WhatsApp e CTA do Wall of Legends.',
					success: 'E-mail de agradecimento enviado com sucesso.',
				},
			},
			hosts: {
				create: { title: 'Novo Apresentador' },
				update: { title: 'Editar Apresentador' },
				status: {
					active: 'Ativo',
					inactive: 'Inativo',
				},
				form: {
					name: 'Nome',
					contact_email: 'E-mail de Contato',
					contact_email_hint: 'Usado para enviar aviso antecipado sobre convidados quando este apresentador não tem conta vinculada na plataforma',
					social_handle: 'Perfil Social',
					social_handle_placeholder: '@usuario',
					bio: 'Bio',
					youtube_url: 'URL do YouTube',
					youtube_url_placeholder: 'https://youtube.com/...',
					twitch_url: 'URL da Twitch',
					twitch_url_placeholder: 'https://twitch.tv/...',
					twitter_url: 'URL do Twitter',
					twitter_url_placeholder: 'https://twitter.com/...',
					instagram_url: 'URL do Instagram',
					instagram_url_placeholder: 'https://instagram.com/...',
					shows: 'Programas',
					status: 'Status',
				},
				sections: {
					social_links: 'Links Sociais',
					show_assignments: 'Programas Vinculados',
					avatar: 'Avatar',
				},
				actions: {
					save: 'Salvar Apresentador',
					update: 'Atualizar Apresentador',
					back_to_list: 'Voltar para Lista',
				},
				validation: {
					required: 'Este campo é obrigatório',
				},
				messages: {
					saved_successfully: 'Salvo com sucesso',
					error_saving: 'Erro ao salvar apresentador',
				},
				list: {
					title: 'Apresentadores de Podcast',
					loading_text: 'Carregando... Por favor aguarde',
					delete_confirm: 'Tem certeza que deseja excluir {name}?',
					no: 'Não',
					yes: 'Sim',
					col_name: 'Nome',
					col_social_handle: 'Perfil Social',
					col_shows: 'Programas',
					col_active: 'Ativo',
					col_actions: 'Ações',
				},
			},
			sponsors: {
				create: { title: 'Novo Espaço de Patrocínio' },
				update: { title: 'Editar Espaço de Patrocínio' },
				messages: {
					saved: 'Espaço de patrocínio salvo com sucesso.',
					error_saving: 'Erro ao salvar espaço de patrocínio.',
				},
				slot_type: {
					pre_roll: 'Pré-Roll',
					mid_roll: 'Meio',
					post_roll: 'Pós-Roll',
					title_sponsor: 'Patrocinador Título',
					segment_sponsor: 'Patrocinador de Segmento',
				},
				status: {
					available: 'Disponível',
					reserved: 'Reservado',
					sold: 'Vendido',
					fulfilled: 'Entregue',
				},
				form: {
					podcast_show: 'Programa de Podcast',
					episode: 'Episódio',
					slot_type: 'Tipo de Slot',
					label: 'Rótulo',
					company_id: 'ID da Empresa',
					price: 'Preço',
					price_placeholder: '0,00',
					notes: 'Observações',
					notes_placeholder: 'Notas internas',
					status: 'Status',
					save: 'Salvar Slot de Patrocinador',
					update: 'Atualizar Slot de Patrocinador',
					back_to_list: 'Voltar à Lista',
				},
				sections: {
					company_logo: 'Logo da Empresa',
				},
				list: {
					title: 'Espaços de Patrocínio',
					loading: 'Carregando... Por favor aguarde',
					delete_confirm: 'Tem certeza que deseja excluir',
					no: 'Não',
					yes: 'Sim',
					col_show: 'Programa',
					col_episode: 'Episódio',
					col_slot_type: 'Tipo de Slot',
					col_label: 'Rótulo',
					col_company: 'Empresa',
					col_price: 'Preço',
					col_status: 'Status',
					col_actions: 'Ações',
				},
			},
			consents: {
				list: {
					title: 'Termos de Cessão Digital',
					filter_consent_type: 'Filtrar por Tipo de Consentimento',
					filter_active: 'Filtrar por Ativo',
					loading: 'Carregando... Aguarde',
					status_active: 'Ativo',
					status_revoked: 'Revogado',
					download_pdf: 'Baixar PDF',
					revoke: 'Revogar',
					dialog_title: 'Revogar Consentimento',
					dialog_confirm_text: 'Tem certeza que deseja revogar o consentimento de {name}?',
					revoke_reason: 'Motivo da revogação',
					cancel: 'Cancelar',
					confirm_revoke: 'Confirmar Revogação',
					col_signer_name: 'Nome do Signatário',
					col_signer_email: 'E-mail do Signatário',
					col_consent_type: 'Tipo de Termo',
					col_version: 'Versão',
					col_status: 'Status',
					col_granted_at: 'Concedido em',
					col_otp_verified_at: 'OTP verificado em',
					col_revoked_at: 'Revogado em',
					col_signed_pdf: 'PDF',
					col_actions: 'Ações',
				},
			},
			slots: {
				status: {
					available: 'Disponível',
					reserved: 'Reservado',
					confirmed: 'Confirmado',
					cancelled: 'Cancelado',
				},
				list: {
					title: 'Slots de Gravação',
					loading: 'Carregando... Aguarde',
					filter_show: 'Filtrar por Programa',
					filter_season: 'Temporada',
					filter_status: 'Status',
					btn_generate: 'Agendar Temporada',
					btn_new: 'Novo Slot',
					col_show: 'Programa',
					col_season: 'Temporada',
					col_date: 'Data e Hora',
					col_guests: 'Convidados',
					col_status: 'Status',
					col_actions: 'Ações',
					season_prefix: 'Temporada',
					delete_confirm_title: 'Excluir slot?',
					delete_confirm_text: 'Excluir o slot de gravação do dia {date}?',
				},
				form: {
					title_new: 'Novo Slot de Gravação',
					title_edit: 'Editar Slot de Gravação',
					show: 'Programa de Podcast',
					season: 'Temporada',
					max_guests: 'Máx. de Convidados',
					max_guests_hint: 'Deixe vazio para ilimitado',
					scheduled_at: 'Data e Hora',
					status: 'Status',
					notes: 'Observações',
					required: 'Este campo é obrigatório',
					guests_title: 'Convidados',
					guests_empty: 'Nenhum convidado reservado neste slot ainda.',
					guests_search_label: 'Buscar convidado por nome ou e-mail',
					guests_add: 'Adicionar',
					guests_remove_confirm: 'Remover {name} deste slot?',
				},
				generate: {
					title: 'Agendar Temporada',
					hint: 'Escolha a data e hora do primeiro episódio. O mesmo dia da semana e horário serão repetidos para todos os episódios.',
					show: 'Programa de Podcast',
					season: 'Número da Temporada',
					first_episode_at: 'Primeiro Episódio — Data e Hora',
					count: 'Quantidade de Episódios',
					max_guests: 'Máx. de Convidados por Slot',
					max_guests_hint: 'Deixe vazio para ilimitado',
					btn_generate: 'Agendar',
					success: '{count} slots criados com sucesso.',
				},
			},
			calendar: {
				title: 'Calendário de Podcast',
				today: 'Hoje',
				new_episode: 'Novo Episódio',
				new_episode_on_date: 'Novo episódio nesta data',
				episodes_tab: 'Episódios',
				guests_tab: 'Convidados',
				filter_by_show: 'Filtrar por Podcast',
				all_shows: 'Todos os Podcasts',
				recent_episodes: 'Últimos Episódios',
				upcoming_episodes: 'Próximos Episódios',
				no_recent: 'Nenhum episódio recente.',
				no_upcoming: 'Nenhum episódio programado.',
				day_detail: 'Episódios em',
				no_episodes_day: 'Nenhum episódio agendado para este dia.',
				create_episode_here: 'Criar episódio nesta data',
				reschedule: 'Remanejar',
				cancel_guest: 'Cancelar agendamento',
				select_new_slot: 'Selecionar nova data',
				no_available_slots: 'Nenhuma data disponível para este podcast.',
				confirm_reschedule: 'Confirmar remanejamento',
				confirm_cancel_guest: 'Cancelar o agendamento de {name}? A vaga ficará disponível para outros.',
				cancel_guest_success: 'Agendamento cancelado.',
				reschedule_success: 'Convidado remanejado.',
				action_error: 'Algo deu errado. Tente novamente.',
			},
		},
		partnersCategories: {
			list: {
				title: 'Lista de Categorias de parceiros',
				subTitle:
					'Verifique a lista de Categorias de parceiros registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Categoria de parceiro',
				subTitle: 'Categoria de parceiro',
			},
			delete: {
				title: 'A Categoria de parceiro foi deletada com sucesso.',
			},
		},
		permissions: {
			list: {
				title: 'Lista de Permissões',
				subTitle: 'Verifique a lista de Permissões registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Permissão',
				subTitle: 'Permissão',
			},
		},
		roles: {
			list: {
				title: 'Lista de funções',
				subTitle: 'Verifique a lista de funções registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Função',
				subTitle: 'Função',
			},
			update: {
				title: 'Editar Função',
				notification: 'Função atualizado com sucesso.',
			},
			fields: {
				viewMembers: 'Ver membros',
			},
		},
		modules: {
			list: {
				title: 'Lista de Módulos',
				subTitle: 'Gerencie módulos do sistema e acesso a funcionalidades por plataforma',
			},
			create: {
				title: 'Novo Módulo',
			},
			update: {
				title: 'Atualizar Módulo',
			},
		},
		moduleAccess: {
			company: {
				title: 'Acesso de Módulos por Empresa',
				subTitle: 'Ative/desative módulos para uma empresa específica',
				selectCompany: 'Selecionar Empresa',
				modules: 'Módulos',
				module: 'Módulo',
				noModules: 'Nenhum módulo encontrado. Crie módulos primeiro na página de gerenciamento de Módulos.',
			},
			user: {
				title: 'Acesso de Módulos por Utilizador',
				subTitle: 'Substituir acesso de módulos para utilizadores individuais',
				searchUser: 'Pesquisar Utilizador',
				platform: 'Plataforma',
				module: 'Módulo',
				grant: 'Conceder Acesso',
				block: 'Bloquear',
				noOverrides: 'Nenhuma substituição de módulo para este utilizador. Todo o acesso segue os padrões da empresa/plano.',
			},
			overview: {
				title: 'Visão Geral dos Módulos por Plataforma',
				subTitle: 'Visão geral do acesso a módulos entre empresas por plataforma',
				selectPlatform: 'Selecionar Plataforma',
				enabled: 'Ativado',
				blocked: 'Bloqueado',
				userOverrides: 'Substituições de Utilizador',
				noModules: 'Nenhum módulo registado para esta plataforma ainda.',
			},
		},
		documentsWebsitesVersion: {
			list: {
				title: 'Lista de Versão de Documentos de Websites',
				subTitle:
					'Verifique a lista de Versão de Documentos de Websites registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Versão de Documento de Website',
				subTitle: 'Versão de Documento de Website',
			},
			delete: {
				title: 'A Versão de Documento de Website foi deletada com sucesso.',
			},
		},
		documentsTypes: {
			list: {
				title: 'Lista de Tipos de Documentos',
				subTitle:
					'Verifique a lista de Tipos de Documentos registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Tipo de Documentos',
				subTitle: 'Tipo de Documento',
			},
			delete: {
				title: 'O Tipo de Documento foi deletado com sucesso.',
			},
		},
		documentsWebsites: {
			list: {
				title: 'Lista de Documentos de Websites',
				subTitle:
					'Verifique a lista de Documentos de Websites registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Documento de Website',
				subTitle: 'Documento de Website',
			},
			delete: {
				title: 'O Documento de Website foi deletado com sucesso.',
			},
		},
		dayTips: {
			list: {
				title: 'Lista de Dicas do Dia',
				subTitle: 'Verifique a lista de Dicas do Dia registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Dica do Dia',
				subTitle: 'Dica do Dia',
			},
			delete: {
				title: 'A Dica do Dia foi deletada com sucesso.',
			},
		},
		announcementBanners: {
			list: {
				title: 'Banners de Anúncio',
				subTitle: 'Gerencie banners de anúncio exibidos em todas as plataformas.',
			},
			create: { title: 'Novo Banner' },
			edit: { title: 'Editar Banner' },
			delete: { title: 'Banner excluído com sucesso' },
			bgColor: 'Cor de fundo',
			textColor: 'Cor do texto',
			linkUrl: 'URL do Link',
			preset: 'Preset',
			noPresetHint: 'Nenhum preset selecionado — use a aba Traduções para adicionar uma mensagem personalizada.',
			linkText: 'Texto do link',
			globalBanner: 'Global (todas as plataformas)',
			startsAt: 'Data de início',
			endsAt: 'Data de término',
		},
		announcementBannerPresets: {
			list: {
				title: 'Presets de Banner',
				subTitle: 'Textos predefinidos disponíveis como opções rápidas para banners.',
			},
			create: { title: 'Novo Preset' },
			edit: { title: 'Editar Preset' },
			delete: { title: 'Preset excluído com sucesso' },
		},
		appBanners: {
			list: {
				title: 'Banners de Instalação do App',
				subTitle: 'Configure o banner institucional de instalação do app por plataforma. Apenas um ativo por plataforma por vez.',
			},
			create: { title: 'Novo Banner de App' },
			edit: { title: 'Editar Banner de App' },
			fields: {
				platformId: 'Plataforma',
				iosUrl: 'URL App Store',
				iosUrlHint: 'Ex.: https://apps.apple.com/app/id...',
				androidUrl: 'URL Google Play',
				androidUrlHint: 'Ex.: https://play.google.com/store/apps/details?id=...',
				qrCodeUrl: 'QR Code (modo claro)',
				qrCodeUrlDark: 'QR Code (modo escuro)',
				logoLightUrl: 'Logo (modo claro)',
				logoDarkUrl: 'Logo (modo escuro)',
				logoHint: 'URL da imagem — será redimensionada para 70% da área de logo',
				targetPlatformIds: 'Exibir também em',
				targetPlatformIdsHint: 'Mostra este banner em plataformas que não têm banner próprio (ex.: banner do Community no network-site)',
				isActive: 'Ativo',
			},
		},
		promotionBanners: {
			list: {
				title: 'Banners Promocionais',
				subTitle: 'Gerencie banners promocionais cross-platform.',
			},
			create: { title: 'Novo Banner Promocional' },
			edit: { title: 'Editar Banner' },
			delete: { title: 'Banner promocional excluído com sucesso' },
			bgColor: 'Cor de fundo',
			textColor: 'Cor do texto',
			imageLabel: 'Imagem do banner',
			imageHint: 'Recomendado: imagem horizontal (ex. 1280x360), JPG ou PNG',
			linkUrl: 'URL do link',
			linkText: 'Texto do link',
			linkTextHint: 'Use a aba Traduções para versões multilíngues',
			startsAt: 'Data de início',
			endsAt: 'Data de término',
			priority: 'Prioridade',
			maxImpressions: 'Máx. de impressões',
			maxImpressionsHint: 'Deixe vazio para ilimitado',
			globalBanner: 'Global (todas as plataformas)',
			translationsHint: 'Salve o banner primeiro para adicionar traduções de título, mensagem e texto do link.',
		},
		domains: {
			list: {
				title: 'Lista de Domínios',
				subTitle: 'Verifique a lista de Domínios registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Domínio',
				subTitle: 'Domínio',
				notification: 'Novo Domínio registrado com sucesso.',
			},
			update: {
				title: 'Atualize um Domínio',
				notification: 'Domínio atualizado com sucesso.',
			},
			delete: {
				title: 'O Domínio foi deletado com sucesso.',
			},
		},
		roadmap: {
			list: {
				title: 'Lista de Roadmaps',
				subTitle: 'Verifique a lista de Roadmaps registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Roadmap',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo Roadmap.',
			},
			update: {
				title: 'Atualize um Roadmap',
				notification: 'Roadmap atualizado com sucesso.',
			},
		},
		roadmapStatus: {
			list: {
				title: 'Lista de Status de Roadmaps',
				subTitle:
					'Verifique a lista de Status de Roadmaps registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Status de Roadmap',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo Status de Roadmap.',
			},
			delete: {
				title: 'O Status de Roadmap foi deletado com sucesso.',
			},
		},
		users: {
			list: {
				title: 'Lista de Usuários',
				subTitle: 'Verifique a lista de Usuários registrados nas plataformas da Indústria Mundo Gamer',
			},
			edit: {
				title: 'Editar Usuário',
				subTitle: 'Usuário',
			},
			anonymize: {
				action: 'Anonimizar Conta',
				title: 'Anonimizar Conta do Usuário',
				warning: 'Esta ação é irreversível. Todos os dados pessoais serão excluídos permanentemente em conformidade com a LGPD. O usuário receberá um e-mail de confirmação.',
				confirm: 'Sim, anonimizar',
				success: 'Conta anonimizada com sucesso. Um e-mail de confirmação foi enviado ao usuário.',
			},
			genders: {
				list: {
					title: 'Lista de Gêneros de Usuários',
					subTitle:
						'Verifique a lista dos Gêneros de Usuários registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Gênero',
					subTitle: 'Gênero',
				},
				delete: {
					title: 'O Gênero, foi deletado com sucesso.',
				},
			},
			notifications: {
				title: 'Notificações',
				preferredPushApp: 'App de push preferido',
				notifyDirectly: 'Notificar diretamente para estes templates',
			},
			groups: {
				list: {
					title: 'Grupos de Usuários (Papéis)',
					subTitle: 'Gerencie os papéis por plataforma e veja quantos usuários pertencem a cada grupo.',
				},
			},
		},
		pressMedia: {
			pressPosts: {
				list: {
					title: 'Lista de Posts da Imprensa',
					subTitle:
						'Verifique a lista de Posts da Imprensa registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Post',
					subTitle: 'Preencha os campos abaixo para publicar um novo Post da Imprensa.',
				},
				update: {
					title: 'Editar Post',
					subTitle: 'Preencha os campos abaixo para editar um Post da Imprensa.',
				},
			},
			mediaFiles: {
				list: {
					title: 'Lista de Arquivos de Mídia',
					subTitle:
						'Verifique a lista de Arquivos de Mídia registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Arquivo de Mídia',
					subTitle: 'Preencha os campos abaixo para publicar um novo Arquivo de Mídia.',
				},
			},
		},
		financial: {
			affiliates: {
				list: {
					title: 'Afiliados',
					subTitle: 'Lista de usuários cadastrados como afiliados na plataforma',
					coupons: 'Cupons Ativos',
					documentStatus: 'Status do Documento',
				},
				view: {
					paymentMethods: 'Métodos de Pagamento',
					commissions: 'Comissões',
					paymentRequests: 'Pedidos de Pagamento',
				},
				transactions: {
					title: 'Transações de Afiliados',
					subTitle: 'Pedidos de pagamento submetidos pelos afiliados',
					updatedMsg: 'Status atualizado com sucesso.',
					updateError: 'Erro ao atualizar o status.',
				},
			},
			affiliateCommissions: {
				list: {
					title: 'Lista de Comissões de Afiliados',
					subTitle:
						'Verifique a lista dos Comissões de Afiliadas registrados nas plataformas da Indústria Mundo Gamer',
				},
			},
			affiliateRequests: {
				list: {
					title: 'Lista de Pedidos de afiliados',
					subTitle:
						'Verifique a lista dos Pedidos de afiliados registrados nas plataformas da Indústria Mundo Gamer',
				},
				edit: {
					title: 'Editar',
					subTitle: 'Editar status do pedido',
				},
			},
			affiliateDocuments: {
				list: {
					title: 'Lista de Documentos de afiliados',
					subTitle:
						'Verifique a lista dos Documentos de afiliados registrados nas plataformas da Indústria Mundo Gamer',
				},
				edit: {
					title: 'Editar Status',
					subTitle: 'Editar status do documento',
				},
				review: {
					title: 'Revisar Documento de Afiliado',
					submissionDate: 'Data de Envio',
					reviewDate: 'Data de Revisão',
					paymentMethods: 'Métodos de Pagamento',
					paymentType: 'Tipo de Pagamento',
					bank: 'Banco',
					default: 'Padrão',
					noPaymentMethods: 'Nenhum método de pagamento cadastrado',
					approve: 'Aprovar',
					reject: 'Rejeitar',
					approvedMsg: 'Documento aprovado com sucesso.',
					rejectedMsg: 'Documento rejeitado com sucesso.',
					updateError: 'Erro ao atualizar status do documento.',
				},
			},
			banks: {
				list: {
					title: 'Lista de Bancos',
					subTitle: 'Verifique a lista dos Bancos registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Banco',
					subTitle: 'Preencha os campos abaixo para gerar uma Fatura.',
				},
			},
			cupons: {
				list: {
					title: 'Lista de Cupons de desconto',
					subTitle:
						'Verifique a lista dos Cupons de desconto registrados nas plataformas da Indústria Mundo Gamer',
				},
				update: {
					title: 'Atualize um Cupom de desconto',
				},
				create: {
					title: 'Novo Cupom de desconto',
				},
				delete: {
					title: 'O Cupom de desconto foi deletado com sucesso.',
				},
			},
			currencies: {
				list: {
					title: 'Lista de Moedas',
					subTitle: 'Verifique a lista dos Moedas registradas nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Nova Moeda',
					subTitle: 'Moeda',
				},
			},
			expensesCategories: {
				list: {
					title: 'Lista de Categorias de despesas',
					subTitle:
						'Verifique a lista dos Categorias de despesas registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Nova Categoria de despesa',
					subTitle: 'Categoria de despesa',
				},
				delete: {
					title: 'A Categoria de despesa foi deletada com sucesso.',
				},
			},
			invoices: {
				list: {
					title: 'Lista de Faturas',
					subTitle: 'Verifique a lista dos Faturas registradas nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Nova Fatura',
					subTitle: 'Preencha os campos abaixo para cadastrar uma nova Fatura.',
				},
				fields: {
					receiptPreview: 'Pré-visualização do recibo',
					billingVatHeading: 'Cobrança / CNPJ',
					billingCompany: 'Razão Social (Cobrança)',
					legalName: 'Nome Legal',
					vatNumber: 'Número de CNPJ/CPF',
					taxId: 'ID Fiscal',
					registrationNumber: 'Número de Registro',
					linkedCompany: 'Empresa Vinculada (CRM)',
					addressLine1: 'Endereço (Linha 1)',
					addressLine2: 'Endereço (Linha 2)',
					stateRegion: 'Estado / Região',
					globalTaxRate: 'Alíquota Global de Imposto (%)',
					documentLanguage: 'Idioma da fatura',
					documentLanguageHint: 'Idioma em que o documento de fatura/recibo será emitido.',
					paymentMethod: 'Forma de pagamento',
					amount: 'Valor cobrado',
					correctionReason: 'Motivo da correção',
					correctionReasonHint: 'Obrigatório — fica registrado no histórico da fatura.',
					currencyChangeHint: 'Trocar a moeda apenas troca o rótulo da fatura; os valores não são convertidos. Ajuste o valor também se ele mudar.',
					paymentMethodHint: 'Como o cliente realmente pagou, mesmo que a fatura tenha sido aberta por outro gateway.',
				},
				preview: {
					title: 'Pré-visualização ao vivo',
					subtitle: 'Exatamente o que será emitido — nada é salvo até você clicar em Salvar.',
					updating: 'Atualizando pré-visualização…',
					error: 'Não foi possível gerar a pré-visualização. Confira os campos acima.',
					refresh: 'Atualizar',
					openInNewTab: 'Abrir em nova aba',
					expand: 'Expandir',
					print: 'Imprimir',
					empty: 'Preencha a fatura para ver a pré-visualização.',
				},
				gateways: {
					stripe: 'Stripe',
					paypal: 'PayPal',
					pix: 'Pix',
					bankTransfer: 'Transferência Bancária',
					cash: 'Dinheiro',
					manual: 'Manual',
					other: 'Outro',
				},
				print: {
					invoiceNumber: 'Fatura #{number}',
					date: 'Data:',
					due: 'Vencimento:',
					payment: 'Pagamento:',
					billingVat: 'Cobrança / CNPJ',
					stateRegion: 'Estado/Região',
					items: 'Itens',
					hash: '#',
					qty: 'Qtd',
					subtotal: 'Subtotal:',
					taxPercent: 'Imposto ({rate}%):',
					totalLabel: 'Total:',
					note: 'Observação:',
				},
			},
			paymentMethods: {
				list: {
					title: 'Lista de Métodos de Pagamento',
					subTitle:
						'Verifique a lista dos Métodos de Pagamento registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Método de Pagamento',
					subTitle: 'Método de Pagamento',
				},
				delete: {
					title: 'O Método de Pagamento, foi deletado com sucesso.',
				},
			},
			paymentPeriods: {
				list: {
					title: 'Lista de Períodos de Pagamento',
					subTitle:
						'Verifique a lista dos Períodos de Pagamento registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Período de Pagamento',
					subTitle: 'Período de Pagamento',
				},
				delete: {
					title: 'O Período de Pagamento, foi deletado com sucesso.',
				},
			},
			paymentFees: {
				list: {
					title: 'Lista de Taxas de Pagamento',
					subTitle:
						'Verifique a lista dos Taxas de Pagamento registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Nova Taxa de Pagamento',
					subTitle: 'Taxa de Pagamento',
				},
				delete: {
					title: 'A Taxa de Pagamento, foi deletada com sucesso.',
				},
			},
			paymentRefunds: {
				list: {
					title: 'Lista de Reembolsos de Pagamento',
					subTitle:
						'Verifique a lista dos Reembolsos de Pagamento registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Reembolso de Pagamento',
					subTitle: 'Reembolso de Pagamento',
				},
				delete: {
					title: 'O Reembolso de Pagamento, foi deletado com sucesso.',
				},
			},
			paymentStatus: {
				list: {
					title: 'Lista de Status de Pagamento',
					subTitle:
						'Verifique a lista dos Status de Pagamento registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Status de Pagamento',
					subTitle: 'Status de Pagamento',
				},
				delete: {
					title: 'O Status de Pagamento, foi deletado com sucesso.',
				},
			},
			paymentTaxes: {
				list: {
					title: 'Lista de Pagamento de impostos',
					subTitle:
						'Verifique a lista dos Pagamento de impostos registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Pagamento de imposto',
					subTitle: 'Pagamento de imposto',
				},
				delete: {
					title: 'O Pagamento de imposto, foi deletado com sucesso.',
				},
			},
			paymentTypes: {
				list: {
					title: 'Lista de Tipos de Pagamento',
					subTitle:
						'Verifique a lista dos Tipos de Pagamento registrados nas plataformas da Indústria Mundo Gamer',
				},
				create: {
					title: 'Novo Tipo de Pagamento',
					subTitle: 'Tipo de Pagamento',
				},
				delete: {
					title: 'O Tipo de Pagamento, foi deletado com sucesso.',
				},
			},
			payouts: {
				fields: {
					taxDocumentOfPayment: 'Documento fiscal deste pagamento',
					invoiceOption: 'Nota Fiscal',
					noDocumentOption: 'Sem documento fiscal',
				},
				actions: {
					markProcessing: 'Marcar Em Processamento',
					markPaid: 'Marcar Pago',
				},
			},
			failedPayments: {
				list: {
					title: 'Pagamentos Falhados',
				},
				fields: {
					searchByEmail: 'Buscar por email',
					gateway: 'Gateway',
				},
			},
		},
		customCarts: {
			list: {
				title: 'Lista de Carrinhos personalizados',
				subTitle:
					'Verifique a lista de Carrinhos personalizados registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Carrinho personalizado',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo Carrinho personalizado.',
			},
			update: {
				title: 'Atualize um Carrinho personalizado',
				notification: 'Carrinho personalizado atualizado com sucesso.',
			},
		},
		abandonedCarts: {
			title: 'Carrinhos Abandonados',
			subtitle: 'Carrinhos onde o checkout nunca foi concluído. Revise a receita potencialmente perdida e limpe registros antigos.',
			widget: {
				title: 'Carrinhos Abandonados',
				seeDetail: 'Ver detalhes',
				windows: {
					'24h': '24H',
					'7d': '7D',
					'15d': '15D',
					'30d': '30D',
				},
			},
			filters: {
				dateFrom: 'De',
				dateTo: 'Até',
				apply: 'Filtrar',
			},
			metrics: {
				abandonedCount: 'Carrinhos Abandonados',
				potentialValueLost: 'Valor Potencial Perdido',
				conversionRate: 'Taxa de Conversão',
			},
			table: {
				uuid: 'Carrinho',
				user: 'Cliente',
				total: 'Total',
				coupon: 'Cupom',
				items: 'Itens',
				invoiceStatus: 'Fatura',
				createdAt: 'Abandonado em',
				actions: 'Ações',
			},
			invoiceStatus: {
				none: 'Sem Fatura',
				pending: 'Pendente',
				paid: 'Paga',
			},
			guest: 'Convidado',
			deleteConfirm: 'Tem certeza que deseja excluir este carrinho abandonado? Essa ação não pode ser desfeita.',
			feedback: {
				loadError: 'Falha ao carregar os carrinhos abandonados.',
				deleteSuccess: 'Carrinho excluído com sucesso.',
				deleteError: 'Falha ao excluir o carrinho.',
			},
		},
		products: {
			list: {
				title: 'Lista de Produtos',
				subTitle: 'Verifique a lista de Produtos registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Produto',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo Produto.',
			},
			update: {
				title: 'Atualize um Produto',
				notification: 'Produto atualizado com sucesso.',
			},
		},
		productBundles: {
			list: {
				title: 'Lista de Pacote de Produtos',
				subTitle:
					'Verifique a lista de Pacote de Produtos registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Pacote de Produto',
				subTitle: 'Preencha os campos abaixo para cadastrar um novo Pacote de Produto.',
			},
			update: {
				title: 'Atualize um Pacote de Produto',
				notification: 'Pacote de Produto atualizado com sucesso.',
			},
		},
		regionalPricing: {
			label: 'Preço regional',
			hint: 'Aplica o desconto por poder de compra neste item para compradores de uma região de preço. Deixe desligado para serviços B2B.',
			floor: 'Preço regional mínimo',
			floorHint: 'Este item nunca fica abaixo disso, em nenhuma região. Vazio usa o piso da própria região.',
		},
		pricingRegions: {
			list: {
				title: 'Regiões de preço por poder de compra',
				subTitle:
					'Compradores nesses países pagam em dólar com preço reduzido. Um preço já localizado (BRL, EUR, GBP) nunca recebe desconto por cima.',
				optInNotice:
					'A região só afeta produtos e pacotes com "Preço regional" habilitado. Os demais mantêm o preço único mundial.',
			},
			fields: {
				code: 'Código',
				codeHint: 'Identificador interno, ex.: tier_2',
				discountPercent: 'Desconto',
				minPrice: 'Preço mínimo',
				minPriceHint: 'O preço nunca cai abaixo deste valor',
				countries: 'Países',
				countriesHint: 'Um país pertence a apenas uma região — adicioná-lo aqui o remove de qualquer outra',
				preview: 'Exemplo: um produto anunciado a US$ {from} é cobrado a US$ {to} nesta região.',
			},
			create: {
				title: 'Nova região',
				subTitle: 'Preencha os campos abaixo para cadastrar uma nova região de preço.',
				notification: 'Região de preço criada com sucesso',
			},
			update: {
				title: 'Atualizar região',
				notification: 'Região de preço atualizada com sucesso',
			},
			delete: {
				title: 'A região de preço foi excluída com sucesso',
			},
			errors: {
				save: 'Não foi possível salvar a região de preço',
				delete: 'Não foi possível excluir a região de preço',
				countries: 'Não foi possível carregar a lista de países',
			},
		},
		productTags: {
			list: {
				title: 'Lista de Tags de Produtos',
				subTitle: 'Verifique a lista de Tags registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Tag',
				subTitle: 'Preencha os campos abaixo para cadastrar uma nova Tag.',
			},
			update: {
				title: 'Atualize uma Tag',
				notification: 'Tag atualizada com sucesso.',
			},
			delete: {
				title: 'A Tag, foi deletada com sucesso.',
			},
		},
		pageTags: {
			list: {
				title: 'Lista de Tags de Páginas',
				subTitle: 'Verifique a lista de Tags registradas nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Nova Tag',
				subTitle: 'Preencha os campos abaixo para cadastrar uma nova Tag.',
			},
			update: {
				title: 'Atualize uma Tag',
				notification: 'Tag atualizada com sucesso.',
			},
			delete: {
				title: 'A Tag, foi deletada com sucesso.',
			},
		},
		documentsManageMarketing: {
			list: {
				title: 'Lista de Documentos de Apresentação',
				subTitle:
					'Verifique a lista de Documentos de Apresentação registrados nas plataformas da Indústria Mundo Gamer',
			},
			create: {
				title: 'Novo Documento de Apresentação',
				subTitle: 'Documento de Apresentação',
			},
			delete: {
				title: 'O Documento de Apresentação foi deletado com sucesso.',
			},
		},
	},

	jobs: {
		recruiterProspects: {
			title: 'Prospecção de Recrutadores',
			subTitle: 'Descubra recrutadores e contatos de RH e convide-os a conhecer o Mundo Gamer Jobs.',
			role: 'Cargo',
			engagement: 'Engajamento',
			engagementOpened: 'Abriu',
			engagementNotOpened: 'Não abriu',
			engagementNotSent: 'Não enviado',
			bulkSending: 'Enviando {done}/{total}…',
			sequencePanelTitle: 'Sequência de follow-up (o que sai e quem está em cada passo)',
			sequenceDay: 'Dia {n}',
			sequenceStepInvite: 'Convite',
			sequenceStepAts: 'Pitch de ATS',
			sequenceStepScale: 'Pitch de escala',
			sequenceSubjectInvite: '"Conheça o Mundo Gamer Jobs"',
			sequenceSubjectAts: '"Seu processo de contratação merece mais que WhatsApp e planilha"',
			sequenceSubjectScale: '"Contratando em volume? Isso muda o jogo" (último e-mail)',
			sequenceDue: '{count} saem na próxima rodada das 06:00',
			sequenceEnded: 'Encerrados (descadastro ou removidos)',
			sequenceClear: 'Limpar filtro',
			sequenceNextStep: 'Próximo e-mail',
			sequenceNextDue: 'Dia {day}: sai na próxima rodada (06:00)',
			sequenceNextIn: 'Dia {day}: em {n} dia(s)',
			sequenceUpdated: '{count} prospect(s) atualizado(s)',
			sequencePausedNote: 'Os follow-ups estão em espera. Retome para continuar do passo que as datas de envio mostram.',
			funnelPaused: 'Pausado',
			pauseSequence: 'Pausar follow-ups ({count})',
			resumeSequence: 'Retomar follow-ups ({count})',
			selectAllNotSent: 'Selecionar todos sem e-mail enviado',
			selectedNotSent: '{count} contato(s) selecionado(s): têm e-mail, nunca receberam e não se descadastraram',
			confirmBulkSend: 'Enviar o convite para {count} contato(s)? Cada um sai no seu idioma (inglês se não houver), com o link de descadastro e o rastreio de abertura.',
			checkUnsubscribeOk: 'Link de descadastro: presente',
			checkUnsubscribeMissing: 'Link de descadastro: AUSENTE',
			checkPixelOnSend: 'Pixel de abertura: entra no envio',
			noPixel: 'sem pixel de rastreio (aberturas desconhecidas)',
			engagementOpenedTimes: 'Abriu {count}×',
			hiringOnly: 'Só estúdios com vagas abertas',
			emailsSent: 'E-mails enviados',
			lastOpened: 'Última abertura',
			mail_invite: 'Convite',
			mail_nurture: 'Follow-up',
			openRoles: 'Vagas abertas',
			careersUrl: 'Página de carreiras',
			companyName: 'Empresa',
			linkedinUrl: 'URL do LinkedIn',
			website: 'Site',
			linkedin: 'Ver LinkedIn',
			openLinkedin: 'Abrir LinkedIn',
			roleKeywords: 'Termos de busca (cargo)',
			termsRequired: 'Informe ao menos um termo de busca (ex.: "recrutador", "talent acquisition").',
			discoverHint: 'Busca no LinkedIn via Apify. Requer configuração do Apify (credencial apify_linkedin). Caso contrário, use entrada manual ou importação do ClickUp.',
			sendInviteOnAdd: 'Enviar convite agora',
			sendInviteOnAddHint: 'Envia o e-mail de convite assim que o contato for salvo, em vez de enviar depois pelas opções da linha.',
			add: 'Adicionar prospect',
			editProspect: 'Editar prospect',
			invite: 'Convidar',
			sendInvite: 'Enviar convite',
			inviteSent: 'Convite enviado.',
			discover: 'Descobrir (Apify)',
			maxResults: 'Máx. resultados',
			sendSelected: 'Enviar selecionados ({count})',
			bulkInviteResult: '{sent} convite(s) enviado(s), {failed} falharam.',
			bulkInviteResultsTitle: 'Resultado do envio',
			editEmail: 'Editar e-mail',
			discoverQueued: 'Descoberta iniciada em segundo plano — você será avisado quando terminar.',
			discoverBusy: 'Já existe uma descoberta em andamento. Aguarde terminar.',
			apifyUsage: 'Consumo Apify',
			apifyNotConfigured: 'Apify não configurado',
			apifyActive: 'ativa',
			details: 'Detalhes',
			discoveredVia: 'Descoberto via',
			notes: 'Notas',
			email: 'E-mail',
			hasEmail: 'Com e-mail',
			noEmail: 'Sem e-mail',
			emailLanguage: 'Idioma do e-mail',
			emailSubject: 'Assunto',
			emailBody: 'Mensagem',
			emailBodyHint: 'Deixe uma linha em branco entre parágrafos.',
			emailPreview: 'Pré-visualização',
			companyMatched: 'Já é cliente do Jobs',
			companyMatchedHint: 'O nome da empresa bateu com uma conta real, já cadastrada no Jobs.',
			companyProspectMatched: 'Conhecida pelo BD da Agency',
			companyProspectMatchedHint: 'O nome da empresa bateu com um contato de BD já existente no agency-api (ainda sem conta cadastrada).',
			sequence: 'Sequência',
			funnelStage0: 'Convite enviado',
			funnelStage1: 'Follow-up ATS enviado',
			funnelStage2: 'Follow-up Escala enviado',
			funnelConverted: 'Convertido',
			funnelStopped: 'Interrompido',
			funnelNotInvited: 'Ainda não convidado',
			funnelUnsubscribed: 'Descadastrado',
			savedButUnsubscribed: 'Contato salvo, mas o e-mail de convite não foi enviado — este endereço está descadastrado.',
			checkRegistration: 'Verificar cadastro',
			registrationFound: 'Este prospect agora tem conta cadastrada — vinculado e marcado como registrado.',
			registrationNotFound: 'Nenhuma conta cadastrada correspondente foi encontrada ainda.',
			registeredAs: 'Cadastrado como',
		},
		linkedinNewsletter: {
			list: {
				title: 'Newsletter do LinkedIn — MG Jobs',
				subTitle: 'Drafts semanais da newsletter do LinkedIn gerados a partir de matérias recentes do community e hot jobs. Revise, escolha um ângulo e copie o markdown para o LinkedIn.',
				configure: 'Configurar',
				generateNow: 'Gerar agora',
				generateDispatched: 'Newsletter gerada.',
				generateFailed: 'Não foi possível disparar a geração. Verifique a configuração ativa.',
				confirmDelete: 'Apagar este draft da newsletter? Não tem como desfazer.',
				deleted: 'Draft apagado.',
				deleteFailed: 'Não foi possível apagar o draft.',
				retryDone: 'Nova tentativa concluída.',
				retryFailed: 'Nova tentativa falhou — veja o draft para detalhes.',
			},
			fields: {
				edition: 'Edição',
				editionPrefix: 'Newsletter ',
				week: 'Semana',
				angleTitle: 'Ângulo editorial',
				status: 'Status',
				generatedAt: 'Gerada em',
				title: 'Título',
				publishedAt: 'Publicada em',
				views: 'Views',
				company: 'Empresa',
				featured: 'Destaque',
				untitled: 'Draft sem título',
			},
			status: {
				pending: 'Pendente',
				suggestions_ready: 'Sugestões prontas',
				generating: 'Gerando',
				draft_ready: 'Draft pronto',
				published: 'Publicada',
				failed: 'Falhou',
			},
			edit: {
				title: 'Draft da newsletter',
				anglesTitle: 'Ângulos editoriais',
				resuggest: 'Sugerir novamente',
				noAngles: 'Nenhum ângulo ainda — a etapa de sugestão pode estar rodando.',
				customAngleOption: 'Escrever meu próprio ângulo',
				customAngleHint: 'Ignorar as sugestões da IA acima e escrever o ângulo editorial você mesmo.',
				customAngleTitle: 'Título do ângulo customizado',
				customAngleSummary: 'Resumo do ângulo customizado',
				pulsesTitle: 'Matérias a incluir',
				jobsTitle: 'Hot jobs em destaque',
				noPulses: 'Nenhuma matéria encontrada no snapshot. Tente Carregar mais ou Sugerir novamente.',
				noJobs: 'Nenhuma vaga em destaque disponível no momento.',
				loadMorePulses: 'Carregar mais matérias',
				loadMoreFailed: 'Não foi possível carregar mais matérias.',
				loadMoreJobs: 'Carregar mais vagas',
				loadMoreJobsFailed: 'Não foi possível carregar mais vagas.',
				actionsTitle: 'Ações',
				saveSelection: 'Salvar seleção',
				generateFinal: 'Gerar markdown final',
				markPublished: 'Marcar como publicada',
				notes: 'Notas',
				selectionSaved: 'Seleção salva.',
				selectionSaveFailed: 'Não foi possível salvar a seleção.',
				resuggestDone: 'Novas sugestões de ângulo prontas.',
				generateFinalDone: 'Markdown final gerado.',
				failureTitle: 'Falha na geração',
				genericFailure: 'O runner não conseguiu concluir. Veja o log do Laravel ou o generation_metadata para detalhes.',
				retry: 'Tentar de novo',
				providerSwitched: 'Provedor de IA atualizado. Clique em Tentar de novo para re-rodar com o novo provedor.',
				providerSwitchFailed: 'Não foi possível atualizar o provedor de IA.',
				generateFinalFailed: 'Não foi possível disparar a geração final.',
				markedPublished: 'Newsletter marcada como publicada.',
			},
			preview: {
				title: 'Preview do markdown',
				rendered: 'Renderizado',
				raw: 'Raw',
				copy: 'Copiar',
				copied: 'Markdown copiado para a área de transferência.',
				copyFailed: 'Não foi possível copiar para a área de transferência.',
				empty: 'Nenhum markdown ainda. Escolha um ângulo e clique em "Gerar markdown final".',
			},
			config: {
				title: 'Newsletter do LinkedIn — configuração',
				subTitle: 'Padrões usados pelo cron da sexta de manhã e pelo botão "Gerar agora".',
				name: 'Nome do template',
				isActive: 'Ativa',
				bannerUrl: 'URL do banner',
				ctaTextEn: 'Texto da CTA (EN)',
				ctaTextPt: 'Texto da CTA (PT-BR)',
				ctaUrl: 'URL da CTA',
				toneOfVoice: 'Tom de voz',
				targetAudience: 'Público-alvo',
				pulsesCount: 'Matérias a enviar para a IA',
				jobsCount: 'Hot jobs a enviar para a IA',
				llmProvider: 'Provedor de IA',
				providerAuto: 'Auto (o que tiver credencial)',
				providerAnthropic: 'Anthropic Claude',
				providerOpenai: 'OpenAI GPT',
				angleSuggestionPrompt: 'Prompt para sugestão de ângulos (override opcional)',
				finalGenerationPrompt: 'Prompt para geração final (override opcional)',
				promptHint: 'Placeholders suportados: {{tone}}, {{audience}}, {{pulses}}, {{jobs}}, {{angle}}, {{cta_text}}, {{cta_url}}, {{banner_url}}',
				saved: 'Configuração salva.',
				saveFailed: 'Não foi possível salvar a configuração.',
			},
		},
		urlChecker: {
			search: 'Buscar por título',
			filter: 'Filtrar',
			refreshStats: 'Atualizar',
			checkAll: 'Rodar Agora',
			checkAllDispatched: 'Verificação em lote disparada. Você receberá um resumo no Telegram quando concluir.',
			recheck: 'Re-verificar',
			reactivate: 'Reativar',
			recheckDone: 'Re-verificação concluída',
			overrideDone: 'Vaga reativada',
			widget: {
				title: 'Verificador de URLs',
				unchecked: 'Não verificadas',
				needsAttention: 'Precisam de atenção',
				goToChecker: 'Ir para o verificador',
				runNow: 'Rodar Agora',
				allGood: 'Todas as URLs estão ativas.',
			},
			settings: {
				title: 'Automação',
				autoDeactivate: 'Ativar desativação automática',
				autoDeactivateHint: 'Quando uma verificação encontrar uma vaga inativa ou com erro, age automaticamente',
				deactivateInSystem: 'Desativar a vaga no sistema',
				deactivateInSystemHint: 'Quando ativo, marca a vaga como inativa no sistema. Quando desativo, apenas atualiza o status do verificador de URL.',
				saved: 'Configurações salvas',
			},
			status: {
				all: 'Todos',
				active: 'Ativa',
				inactive: 'Inativa',
				error: 'Erro',
				needs_review: 'Revisar',
				unchecked: 'Não verificada',
				disabled: 'Desativada',
			},
			columns: {
				vacancy: 'Vaga',
				status: 'Status',
				http: 'HTTP',
				confidence: 'Confiança',
				reason: 'Motivo',
				checkedAt: 'Verificado em',
				checkActive: 'Check',
				actions: 'Ações',
			},
		},
		statusmentorships: {
			list: {
				title: 'Lista de Status do recrutamento de mentores mais recentes no Mundo Gamer Jobs',
				subTitle: 'Confira a lista de Status do recrutamento de mentores cadastrados na Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Status do recrutamento de mentores',
				subTitle: 'Status do recrutamento de mentores',
			},
			update: {
				title: 'Editar Status do recrutamento de mentores',
			},
			delete: {
				title: 'O Status do recrutamento de mentores foi deletado com sucesso.',
			},
		},
		vacancies: {
			list: {
				title: 'Lista de Vagas Mundo Gamer',
				subTitle: 'Verifique a lista de Vagas registradas do Mundo Gamer Jobs.',
				filterAll: 'Todas',
				filterPending: 'Pendentes',
				filterApproved: 'Aprovadas',
				filterRejected: 'Rejeitadas',
			},
			optionalOrderBy: {
				most_relevant: 'Mais populares',
				featured: 'Promovidas',
				newest: 'Mais Recentes',
				close_expiration: 'Expirando',
				expired: 'Encerradas',
				oldest: 'Mais Antigas',
				pending_first: 'Pendentes Primeiro',
			},
			create: {
				title: 'Nova vaga',
				subTitle: 'Preencha os campos abaixo para cadastrar uma Vaga.',
			},
			delete: {
				title: 'A Vaga foi deletada com sucesso.',
			},
		},
		vacanciesStatus: {
			list: {
				title: 'Lista de Status de Vagas da Mundo Gamer',
				subTitle: 'Verifique a lista de Status de Vagas registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Status de Vaga',
				subTitle: 'Status de Vaga',
			},
			delete: {
				title: 'O Status de Vaga foi deletado com sucesso.',
			},
		},
		requests: {
			list: {
				title: 'Lista de Solicitações Recrutamento e Carreiras mais recentes do Mundo Gamer Jobs',
				subTitle: 'Confira a lista de Solicitações de Recrutamento e Carreiras enviadas na Mundo Gamer Jobs.',
			},
			create: {
				title: 'Solicitação de Recrutamento e Carreiras',
			},
		},
		resumes: {
			list: {
				title: 'Lista de Currículos Mundo Gamer',
				subTitle: 'Verifique a lista de Currículos registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Currículo',
				subTitle: 'Preencha os campos abaixo para cadastrar um Currículo.',
			},
		},
		selectionProcesses: {
			list: {
				title: 'Processos Seletivos',
				subTitle: 'Processos de recrutamento conduzidos pela equipe da MG Jobs em nome de empresas clientes, usando o banco de talentos da MG Jobs.',
				create: 'Novo processo',
				empty: 'Nenhum processo seletivo ainda.',
				columns: {
					client: 'Cliente',
					title: 'Título',
					applications: 'Candidatos',
					createdAt: 'Criado em',
					actions: 'Ações',
				},
				viewCandidates: 'Candidatos',
			},
			create: {
				title: 'Novo Processo Seletivo',
				subTitle: 'Cria uma vaga privada vinculada à empresa cliente — nunca listada publicamente — para conduzir o processo contra o banco de talentos.',
				clientName: 'Nome da empresa cliente',
				clientNameHint: 'Buscado por nome exato em uma empresa já existente, ou criado automaticamente caso ainda não exista.',
				country: 'País',
				companyType: 'Tipo de empresa',
				companyDetailsHint: 'Usado apenas se esta for uma empresa cliente totalmente nova.',
				numberVacancies: 'Número de vagas',
				save: 'Criar processo',
				savedSuccess: 'Processo seletivo criado com sucesso.',
				saveError: 'Não foi possível criar o processo seletivo.',
			},
			candidates: {
				backToList: 'Voltar para processos seletivos',
				applicationsCount: '{count} candidato(s) neste processo até agora',
				aiSearch: {
					label: 'Busca com IA',
					placeholder: 'ex.: "preciso de um game designer sênior com Unreal e inglês fluente"',
					button: 'Interpretar com IA',
					hint: 'Pré-preenche os filtros abaixo para você revisar — nunca busca sozinha.',
					prefilled: 'Filtros pré-preenchidos pela sua busca. Revise-os e clique em Aplicar filtros.',
					unresolved: 'Termos que a IA não conseguiu reconhecer com confiança',
					error: 'A busca por IA não está disponível no momento. Use os filtros abaixo.',
				},
				filters: {
					title: 'Filtros',
					apply: 'Aplicar filtros',
					reset: 'Limpar filtros',
					any: 'Qualquer',
					yes: 'Sim',
					no: 'Não',
					term: 'Título contém',
					localization: 'Localização contém',
					restrict: 'Exigir TODOS os filtros selecionados (em vez de qualquer um)',
					creationPeriod: 'Perfil criado',
					creationPeriodOptions: {
						all: 'Qualquer período',
						last_hour: 'Última hora',
						last_week: 'Última semana',
						last_2_weeks: 'Últimas 2 semanas',
						last_month: 'Último mês',
					},
					special: 'PCD (pessoa com deficiência)',
					unlocked: 'Desbloqueado por mim',
					bookmarked: 'Salvo por mim',
					languages: 'Idiomas',
					workMethodologies: 'Metodologias de trabalho',
					employmentContractTypes: 'Tipos de contrato',
					experiences: 'Níveis de experiência',
					industrySectors: 'Setores da indústria',
					workAvailabilities: 'Disponibilidade de trabalho',
					skills: 'Habilidades',
					gameIndustryExperience: 'Experiência na indústria de games',
					hasBehavioralProfile: 'Concluiu um teste comportamental',
					hasAcademyCertification: 'Possui certificação da Academy',
					hasCareerTrailCompleted: 'Concluiu uma trilha de carreira',
					hasPersonalityTestCompleted: 'Concluiu um teste de personalidade',
				},
				table: {
					name: 'Candidato',
					location: 'Localização',
					skills: 'Habilidades',
					score: 'Nota da IA',
					reason: 'Motivo da IA',
					noResults: 'Nenhum candidato corresponde a esses filtros.',
					employmentStatus: {
						available: 'Disponível agora',
						open_to_opportunities: 'Aberto a oportunidades',
						employed: 'Empregado(a)',
					},
					relocate: 'Aberto(a) a mudança de cidade/país',
					linkedin: 'Abrir perfil do LinkedIn',
				},
				rank: {
					button: 'Ranquear com IA',
					ranking: 'Ranqueando…',
					result: 'Ranqueados os {considered} melhores de {total} candidatos correspondentes.',
					clear: 'Limpar ranqueamento da IA',
					error: 'O ranqueamento por IA não está disponível no momento.',
				},
				bulk: {
					selectedCount: '{count} selecionado(s)',
					addToProcess: 'Adicionar ao processo',
					addSuccess: '{count} candidato(s) adicionado(s) ao processo.',
					addError: 'Não foi possível adicionar os candidatos selecionados ao processo.',
					justAdded: '{count} candidato(s) recém adicionado(s) ao processo.',
					inviteToInterview: 'Convidar para entrevista',
				},
				invite: {
					title: 'Convidar para entrevista',
					subtitle: 'Enviando para {count} candidato(s) já adicionado(s) a este processo.',
					titleField: 'Título da reunião',
					description: 'Descrição (opcional)',
					platform: 'Plataforma',
					platforms: {
						google_meet: 'Google Meet',
						zoom: 'Zoom',
						microsoft_teams: 'Microsoft Teams',
					},
					durationMinutes: 'Duração (minutos)',
					timezone: 'Fuso horário',
					expiresAt: 'Link expira em (opcional)',
					slots: 'Horários propostos',
					slotsHint: 'Cada candidato convidado recebe sua própria cópia independente de TODOS esses horários para escolher — isso não é uma agenda compartilhada. Se dois candidatos reservarem o mesmo horário, isso é um conflito de agenda que você mesmo precisará perceber e resolver, assim como enviar convites individuais um a um. Proponha mais horários do que candidatos para reduzir esse risco.',
					addSlot: 'Adicionar horário',
					removeSlot: 'Remover',
					slotStart: 'Início',
					slotEnd: 'Fim',
					send: 'Enviar convites',
					queued: '{count} convite(s) enfileirado(s) para envio.',
					error: 'Não foi possível enfileirar os convites de entrevista.',
					cancel: 'Cancelar',
				},
			},
		},
		applications: {
			list: {
				title: 'Lista de Candidaturas no Mundo Gamer',
				subTitle: 'Verifique a lista de Candidaturas registradas no Mundo Gamer Jobs.',
			},
		},
		salaryInsightTextCategories: {
			list: {
				title: 'Categorias de Textos de Insights Salariais',
				subTitle: 'Gerencie as categorias utilizadas para agrupar os textos de insights salariais.',
			},
			create: {
				title: 'Nova Categoria',
				success: 'Categoria criada com sucesso.',
			},
			edit: {
				title: 'Editar Categoria',
				success: 'Categoria atualizada com sucesso.',
			},
			delete: {
				success: 'Categoria excluída com sucesso.',
			},
		},
		salaryInsightTexts: {
			list: {
				title: 'Textos de Insights Salariais',
				subTitle: 'Gerencie os textos de insights salariais exibidos aos usuários na página de insights.',
			},
			create: {
				title: 'Novo Texto de Insight Salarial',
				success: 'Texto de insight salarial criado com sucesso.',
			},
			edit: {
				title: 'Editar Texto de Insight Salarial',
				success: 'Texto de insight salarial atualizado com sucesso.',
			},
			delete: {
				success: 'Texto de insight salarial excluído com sucesso.',
			},
		},
		salaryTaxRates: {
			list: {
				title: 'Taxas de Impostos Salariais por País',
				subTitle: 'Gerencie as faixas estimadas de impostos usadas nos cálculos de insights salariais.',
			},
			save: {
				success: 'Taxas de impostos atualizadas com sucesso.',
				error: 'Falha ao atualizar taxas de impostos.',
			},
			fields: {
				taxRateMin: 'Taxa Mínima (%)',
				taxRateMax: 'Taxa Máxima (%)',
				type: 'Tipo',
				exact: 'Exata',
				range: 'Faixa',
				notSet: 'Não definida',
			},
		},
		salary_insights: {
			title: 'Pesquisas de Insights Salariais',
			searches_today: 'Pesquisas hoje',
			searches_week: 'Pesquisas esta semana',
			searches_month: 'Pesquisas este mês',
			credits_month: 'Créditos usados (mês)',
			total_searches: 'Total de pesquisas',
			credits_unlocked: 'Total de créditos usados',
			authenticated: 'Autenticado',
			anonymous: 'Anônimo',
			today: 'Hoje',
			week: 'Semana',
			user: 'Usuário',
			resource: 'Tipo',
			date: 'Data',
		},
		nurture_stats: {
			title: 'Nurture do Teste de Personalidade',
			view_all: 'Ver Todos',
			total_leads: 'Total de leads',
			purchased: 'Comprou',
			answered: 'Responderam "por quê"',
			no_answer: 'Sem resposta ainda',
			reasons_given: 'Motivos informados',
			lead: 'Lead',
			opens: 'Aberturas',
			progress: 'Progresso',
			reason: 'Motivo',
			enrolled: 'Inscrito em',
		},
		search_insights: {
			title: 'Insights de buscas da comunidade',
			searches_today: 'Buscas hoje',
			searches_week: 'Buscas esta semana',
			searches_month: 'Buscas este mês',
			total_searches: 'Total de buscas',
			authenticated: 'Autenticado',
			anonymous: 'Anônimo',
			user: 'Usuário',
			resource: 'Recurso',
			term: 'Termo buscado',
			date: 'Data',
			top_terms: 'Termos mais buscados',
			empty: 'Nenhuma busca rastreada ainda.',
		},
		companiesPerks: {
			list: {
				title: 'Lista de Benefícios das Empresas no Mundo Gamer',
				subTitle: 'Verifique a lista de  Benefícios das Empresas registradas no Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Benefício da Empresa',
				subTitle: 'Benefício da Empresa',
			},
			delete: {
				title: 'O benefício foi deletado com sucesso.',
			},
		},
		employmentsTypes: {
			list: {
				title: 'Lista de Tipos de emprego no Mundo Gamer',
				subTitle: 'Verifique a lista de  Tipos de emprego registrados no Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Tipo de emprego',
				subTitle: 'Tipo de emprego',
			},
			delete: {
				title: 'O Tipos de emprego foi deletado com sucesso.',
			},
		},
		experiences: {
			list: {
				title: 'Lista de Experiências Mundo Gamer',
				subTitle: 'Verifique a lista de Experiências registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Nova Experiência',
				subTitle: 'Experiência',
			},
			delete: {
				title: 'A Experiência foi deletada com sucesso.',
			},
		},
		sourcetypes: {
			list: {
				title: 'Lista de Tipos de fontes salariais da Mundo Gamer',
				subTitle: 'Verifique a lista de Tipos de fontes salariais registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Tipo de fonte de salário',
				subTitle: 'Tipo de fonte de salário',
			},
			delete: {
				title: 'O Tipo de fonte de salário foi deletado com sucesso.',
			},
		},
		vacancytitles: {
			list: {
				title: 'Lista de Títulos de Vagas da Mundo Gamer',
				subTitle: 'Verifique a lista de Títulos de Vagas registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Título de Vaga',
				subTitle: 'Título de Vaga',
			},
			delete: {
				title: 'O Título de Vaga foi deletado com sucesso.',
			},
			canonical: 'Título canônico (variação de)',
			canonical_hint: 'Preencha se este título é uma variação ou tradução de outro. Os dados de salário serão agrupados sob o canônico.',
		},
		submissions: {
			list: {
				title: 'Lista de Envios de salários da Mundo Gamer',
				subTitle: 'Verifique a lista de Envios de salários registrados do Mundo Gamer Jobs.',
				pending: 'pendente(s)',
				status_approved: 'Aprovado',
				status_pending: 'Pendente',
				filter_all: 'Todos',
				filter_pending: 'Pendentes',
				approve: 'Aprovar',
				approved: 'Envio aprovado com sucesso!',
				approve_error: 'Erro ao aprovar envio.',
				reject: 'Reprovar',
				rejected: 'Envio reprovado com sucesso!',
				reject_error: 'Erro ao reprovar envio.',
			},
			create: {
				title: 'Novo Envio de salário',
				subTitle: 'Envio de salário',
			},
			delete: {
				title: 'O Envio de salário foi deletado com sucesso.',
			},
		},
			personalityTests: {
				list: {
					title: 'Testes de Personalidade',
					subtitle: 'Gerencie os testes disponíveis na plataforma.',
					searchLabel: 'Buscar por nome ou slug',
					newTest: 'Novo Teste',
					test: 'Teste',
					confirmDeactivateTitle: 'Confirmar desativação',
					confirmDeactivateMessage: 'Deseja desativar o teste {name}? O teste será marcado como inativo mas não será excluído.',
					deactivateBtn: 'Desativar',
					deactivateSuccess: 'Teste desativado com sucesso.',
				},
				results: {
					title: 'Resultados dos Testes',
					subtitle: 'Monitore resultados agrupados por ciclo de usuário. Cada ciclo inclui 3 testes.',
					pdfStatus: 'Status do PDF',
					pdf: 'PDF',
					test: 'Teste',
					notStarted: 'Não iniciado',
					pdfReady: 'PDF Pronto',
					completed: 'Concluído',
				},
				detail: {
					title: 'Teste',
					tabQuestions: 'Questões',
					tabDimensions: 'Dimensões',
					tabInterpretations: 'Interpretações',
					questions: 'Questões',
					question: 'Questão',
					questionText: 'Texto da questão',
					newQuestion: 'Nova Questão',
					options: 'Opções',
					option: 'Opção',
					optionText: 'Texto da opção',
					newOption: 'Nova Opção',
					optionsFor: 'Opções de',
					weight: 'Peso',
					order: 'Ordem',
					dimensions: 'Dimensões',
					dimension: 'Dimensão',
					newDimension: 'Nova Dimensão',
					interpretations: 'Interpretações',
					interpretation: 'Interpretação',
					newInterpretation: 'Nova Interpretação',
					deleteWarning: 'Esta ação não pode ser desfeita.',
				},
				questionType: {
					label: 'Tipo de questão',
					likert: 'Escala (Likert)',
					radio: 'Múltipla escolha (Radio)',
					multiselect: 'Seleção múltipla',
				},
				assignments: {
					title: 'Convites — Testes de Personalidade',
					subtitle: 'Envie convites para usuários realizarem um teste de personalidade sem consumir créditos.',
					filterTest: 'Teste',
					filterStatus: 'Status',
					filterEmail: 'E-mail do destinatário',
					btnFilter: 'Filtrar',
					btnSend: 'Enviar convite',
					btnCancel: 'Cancelar',
					cancelBtn: 'Cancelar convite',
					loading: 'Carregando...',
					successSend: 'Convites enviados com sucesso!',
					errorSend: 'Erro ao enviar convites.',
					errorCancel: 'Erro ao cancelar convite.',
					headers: {
						recipient: 'Destinatário',
						status: 'Status',
						consent: 'Consentimento',
						startedAt: 'Iniciado em',
						completedAt: 'Concluído em',
						expiresAt: 'Expira em',
						createdAt: 'Enviado em',
					},
					status: {
						pending: 'Pendente',
						redeemed: 'Resgatado',
						started: 'Iniciado',
						completed: 'Concluído',
						cancelled: 'Cancelado',
						expired: 'Expirado',
					},
					sendDialog: {
						title: 'Enviar convite de teste',
						fieldTest: 'Teste *',
						fieldEmails: 'E-mails (um por linha ou separados por vírgula) *',
						emailsHint: 'Ex: joao@email.com, maria@email.com',
						fieldExpires: 'Data de expiração (opcional)',
						ruleTest: 'Selecione o teste',
						ruleEmails: 'Informe ao menos um e-mail',
						btnSubmit: 'Enviar',
					},
					cancelDialog: {
						title: 'Cancelar convite',
						message: 'Tem certeza que deseja cancelar o convite para',
						btnNo: 'Não',
						btnYes: 'Sim, cancelar',
					},
				},
			},
		applicationMethods: {
			list: {
				title: 'Lista de Métodos de aplicação da Mundo Gamer',
				subTitle: 'Verifique a lista de Métodos de aplicação registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Método de aplicação',
				subTitle: 'Método de aplicação',
			},
			delete: {
				title: 'O Método de aplicação foi deletado com sucesso.',
			},
		},
		applicationStatus: {
			list: {
				title: 'Lista de Status de aplicação da Mundo Gamer',
				subTitle: 'Verifique a lista de Status de aplicação registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Status de aplicação',
				subTitle: 'Status de aplicação',
			},
			delete: {
				title: 'O Status de aplicação foi deletado com sucesso.',
			},
		},
		educationLevels: {
			list: {
				title: 'Lista de Níveis de Instrução da Mundo Gamer',
				subTitle: 'Verifique a lista de Níveis de Instrução registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Nível de Instrução',
				subTitle: 'Nível de Instrução',
			},
			delete: {
				title: 'O Nível de Instrução foi deletado com sucesso.',
			},
		},
		languageLevels: {
			list: {
				title: 'Lista de Níveis de linguagem da Mundo Gamer',
				subTitle: 'Verifique a lista de Níveis de linguagem registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Nível de linguagem',
				subTitle: 'Nível de linguagem',
			},
			delete: {
				title: 'O Nível de linguagem foi deletado com sucesso.',
			},
		},
		professionalSituations: {
			list: {
				title: 'Lista de Situações Profissionais da Mundo Gamer',
				subTitle: 'Verifique a lista de Situações Profissionais registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Nova Situação Profissional',
				subTitle: 'Situação Profissional',
			},
			delete: {
				title: 'A Situação Profissional foi deletada com sucesso.',
			},
		},
		widgetFormats: {
			list: {
				title: 'Lista de Formatos de Widgets da Mundo Gamer',
				subTitle: 'Verifique a lista de Formatos de Widgets registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Formato de Widget',
				subTitle: 'Formato de Widget',
			},
			delete: {
				title: 'O Formato de Widget foi deletado com sucesso.',
			},
		},
		widgets: {
			list: {
				title: 'Lista de Widgets da Mundo Gamer',
				subTitle: 'Verifique a lista de Widgets registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Widget',
				subTitle: 'Widget',
			},
			delete: {
				title: 'O Widget foi deletado com sucesso.',
			},
		},
		workHours: {
			list: {
				title: 'Lista de Horários de trabalho Mundo Gamer',
				subTitle: 'Verifique a lista de Horários de trabalho registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Novo Horário de trabalho',
				subTitle: 'Horário de trabalho',
			},
			delete: {
				title: 'O Horário de trabalho foi deletado com sucesso.',
			},
		},
		workMethodologies: {
			list: {
				title: 'Lista de Metodologias de trabalho Mundo Gamer',
				subTitle: 'Verifique a lista de Metodologias de trabalho registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Nova Metodologia de trabalho',
				subTitle: 'Metodologia de trabalho',
			},
			delete: {
				title: 'A Metodologia de trabalho foi deletada com sucesso.',
			},
		},
		workAvailabilities: {
			list: {
				title: 'Lista de Disponibilidades de trabalho Mundo Gamer',
				subTitle: 'Verifique a lista de Disponibilidades de trabalho registrados do Mundo Gamer Jobs.',
			},
			create: {
				title: 'Nova Disponibilidade de trabalho',
				subTitle: 'Disponibilidade de trabalho',
			},
			delete: {
				title: 'A Disponibilidade de trabalho foi deletada com sucesso.',
			},
		},
	},

	shop: {
		categories: {
			list: {
				title: 'Lista de Categorias no Mundo Gamer',
				subTitle: 'Verifique a lista de  Categorias registradas no Mundo Gamer Deals.',
			},
			create: {
				title: 'Nova Categoria',
				subTitle: 'Categoria',
			},
		},
		subcategories: {
			list: {
				title: 'Lista de Subcategorias no Mundo Gamer',
				subTitle: 'Verifique a lista de  Subcategorias registradas no Mundo Gamer Deals.',
			},
			create: {
				title: 'Nova Subcategoria',
				subTitle: 'Subcategoria',
			},
		},
		productSuppliers: {
			title: 'Fornecedores de Ofertas',
			subtitle: 'Gerencie as fontes de afiliados/curadoria que alimentam o catálogo de "Ofertas" (Amazon, Awin, Shopee, curadoria manual, etc).',
			newSupplier: 'Novo Fornecedor',
			editSupplier: 'Editar Fornecedor',
			integrationType: 'Tipo de Integração',
			supportedProductTypes: 'Tipos de Produto Suportados',
			apiBaseUrl: 'URL Base da API',
			apiKey: 'Chave de API',
			apiKeyStoredHint: 'Armazenada com segurança — preencha apenas para substituir',
			configuration: 'Configuração (JSON)',
			configurationHint: 'Configuração JSON livre para esta integração (ex: IDs de itens da watchlist, URL do feed).',
			configurationInvalid: 'JSON inválido.',
			active: 'Ativo',
			savedSuccess: 'Salvo com sucesso.',
			deletedSuccess: 'Removido com sucesso.',
		},
		coupons: {
			title: 'Cupons',
			subtitle: 'Códigos de desconto cadastrados manualmente, validados por produto no momento do disparo (preço mínimo, teto de desconto, escopo, validade) — não sincronizados do painel de afiliado do marketplace.',
			newCoupon: 'Novo Cupom',
			editCoupon: 'Editar Cupom',
			code: 'Código',
			discountType: 'Tipo de Desconto',
			discountValue: 'Valor do Desconto',
			fixedAmount: 'Valor fixo',
			minProductPrice: 'Preço Mínimo do Produto',
			maxDiscountAmount: 'Desconto Máximo (teto)',
			appliesToLabel: 'Se Aplica A',
			appliesTo: {
				all: 'Todos os produtos',
				category: 'Uma categoria',
				product_list: 'Produtos específicos',
			},
			categoryId: 'ID da Categoria',
			categoryIdHint: 'O ID em shop.categories ao qual este cupom se aplica.',
			productIds: 'IDs dos Produtos',
			productIdsHint: 'Digite um ID de creator_product e aperte enter — um cupom pode cobrir mais de um.',
			supplier: 'Fornecedor (opcional)',
			supplierHint: 'Deixe vazio para aplicar independente do fornecedor (Amazon, Awin, Shopee, etc).',
			validFrom: 'Válido a Partir de',
			validUntil: 'Válido Até',
			active: 'Ativo',
			savedSuccess: 'Salvo com sucesso.',
			deletedSuccess: 'Removido com sucesso.',
		},
		retailers: {
			title: 'Lojas',
			subtitle: 'As lojas do Deals: nome, logo, plataforma e todas as grafias com que uma oferta pode chegar. O site e o app leem esta lista.',
			newRetailer: 'Nova Loja',
			editRetailer: 'Editar Loja',
			slug: 'Chave (slug)',
			slugInvalid: 'Use letras minúsculas, números, hífen ou sublinhado.',
			slugHint: 'A chave que as ofertas carregam (ex.: greenmangaming). Se você mudar, a antiga continua funcionando como apelido.',
			name: 'Nome',
			platform: 'Plataforma',
			allPlatforms: 'Todas as plataformas',
			platforms: {
				pc: 'PC',
				playstation: 'PlayStation',
				xbox: 'Xbox',
				nintendo: 'Nintendo',
			},
			marketplace: 'Marketplace',
			marketplaceHint: 'Vários vendedores numa página de produto: o preço listado é o menor deles, e a página da loja pode destacar outro.',
			linkMode: 'Link para a loja',
			linkModeHint: 'Link direto não rende nada; link de afiliado é rastreado por um sistema de afiliados. É informativo: o que é pago é decidido por cada oferta.',
			linkModes: {
				none: 'Não classificada',
				direct: 'Link direto para a loja',
				affiliate: 'Link de afiliado',
			},
			linkShort: {
				direct: 'Direto',
				affiliate: 'Afiliado',
			},
			filterLink: 'Link',
			affiliateNetwork: 'Sistema de afiliados',
			affiliateNetworkHint: 'impact, awin, cj, rakuten... (escolha um ou digite outra chave)',
			countryMode: 'Onde aparece',
			countryModeHint: 'Por padrão a loja aparece em todos os países. O Deals a deixa de fora dos países que você restringir, em listas, preços e no resumo diário.',
			countryModes: {
				all: 'Todos os países',
				only: 'Somente nestes países',
				except: 'Em todos, exceto nestes',
			},
			countrySummary: {
				only: 'Somente {list}',
				except: 'Exceto {list}',
			},
			filterCountries: 'Regra de países',
			countries: 'Países',
			website: 'Site',
			logo: 'Logo',
			logoHint: 'PNG, JPG, WebP ou SVG de até 2 MB. Aparece entre 20 e 36 px.',
			logoTooBig: 'O arquivo tem mais de 2 MB.',
			noLogo: 'Sem logo',
			withoutLogo: 'Sem logo',
			removeLogo: 'Remover logo',
			logoPlate: 'Placa clara atrás do logo',
			logoPlateHint: 'Para marcas escuras ou transparentes que sumiriam no tema escuro.',
			sortOrder: 'Ordem',
			notes: 'Observações',
			aliases: 'Apelidos',
			aliasesHint: 'Outras grafias com que uma oferta pode chegar (digite e aperte enter). Só letras e números contam: "Green-Man_Gaming" e "greenmangaming" são a mesma.',
			aliasesCount: 'Apelidos',
			deleteWarning: 'As ofertas desta loja ficarão sem loja cadastrada e aparecerão com iniciais.',
			status: 'Status',
			statuses: {
				on: 'No ar',
				off: 'Fora do ar',
			},
			filterStatus: 'Status',
			isActive: 'Manter as ofertas desta loja no ar',
			isActiveHint: 'Desligada, as ofertas no ar da loja saem agora, nenhuma sincronização as devolve, e o site, o app e o resumo diário deixam de mostrar a loja. Ligue de novo e a próxima sincronização dela traz as ofertas de volta com preços atualizados.',
			switchOffTitle: 'Tirar as ofertas do ar?',
			switchOffConfirm: 'Todas as ofertas no ar de {name} saem agora. Depois que você religar a loja, elas voltam na próxima sincronização dela.',
			switchOffAction: 'Desligar e tirar do ar',
			savedOff: 'Salvo. Ofertas retiradas do ar: {count}.',
			giftCards: 'Gift cards',
			giftCardsListed: 'Listar os gift cards desta loja',
			giftCardsListedHint: 'Desligado, os gift cards dela saem do site e do app (a lista e a busca), e um link compartilhado antes vai para a página de gift cards em vez da loja. As ofertas de jogos continuam. Nada é derrubado: ligue de novo e os cards voltam na hora.',
			giftCardsCommission: 'Comissão nos gift cards',
			giftCardsCommissionHint: 'O que você descobriu. É só um registro: nada é escondido, reordenado ou linkado diferente por causa dele.',
			giftCardCommissions: { unknown: 'Ainda não verificado', yes: 'Paga comissão', no: 'Sem comissão' },
			giftCardsShown: { on: 'Listados', off: 'Ocultos' },
			filterGiftCards: 'Gift cards',
			filterGiftCardsCommission: 'Comissão dos gift cards',
			savedSuccess: 'Salvo com sucesso.',
			deletedSuccess: 'Removido com sucesso.',
		},
		products: {
			title: 'Catálogo de Produtos e Ofertas',
			subtitle: 'Navegue e gerencie todo produto de toda loja e fornecedor — ofertas, produtos físicos, digitais e serviços.',
			newProduct: 'Novo Produto',
			editProduct: 'Editar Produto',
			productType: 'Tipo',
			store: 'Loja',
			supplier: 'Fornecedor',
			price: 'Preço',
			currency: 'Moeda',
			thumbnailUrl: 'URL da Miniatura',
			description: 'Descrição',
			dealFieldsTitle: 'Detalhes da Oferta de Afiliado',
			affiliateUrl: 'URL de Afiliado',
			affiliateUrlHint: 'O link rastreado pra onde um clique nesta oferta deve ir.',
			originalPrice: 'Preço Original (antes do desconto)',
			discountPercent: 'Desconto %',
			storeLabel: 'Rótulo da Loja (ex: amazon, awin-kabum)',
			active: 'Ativo',
			featured: 'Destaque',
			savedSuccess: 'Salvo com sucesso.',
			deletedSuccess: 'Removido com sucesso.',
		},
		deals: {
			title: 'Ofertas — Programa de Streamers e Comissões',
			subtitle: 'Aprove candidaturas de streamers ao programa de indicação de ofertas e concilie comissões dos cliques em links de afiliado.',
			streamersTab: 'Candidaturas de Streamers',
			commissionsTab: 'Comissões',
			reachTab: 'Alcance',
			broadcastsTab: 'Envios',
			queueTab: 'Fila',
			opportunitiesTab: 'Oportunidades',
			channelsTab: 'Canais de Divulgação',
			channels: {
				newChannel: 'Novo Canal de Divulgação',
				deactivateHint: 'Desative para parar de receber divulgações de ofertas nesse canal, sem apagá-lo.',
				provider: 'Provedor',
				providerHint: 'Como as ofertas são enviadas para este canal. Grupos de WhatsApp mantêm o envio próprio; as mensagens de Telegram e Discord são formatadas para cada plataforma.',
				discordHelp: 'No Discord: Configurações do servidor > Integrações > Webhooks > Novo webhook > Copiar URL do webhook. Só webhooks do discord.com são aceitos.',
				webhookStored: 'Já existe um webhook salvo neste canal. Mostre para conferir, ou cole um novo para substituir.',
				showWebhook: 'Mostrar URL do webhook',
				hideWebhook: 'Ocultar URL do webhook',
				senderName: 'Nome do remetente (opcional)',
				senderNameHint: 'Só no Discord. Publica com este nome em vez do nome definido no próprio webhook, p. ex. Achados Games.',
				digestSection: 'Resumo diário',
				digestEnabled: 'Enviar o resumo diário das melhores ofertas para este canal',
				digestEnabledHint: 'Uma vez por dia, na hora e no fuso abaixo. Desligue para parar o envio sem apagar o canal.',
				digestHour: 'Hora do resumo (0 a 23)',
				digestHourHint: 'Hora local em que o resumo sai. Vazio significa 12.',
				digestCount: 'Ofertas por resumo (1 a 15)',
				digestCountHint: 'Vazio significa 6.',
				digestSpacing: 'Minutos entre as mensagens (1 a 120)',
				digestSpacingHint: 'Intervalo entre as mensagens de um mesmo resumo. Vazio significa 10.',
				timezoneDigestHint: 'Fuso horário IANA, p. ex. America/Sao_Paulo ou Europe/Berlin. A hora do resumo é lida neste relógio (e, no WhatsApp, a janela de envio). Vazio usa o fuso do primeiro país.',
				digestColumn: 'Resumo',
				digestOn: 'Ligado',
				digestOff: 'Desligado',
				testSection: 'Mensagens de teste',
				allowTest: 'Permitir mensagens de teste neste canal',
				allowTestHint: 'Desligado por padrão. Quando ligado, a ação Testar pode publicar uma mensagem de exemplo, marcada como teste, neste canal ao vivo.',
				testDialogTitle: 'Enviar mensagem de teste',
				testDialogWarning: 'Isto publica uma mensagem real, marcada como teste, no canal {provider} ao vivo {name}. Todos os que estão nesse canal vão ver.',
				testNotAllowed: 'As mensagens de teste não estão habilitadas neste canal. Ligue Permitir mensagens de teste nas configurações do canal primeiro.',
				testConfirm: 'Entendo que isto envia uma mensagem real para o canal ao vivo',
				testSend: 'Enviar mensagem de teste',
				testSent: 'Mensagem de teste enviada.',
				testFailed: 'O canal não aceitou a mensagem de teste: {reason}',
				testRefused: 'A mensagem de teste não foi enviada: {reason}',
				chatIdRule: 'Use um id numérico como -1001234567890, ou o nome de usuário do canal começando com @.',
				webhookRule: 'Esta não é uma URL de webhook do Discord (https://discord.com/api/webhooks/...).',
				rangeRule: 'Digite um número inteiro de {min} a {max}.',
				timezoneRule: 'Use um fuso horário IANA, p. ex. America/Sao_Paulo.',
			},
			streamer: 'Streamer',
			deal: 'Oferta',
			price: 'Preço',
			appliedAt: 'Candidatou-se em',
			clickedAt: 'Clicado em',
			approve: 'Aprovar',
			reject: 'Rejeitar',
			rejectionReason: 'Motivo da rejeição',
			markConverted: 'Marcar convertido',
			markNoSale: 'Marcar sem venda',
			saleAmount: 'Valor da venda',
			networkCommissionPercent: 'Comissão da rede (%)',
			networkCommissionPercentHint: 'O percentual de comissão que a rede de afiliados realmente pagou à MGN por essa venda.',
			savedSuccess: 'Salvo com sucesso.',
			reachSubtitle: 'Cliques em links de ofertas enviados pro Telegram/Discord/WhatsApp — alcance total, não é atribuído a comissão (isso fica na aba Comissões).',
			reachDealId: 'ID da oferta',
			reachDate: 'Data',
			reachClicks: 'Cliques',
			reachEmpty: 'Nenhum clique de divulgação registrado ainda.',
			broadcastsSubtitle: 'Histórico de mensagens de oferta realmente enviadas aos canais.',
			broadcastsOnlyDeals: 'Só ofertas',
			queueSubtitle: 'Prévia do que a próxima rodada de polling (a cada ~30min) enviaria — não é uma fila persistente; atualize pra recalcular.',
			queueRefresh: 'Atualizar',
			queueDiscount: 'Desconto',
			queueChannels: 'Canais',
			queueLocale: 'Idioma',
			queueEmpty: 'Nada pendente — toda oferta elegível já foi anunciada no preço atual.',
			opportunitiesSubtitle: 'Ofertas afiliadas ativas, ordenadas por desconto — maiores economias primeiro.',
			opportunitiesStore: 'Loja',
			opportunitiesDiscount: 'Desconto',
			opportunitiesOriginalPrice: 'Preço original',
			opportunitiesEdit: 'Editar',
		},
		dealCommunity: {
			title: 'Moderação da comunidade de ofertas',
			subtitle: 'Revise comentários denunciados e ocultos nas ofertas e remova a marca de "expirada" que a comunidade coloca nas ofertas.',
			game: 'Jogo #{id}',
			tabs: {
				comments: 'Comentários',
				flags: 'Marcas de expirada',
				overview: 'Visão geral',
			},
			states: {
				retry: 'Tentar novamente',
				disabled: {
					title: 'A comunidade de ofertas está desligada',
					text: 'A feature flag deals.community.enabled está desligada na API, então ainda não há nada para moderar. Votos, comentários e denúncias de oferta expirada começam a chegar assim que ela for ligada.',
				},
				forbidden: {
					title: 'Você não pode moderar a comunidade de ofertas',
					text: 'Esta área é para a equipe da Mundo Gamer Network com o papel de administrador. Peça acesso a um administrador.',
				},
				error: {
					title: 'Não foi possível carregar os dados de moderação',
					text: 'A API não respondeu como esperado. Verifique sua conexão e tente novamente.',
				},
			},
			filters: {
				status: 'Status',
				statusReported: 'Denunciados (aguardando revisão)',
				statusHidden: 'Ocultos',
				statusAll: 'Todos os comentários',
				store: 'Loja',
				search: 'Buscar por ID do jogo, autor ou texto',
				searchGame: 'Buscar por ID do jogo',
				refresh: 'Atualizar',
				pageOnlyHint: 'Mostrando {shown} dos {loaded} itens desta página. Os filtros de loja e busca só restringem a página carregada.',
			},
			comments: {
				comment: 'Comentário',
				author: 'Autor',
				offer: 'Oferta',
				reports: 'Denúncias',
				status: 'Status',
				date: 'Data',
				unknownAuthor: 'Usuário desconhecido',
				fullText: 'Comentário completo',
				hiddenInfo: 'Oculto',
				hiddenBy: 'pelo usuário da equipe #{id}',
				hiddenNote: 'Nota',
			},
			status: {
				reported: 'Denunciado',
				hiddenByReports: 'Oculto por denúncias',
				hiddenByStaff: 'Oculto pela equipe',
				deletedByAuthor: 'Apagado pelo autor',
				visible: 'Visível',
			},
			reports: {
				title: 'Denúncias ({count})',
				none: 'Nenhuma denúncia neste comentário.',
				reviewed: 'Revisada',
			},
			reasons: {
				spam: 'Spam',
				offensive: 'Ofensivo',
				misleading: 'Enganoso',
				other: 'Outro',
			},
			actions: {
				hide: 'Ocultar comentário',
				unhide: 'Reexibir comentário',
				clearFlag: 'Remover marca de expirada',
			},
			dialogs: {
				hideTitle: 'Ocultar este comentário?',
				hideText: 'O comentário deixa de aparecer no site. O autor continua com ele e você pode reexibi-lo depois.',
				noteLabel: 'Nota (opcional)',
				noteHint: 'Fica guardada junto ao comentário para os outros moderadores, até 200 caracteres.',
				hideConfirm: 'Ocultar comentário',
				hiding: 'Ocultando...',
				unhideTitle: 'Reexibir este comentário?',
				unhideText: 'O comentário volta a aparecer no site e as denúncias abertas dele são marcadas como revisadas, para que a ocultação automática não dispare de novo logo em seguida.',
				unhideConfirm: 'Reexibir comentário',
				unhiding: 'Reexibindo...',
				clearFlagTitle: 'Remover a marca de expirada?',
				clearFlagText: '{game} em {store} está marcada como expirada pela comunidade.',
				clearFlagNote: 'A oferta volta às listas do site e os votos de expirada dados até agora deixam de contar.',
				clearFlagConfirm: 'Remover marca',
				clearing: 'Removendo...',
			},
			messages: {
				hidden: 'Comentário ocultado.',
				unhidden: 'Comentário reexibido.',
				flagCleared: 'Marca de expirada removida.',
			},
			empty: {
				reported: 'Nenhum comentário denunciado aguardando revisão.',
				hidden: 'Nenhum comentário oculto.',
				all: 'Ainda não há comentários.',
				flags: 'Nenhuma oferta está marcada como expirada agora.',
				filtered: 'Nada nesta página corresponde aos filtros.',
			},
			flags: {
				offer: 'Oferta',
				expiredReports: 'Denúncias de expirada',
				heat: 'Temperatura',
				comments: 'Comentários',
				flaggedAt: 'Marcada em',
				lastVote: 'Último voto',
				autoLiftHint: 'A marca também sai sozinha quando uma sincronização de preço confirma o preço, após 48 horas (padrão) ou quando as denúncias ficam abaixo do limite.',
			},
			overview: {
				intro: 'Como está a moderação da comunidade agora.',
				reportedPending: 'Denunciados, aguardando revisão',
				reportedPendingHint: 'Comentários com pelo menos uma denúncia aberta.',
				hidden: 'Comentários ocultos',
				hiddenHint: 'Ocultos pela equipe ou pelo limite de denúncias.',
				flagged: 'Ofertas marcadas como expiradas',
				flaggedHint: 'Escondidas das listas do site até a marca ser removida.',
				commentsToday: 'Comentários hoje',
				commentsTodayHint: '{total} comentários no total.',
				offersVotedToday: 'Ofertas com votos hoje',
				offersVotedTodayHint: 'Ofertas que receberam pelo menos um voto hoje.',
				sampleNote: 'As contagens de denunciados, ocultos e marcados são exatas. "Hoje" é contado no seu fuso horário sobre os {size} comentários mais novos e as {size} ofertas votadas mais recentemente (um sinal de mais indica que a amostra estava cheia). O número de votos individuais dados hoje depende de um endpoint de agregação na API.',
			},
		},
		dealsHome: {
			title: 'Mundo Gamer Deals',
			subtitle: 'O que os Deals guardam agora e o que aconteceu nos últimos {days} dias.',
			refresh: 'Atualizar',
			openDashboard: 'Abrir o dashboard dos Deals',
			offersLive: 'Ofertas ativas',
			storesCovered: 'Lojas com ofertas',
			noClicksYet: 'Ainda não há cliques. Eles são contados quando um link de oferta é enviado a um canal ou compartilhado.',
			allAlerts: 'Todos os alertas ({count})',
			storesTitle: 'Lojas com mais ofertas',
			allStores: 'Todas as lojas',
			noStores: 'Nenhuma loja tem ofertas ativas ainda.',
			shortcutsTitle: 'Ir para',
			shortcuts: {
				dealsDashboard: 'Lojas, integrações, cliques, comissões e a saúde da coleta, em detalhe.',
				stores: 'O cadastro de lojas: logos, links e países.',
				productSuppliers: 'As fontes de onde as ofertas são coletadas.',
				deals: 'Candidaturas de streamers, comissões, envios e canais.',
				dealCommunity: 'Votos, comentários e marcações de expirada para moderar.',
				coupons: 'Os cupons exibidos junto das ofertas.',
			},
		},
		dealsDashboard: {
			title: 'Painel de ofertas',
			subtitle: 'Lojas, integrações, cliques, comissões e a saúde da coleta das Ofertas em um só lugar.',
			refresh: 'Atualizar',
			retry: 'Tentar de novo',
			search: 'Buscar',
			empty: 'Nada para mostrar neste período.',
			noMatches: 'Nenhuma linha corresponde a estes filtros.',
			required: 'Campo obrigatório',
			numberInvalid: 'Informe um número válido.',
			cancel: 'Cancelar',
			save: 'Salvar',
			close: 'Fechar',
			yes: 'Sim',
			no: 'Não',
			confirmation: 'Confirmação',
			actions: 'Ações',
			countryIgnored: 'O filtro de país não se aplica a estes dados: os valores são de todos os países.',
			moneyForbidden: 'O servidor recusou as telas de dinheiro: elas são só para administradores da plataforma.',
			moneyHidden: 'Comissões, cliques sem monetização, receita das redes e taxas de comissão só aparecem para administradores da plataforma.',
			errors: {
				generic: 'Não foi possível carregar estes dados.',
				network: 'O servidor não respondeu. Verifique a conexão e tente de novo.',
				forbidden: 'Somente administradores da plataforma podem ver estes dados.',
			},
			tabs: {
				overview: 'Visão geral',
				stores: 'Lojas',
				integrations: 'Integrações',
				clicks: 'Cliques',
				commissions: 'Comissões',
				untapped: 'Sem monetização',
				revenue: 'Receita das redes',
				rates: 'Taxas de comissão',
				health: 'Saúde',
			},
			filters: {
				from: 'De',
				to: 'Até',
				store: 'Loja',
				country: 'País',
				invalidRange: 'A data inicial não pode ser depois da data final.',
			},
			money: {
				currency: 'Moeda',
				none: 'Nenhum valor neste período.',
				fields: {
					pending: 'Pendente',
					approved: 'Aprovada',
					approved_unpaid: 'Aprovada, não paga',
					paid: 'Paga',
					reversed: 'Estornada',
					rejected: 'Rejeitada',
				},
			},
			severity: {
				critical: 'Crítico',
				warning: 'Atenção',
				info: 'Informação',
			},
			freshness: {
				fresh: 'Em dia',
				stale: 'Atrasada',
				frozen: 'Congelada',
				none: 'Sem dados',
			},
			platforms: {
				pc: 'PC',
				playstation: 'PlayStation',
				xbox: 'Xbox',
				nintendo: 'Nintendo',
			},
			linkMode: {
				affiliate: 'Afiliado',
				direct: 'Direto',
				none: 'Não definido',
			},
			collection: {
				shop: 'Shop',
				community: 'Comunidade',
				supplier: 'Fornecedor',
				none: 'Ninguém',
			},
			networks: {
				impact: 'Impact',
				awin: 'Awin',
				adtraction: 'Adtraction',
				amazon: 'Amazon',
				amazon_associates: 'Amazon Associates',
				shopee: 'Shopee',
				eneba: 'Eneba',
				cj: 'CJ',
				rakuten: 'Rakuten',
				admitad: 'Admitad',
				other: 'Outra',
			},
			integrationTypes: {
				internal_api: 'Comparador de preços',
				amazon_paapi: 'Amazon PA-API',
				awin_feed: 'Feed da Awin',
				shopee_affiliate: 'Afiliado Shopee',
				shopee_feed: 'Feed da Shopee',
				impact_affiliate: 'Afiliado Impact',
				ml_scraping: 'Cupons do Mercado Livre',
				store_direct: 'Loja direta',
				manual: 'Curadoria manual',
			},
			missingConfig: {
				feed_url: 'URL do feed',
				affiliate_id: 'ID de afiliado',
				shopee_open_api_credentials: 'Credenciais da Open API da Shopee',
				watchlist_item_ids: 'IDs dos itens da lista de acompanhamento',
				amazon_paapi_credentials: 'Credenciais da Amazon PA-API',
				watchlist_asins: 'ASINs da lista de acompanhamento',
				impact_credentials: 'Credenciais da Impact',
				impact_program_id: 'ID do programa da Impact',
				tracking_link_base: 'Base do link de rastreamento',
				unknown_integration_type: 'Tipo de integração desconhecido',
			},
			runStatus: {
				running: 'Em execução',
				success: 'Sucesso',
				failed: 'Falhou',
			},
			linkStatus: {
				ok: 'OK',
				missing_identity: 'Identidade ausente',
				error: 'Erro',
			},
			txStatus: {
				pending: 'Pendente',
				approved: 'Aprovada',
				paid: 'Paga',
				reversed: 'Estornada',
				rejected: 'Rejeitada',
			},
			txSource: {
				api: 'Rede',
				manual: 'Manual',
				import: 'Importação CSV',
			},
			commissionStatus: {
				awaiting_payment: 'Aguardando pagamento',
				not_paid: 'Aprovada, não paga',
				paid: 'Paga',
				cancelled: 'Cancelada',
				pending: 'Pendente',
				converted: 'Vendido',
				no_sale: 'Sem venda',
			},
			rateModels: {
				percent_of_sale: 'Percentual da venda',
				fixed_per_sale: 'Valor fixo por venda',
			},
			rateSource: {
				contract: 'Contrato',
				network_page: 'Página da rede',
				observed: 'Vista em um pagamento',
				estimate: 'Estimativa',
			},
			rateValidity: {
				active: 'Em vigor',
				scheduled: 'Agendada',
				expired: 'Expirada',
			},
			alerts: {
				store_frozen: '{store} está sem atualização há {hours} h e parece congelada.',
				store_stale: '{store} está atrasada: a última atualização foi há {hours} h.',
				supplier_stale: 'A integração {supplier} está atrasada: a última atualização foi há {hours} h.',
				supplier_inactive_with_offers: 'A integração {supplier} está desligada, mas ainda tem {count} ofertas ativas.',
				sync_failed: 'A última execução de {subject} falhou.',
				sync_missing: 'Não há execução recente registrada para {supplier}, que deveria rodar a cada {cadence} h.',
				link_missing_identity: 'O link de afiliado de {store} chega ao lojista sem a nossa identidade de afiliado ({network}: {marker}).',
				unregistered_store: '{store} tem {offers} ofertas e {prices} linhas de preço, mas não está cadastrada como loja.',
				config_missing: 'A integração {supplier} está com configuração faltando: {keys}.',
				store_without_logo: '{store} está sem logo.',
				unknown: 'Alerta {code} para {subject}.',
			},
			overview: {
				alerts: 'Alertas',
				noAlerts: 'Nenhum alerta: tudo o que o painel acompanha está em ordem.',
				showAll: 'Mostrar todos ({count})',
				showFewer: 'Mostrar menos',
				clicksByDay: 'Cliques por dia',
				noClicks: 'Nenhum clique neste período.',
				seriesClicks: 'Cliques',
				seriesCommissionClicks: 'Cliques em links com comissão',
				moneyTitle: 'Dinheiro',
				owedToStreamers: 'A pagar aos streamers: saldo acumulado',
				networkCommission: 'Comissão informada pelas redes neste período',
				untappedClicks: 'Cliques que não renderam nada',
				untappedHint: 'Cliques que foram para uma loja sem link monetizado. Veja a aba Sem monetização.',
			},
			kpi: {
				offersMonetized: 'Ofertas monetizadas',
				monetizedPct: '{pct} das ofertas ativas rendem comissão',
				storesWithOffers: '{withOffers} de {total} lojas têm ofertas ativas',
				priceRows: 'Linhas de preço',
				priceRowsDiscounted: '{count} em promoção ({pct})',
				clicks: 'Cliques no período',
				clicksDelta: '{pct} em relação a {previous} no período anterior',
				clicksNoPrevious: 'Sem cliques no período anterior para comparar.',
				commissionClicks: '{count} em links com comissão ({pct})',
				commissionClicksUnavailable: 'Cliques com comissão não são contados por país.',
				attention: 'Precisa de atenção',
				staleStores: 'Lojas atrasadas',
				frozenStores: 'Lojas congeladas',
				failingIntegrations: 'Integrações com falha',
			},
			stores: {
				platform: 'Plataforma',
				freshness: 'Atualização',
				monetized: 'Monetização',
				monetizedYes: 'Com ofertas monetizadas',
				monetizedNo: 'Sem ofertas monetizadas',
				unregistered: 'Não cadastrada',
				unregisteredHint: 'Aparece em ofertas ou preços, mas não existe cadastro dela como loja.',
				register: 'Cadastrar',
				noLogo: 'Sem logo',
				inactive: 'inativa',
				viaComparator: 'também alimentada pelo comparador de preços',
				inactiveOffers: '{count} inativas',
				discounted: '{count} em promoção',
				commissionClicks: '{count} com comissão',
				updatedTitle: 'Ofertas: {offers}. Preços: {prices}.',
				countriesCovered: 'Países: {count}',
				columns: {
					store: 'Loja',
					link: 'Link',
					collection: 'Coletada por',
					offers: 'Ofertas ativas',
					monetized: 'Monetizadas',
					prices: 'Linhas de preço',
					freshness: 'Atualização',
					clicks: 'Cliques',
					expectedRate: 'Taxa esperada',
				},
			},
			integrations: {
				type: 'Tipo',
				status: 'Situação',
				active: 'Ativa',
				inactive: 'Inativa',
				problemsOnly: 'Só o que precisa de atenção',
				configOk: 'Completa',
				configMissing: '{count} faltando',
				keyYes: 'Chave definida',
				keyNo: 'Sem chave',
				cadenceEvery: 'a cada {hours} h',
				neverRan: 'Nenhuma execução registrada',
				runCounts: 'Importados {imported}, atualizados {updated}, ignorados {skipped}, falhas {failed}',
				columns: {
					integration: 'Integração',
					status: 'Situação',
					liveOffers: 'Ofertas ativas',
					freshness: 'Atualização',
					cadence: 'Cadência esperada',
					config: 'Configuração',
					credentials: 'Credenciais',
					schedule: 'Agendamento',
					lastRun: 'Última execução',
				},
			},
			clicks: {
				groupBy: 'Agrupar por',
				total: 'Cliques',
				commissionTotal: 'Em links com comissão',
				commissionShare: 'Parcela em links com comissão',
				groups: {
					store: 'Loja',
					source: 'Origem',
					day: 'Dia',
					country: 'País',
				},
				columns: {
					clicks: 'Cliques',
					commissionClicks: 'Em links com comissão',
					share: 'Parcela',
					converted: 'Vendas',
				},
			},
			commissions: {
				owedTitle: 'A pagar a streamers e parceiros: saldo acumulado',
				owedHint: 'O saldo de todas as comissões que vieram de um clique em oferta, de qualquer data: ele não segue as datas acima. As duas últimas colunas são a parte criada no período.',
				status: 'Situação',
				count: 'Comissões, acumulado',
				amount: 'Valor, acumulado',
				countPeriod: 'Comissões no período',
				amountPeriod: 'Valor no período',
				byStatus: 'Cliques de streamers por situação da comissão',
				byStore: 'Por loja',
				byStoreHint: 'Cliques de streamers no período, quantos viraram venda e quanto ainda é devido sobre eles.',
				columns: {
					store: 'Loja',
					currency: 'Moeda',
					clicks: 'Cliques',
					converted: 'Vendidos',
					owed: 'Ainda a pagar',
				},
			},
			untapped: {
				summary: 'Cliques que foram para uma loja sem link monetizado',
				ofClicks: '{untapped} de {total} cliques',
				hint: 'Dinheiro na mesa: as pessoas clicaram, mas a loja não nos paga nada por esse clique.',
				storesTitle: 'Onde acontece',
				none: 'Todos os cliques deste período foram para um link monetizado.',
				noProgramme: 'Nenhum programa registrado',
				ofStoreClicks: 'de {count} para a loja',
				columns: {
					store: 'Loja',
					clicks: 'Cliques sem monetização',
					share: 'Parcela do total sem monetização',
					offers: 'Ofertas ativas',
					link: 'Link',
					programmes: 'Programas conhecidos',
				},
				notes: {
					awin_advertiser_approval: 'Programa de afiliados da Awin: o anunciante precisa nos aprovar.',
					network_unconfirmed: 'A rede ainda não foi confirmada.',
					adtraction_confirm_regions: 'Adtraction: confirmar quais regiões o programa cobre.',
					impact_active: 'Programa da Impact já ativo.',
					shopee_affiliate_id_in_link: 'Shopee: o nosso ID de afiliado precisa estar no link.',
					amazon_associates_sales_requirement: 'Amazon Associates: o programa exige um mínimo de vendas.',
				},
			},
			revenue: {
				summaryTitle: 'O que as redes dizem que ganhamos',
				summaryHint: 'Por moeda: valores de moedas diferentes nunca são somados. Venda e comissão não incluem as transações estornadas e rejeitadas; elas têm colunas próprias.',
				groups: {
					store: 'Loja',
					network: 'Rede',
					month: 'Mês',
				},
				transactionsTitle: 'Transações',
				newButton: 'Nova transação',
				importButton: 'Importar CSV',
				newTitle: 'Nova transação',
				editTitle: 'Editar transação',
				noTransactions: 'Nenhuma transação corresponde a estes filtros.',
				readOnly: 'Vem da rede: não pode ser alterada aqui.',
				externalIdHint: 'O ID que a rede dá a esta transação. Em um lançamento manual, qualquer rótulo ainda não usado com esta rede.',
				searchHint: 'Busca no ID externo e na referência',
				externalIdLocked: 'O ID de uma transação não muda.',
				currencyHint: 'Três letras, ex.: USD',
				currencyInvalid: 'Use um código de moeda de três letras.',
				confirmDelete: 'Tem certeza de que deseja remover a transação {id}?',
				deleteWarning: 'Ela deixa de contar nos números de receita. Transações vindas de uma rede não podem ser removidas aqui.',
				saved: 'Transação salva.',
				deleted: 'Transação removida.',
				imported: 'CSV importado.',
				importTitle: 'Importar transações de um CSV',
				importIntro: 'Uma transação por linha, com estas colunas no cabeçalho. Uma linha com rede e ID externo que já existem atualiza essa transação.',
				importFile: 'Arquivo CSV',
				importHint: 'Até 5.000 linhas e 2 MB. As linhas válidas são salvas mesmo quando outras são recusadas; as recusadas são listadas depois da importação.',
				importTooBig: 'O arquivo tem mais de 2 MB.',
				importSend: 'Importar',
				importResult: 'Resultado',
				import_imported: 'Importadas',
				import_updated: 'Atualizadas',
				import_skipped: 'Ignoradas',
				importErrors: 'Linhas recusadas: {count}',
				importErrorsShown: 'Mostrando as primeiras {shown} de {total}.',
				importLine: 'Linha',
				importField: 'Campo',
				importReason: 'Motivo',
				columns: {
					network: 'Rede',
					externalId: 'ID externo',
					store: 'Loja',
					status: 'Situação',
					currency: 'Moeda',
					saleAmount: 'Venda',
					commissionAmount: 'Comissão',
					occurredAt: 'Data',
					reference: 'Referência',
					transactions: 'Transações',
					source: 'Origem',
				},
			},
			rates: {
				title: 'Taxas de comissão',
				hint: 'O que o programa de cada loja deve nos pagar, entre duas datas. É a base de comparação dos pagamentos reais.',
				newButton: 'Nova taxa',
				newTitle: 'Nova taxa de comissão',
				editTitle: 'Editar taxa de comissão',
				none: 'Nenhuma taxa de comissão ainda.',
				openEnded: 'sem fim',
				sourceHint: 'O quanto o número é confiável.',
				validUntilHint: 'Vazio significa que não tem data de fim.',
				percentInvalid: 'Informe uma porcentagem de 0 a 100.',
				untilInvalid: 'A data final não pode ser antes da inicial.',
				confirmDelete: 'Tem certeza de que deseja remover a taxa de {store}?',
				saved: 'Taxa de comissão salva.',
				deleted: 'Taxa de comissão removida.',
				columns: {
					store: 'Loja',
					network: 'Rede',
					model: 'Modelo',
					rate: 'Taxa',
					source: 'Fonte',
					ratePercent: 'Porcentagem da venda',
					fixedAmount: 'Valor fixo',
					currency: 'Moeda',
					cookieDays: 'Janela do cookie (dias)',
					validFrom: 'Válida desde',
					validUntil: 'Válida até',
					validity: 'Vigência',
					notes: 'Observações',
				},
			},
			health: {
				runsTitle: 'Execuções da coleta',
				runsHint: 'Cada comando agendado que alimenta as Ofertas, com quanto tempo levou e o que fez.',
				noRuns: 'Nenhuma execução registrada neste período.',
				linksTitle: 'Verificações de links de afiliado',
				linksHint: 'Seguimos só o primeiro redirecionamento de um link monetizado e procuramos nossa identidade nele. O endereço do lojista aparece sem a parte de consulta.',
				latestPerStore: 'Última verificação de cada loja',
				linkHistory: 'Histórico',
				noLinkChecks: 'Nenhuma verificação de link registrada neste período.',
				markersFound: 'encontrado: {markers}',
				qualityTitle: 'Qualidade dos dados',
				qualityHint: 'Coisas no catálogo que ninguém corrigiu ainda.',
				offersWithoutGame: 'Ofertas sem jogo',
				offersWithoutGameHint: 'Ofertas ativas sem jogo associado: a página delas não tem os recursos de jogo.',
				withoutLogo: 'Lojas sem logo',
				unregistered: 'Lojas que ninguém cadastrou',
				alertsWaiting: 'Alertas de preço aguardando',
				anyStore: 'Qualquer loja',
				broadcasts: 'Envios para os canais dos grupos',
				noBroadcasts: 'Nenhum envio neste período.',
				noneToFix: 'Nada a corrigir.',
				openStores: 'Abrir as lojas',
				columns: {
					startedAt: 'Início',
					kind: 'Tipo',
					subject: 'Assunto',
					status: 'Situação',
					duration: 'Duração',
					counts: 'Resultado',
					message: 'Mensagem',
					store: 'Loja',
					network: 'Rede',
					checkedAt: 'Verificado',
					finalUrl: 'Chegou em',
					marker: 'Marcador de identidade',
					offers: 'Ofertas',
					priceRows: 'Linhas de preço',
					activeAlerts: 'Alertas ativos',
					channel: 'Canal',
					sent: 'Enviados',
					failed: 'Falhas',
					lastSent: 'Último envio',
				},
			},
		},
	},

	tv: {
		banners: {
			rotatingBanners: {
				list: {
					title: 'Lista de Modelos de Banners Rotativos mais recentes do Mundo Gamer TV',
					subTitle: 'Confira a lista de Banners Rotativos cadastrados na Mundo Gamer TV.',
				},
				create: {
					title: 'Novo Modelo de Banner Rotativo',
					subTitle: 'Preencha os campos abaixo para cadastrar um Banner Rotativo.',
				},
				update: {
					title: 'Editar Modelo de Banner Rotativo',
					subTitle: 'Modelo de Banner Rotativo',
				},
				delete: {
					title: 'O Banner Rotativo foi deletado com sucesso.',
				},
			},
		},
		categories: {
			list: {
				title: 'Lista de Categorias no Mundo Gamer',
				subTitle: 'Verifique a lista de Categorias registradas no Mundo Gamer TV.',
			},
			create: {
				title: 'Nova Categoria',
				subTitle: 'Categoria',
			},
			delete: {
				title: 'A Categoria foi deletada com sucesso.',
			},
		},
		subcategories: {
			list: {
				title: 'Lista de Subcategorias no Mundo Gamer',
				subTitle: 'Verifique a lista de  Subcategorias registradas no Mundo Gamer TV.',
			},
			create: {
				title: 'Nova Subcategoria',
				subTitle: 'Subcategoria',
			},
			delete: {
				title: 'A Subcategoria foi deletada com sucesso.',
			},
		},
		streamers: {
			list: {
				title: 'Lista de Streamers no Mundo Gamer',
				subTitle: 'Verifique a lista de Streamers registrados no Mundo Gamer TV.',
			},
			create: {
				title: 'Novo Streamer',
				subTitle: 'Streamer',
			},
			delete: {
				title: 'O Streamer foi deletado com sucesso.',
			},
			comingSoon: 'Em breve',
			kickComingSoonDesc: 'A integração com o Kick ainda não está disponível. Fique ligado para atualizações futuras.',
			refreshStatus: 'Atualizar status ao vivo',
			refreshStatusSuccess: 'Status ao vivo atualizado com sucesso',
			refreshStatusError: 'Falha ao atualizar o status ao vivo',
			tabs: {
				all: 'Todos',
			},
		},
		streamersTypes: {
			list: {
				title: 'Lista de Tipos de Streamers no Mundo Gamer',
				subTitle: 'Verifique a lista de Tipos de Streamers registrados no Mundo Gamer TV.',
			},
			create: {
				title: 'Novo Tipo de Streamer',
				subTitle: 'Tipo de Streamer',
			},
			delete: {
				title: 'O Tipo de Streamer foi deletado com sucesso.',
			},
		},
		streamersApplications: {
			list: {
				title: 'Lista de Candidaturas de Streamers no Mundo Gamer',
				subTitle: 'Verifique a lista de Candidaturas de Streamers registrados no Mundo Gamer TV.',
			},
			create: {
				title: 'Nova Candidatura de Streamer',
				subTitle: 'Streamer',
			},
			delete: {
				title: 'A Candidatura do Streamer foi deletado com sucesso.',
			},
			applicationType: 'Oficial',
			official: 'Oficial',
			partner: 'Parceiro',
		},
	},

	Dashboards: 'Dashboards',
	CRM: 'CRM',
	Analytics: 'Analytics',
	eCommerce: 'eCommerce',
	Calendar: 'Calendário',
	Chat: 'Chat',
	Email: 'Email',
	professionalEmail: 'E-mail profissional',
	Invoice: 'Invoice',
	List: 'Lista',
	Preview: 'Pré-visualização',
	Edit: 'Editar',
	Add: 'Adicionar',
	user: 'Usuário',
	users: 'Usuários',
	allUsers: 'Selecionar todos os usuários',
	'User List': 'Lista de Usuários',
	'User View': 'Visualizar Usuários',
	'APPS AND PAGES': 'APPS AND PAGES',
	Pages: 'Pages',
	Authentication: 'Autenticação',
	'Login V1': 'Login V1',
	'Login V2': 'Login V2',
	'Register V1': 'Register V1',
	'Register V2': 'Register V2',
	'Forgot Password V1': 'Forgot Password V1',
	'Forgot Password V2': 'Forgot Password V2',
	'Reset Password V1': 'Reset Password V1',
	'Reset Password V2': 'Reset Password V2',
	Miscellaneous: 'Miscellaneous',
	'Under Maintenance': 'Under Maintenance',
	Error: 'Error',
	'Coming Soon': 'Coming Soon',
	'Not Authorized': 'Not Authorized',
	'Knowledge Base': 'Knowledge Base',
	'Account Settings': 'Account Settings',
	Pricing: 'Preços',
	Payments: 'Pagamentos',
	FAQ: 'FAQ',
	'USER INTERFACE': 'USER INTERFACE',
	Typography: 'Typography',
	Icons: 'Icons',
	status: 'Status',
	Gamification: 'Gamification',
	Cards: 'Cards',
	Basic: 'Basic',
	Statistics: 'Statistics',
	Advance: 'Advance',
	Actions: 'Ações',
	Chart: 'Chart',
	Components: 'Components',
	Alert: 'Alert',
	Avatar: 'Avatar',
	Badge: 'Badge',
	Button: 'Button',
	Menu: 'Menu',
	'Expansion Panel': 'Expansion Panel',
	Dialog: 'Dialog',
	Pagination: 'Pagination',
	Tabs: 'Tabs',
	Tooltip: 'Tooltip',
	Chip: 'Chip',
	Snackbar: 'Snackbar',
	Stepper: 'Stepper',
	Timeline: 'Timeline',
	Treeview: 'Treeview',
	'FORMS & TABLES': 'FORMS & TABLES',
	'Forms Elements': 'Forms Elements',
	Autocomplete: 'Autocomplete',
	Checkbox: 'Checkbox',
	Combobox: 'Combobox',
	'File Input': 'File Input',
	Radio: 'Radio',
	'Range Slider': 'Range Slider',
	Select: 'Select',
	Slider: 'Slider',
	Switch: 'Switch',
	Textarea: 'Textarea',
	Textfield: 'Textfield',
	'Date Picker': 'Date Picker',
	'Month Picker': 'Month Picker',
	'Time Picker': 'Time Picker',
	Rating: 'Rating',
	'Form Layout': 'Form Layout',
	'Form validation': 'Form validation',
	Tables: 'Tables',
	'Simple Table': 'Simple Table',
	Datatable: 'Datatable',
	'CHARTS AND MAPS': 'CHARTS AND MAPS',
	Charts: 'Charts',
	'Apex Chart': 'Apex Chart',
	Chartjs: 'Chartjs',
	'Leaflet Maps': 'Leaflet Maps',
	Others: 'Outros(a)',
	Other: 'Outro(a)',
	about: 'Sobre',
	hear: 'Ouviu',
	'Menu Levels': 'Menu Levels',
	'Menu Level 2.1': 'Menu Level 2.1',
	'Menu Level 2.2': 'Menu Level 2.2',
	'Menu Level 3.1': 'Menu Level 3.1',
	'Menu Level 3.2': 'Menu Level 3.2',
	'Disabled Menu': 'Disabled Menu',
	'Raise Support': 'Raise Support',
	Documentation: 'Documentation',
	'Charts & Maps': 'Charts & Maps',
	Apps: 'Apps',
	'User Interface': 'User Interface',
	'Forms & Tables': 'Forms & Tables',

	applicationText: 'Texto da Aplicação',
	applicationAdress: 'Endereço de destino',
	applicationAdressPlaceholder: 'Website ou E-mail',
	showSalary: 'Mostrar salário',
	customSalary: 'Salário customizado',
	'Company Name': 'Empresa',
	'Number Vacations': 'Número de Vagas',
	'Publication Date': 'Data de Publicação',
	'Expiration Date': 'Data de Expiração',
	apiError: 'Ocorreu um erro desconhecido na comunicação com o servidor',
	rangeSalary: 'Faixa de Salário',
	noHave: 'Não possui',
	forDisablePerson: 'For Disable Persons',
	isFeatured: 'Featured',
	visible: 'Visível',
	enableComments: 'Habilitar Comentários',
	invalidImageFormat: 'Apenas formatos JPG e PNG são permitidos.',
	imageTooSmall: 'Esta imagem é muito pequena (mínimo {dimensions}px). Imagens maiores são necessárias para aparecer no Google Discover e Notícias.',
	disapprovalReason: 'Motivo da rejeição',
	installedApps: 'Dispositivos',
	peopleWithApp: 'Pessoas com o app',
	deviceTokens: 'tokens de dispositivo',
	allPlatforms: 'Todas as Plataformas',

	// ─── Academy ───────────────────────────────────────────────────
	academyTitle: 'Academy',
	academyDashboard: 'Dashboard',
	academyCatalog: 'Catálogo',
	academyCourses: 'Cursos',
	academyMentorships: 'Mentorias',
	academyCreators: 'Mentores',
	academyCreatorApplications: 'Solicitações de Mentores',
	academyProducts: 'Produtos',
	academyEntitlements: 'Acessos',
	academyCertificates: 'Certificados',
	academyReviews: 'Avaliações',
	academyReports: 'Denúncias',
	academyPromotions: 'Promoções',
	academyCommissions: 'Comissões',
	academyFinancial: 'Financeiro',
	academyPayoutsTitle: 'Resgates de Mentores',
	academyPayoutsApprove: 'Aprovar',
	academyPayoutsMarkPaid: 'Marcar como pago',
	academyPayoutsReject: 'Rejeitar',
	academyPayoutsActionApprove: 'Aprovar Resgate',
	academyPayoutsActionMarkPaid: 'Marcar como Pago',
	academyPayoutsActionReject: 'Rejeitar Resgate',
	academyPayoutsAction: 'Ação',
	academyRefundRequestsTitle: 'Solicitações de Reembolso',
	academyRefundRequestsApprove: 'Aprovar',
	academyRefundRequestsReject: 'Rejeitar',
	academyRefundRequestsActionApprove: 'Aprovar Reembolso',
	academyRefundRequestsActionReject: 'Rejeitar Reembolso',
	academyRefundRequestsAction: 'Ação',
	academyRefundRequestsConfirm: 'Confirmar',
	academyRefundRequestsDialogOrder: 'Pedido',
	academyRefundRequestsDialogAmount: 'Valor',
	academyRefundRequestsDialogReason: 'Motivo do aluno',
	academyRefundRequestsDialogNotesRequired: 'Motivo da rejeição (obrigatório)',
	academyRefundRequestsDialogNotesOptional: 'Notas (opcional)',
	academyScheduledLessons: 'Aulas Agendadas',
	academyCategories: 'Categorias',
	academySubcategories: 'Subcategorias',
	academyFormats: 'Formatos',
	academyLevels: 'Níveis',
	academyTotalCourses: 'Total de Cursos',
	academyTotalCreators: 'Total de Mentores',
	academyTotalStudents: 'Total de Alunos',
	academyTotalBookings: 'Total de Agendamentos',
	academyPendingModeration: 'Pendentes de Moderação',
	academyLatestCourses: 'Últimos Cursos',
	academyLatestCreators: 'Últimos Mentores',
	academyRevenueMonthly: 'Receita Mensal',
	academyBookingsDay: 'Agendamentos por Dia',
	academyCoursesByStatus: 'Cursos por Status',
	academyStatusDraft: 'Rascunho',
	academyStatusSubmitted: 'Submetido',
	academyStatusPublished: 'Publicado',
	academyStatusRejected: 'Rejeitado',
	academyStatusPending: 'Pendente',
	academyStatusApproved: 'Aprovado',
	academyStatusFlagged: 'Sinalizado',
	academyCreatorTypeInstructor: 'Instrutor',
	academyCreatorTypeMentor: 'Mentor',
	academyCreatorTypeBoth: 'Instrutor & Mentor',
	academyApprove: 'Aprovar',
	academyReject: 'Rejeitar',
	academyFeature: 'Destacar',
	academyUnfeature: 'Remover Destaque',
	academyVerified: 'Verificado',
	academyRating: 'Nota',
	academyReviewCount: 'Avaliações',
	academyStudentCount: 'Alunos',
	academyMotivation: 'Motivação',
	academyPortfolio: 'Portfólio',
	academyLinkedin: 'LinkedIn',
	academyAreasOfExpertise: 'Áreas de Especialização',
	academySampleContent: 'Conteúdo de Amostra',
	academyReviewerNotes: 'Notas do Revisor',
	academyRejectionReason: 'Motivo de Rejeição',

	// --- Avaliações Técnicas ---
	academyAssessmentsTechnical: 'Avaliações Técnicas',
	academyAssessmentsNew: 'Nova Avaliação',
	academyAssessmentsEdit: 'Editar Avaliação',
	academyAssessmentsLoading: 'Carregando...',
	academyAssessmentsReviewAi: 'Revisar IA',
	academyAssessmentsGenerateWithAi: 'Gerar com IA',
	academyAssessmentsOwnerType: 'Tipo',
	academyAssessmentsStatus: 'Status',
	academyAssessmentsDifficulty: 'Dificuldade',
	academyAssessmentsCategory: 'Categoria',
	academyAssessmentsSkill: 'Habilidade',
	academyAssessmentsSkills: 'Habilidades',
	academyAssessmentsSkillsHint: 'A primeira habilidade selecionada é a habilidade principal deste assessment.',
	academyAssessmentsPrimary: 'Principal',
	academyAssessmentsQuestionsCount: 'questões',
	academyAssessmentsQuestionsHeader: 'Questões',
	academyAssessmentsColLanguage: 'Idioma',
	academyAssessmentsPendingReview: 'Aguardando revisão',
	academyAssessmentsPublish: 'Publicar',
	academyAssessmentsApproveAi: 'Aprovar IA',
	academyAssessmentsRejectAi: 'Rejeitar IA',
	academyAssessmentsArchive: 'Arquivar Avaliação',
	academyAssessmentsArchiveConfirm: 'Tem certeza que deseja arquivar',
	academyAssessmentsArchiveBtn: 'Arquivar',
	academyAssessmentsRejectAiTitle: 'Rejeitar Avaliação IA',
	academyAssessmentsRejectionReason: 'Motivo da rejeição',
	academyAssessmentsAssessment: 'Avaliação',
	academyAssessmentsCompany: 'Empresa',

	// Abas do formulário
	academyAssessmentsTabGeneral: 'Geral',
	academyAssessmentsTabQuestions: 'Questões',
	academyAssessmentsTabSettings: 'Configurações',
	academyAssessmentsTabAi: 'IA',
	academyAssessmentsTabAiReview: 'Revisar',
	academyAssessmentsTabRelated: 'Conteúdo Relacionado',
	academyAssessmentsTabTranslations: 'Traduções',

	// Formulário - Aba Geral
	academyAssessmentsTitle: 'Título (EN) *',
	academyAssessmentsDesc: 'Descrição (EN)',
	academyAssessmentsSaveFirstTranslations: 'Salve a avaliação primeiro para gerenciar as traduções.',
	academyAssessmentsTitleAllLangs: 'Título (todos os idiomas)',
	academyAssessmentsSlugHint: 'Gerado automaticamente ao salvar',
	academyAssessmentsDescAllLangs: 'Descrição (todos os idiomas)',
	academyAssessmentsOwnerTypeLabel: 'Tipo de dono',
	academyAssessmentsCertEnabled: 'Habilitar certificado',
	academyAssessmentsFree: 'Gratuito',

	// Formulário - Aba Questões
	academyAssessmentsNewQuestion: 'Nova Questão',
	academyAssessmentsNoQuestions: 'Nenhuma questão adicionada. Clique em "Nova Questão" para começar.',
	academyAssessmentsNoTitle: '(sem título)',
	academyAssessmentsQuestionText: 'Texto da questão',
	academyAssessmentsQuestionExplanation: 'Explicação (exibida pós-resposta)',
	academyAssessmentsQuestionType: 'Tipo',
	academyAssessmentsPoints: 'Pontos',
	academyAssessmentsOptions: 'Alternativas',
	academyAssessmentsCorrect: 'Correta',
	academyAssessmentsTextEn: 'Texto (EN)',
	academyAssessmentsTextPtBr: 'Texto (PT-BR)',
	academyAssessmentsTextEs: 'Texto (ES)',
	academyAssessmentsTextDe: 'Texto (DE)',
	academyAssessmentsTextRo: 'Texto (RO)',
	academyAssessmentsQuestionTranslations: 'Traduções das Questões',
	academyAssessmentsOptionTranslations: 'Traduções das Alternativas',
	academyAssessmentsOptionText: 'Texto da alternativa',

	// Formulário - Aba Configurações
	academyAssessmentsTimeLimit: 'Tempo limite (minutos)',
	academyAssessmentsTimeLimitHint: '0 = sem limite',
	academyAssessmentsPassScore: 'Nota mínima para aprovação (%)',
	academyAssessmentsPassScoreHint: 'Ex: 70 = 70%',
	academyAssessmentsAllowRetake: 'Permitir retentativa',
	academyAssessmentsCooldown: 'Cooldown entre tentativas (dias)',
	academyAssessmentsVisibility: 'Visibilidade',
	academyAssessmentsRequiresSub: 'Requer assinatura',
	academyAssessmentsRandomizeQuestions: 'Randomizar ordem das questões',
	academyAssessmentsRandomizeOptions: 'Randomizar alternativas',
	academyAssessmentsInternal: 'Interno (não visível no marketplace)',

	// Formulário - Aba IA
	academyAssessmentsAiGenerated: 'Gerado por IA',
	academyAssessmentsAiMetadata: 'Metadata de Geração IA',
	academyAssessmentsNotAiGenerated: 'Esta avaliação não foi gerada por IA.',
	academyAssessmentsReviewStatus: 'Status de Revisão',
	academyAssessmentsReviewApproved: 'Revisão aprovada.',
	academyAssessmentsReviewRejected: 'Revisão rejeitada.',
	academyAssessmentsReason: 'Motivo:',
	academyAssessmentsAiModel: 'Modelo',
	academyAssessmentsAiPromptTemplate: 'Template de prompt',
	academyAssessmentsAiTopic: 'Tópico gerado',
	academyAssessmentsAiQuestionsRequested: 'Questões solicitadas',
	academyAssessmentsAiGeneratedAt: 'Gerado em',
	academyAssessmentsAiReviewStatus: 'Status de revisão',
	academyAssessmentsAiReviewedBy: 'Revisado por (user_id)',
	academyAssessmentsAiReviewedAt: 'Revisado em',
	academyAssessmentsAiEditCount: 'Edições realizadas',

	// Formulário - Aba Conteúdo Relacionado
	academyAssessmentsLearningContent: 'Conteúdo de Aprendizado Associado',
	academyAssessmentsAssociateProduct: 'Associar Produto',
	academyAssessmentsLearningContentHint: 'Associe cursos ou ebooks do Academy para recomendar após a realização da avaliação.',
	academyAssessmentsSaveFirst: 'Salve a avaliação primeiro para associar conteúdo relacionado.',
	academyAssessmentsContext: 'Contexto',
	academyAssessmentsRecommendationType: 'Tipo de Recomendação',
	academyAssessmentsNoContent: 'Nenhum conteúdo associado ainda.',
	academyAssessmentsUpdate: 'Atualizar',
	academyAssessmentsCreate: 'Criar',

	// Textos de opções de select
	academyAssessmentsVisPrivate: 'Privado',
	academyAssessmentsVisPlatform: 'Plataforma',
	academyAssessmentsVisMarketplace: 'Marketplace',
	academyAssessmentsVisCommunity: 'Comunidade',
	academyAssessmentsQtSingle: 'Única escolha',
	academyAssessmentsQtMultiple: 'Múltipla escolha',
	academyAssessmentsQtTrueFalse: 'Verdadeiro/Falso',
	academyAssessmentsCtxBoth: 'Qualquer resultado',
	academyAssessmentsCtxPassed: 'Aprovado',
	academyAssessmentsCtxFailed: 'Reprovado',
	academyAssessmentsRtPrerequisite: 'Pré-requisito',
	academyAssessmentsRtDeepen: 'Aprofundamento',
	academyAssessmentsRtAdvance: 'Avançar',

	// Página Gerar com IA
	academyAssessmentsGenerateAiTitle: 'Gerar Avaliação com IA',
	academyAssessmentsGenerateAiInfo: 'A IA irá gerar uma avaliação técnica completa com questões, alternativas e explicações. A avaliação será criada com status draft e ficará pendente de revisão humana.',
	academyAssessmentsGenerateTopic: 'Tópico / Tema *',
	academyAssessmentsGenerateQuestionsCount: 'Nº de questões *',
	academyAssessmentsGenerateLanguage: 'Idioma de geração *',
	academyAssessmentsGenerateProvider: 'Provedor de IA (opcional)',
	academyAssessmentsGeneratePassScore: 'Nota mínima (%)',
	academyAssessmentsGenerateInstructions: 'Instruções adicionais (opcional)',
	academyAssessmentsGenerateError: 'Erro ao gerar avaliação. Verifique se o serviço de IA está disponível e tente novamente.',
	academyAssessmentsGenerateSuccess: 'Avaliação gerada com sucesso!',
	academyAssessmentsGenerateReviewNow: 'Revisar agora →',
	academyAssessmentsGenerateHint: 'O processo de geração pode levar até 60 segundos dependendo do modelo de IA e do número de questões.',
	academyAssessmentsGenerateBtn: 'Gerar Avaliação',
	academyAssessmentsGenerateRequired: 'Obrigatório',

	// Página de Categorias
	academyAssessmentsCategoriesTitle: 'Categorias de Avaliação',
	academyAssessmentsCategoryNew: 'Nova Categoria',
	academyAssessmentsCategoryName: 'Nome',
	academyAssessmentsCategoryParent: 'Pai',
	academyAssessmentsCategorySkill: 'Skill',
	academyAssessmentsCategoryOrder: 'Ord.',
	academyAssessmentsCategoryEdit: 'Editar Categoria',
	academyAssessmentsCategoryParentLabel: 'Categoria pai',
	academyAssessmentsCategorySort: 'Ordenação',
	academyAssessmentsCategoryActive: 'Ativo',
	academyAssessmentsCategoryDelete: 'Excluir Categoria',
	academyAssessmentsCategoryDeleteConfirm: 'Tem certeza que deseja excluir',
	academyAssessmentsCategoryDeleteWarning: 'Categorias com avaliações associadas não podem ser excluídas.',
	academyAssessmentsCategoryDeleteBtn: 'Excluir',
	academyAssessmentsCategoryStatusActive: 'Ativo',
	academyAssessmentsCategoryStatusInactive: 'Inativo',
	academyAssessmentsCategorySlugHint: 'Gerado automaticamente',

	// Página de Certificações
	academyAssessmentsCertificationsTitle: 'Certificações de Skills',
	academyAssessmentsCertificationsSearch: 'Buscar por user ID ou skill ID...',
	academyAssessmentsCertificationsLevel: 'Nível',
	academyAssessmentsCertificationsUser: 'Usuário',
	academyAssessmentsCertificationsAssessmentSkill: 'Avaliação / Skill',
	academyAssessmentsCertificationsType: 'Tipo',
	academyAssessmentsCertificationsExpiry: 'Validade',
	academyAssessmentsCertificationsIssuedAt: 'Emitido em',
	academyAssessmentsCertificationsCode: 'Código',
	academyAssessmentsCertVerified: 'Verificado',
	academyAssessmentsCertDigital: 'Digital',
	academyAssessmentsCertNoExpiry: 'Sem validade',

	// Live Activity pages
	academyActivityAssessmentsTitle: 'Atividade ao Vivo — Assessments',
	academyActivityTrailsTitle: 'Atividade ao Vivo — Trilhas de Carreira',
	academyActivityColUser: 'Usuário',
	academyActivityColCountry: 'País',
	academyActivityColAssessment: 'Assessment',
	academyActivityColTrail: 'Trilha',
	academyActivityColStatus: 'Status',
	academyActivityColResult: 'Resultado',
	academyActivityColScore: 'Pontuação',
	academyActivityColStartedAt: 'Iniciado em',
	academyActivityColEnrolledAt: 'Inscrito em',
	academyActivityColCompletedAt: 'Concluído em',
	academyActivityFilterStatus: 'Status',
	academyActivityStatusStarted: 'Iniciado',
	academyActivityStatusCompleted: 'Concluído',
	academyActivityStatusExpired: 'Expirado',
	academyActivityStatusAbandoned: 'Abandonado',
	academyActivityStatusEnrolled: 'Inscrito',
	academyActivityStatusInProgress: 'Em andamento',
	academyActivityResultPassed: 'Aprovado',
	academyActivityResultFailed: 'Reprovado',
	academyActivityResultPending: 'Em andamento',
	academyLearningWidget: {
		title: 'Atividade de aprendizado — assessments e trilhas de carreira',
		assessmentsTitle: 'Assessments',
		trailsTitle: 'Trilhas de carreira',
		takers: 'Pessoas que iniciaram',
		completed: 'Concluíram',
		passRate: 'Taxa de aprovação',
		enrolled: 'Inscritos',
		completionRate: 'Taxa de conclusão',
		recent: 'Últimas atividades',
		empty: 'Nenhuma atividade ainda.',
		viewAll: 'Abrir atividade ao vivo',
		failed: 'Não foi possível carregar esta atividade agora.',
	},
	academyProductAnalytics: {
		menu: 'Funil & Conversões',
		widget: {
			title: 'Funil de Produtos — eBooks',
			subtitle: 'Últimos 30 dias. Acessos, conversão e desempenho dos tiers de preço.',
			viewAll: 'Ver relatório completo',
			byProduct: 'Por eBook',
			pendingMigration: 'O rastreamento do funil ainda não foi aplicado no banco desta instalação. Assim que a migration rodar no deploy, os dados aparecem aqui.',
			failed: 'Não foi possível carregar o funil agora. Abra o relatório completo para ver o erro em detalhe.',
		},
		title: 'Funil, Conversões e Receita por Produto',
		subtitle: 'Histórico de acessos, conversões, localização e valores por produto — eBooks hoje, cursos e mentorias assim que suas páginas dispararem o mesmo rastreamento.',
		tabs: {
			overview: 'Visão geral',
			geo: 'Localizações & Tiers',
			products: 'Produtos',
			attribution: 'Origem do tráfego',
			sessions: 'Histórico de visitas',
			access: 'Acessos ao conteúdo',
		},
		filters: {
			dateFrom: 'De',
			dateTo: 'Até',
			platform: 'Plataforma',
			product: 'Produto',
			country: 'País',
			region: 'Tier de preço',
			search: 'Buscar',
			searchHint: 'E-mail, sessão ou slug do produto',
			apply: 'Aplicar',
			clear: 'Limpar',
			regionStandard: 'Preço cheio (sem tier)',
			regionUnknown: 'País não identificado',
		},
		kpis: {
			visits: 'Visitantes únicos',
			pageViews: 'visualizações de página',
			leads: 'Leads (e-mails)',
			checkouts: 'Checkouts iniciados',
			purchases: 'Compras',
			conversionRate: 'compram (por visitante)',
			ofVisits: 'dos visitantes',
			orders: 'pedidos',
			averageOrder: 'ticket médio',
		},
		funnel: {
			title: 'Funil',
			step: 'Etapa',
			sessions: 'Visitantes',
			events: 'Eventos',
			ofTotal: '% do total',
			ofPrevious: '% da etapa anterior',
		},
		reasons: {
			title: 'Motivo de não ter comprado',
			empty: 'Ninguém respondeu ainda. A pergunta aparece na página do eBook, no abandono do checkout.',
			price: 'Preço',
			not_sure_fits: 'Não sei se é pra mim',
			no_time: 'Sem tempo agora',
			technical_issue: 'Problema técnico',
		},
		steps: {
			page_view: 'Visualizou a página',
			email_captured: 'Deixou o e-mail',
			cart_added: 'Adicionou ao carrinho',
			checkout_started: 'Iniciou o checkout',
			purchase_completed: 'Comprou',
		},
		series: {
			title: 'Evolução diária',
			visits: 'Visitantes',
			leads: 'Leads',
			checkouts: 'Checkouts',
			purchases: 'Compras',
			revenueTitle: 'Receita por dia (uma série por moeda)',
			empty: 'Sem eventos no período selecionado.',
		},
		geo: {
			regionTitle: 'Tiers de preço',
			regionSubtitle: 'Responde direto se o desconto regional está convertendo. O tier é o que o visitante realmente viu no momento do acesso, não o tier configurado hoje.',
			tierPagesTitle: 'Tiers por página',
			tierPagesSubtitle: 'Em qual página o visitante esteve dentro de cada tier. Um tier inteiro pode parecer ruim quando o problema é uma página só.',
			countryTitle: 'Países',
			countrySubtitle: 'De onde vêm os acessos e quanto cada país converte.',
			region: 'Tier',
			country: 'País',
			discount: 'Desconto',
			avgPriceShown: 'Preço médio exibido',
			avgPaid: 'Preço médio pago',
			noTier: 'Preço cheio',
			unknownCountry: 'Não identificado',
		},
		products: {
			title: 'Desempenho por produto',
			subtitle: 'Compare eBooks entre si — e, futuramente, cursos e mentorias na mesma tabela.',
			product: 'Produto',
		},
		attribution: {
			title: 'Origem do tráfego',
			subtitle: 'Atribuição por visita, não por evento: uma visita inteira conta para a origem que a trouxe.',
			dimension: 'Dimensão',
			value: 'Origem',
			direct: 'Direto',
			dimensions: {
				utm_source: 'Origem (utm_source)',
				utm_medium: 'Mídia (utm_medium)',
				utm_campaign: 'Campanha (utm_campaign)',
				utm_content: 'Conteúdo (utm_content)',
				referral_code: 'Código de indicação',
			},
		},
		sessions: {
			title: 'Histórico de visitas',
			subtitle: 'Uma linha por visita: quem, de onde, qual preço viu, até onde avançou e quanto pagou.',
			visitor: 'Visitante',
			anonymous: 'Anônimo',
			guest: 'Sem login',
			product: 'Produto',
			location: 'Localização',
			priceShown: 'Preço exibido',
			paid: 'Pago',
			furthestStep: 'Etapa máxima',
			source: 'Origem',
			lastSeen: 'Último evento',
		},
		access: {
			title: 'Acessos ao conteúdo',
			subtitle: 'Leitura e download depois da compra — mostra se o que foi vendido está sendo usado.',
			user: 'Usuário',
			product: 'Produto',
			accessType: 'Tipo de acesso',
			locale: 'Idioma',
			ip: 'IP',
			date: 'Data',
			uniqueUsers: 'usuários únicos',
		},
		common: {
			visits: 'Visitantes',
			leads: 'Leads',
			checkouts: 'Checkouts',
			purchases: 'Compras',
			conversion: 'Conversão',
			revenue: 'Receita',
			refresh: 'Atualizar',
			loading: 'Carregando...',
			noData: 'Nenhum dado no período selecionado.',
		},
	},
	academyStats: 'Estatísticas de Engajamento',
	academyAssessmentsList: 'Todas as Avaliações',
	academyCareerTrailsTitle: 'Trilhas de Carreira',
	academyCareerTrailsList: 'Todas as Trilhas',
	academyCareerTrailsNew: 'Nova Trilha',
	academyCareerTrailsColTrail: 'Trilha',
	academyCareerTrailsColCategory: 'Área',
	academyCareerTrailsColDifficulty: 'Nível',
	academyCareerTrailsColLevels: 'Níveis',
	academyCareerTrailsColHours: 'Horas',
	academyCareerTrailsColEnrolled: 'Inscritos',
	academyCareerTrailsColStatus: 'Status',
	academyCareerTrailsFeatured: 'Destaque',
	academyCareerTrailsFree: 'Gratuito',
	academyCareerTrailsSubscription: 'Assinatura',
	academyCareerTrailsFilterStatus: 'Status',
	academyCareerTrailsFilterCategory: 'Área',
	academyCareerTrailsFilterDifficulty: 'Nível',
	academyCareerTrailsPublish: 'Publicar',
	academyCareerTrailsArchive: 'Arquivar Trilha',
	academyCareerTrailsArchiveText: 'Tem certeza que deseja arquivar',
	academyCareerTrailsFormNewTitle: 'Nova Trilha de Carreira',
	academyCareerTrailsFormEditTitle: 'Editar Trilha de Carreira',
	academyCareerTrailsFormBack: 'Voltar',
	academyCareerTrailsFormTabGeneral: 'Geral',
	academyCareerTrailsFormTabTranslations: 'Traduções',
	academyCareerTrailsFormTabLevels: 'Níveis',
	academyCareerTrailsFormTitleSection: 'Título',
	academyCareerTrailsFormDescSection: 'Descrição',
	academyCareerTrailsFormSlug: 'Slug',
	academyCareerTrailsFormSlugHint: 'Gerado automaticamente, editável',
	academyCareerTrailsFormCategory: 'Área / Categoria',
	academyCareerTrailsFormDifficulty: 'Dificuldade',
	academyCareerTrailsFormHours: 'Horas estimadas',
	academyCareerTrailsFormThumbnail: 'URL da Thumbnail',
	academyCareerTrailsFormFree: 'Gratuito',
	academyCareerTrailsFormFeatured: 'Destaque',
	academyCareerTrailsFormSubscription: 'Requer assinatura',
	academyCareerTrailsFormSaveFirst: 'Salve a trilha primeiro para adicionar níveis.',
	academyCareerTrailsFormNewLevel: 'Novo Nível',
	academyCareerTrailsFormAddStep: 'Adicionar Step',
	academyCareerTrailsFormSaveLevel: 'Salvar Nível',
	academyCareerTrailsFormCreateLevel: 'Criar Nível',
	academyCareerTrailsFormCreate: 'Criar Trilha',
	academyCareerTrailsFormUpdate: 'Atualizar',
	academyCareerTrailsFormCancel: 'Cancelar',
	academyCareerTrailsFormLevelTitle: 'Título do Nível (EN) *',
	academyCareerTrailsFormLevelTitlePt: 'Título do Nível (PT-BR)',
	academyCareerTrailsFormXpReward: 'Recompensa XP',
	academyCareerTrailsFormMgcReward: 'Recompensa MGC',
	academyCareerTrailsFormBadgeId: 'ID do Badge',
	academyCareerTrailsFormBadgeHint: 'Referência suave para academy.skill_badges',
	academyCareerTrailsRemoveLevelTitle: 'Remover Nível',
	academyCareerTrailsRemoveLevelText: 'Tem certeza que deseja remover este nível e todos os seus steps?',
	academyCareerTrailsStepType: 'Tipo',
	academyCareerTrailsStepRef: 'Referência',
	academyCareerTrailsStepRequired: 'Obrigatório',
	academyCareerTrailsStepMinScore: 'Score mín.',
	academyCareerTrailsStepExternalUrl: 'URL Externa',
	academyCareerTrailsStepLesson: 'Aula / Vídeo',
	academyCareerTrailsStepAssessment: 'Assessment',
	academyCareerTrailsStepReading: 'Leitura (Ebook)',
	academyCareerTrailsStepProject: 'Projeto',
	academyCareerTrailsStepArticle: 'Artigo',
	academyCareerTrailsStepVideo: 'Vídeo',
	academyCareerTrailsStepMixed: 'Artigo + Vídeo',
	academyCareerTrailsStepExternal: 'Link Externo',
	academyCareerTrailsStepSelectCourse: 'Selecione um curso',
	academyCareerTrailsStepSelectAssessment: 'Selecione um assessment',
	academyCareerTrailsStepSelectEbook: 'Selecione um ebook',
	academyCareerTrailsContentTitle: 'Título do Conteúdo',
	academyCareerTrailsContentBody: 'Corpo do Artigo',
	academyCareerTrailsContentVideoUrl: 'URL do Vídeo',
	academyCareerTrailsContentDuration: 'Min.',
	academyCareerTrailsEditContent: 'Editar Conteúdo',
	academyCareerTrailsSaveContent: 'Concluído',

	// Content Engine — RSS Queue
	contentRss: {
		title: 'Motor de Conteúdo',
		subtitle: 'Tópicos lidos recentemente das fontes RSS, com o status da automação.',
		filterStatus: 'Status',
		filterFeed: 'Fonte',
		search: 'Buscar',
		colCover: 'Capa',
		colSource: 'Fonte',
		colTitle: 'Título',
		colStatus: 'Status',
		colRelevance: 'Relevância',
		colDuplicate: 'Duplicado de',
		colCreated: 'Lido em',
		colActions: 'Ações',
		viewOriginal: 'Ver original',
		viewPulse: 'Ver pulse',
		approve: 'Selecionar e escrever',
		reject: 'Ignorar',
		rewrite: 'Reescrever',
		publish: 'Publicar',
		preview: 'Pré-visualizar',
		bulkRewrite: 'Escrever selecionados',
		bulkIgnore: 'Ignorar selecionados',
		selectedCount: '{count} selecionado(s)',
		processingStarted: 'Os tópicos selecionados estão sendo escritos. Você receberá o conteúdo para aprovar.',
		publishStarted: 'Publicando a matéria…',
		rewriteStarted: 'Reescrevendo a matéria…',
		delete: 'Excluir',
		cancel: 'Cancelar',
		confirmDelete: 'Remover este tópico da fila?',
		writtenBy: 'Reescrito por',
		empty: 'Nenhum tópico lido ainda.',
		statuses: {
			new: 'Novo',
			pending: 'Aguardando revisão',
			rewriting: 'Reescrevendo',
			rewritten: 'Reescrito',
			selected: 'Selecionado',
			approved: 'Aprovado',
			pending_review: 'Em revisão nos Pulses',
			published: 'Publicado',
			rejected: 'Rejeitado',
			duplicate: 'Duplicado',
		},
	},

	// Central de Curadoria — feed unificado RSS + Onboarding de Estúdio
	contentFeed: {
		title: 'Central de Curadoria',
		search: 'Buscar',
		empty: 'Nenhuma sugestão pendente.',
		refresh: 'Atualizar',
		originRss: 'RSS',
		originOnboarding: 'Onboarding de Estúdio',
		approve: 'Aprovar',
		discard: 'Descartar',
		selectPrompt: 'Selecione uma sugestão na lista para começar.',
		generate: 'Gerar matéria',
		viewOriginal: 'Ver original',
		noCover: 'Sem capa — publique sem imagem ou adicione uma pela tela de Pulses após criar.',
		writing: 'Escrevendo…',
		writeTimeout: 'A escrita demorou mais que o esperado. Tente novamente.',
		fieldTitle: 'Título',
		schedule: 'Agendamento',
		publishNow: 'Publicar agora',
		publishScheduled: 'Agendar publicação',
		startDate: 'Data',
		startTime: 'Hora',
		sendNotification: 'Disparar notificação ao publicar',
		voiceGuideline: 'Diretriz de voz da redação',
		publish: 'Publicar',
		published: 'Matéria publicada com sucesso.',
		translationStarted: 'Tradução iniciada.',
	},

	// Content Engine — Configurações
	contentEngineSettings: {
		title: 'Configurações do Content Engine',
		subtitle: 'Configure o pipeline de automação, notificações do Telegram e limites de uso de IA.',
		saved: 'Configurações salvas com sucesso.',
		save: 'Salvar Configurações',
		secretPlaceholder: 'Deixe em branco para manter o valor atual',
		empty: 'Nenhuma configuração encontrada. Execute',
		groups: {
			general: 'Geral',
			automation: 'Automação',
			telegram: 'Telegram',
			rss: 'RSS',
			ai: 'IA',
		},
		fields: {
			is_enabled: {
				label: 'Content Engine Ativo',
				description: 'Quando desativado, o pipeline inteiro para. Nenhum artigo é buscado, reescrito ou publicado.',
			},
			auto_mode_enabled: {
				label: 'Pipeline Automático',
				description: 'Pula a curadoria manual de títulos — artigos são pontuados e reescritos automaticamente. Combine com Publicação Automática para modo 100% sem intervenção.',
			},
			auto_publish_enabled: {
				label: 'Publicação Automática',
				description: 'Publica os Pulses ao vivo imediatamente. Quando desativado, artigos automatizados caem na fila de moderação (pending_review) para revisão final antes de ir ao ar.',
			},
			automation_user_id: {
				label: 'ID do Usuário de Automação',
				description: 'ID do usuário da community que assina os pulses automatizados.',
			},
			automation_pulse_category_id: {
				label: 'ID da Categoria do Pulse',
				description: 'Categoria atribuída aos pulses automáticos. Usa a primeira categoria disponível como fallback.',
			},
			community_api_url: {
				label: 'URL da Community API',
				description: 'URL base da community API (ex.: https://api-community.mundogamer.network). /api é adicionado automaticamente.',
			},
			automation_secret: {
				label: 'Automation Secret',
				description: 'Token compartilhado entre api-main e community-api. Obrigatório — sem ele todos os publishes falham.',
			},
			telegram_channel_name: {
				label: 'Nome do Canal Telegram',
				description: 'Nome do registro WebhookChannel usado para enviar notificações de aprovação.',
			},
			rss_fetch_interval: {
				label: 'Intervalo de Busca (minutos)',
				description: 'Com que frequência o scheduler verifica novos artigos em todos os feeds.',
			},
			ai_daily_token_cap: {
				label: 'Limite Diário de Tokens',
				description: 'Máximo de tokens que podem ser consumidos por dia entre todos os usuários.',
			},
			ai_rate_limit_per_min: {
				label: 'Rate Limit (req/min)',
				description: 'Máximo de requisições de IA por minuto por usuário.',
			},
			content_min_chars: {
				label: 'Tamanho Mínimo do Artigo (chars)',
				description: 'Mínimo de caracteres visíveis para um artigo reescrito. A IA é instruída a atingir esse alvo.',
			},
			content_max_chars: {
				label: 'Tamanho Máximo do Artigo (chars)',
				description: 'Máximo de caracteres visíveis para um artigo reescrito. Mantém o conteúdo focado.',
			},
			brand_voice_guidelines: {
				label: 'Diretrizes de Voz da Marca',
				description: 'Notas livres de tom, palavras a evitar e estilo da redação — injetadas no prompt de reescrita da IA, tanto para artigos RSS quanto para rascunhos gerados a partir do onboarding de estúdios.',
			},
		},
	},

	// Content Engine — Fontes RSS
	contentEngineFeeds: {
		title: 'Fontes RSS',
		subtitle: 'Gerencie os feeds RSS que o Motor de Conteúdo lê.',
		newFeed: 'Nova fonte',
		editFeed: 'Editar fonte',
		name: 'Nome',
		url: 'URL do feed',
		category: 'Categoria',
		language: 'Idioma de publicação',
		status: 'Status',
		autoApprove: 'Aprovar automático',
		lastFetched: 'Última leitura',
		articles: 'Artigos',
		actions: 'Ações',
		test: 'Testar',
		sync: 'Sincronizar agora',
		save: 'Salvar',
		cancel: 'Cancelar',
		delete: 'Remover',
		confirmDelete: 'Remover esta fonte?',
		testOk: 'Feed válido ({count} itens): {sample}',
		testFail: 'Falha no teste do feed: {error}',
		syncStarted: 'Sincronização iniciada.',
		empty: 'Nenhuma fonte RSS ainda.',
		active: 'Ativo',
		paused: 'Pausado',
	},

	// Bots register
	bots: {
		title: 'Bots',
		subtitle: 'Cadastre cada bot do Telegram uma única vez. Os canais escolhem um bot aqui em vez de guardar o próprio token.',
		newBot: 'Novo bot',
		editBot: 'Editar bot',
		name: 'Nome',
		username: 'Usuário',
		purpose: 'Finalidade',
		active: 'Ativo',
		channels: 'Canais',
		lastCheck: 'Última verificação',
		never: 'Nunca',
		purposes: {
			broadcast: 'Transmissão',
			alerts: 'Alertas',
			approvals: 'Aprovações',
			gateway: 'Gateway',
		},
		token: 'Token do bot',
		secretToken: 'Token secreto do webhook',
		saved: 'Salvo. Deixe vazio para manter, ou digite um novo para substituir.',
		notSet: 'Não definido.',
		tokenRule: 'Este não é um token de bot do Telegram válido. Ele se parece com 123456789:AAH...',
		secretTokenRule: 'Use apenas letras, números, sublinhado e hífen (até 256 caracteres).',
		authorizedUserIds: 'IDs de usuário do Telegram autorizados',
		authorizedUserIdsHint: 'IDs numéricos de usuários do Telegram autorizados a usar este bot (máx. 20). Digite um ID e tecle Enter.',
		authorizedUserIdsRule: 'Apenas números inteiros, até 20 IDs.',
		checkBot: 'Verificar bot',
		checkOk: 'O bot está acessível: @{username}',
		checkFailed: 'A verificação do bot falhou.',
		revealCredentials: 'Mostrar credenciais',
		hideCredentials: 'Ocultar credenciais',
		revealWarning: 'As credenciais ficam visíveis apenas até você fechar esta janela.',
		revealError: 'Não foi possível carregar as credenciais.',
		copy: 'Copiar',
		copied: 'Copiado.',
		copyError: 'Não foi possível copiar. Selecione o valor e copie manualmente.',
		noSecretToken: 'Nenhum token secreto de webhook salvo.',
		deleted: 'Bot excluído.',
		deleteTitle: 'Excluir bot',
		inUse: 'Este bot ainda é usado por canais. Mova esses canais para outro bot antes de excluí-lo.',
		selectBot: 'Bot',
		selectBotHint: 'Bot do Telegram cadastrado que envia por este canal. Gerencie os bots em Network > Bots.',
		selectBotRequired: 'Selecione um bot.',
		legacyNoBot: 'Este canal ainda usa um token próprio. Selecione um bot cadastrado para salvar.',
		noBots: 'Nenhum bot ativo do Telegram cadastrado ainda. Crie um em Network > Bots.',
	},

	// Webhook Channels
	webhookChannels: {
		bot: 'Bot',
		title: 'Canais de Webhook',
		subtitle: 'Gerencie canais de notificação do Discord, Telegram e WhatsApp e seus gatilhos de automação.',
		newChannel: 'Novo Canal',
		editChannel: 'Editar Canal',
		webhookUrl: 'URL do Webhook',
		chatId: 'ID do Chat',
		threadId: 'Thread ID',
		threadIdHint: 'ID do tópico em supergrupos com fórum (ex: https://t.me/c/GRUPOID/1 → use 1). Deixe vazio para grupos normais.',
		apiUrl: 'URL da API',
		apiKey: 'Chave da API',
		groupId: 'ID do Grupo',
		minSendIntervalSeconds: 'Intervalo mínimo entre envios (segundos)',
		minSendIntervalSecondsHint: 'Espaçamento anti-banimento para grupos de WhatsApp — o canal espera esse tempo depois de cada envio antes do próximo. Padrão de 8s se deixado vazio.',
		jitterSeconds: 'Variação aleatória (segundos)',
		jitterSecondsHint: 'Atraso aleatório extra somado ao intervalo mínimo, pra os envios nunca caírem num ritmo perfeitamente regular. Padrão de 5s se deixado vazio.',
		sendWindowStart: 'Início da janela de envio',
		sendWindowEnd: 'Fim da janela de envio',
		timezone: 'Fuso horário',
		timezoneHint: 'Fuso horário IANA da janela de envio (ex: America/Sao_Paulo, Europe/Berlin). Padrão America/Sao_Paulo se deixado vazio.',
		dedupWindowHours: 'Janela de dedup (horas)',
		dedupWindowHoursHint: 'Não reenvia a mesma oferta pro mesmo grupo dentro desse número de horas (1-168). Padrão de 24 se deixado vazio.',
		joinSlug: 'Slug do link de entrada',
		joinSlugHint: 'Identificador público do "Link Inteligente" deste canal — divulgue https://<api>/api/v1/join/<slug> numa bio de rede social. Deixe vazio pra desativar o link de entrada deste canal.',
		joinPoolMaxMembers: 'Máximo de membros por grupo no pool',
		joinPoolMaxMembersHint: 'Um grupo com esse número de membros ou mais é pulado a favor do próximo, ou um grupo novo é criado. Padrão de 900 se deixado vazio (o limite do próprio WhatsApp é 1024).',
		publicInviteUrl: 'Link público de convite',
		publicInviteUrlHint: 'O link de "entrar neste canal" que o usuário vê (convite de grupo do WhatsApp, convite de servidor Discord, link do Telegram) exibido no Mundo Gamer Deals. Separado das credenciais de webhook/API acima — seguro para compartilhar publicamente.',
		role: 'O que é',
		roleHint: 'O que o site Deals diz que a pessoa vai encontrar: avisos dedicados com o histórico de cada oferta, ou uma conversa. Vazio = o site decide pela plataforma.',
		roleBroadcast: 'Avisos dedicados',
		roleChat: 'Conversa',
		membersCount: 'Membros',
		membersCountHint: 'Telegram, Discord e a lista do WhatsApp Cloud são medidos todo dia, então um número digitado aqui para eles é substituído. Digite para grupos/canais do WhatsApp e Instagram, que não informam número a uma API.',
		membersCountRule: 'Use um número inteiro a partir de 0.',
		membersLastSet: 'Definido em {date}.',
		region: 'Região',
		regionHint: 'Onde mora o público: define o catálogo das ofertas, o fuso e o idioma padrão. Vazio = deduzido dos países abaixo.',
		regions: {
			US: 'Estados Unidos',
			BR: 'Brasil',
			DE: 'Alemanha',
			RO: 'Romênia',
			EU: 'Europa (zona do euro)',
		},
		language: 'Idioma',
		languageHint: 'O idioma das mensagens e da listagem no site Deals. Preencha só quando for diferente do da região (um canal em português para um público alemão).',
		languages: {
			en: 'Inglês',
			'pt-BR': 'Português (Brasil)',
			pt: 'Português (Portugal)',
			es: 'Espanhol',
			de: 'Alemão',
			ro: 'Romeno',
		},
		interestsTitle: 'Pedidos de canal em um idioma que ainda não temos',
		interestsHint: 'Visitantes do site Deals cujo idioma não tem canal podem pedir um. É uma contagem por idioma e país, nada sobre a pessoa é guardado. Os maiores pedidos são os próximos canais a abrir.',
		interestsCountry: 'País',
		interestsRequests: 'Pedidos',
		interestsLast: 'Último pedido',
		interestsUnknownCountry: 'Desconhecido',
		countries: 'Países',
		countriesHint: 'Deixe vazio para receber ofertas de qualquer país. Digite um código ISO (ex: BR, DE) e aperte enter — um canal pode cobrir mais de um.',
		allCountries: 'Todos os países',
		categories: 'Categorias',
		categoriesHint: 'Deixe vazio para receber ofertas de qualquer categoria. Um canal pode cobrir mais de uma.',
		allCategories: 'Todas as categorias',
		active: 'Ativo',
		test: 'Testar Canal',
		testSuccess: 'Mensagem de teste enviada com sucesso.',
		testError: 'Falha ao enviar mensagem de teste. Verifique a configuração do canal.',
		triggers: 'Gatilhos',
		triggersFor: 'Gatilhos de',
		newTrigger: 'Novo Gatilho',
		editTrigger: 'Editar Gatilho',
		event: 'Evento',
		eventKey: 'Evento',
		messageTemplate: 'Template da Mensagem',
		templateHint: 'Use {variavel} como placeholders para valores dinâmicos (ex: {user_name}, {amount}).',
		deleteChannelConfirm: 'Tem certeza que deseja excluir o canal',
		deleteTriggerConfirm: 'Tem certeza que deseja excluir este gatilho?',
		savedSuccess: 'Salvo com sucesso.',
		deletedSuccess: 'Excluído com sucesso.',
		subChannels: 'Sub-canais',
		subChannelsFor: 'Sub-canais de',
		newSubChannel: 'Novo Sub-canal',
		editSubChannel: 'Editar Sub-canal',
		targetId: 'ID do Destino',
		targetIdHint: 'Chat ID, Channel ID ou Group ID para este sub-canal.',
		subChannelNameHint: 'Rótulo amigável, ex: #anúncios',
		deleteSubChannelConfirm: 'Tem certeza que deseja excluir este sub-canal?',
	},
	broadcast: {
		title: 'Broadcast',
		subtitle: 'Envie mensagens manuais para canais do Discord, Telegram e WhatsApp.',
		action: 'Disparar broadcast',
		confirm: 'Enviar esta campanha para os canais e para os usuários elegíveis com alertas?',
		newMessage: 'Nova Mensagem',
		filterStatus: 'Filtrar por status',
		dateFrom: 'De',
		dateTo: 'Até',
		date: 'Data',
		messagePreview: 'Prévia da Mensagem',
		destinations: 'Destinos',
		viewDetail: 'Ver detalhe',
		sectionContent: 'Conteúdo da Mensagem',
		sectionDestinations: 'Destinos',
		sectionPreview: 'Prévia',
		messageText: 'Texto da Mensagem',
		messageTextHint: 'Texto simples a ser enviado. Pelo menos um dos campos texto, imagem ou link é obrigatório.',
		linkUrl: 'URL do Link',
		linkLabel: 'Rótulo do Link (opcional)',
		imageUrl: 'URL da Imagem (opcional)',
		noChannelsAvailable: 'Nenhum canal ativo configurado. Configure em Canais de Webhook.',
		loadingTargets: 'Carregando sub-canais...',
		selectTargets: 'Selecione sub-canais (opcional):',
		previewEmpty: 'Preencha os campos de conteúdo acima para ver uma prévia.',
		destinationsSummary: 'Enviando para',
		sendNow: 'Enviar Agora',
		confirmSendTitle: 'Confirmar Broadcast',
		confirmSendText: 'Enviar esta mensagem agora para:',
		sentSuccess: 'Mensagem enviada com sucesso.',
		detailTitle: 'Detalhe do Broadcast',
		sentAt: 'Enviado Em',
		targetStatuses: 'Status por Destino',
		channelName: 'Canal',
		targetName: 'Sub-canal',
		errorMessage: 'Erro',
		status_queued: 'Na Fila',
		status_sent: 'Enviado',
		status_scheduled: 'Agendado',
		status_failed: 'Falhou',
		status_cancelled: 'Cancelado',
	},

	wallOfLegends: {
		description: 'Gerencie os creators em destaque no Wall of Legends',
		entryType: 'Tipo de Entrada',
		position: 'Posição',
		status: 'Status',
		active: 'Ativo',
		inactive: 'Inativo',
		featuredAt: 'Destaque em',
		influencer: 'Influenciador',
		influencerId: 'ID do Influenciador',
		addEntry: 'Adicionar ao Wall',
		editEntry: 'Editar Entrada',
		deleteConfirm: 'Tem certeza que deseja remover este creator do Wall of Legends?',
		sendPixelNotification: 'Enviar Pixel',
		pixelNotificationDescription: 'Enviar um e-mail de notificação para usuários informando que receberam pixels gratuitos do Wall of Legends. Nenhuma fatura será gerada.',
		recipientEmails: 'E-mails dos Destinatários',
		emailsHint: 'Digite um endereço de e-mail e pressione Enter para adicionar',
		pixelQuantity: 'Quantidade de Pixels',
		sendNotification: 'Enviar Notificação',
		confirmSendTitle: 'Confirmar Envio',
		confirmSendMessage: 'Enviar notificação de pixel para {count} destinatário(s) com {quantity} pixel(s)?',
		notificationsSent: '{count} notificação(ões) enviada(s) com sucesso',
		emailsNotFound: 'Não encontrados: {emails}',
		notificationError: 'Falha ao enviar notificações de pixel',
	},

	// ── Mail Hub ────────────────────────────────────────
	mailHub: {
		studioKeyRequests: {
			list: {
				title: 'Solicitar keys a estúdio',
				subTitle: 'Peça uma key de avaliação a um estúdio para cobertura editorial.',
			},
			upcomingGames: 'Jogos em breve',
			form: {
				gameName: 'Jogo',
				contactSearch: 'Buscar contato, estúdio ou jogo',
				contactName: 'Nome do contato',
				contactEmail: 'Email do contato',
				language: 'Idioma do email',
				mailAccount: 'Enviar de',
				flagCommercial: 'Sinalizar como lead comercial',
				commercialNote: 'Nota para a equipe de vendas',
				send: 'Enviar',
				previewAndSend: 'Ver e enviar',
				previewHint: 'Revise o email abaixo — você pode editar o assunto e o corpo antes de enviar.',
				noContactFound: 'Nenhum contato cadastrado para este jogo — preencha o destinatário manualmente.',
				supplierBadge: 'Fornecedor',
				useContact: 'Usar',
			},
			matchStrength: {
				key_history: 'Contato de uma campanha de key anterior',
				key_supplier: 'Contato de fornecedor de key cadastrado',
				company_only: 'Contato genérico da empresa — sem PR cadastrado, revise antes de enviar',
			},
			messages: {
				sent: 'Pedido de key enviado',
				duplicate: 'Um pedido de key já foi enviado para este contato neste jogo',
				suppressed: 'Este contato optou por não receber emails e não pode ser contatado',
			},
			history: {
				title: 'Histórico de pedidos',
				previewTitle: 'Email enviado',
				previewBody: 'Corpo',
			},
		},
		accounts: {
			title: 'Contas de Email',
			subTitle: 'Gerencie as contas de email conectadas ao Email Hub',
			addAccount: 'Adicionar Conta',
			editAccount: 'Editar Conta',
			brand: 'Marca',
			account: 'Conta',
			emailAddress: 'Endereço de Email',
			displayName: 'Nome de Exibição',
			replyTo: 'Responder Para',
			officialCastingCreator: 'Creator do Casting Oficial',
			officialCastingCreatorHint: 'Vincula essa caixa a um creator específico — deixe em branco para caixas de marca/casa.',
			imapSettings: 'Configurações IMAP',
			imapHost: 'Host IMAP',
			imapPort: 'Porta',
			encryption: 'Criptografia',
			username: 'Usuário',
			password: 'Senha',
			newPassword: 'Nova Senha',
			leaveBlank: 'Deixe em branco para manter a atual',
			aiProfile: 'Perfil de IA Padrão',
			aiSuggestionsOn: 'Sugestões de resposta com IA: ATIVADO',
			aiSuggestionsOff: 'Sugestões de resposta com IA: DESATIVADO',
			aiSuggestionsHint: 'Quando desativado, nenhuma sugestão de resposta será gerada para esta conta (economiza tokens)',
			suggestionProfiles: 'Perfis que recebem sugestões de resposta',
			suggestionProfilesHint: 'Selecione quais perfis de e-mail devem gerar sugestões de resposta com IA. Deixe todos desmarcados para permitir todos os perfis.',
			suggestionProfilesAll: 'Todos os perfis irão gerar sugestões',
			suggestionProfilesSelected: '{count} perfil(s) selecionado(s) — somente estes vão gerar sugestões',
			signature: 'Assinatura',
			signatureHtml: 'Assinatura (HTML)',
			lastSync: 'Última Sincronização',
			messages30d: 'Mensagens (30d)',
			testConnection: 'Testar Conexão',
			testing: 'Testando conexão...',
			connectionSuccess: 'Conexão realizada com sucesso',
			folders: 'Pastas',
			syncNow: 'Sincronizar Agora',
			syncQueued: 'Job de sincronização enfileirado',
			created: 'Conta criada com sucesso',
			updated: 'Conta atualizada com sucesso',
			confirmDelete: 'Tem certeza que deseja excluir a conta {email}?',
			notifications: 'Notificações',
			notificationChannel: 'ID do Canal de Notificação',
			notificationChannelHint: 'ID do canal de webhook (Telegram/Discord) para receber sugestões de IA para revisão',
		},
		inbox: {
			title: 'Caixa de Entrada',
			account: 'Conta',
			from: 'De',
			category: 'Categoria',
			priority: 'Prioridade',
			subject: 'Assunto',
			messages: 'Mensagens',
			lastActivity: 'Última Atividade',
			total: 'Total',
			noSubject: '(Sem Assunto)',
			selected: 'selecionados',
			deleteSelected: 'Excluir Selecionados',
			confirmDelete: 'Tem certeza que deseja excluir esta conversa e todas as suas mensagens?',
			confirmBulkDelete: 'Tem certeza que deseja excluir {count} conversas e todas as suas mensagens?',
		},
		thread: {
			noSubject: '(Sem Assunto)',
			messages: 'mensagens',
			sent: 'Enviado',
			to: 'Para',
			expand: 'Ver mais',
			collapse: 'Ver menos',
			attachments: 'Anexos',
			archive: 'Arquivar',
			unarchive: 'Desarquivar',
			mute: 'Silenciar',
			unmute: 'Reativar',
			toggleAI: 'Alternar Painel IA',
			aiAnalysis: 'Análise de IA',
			category: 'Categoria',
			intent: 'Intenção',
			priority: 'Prioridade',
			confidence: 'Confiança',
			summary: 'Resumo',
			recommendedAction: 'Ação Recomendada',
			noAnalysis: 'Nenhuma análise de IA disponível ainda. Selecione uma mensagem recebida para ver sua análise.',
			analyzing: 'Analisando mensagem...',
			profile: 'Perfil de IA',
			suggestions: 'Sugestões de IA',
			accept: 'Aceitar',
			discard: 'Descartar',
		},
		suggestions: {
			title: 'Sugestões de IA',
			subTitle: 'Revise sugestões de resposta geradas por IA em todas as contas',
			kind: 'Tipo',
			createdAt: 'Criado em',
			refresh: 'Atualizar',
			viewThread: 'Ver Conversa',
		},
		reply: {
			reply: 'Responder',
			compose: 'Compor Resposta',
			body: 'Mensagem',
			send: 'Enviar',
			sent: 'Mensagem enviada com sucesso',
			useAiDraft: 'Usar Rascunho IA',
			saveDraft: 'Salvar Rascunho',
		},
		leads: {
			title: 'Leads',
			contact: 'Contato',
			company: 'Empresa',
			creator: 'Creator',
			convertToCampaign: 'Converter em Campanha',
			convertedSuccess: 'Campanha rascunho criada.',
			convertError: 'Falha ao converter este lead em campanha.',
			subject: 'Assunto',
			hasBudget: 'Tem orçamento',
			companyContext: 'Essa empresa também tem',
			otherContacts: 'Outros contatos',
			otherLeads: 'Outros leads',
			type: 'Tipo',
			stage: 'Etapa',
			health: 'Saúde',
			priority: 'Prioridade',
			language: 'Idioma',
			country: 'País',
			lastUpdate: 'Última Atualização',
			timeline: 'Linha do Tempo',
			interactions: 'interações',
			addNote: 'Adicionar nota...',
			noInteractions: 'Nenhuma interação registrada ainda.',
			enrich: 'Enriquecer com IA',
			enrichQueued: 'Job de enriquecimento enfileirado',
			enrichment: 'Dados de Enriquecimento IA',
			responseTime: 'Tempo Médio de Resposta',
			responseTimeValue: '{hours}h ({count} respostas)',
			openInClickUp: 'Abrir no ClickUp',
			scheduleMeeting: 'Agendar Reunião',
			meetingStartsAt: 'Data e Hora',
			meetingDuration: 'Duração (minutos)',
			meetingTitle: 'Título',
			meetingTitleDefault: 'Reunião com {name}',
			meetingNotes: 'Observações (opcional)',
			meetingScheduled: 'Reunião agendada — {link}',
			meetingScheduledNoLink: 'Reunião agendada',
			generateProposal: 'Gerar Proposta',
			proposalSummary: 'Resumo da Proposta',
			proposalSummaryHint: 'O que está sendo proposto a este lead? (ex.: patrocínio, parceria, serviço)',
			proposalOfferedTerms: 'Termos Oferecidos',
			proposalOfferedTermsHint: 'Valor, condições de pagamento, entregáveis, prazo, direitos de uso, etc.',
			proposalGenerated: 'Rascunho da proposta gerado com sucesso',
			proposalGeneratedHint: 'Isto é apenas um rascunho — ainda não foi enviado nem assinado. Revise antes de compartilhar.',
			proposalPreview: 'Pré-visualização da Proposta',
			proposalDownloadPdf: 'Baixar PDF',
			proposalClose: 'Fechar',
		},
		sent: {
			title: 'Enviados',
			totalSent: 'Total Enviados',
			recipients: 'Destinatários',
			sentAt: 'Enviado em',
			viewDelivery: 'Entrega',
			deliveryEvents: 'Eventos de Entrega',
			noEvents: 'Nenhum evento de entrega registrado.',
		},
		suppression: {
			title: 'Supressão de Email',
			subTitle: 'Suprima ou reative manualmente um endereço de email, ou consulte o status atual.',
			email: 'Endereço de email',
			reason: 'Motivo (opcional)',
			reasonHint: 'ex.: "pedido por telefone", "solicitado via ticket de suporte"',
			check: 'Consultar',
			suppress: 'Suprimir',
			reactivate: 'Reativar',
			statusSuppressed: 'Suprimido',
			statusNotSuppressed: 'Não suprimido',
			suppressedSince: 'Última atualização',
			suppressSuccess: 'Email suprimido.',
			unsuppressSuccess: 'Email reativado.',
			recentlySuppressed: 'Suprimidos recentemente',
			noEmail: 'Digite um endereço de email para consultar o status.',
		},
		channels: {
			title: 'Canais de Notificação',
			subTitle: 'Configure canais de Telegram, Discord ou WhatsApp para receber alertas de email',
			addChannel: 'Adicionar Canal',
			name: 'Nome',
			type: 'Tipo',
			status: 'Status',
			active: 'Ativo',
			inactive: 'Inativo',
			targets: 'Destinos',
			chatId: 'Chat ID',
			webhookUrl: 'Webhook URL',
			testMessage: 'Enviar Teste',
			testSent: 'Mensagem de teste enviada',
			created: 'Canal criado com sucesso',
			updated: 'Canal atualizado com sucesso',
			confirmDelete: 'Tem certeza que deseja excluir este canal?',
			targetName: 'Nome do Destino',
			targetId: 'ID do Destino (Chat ID / Webhook URL)',
			addTarget: 'Adicionar Destino',
			targetCreated: 'Destino adicionado',
			targetDeleted: 'Destino removido',
			noTargets: 'Nenhum destino configurado. O canal usará a configuração padrão.',
			configSection: 'Configuração do Canal',
			targetsSection: 'Destinos de Notificação',
			threadId: 'Thread ID',
			threadIdHint: 'Para grupos com tópicos (fórum). Deixe vazio para grupos normais.',
		},
		templates: {
			title: 'Modelos de Resposta',
			subTitle: 'Configure direcionamentos de resposta da IA por categoria de email. Esses modelos orientam como a IA redige as sugestões de resposta.',
			addTemplate: 'Adicionar Modelo',
			name: 'Nome',
			category: 'Categoria',
			intent: 'Intenção',
			direction: 'Direcionamento de Resposta',
			directionHint: 'Instruções para a IA sobre como responder este tipo de email',
			exampleBody: 'Exemplo de Resposta (opcional)',
			tone: 'Tom',
			language: 'Idioma',
			created: 'Modelo criado com sucesso',
			updated: 'Modelo atualizado com sucesso',
			confirmDelete: 'Tem certeza que deseja excluir este modelo?',
		},
		settings: {
			title: 'Configurações do Email Hub',
			subTitle: 'Gerencie os controles globais do Email Hub',
			aiAnalysisEnabled: 'Análise por IA Ativada',
			aiAnalysisEnabledHint: 'Quando desativado, os emails recebidos são armazenados mas não são enviados para a IA para categorização, resumo ou sugestões de resposta. Isso interrompe todo o consumo de tokens/API da IA e volta para triagem manual. Emails já analisados não são afetados.',
			envOverrideActive: 'A análise por IA está forçadamente desativada pela configuração deste ambiente (MAIL_HUB_AI_DISABLED). Esta opção não terá efeito até que isso seja desativado.',
			confirmDisableTitle: 'Desativar a Análise por IA?',
			confirmDisableMessage: 'Novos emails deixarão de ser categorizados, resumidos ou de receber sugestões de resposta da IA até você reativar isso. Esta é uma automação crítica para o negócio — tem certeza?',
			enabledNotification: 'Análise por IA agora está ATIVADA',
			disabledNotification: 'Análise por IA agora está DESATIVADA',
			loadError: 'Falha ao carregar as configurações do Email Hub',
			saveError: 'Falha ao atualizar a configuração',
		},
	},

	// ── Tickets de Suporte ──────────────────────────────
	supportTickets: {
		list: {
			title: 'Tickets de Suporte',
		},
		filters: {
			platform: 'Plataforma',
			category: 'Categoria',
			status: 'Status',
			priority: 'Prioridade',
			assignedStaff: 'Responsável',
			priorityOnly: 'Somente prioritários',
			dateFrom: 'De',
			dateTo: 'Até',
		},
		columns: {
			id: '#',
			subject: 'Assunto',
			requester: 'Solicitante',
			platform: 'Plataforma',
			category: 'Categoria',
			status: 'Status',
			priority: 'Prioridade',
			assignedStaff: 'Responsável',
			lastActivity: 'Última Atividade',
			createdAt: 'Criado em',
		},
		category: {
			billing: 'Faturamento',
			technical_bug: 'Bug Técnico',
			account_access: 'Acesso à Conta',
			content_moderation: 'Moderação de Conteúdo',
			feature_request: 'Solicitação de Funcionalidade',
			data_issue: 'Dado ou Registro Incorreto',
			other: 'Outro',
		},
		status: {
			open: 'Aberto',
			pending_user: 'Aguardando Usuário',
			pending_staff: 'Aguardando Equipe',
			resolved: 'Resolvido',
			closed: 'Fechado',
			reopened: 'Reaberto',
		},
		priority: {
			low: 'Baixa',
			medium: 'Média',
			high: 'Alta',
			urgent: 'Urgente',
		},
		detail: {
			unassigned: 'Não atribuído',
			assignTo: 'Atribuir a',
			requester: 'Solicitante',
			platform: 'Plataforma',
			category: 'Categoria',
			status: 'Status',
			priority: 'Prioridade',
			markPriority: 'Marcar como prioritário',
			createdAt: 'Criado em',
			lastActivity: 'Última Atividade',
			resolvedAt: 'Resolvido em',
			closedAt: 'Fechado em',
			messages: 'Mensagens',
			noMessages: 'Nenhuma mensagem ainda.',
			internalNote: 'Nota interna',
			internalNoteHint: 'Notas internas são visíveis apenas para a equipe, não para o solicitante.',
			replyPlaceholder: 'Escreva uma resposta...',
			send: 'Enviar',
			close: 'Fechar Ticket',
			reopen: 'Reabrir Ticket',
			confirmClose: 'Tem certeza que deseja fechar este ticket?',
			confirmReopen: 'Reabrir este ticket?',
			attachments: 'Anexos',
			attachmentError: 'Não foi possível abrir o anexo. Tente novamente.',
			assignSuccess: 'Ticket atribuído',
			updateSuccess: 'Ticket atualizado',
			replySuccess: 'Resposta enviada',
			closeSuccess: 'Ticket fechado',
			reopenSuccess: 'Ticket reaberto',
			backToList: 'Voltar para tickets',
			staffReply: 'Equipe',
		},
	},
	contentEngine: {
		dashboard: {
			alerts: 'Alertas de Performance',
			topVideos: 'Vídeos em Destaque',
			videoTitle: 'Título do Vídeo',
			views: 'Visualizações',
			recommendations: 'Recomendações IA',
			pipeline: 'Pipeline de Conteúdo',
			growthProjection: 'Projeção de Crescimento',
			projected30d: 'Inscritos Projetados (30d)',
			daysToGoal: 'Dias para Meta 10K',
			goalTarget: 'Meta: 10.000 inscritos',
			weeklyGrowthNeeded: 'Crescimento Semanal Necessário',
			subsPerWeek: 'inscritos/semana',
		},
		clips: {
			title: 'Fila de Clips',
			analyzeVideo: 'Analisar Vídeo',
			analyzeVideoTitle: 'Analisar Vídeo do YouTube',
			filterStatus: 'Status',
			filterFormat: 'Formato',
			search: 'Buscar clips...',
			videoId: 'ID do Vídeo YouTube',
			videoTitle: 'Título do Vídeo',
			gameName: 'Nome do Jogo',
			developerName: 'Nome do Desenvolvedor',
			episodeNumber: 'Número do Episódio',
			analyze: 'Analisar',
			rejectClip: 'Rejeitar Clip',
			rejectReason: 'Motivo (opcional)',
			videoTitleCol: 'Vídeo',
			selectedTitleCol: 'Título Selecionado',
			formatCol: 'Formato',
			statusCol: 'Status',
			platformsCol: 'Plataformas',
			createdAtCol: 'Criado em',
		},
		clip: {
			emotionalHook: 'Gatilho Emocional',
			timeRange: 'Intervalo de Tempo',
			platforms: 'Plataformas',
			thumbnailBrief: 'Brief da Thumbnail',
			youtubeTags: 'Tags YouTube',
			captions: 'Legendas e Posts',
			communityPost: 'Post Comunidade',
			transcript: 'Transcrição',
		},
		calendar: {
			title: 'Calendário de Conteúdo',
			weeklyCalendar: 'Calendário Semanal',
			generateCalendar: 'Gerar com IA',
			noCalendar: 'Nenhum calendário gerado. Clique em "Gerar com IA" para criar.',
			date: 'Data',
			platform: 'Plataforma',
			type: 'Tipo',
			topic: 'Tópico',
			priority: 'Prioridade',
			effort: 'Esforço',
			statusCol: 'Status',
			weekStart: 'Início da Semana',
			includeEcosystem: 'Incluir conteúdo do ecossistema',
			aiInsights: 'Insights da IA',
			prevWeek: 'Anterior',
			thisWeek: 'Esta Semana',
			nextWeek: 'Próxima',
		},
		titles: {
			variants: 'Variantes de Título',
			generateTitle: 'Gerar Variantes de Título',
			topicLabel: 'Tópico ou descrição do vídeo',
			currentTitleLabel: 'Título atual (referência)',
			targetPlatform: 'Plataforma Alvo',
			generateVariants: 'Gerar Variantes',
			seoAnalysis: 'Análise SEO',
			titleStrength: 'Força do Título',
			suggestedTags: 'Sugestões de Tags',
			noVariantsYet: 'Insira um tópico e gere variantes de título com IA.',
		},
		analytics: {
			title: 'Análises',
			week: 'Semana',
			month: 'Mês',
			ninetyDays: '90 Dias',
			topVideos: 'Vídeos em Destaque',
			videoTitle: 'Título',
			views: 'Visualizações',
			publishedClips: 'Clips Publicados',
			performanceReport: 'Relatório de Performance',
			recommendations: 'Recomendações',
		},
		metrics: {
			subscribers: 'Inscritos',
			totalViews: 'Visualizações Totais',
			avgCTR: 'CTR Médio',
			watchTime: 'Tempo de Exibição',
			pendingClips: 'Clips Pendentes',
			publishedWeek: 'Publicados Esta Semana',
			vsLastWeek: 'vs semana passada',
		},
		pipeline: {
			pending: 'Pendentes',
			approved: 'Aprovados',
			published: 'Publicados',
			rejected: 'Rejeitados',
			total: 'Total Gerado',
		},
		platforms: {
			selectPlatforms: 'Selecionar Plataformas',
		},
		actions: {
			approve: 'Aprovar',
			reject: 'Rejeitar',
			cancel: 'Cancelar',
			filter: 'Filtrar',
			save: 'Salvar',
			generate: 'Gerar',
			publish: 'Publicar',
			schedule: 'Agendar',
			retry: 'Tentar novamente',
			regenerate: 'Regenerar',
			addToCalendar: 'Adicionar ao Calendário',
		},
		rss: {
			feedsTitle: 'Fontes RSS',
			addFeed: 'Adicionar Feed',
			editFeed: 'Editar Feed',
			feedName: 'Nome do Feed',
			feedUrl: 'URL RSS',
			feedCategory: 'Categoria',
			feedLanguage: 'Idioma',
			feedStatus: 'Status',
			lastFetched: 'Última Busca',
			articlesCount: 'Artigos',
			autoApprove: 'Aprovar automaticamente fonte confiável',
			testFeed: 'Testar Feed',
			testSuccess: 'Feed válido e acessível',
			testFailed: 'Não foi possível acessar o feed',
			syncNow: 'Sincronizar',
			syncStarted: 'Sincronização iniciada',
			deleteFeed: 'Excluir Feed',
			deleteConfirm: 'Tem certeza que deseja excluir este feed?',
			queueTitle: 'Fila de Artigos',
			originalTitle: 'Título Original',
			source: 'Fonte',
			relevance: 'Relevância',
			summary: 'Resumo',
			rewrite: 'Reescrever com IA',
			rewriting: 'Reescrevendo...',
			rewriteResult: 'Reescrita IA',
			publishTarget: 'Publicar Em',
			publishBlog: 'Post no Blog',
			publishPulse: 'Pulse na Comunidade',
			publishBoth: 'Ambos (Blog + Pulse)',
			publishAsDraft: 'Publicar como Rascunho',
			publishNow: 'Publicar Agora',
			originalContent: 'Conteúdo Original',
			rewrittenContent: 'Conteúdo Reescrito',
			viewOriginal: 'Ver Artigo Original',
			noArticles: 'Nenhum artigo na fila. Adicione feeds RSS e sincronize.',
			filterStatus: 'Status',
			filterFeed: 'Fonte',
			filterRelevance: 'Relevância Mínima',
			articleDetail: 'Detalhe do Artigo',
		},
		social: {
			postsTitle: 'Posts de Redes Sociais',
			generatePost: 'Gerar Post Social',
			generateFromContent: 'Gerar a partir do Conteúdo',
			platform: 'Plataforma',
			format: 'Formato',
			copyText: 'Legenda',
			hashtags: 'Hashtags',
			charCount: 'Contagem de Caracteres',
			visual: 'Ativo Visual',
			selectTemplate: 'Selecionar Template',
			generateVisual: 'Gerar Visual',
			previewVisual: 'Pré-visualizar',
			schedule: 'Agendar',
			scheduledAt: 'Agendado para',
			publishNow: 'Publicar Agora',
			publishAll: 'Publicar em Todas as Plataformas',
			sourceContent: 'Conteúdo Fonte',
			noPostsYet: 'Nenhum post social ainda. Gere um a partir de qualquer conteúdo.',
			editor: 'Editor de Post',
			platformPreview: 'Pré-visualização por Plataforma',
			platformCaptions: 'Legendas por Plataforma',
			editCaption: 'Editar Legenda',
			publishStatus: 'Status de Publicação',
			publishSuccess: 'Publicado com sucesso',
			publishFailed: 'Falha na publicação',
			retryPlatform: 'Tentar novamente',
			viewPost: 'Ver Post',
			sourceType: 'Tipo de Fonte',
			approveAll: 'Aprovar Todas as Plataformas',
			selectPlatforms: 'Selecionar Plataformas',
		},
		studio: {
			title: 'Creative Studio',
			subtitle: 'Descreva sua ideia de conteúdo e a IA vai gerar legendas + visuais para todas as plataformas.',
			ideaPlaceholder: 'Descreva sua ideia de conteúdo...',
			ideaExample: 'ex: "Post sobre o anúncio da data de lançamento do Hollow Knight Silksong, hypar a comunidade"',
			publishMode: 'Após Geração',
			generateAll: 'Gerar Conteúdo',
			visualPreview: 'Pré-visualização Visual',
			newIdea: 'Nova Ideia',
			regenerateCaptions: 'Regenerar Legendas',
			sendToApproval: 'Enviar para Aprovação no Telegram',
			publishNow: 'Publicar em Todas as Plataformas Agora',
			recentCreations: 'Criações Recentes',
		},
		conversionLogs: {
			title: 'Logs de Conversão (Meta CAPI)',
			subtitle: 'Acompanhe todos os eventos de conversão server-side enviados ao Meta, com status e reenvio.',
			event: 'Evento',
			user: 'Usuário',
			country: 'País',
			platform: 'Plataforma',
			value: 'Valor',
			source: 'Origem',
			page: 'Página',
			guest: 'Visitante',
			sent: 'Enviado',
			failed: 'Falhou',
			pending: 'Pendente',
			failedPending: 'Falhou / Pendente',
			retryAllFailed: 'Reenviar Todos com Falha',
			exportCsv: 'Exportar CSV',
			retry: 'Reenviar',
			viewDetails: 'Ver Detalhes',
			error: 'Erro',
		},
		ecosystem: {
			title: 'Conteúdo do Ecossistema',
			contentType: 'Tipo de Conteúdo',
			author: 'Autor',
			publishedAt: 'Publicado em',
			generateSocial: 'Gerar Post Social',
			addToCalendar: 'Adicionar ao Calendário',
			crossPromo: 'Sugestões de Promoção Cruzada',
			suggestCrossPromo: 'Sugerir Promoções Cruzadas',
			noContent: 'Nenhum conteúdo do ecossistema disponível.',
			pulse: 'Pulse',
			review: 'Review',
			video: 'Vídeo',
			vacancy: 'Vaga',
			course: 'Curso',
			influencer: 'Post de Influenciador',
		},
	},
	feedConfig: {
		title: 'Config. do Feed',
		subtitle: 'Configure os parâmetros do algoritmo do feed da Comunidade em tempo real.',
		sectionScoreWeights: 'Pesos de Pontuação',
		sectionTimeDecay: 'Decaimento Temporal',
		sectionCandidateWindow: 'Janela de Candidatos',
		sectionCampaignSlots: 'Slots de Campanha',
		sectionMultipliers: 'Multiplicadores',
		wLikes: 'Curtidas',
		wComments: 'Comentários',
		wShares: 'Compartilhamentos',
		wSaves: 'Salvamentos',
		wProfileClicks: 'Cliques no Perfil',
		decayK: 'Fator de Decaimento (k)',
		candidateWindowHours: 'Janela de Candidatos (horas)',
		campaignSlotFrequency: 'Frequência de Slot de Campanha (posts orgânicos entre anúncios)',
		multiplierPro: 'Multiplicador Pro',
		multiplierBusiness: 'Multiplicador Business',
		multiplierFollowing: 'Multiplicador Seguindo',
		multiplierVerified: 'Multiplicador Verificado',
		save: 'Salvar',
		restoreDefaults: 'Restaurar Padrões',
		restoreConfirmTitle: 'Restaurar Padrões',
		restoreConfirmText: 'Isso irá redefinir todos os valores de configuração do feed para os padrões. Esta ação não pode ser desfeita. Continuar?',
		updatedBy: 'Atualizado por',
		updatedAt: 'Atualizado em',
		saveSuccess: 'Configuração do feed salva com sucesso.',
		saveError: 'Falha ao salvar a configuração do feed.',
		restoreSuccess: 'Configuração do feed restaurada para os padrões.',
		restoreError: 'Falha ao restaurar a configuração do feed.',
		loadError: 'Falha ao carregar a configuração do feed.',
		decayCurveTitle: 'Prévia da Curva de Decaimento',
		decayCurveScore: 'Pontuação',
	},

	feedPromotion: {
		title: 'Promoções no Feed',
		subtitle: 'Promova qualquer URL como card no feed da comunidade durante uma janela de tempo definida.',
		create: 'Nova Promoção',
		createTitle: 'Criar Promoção no Feed',
		createSubmit: 'Criar',
		createSuccess: 'Promoção criada. Os metadados serão buscados em segundo plano.',
		createError: 'Falha ao criar a promoção.',
		deleteTitle: 'Remover Promoção',
		deleteConfirm: 'Tem certeza que deseja remover esta promoção do feed?',
		deleteSuccess: 'Promoção removida.',
		deleteError: 'Falha ao remover a promoção.',
		loadError: 'Falha ao carregar as promoções.',
		fieldUrl: 'URL',
		fieldUrlHint: 'A URL a ser promovida. Os metadados OpenGraph (título, imagem, descrição) serão buscados automaticamente.',
		fieldStartAt: 'Data de início',
		fieldEndAt: 'Data de término',
		invalidUrl: 'Insira uma URL válida começando com http:// ou https://',
		colUrl: 'URL',
		colType: 'Tipo',
		colActive: 'Ativo',
		colStartAt: 'Início',
		colEndAt: 'Término',
		editorial: 'Editorial',
		sponsored: 'Patrocinado',
		job_hiring: 'Vagas Jobs',
		quiz: 'Quiz',
		tv_live: 'TV Live',
		community: 'Comunidade',
	},

	levelUpJobsMenuTitle: 'Level Up Jobs',
	levelUpJobsCareerQuestionsTitle: 'Perguntas de Carreira',
	levelUpJobsCareerQuestionsNew: 'Nova Pergunta',
	levelUpJobsCareerQuestionsEdit: 'Editar Pergunta',
	levelUpJobsCareerQuestionsLabel: 'Pergunta',
	levelUpJobsCareerQuestionsType: 'Tipo',
	levelUpJobsCareerQuestionsCategory: 'Categoria',
	levelUpJobsCareerQuestionsOptions: 'Opções',
	levelUpJobsCareerQuestionsOptionsHint: 'Digite e pressione Enter para adicionar opções',
	levelUpJobsCareerQuestionsDeleteTitle: 'Excluir Pergunta',
	levelUpJobsCareerQuestionsDeleteText: 'Esta pergunta será removida permanentemente.',
	levelUpJobsCareerQuestionsCatExperience: 'Experiência',
	levelUpJobsCareerQuestionsCatAvailability: 'Disponibilidade',
	levelUpJobsCareerQuestionsCatTechnical: 'Técnico',
	levelUpJobsCareerQuestionsCatBehavioral: 'Comportamental',

	permissions: 'Permissões',
	selectAll: 'Selecionar Todos',

	userTabs: {
		profile: 'Perfil',
		subscriptions: 'Assinaturas',
		productsCredits: 'Produtos & Créditos',
		gamification: 'Gamificação',
		history: 'Histórico',
		affiliate: 'Afiliado',
	},

	nickname: 'Apelido',

	userGamification: {
		mgcBalance: 'Saldo MGC',
		totalXp: 'XP Total',
		completedMissions: 'Missões Concluídas',
		achievements: 'Conquistas',
		walletTransactions: 'Transações da Carteira',
	},

	gamificationFilters: {
		earn: 'Ganho',
		spend: 'Gasto',
		transferIn: 'Transferência Entrada',
		transferOut: 'Transferência Saída',
		refund: 'Reembolso',
		adjustment: 'Ajuste',
		achievement: 'Conquista',
		mission: 'Missão',
		levelUp: 'Subiu de Nível',
		transfer: 'Transferência',
		purchase: 'Compra',
		admin: 'Admin',
		dailyBonus: 'Bônus Diário',
		rewardRedemption: 'Resgate de Recompensa',
		tvWatch: 'Assistir TV',
		tvChat: 'Chat TV',
		referral: 'Indicação',
	},

	userHistory: {
		transactionHistory: 'Histórico de Transações',
		emailHistory: 'Histórico de E-mails',
		creditUsageHistory: 'Histórico de Uso de Créditos',
		source: 'Origem',
		subject: 'Assunto',
		sentAt: 'Enviado em',
		searchBySubject: 'Buscar por assunto ou e-mail',
		lifetimeEarned: 'Total Ganho',
		lifetimeSpent: 'Total Gasto',
		balanceAfter: 'Saldo Após',
		item: 'Item',
		system: 'Sistema',
		emailPreview: 'Visualização do E-mail',
		noPreviewAvailable: 'Nenhuma visualização disponível',
	},

	userAffiliate: {
		linkedCoupons: 'Cupons Vinculados',
		commissions: 'Comissões',
		commission: 'Comissão %',
		couponCode: 'Código do Cupom',
		availableBalance: 'Saldo Disponível',
		paymentRequests: 'Solicitações de Pagamento',
		paymentMethods: 'Métodos de Pagamento',
		paymentDate: 'Data de Pagamento',
		validUntil: 'Válido Até',
		noPaymentMethods: 'Nenhum método de pagamento cadastrado.',
		documents: 'Documentos',
		documentsAccepted: 'Documentos Aceitos',
		documentsPending: 'Documentos Pendentes de Revisão',
		gracePeriod: 'Em Carência',
		usageCount: 'Usos',
	},

	observatory: {
		organizations: {
			fromRequest:
				'Criando a partir do pedido de acesso de {name}. Pediram: {territory}. Informe o primeiro país abaixo para a organização enxergar algo; o pedido é marcado como convertido ao criar.',
			requestNotLinked: 'Organização criada, mas não foi possível ligar o pedido de acesso a ela. Atualize o pedido manualmente.',
			title: 'Organizações do Observatório',
			loadError: 'Não foi possível carregar a lista de organizações. O serviço do Observatório não respondeu como esperado.',
			retry: 'Tentar de novo',
			pickCountry: 'Escolha pelo menos um país.',
			grantedMany: '{count} países concedidos.',
			countriesError: 'Não foi possível carregar a lista de países ou estados.',
			subTitle: 'Quem tem acesso ao Observatório, e a que jurisdição cada um alcança.',
			failClosedNotice:
				'Sem jurisdição concedida, a organização não enxerga registro nenhum. Ausência de concessão não é "sem restrição": é o oposto.',
			new: 'Nova organização',
			grant: 'Conceder jurisdição',
			grantHelp:
				'País alcança qualquer estado dele. País com estado exige aquele estado. Município exige o estado junto, e não dá acesso a estatística — a célula mais fina publicada é o estado, que é mais larga que o município.',
			revoke: 'Revogar',
			confirmRevoke: 'Revogar o acesso a {area}? O que já foi lido continua no histórico de acesso.',
			issueKey: 'Emitir chave de API',
			keyTitle: 'Chave de API',
			keyOnce: 'Ela aparece uma vez e não fica guardada. Copie agora.',
			reachEverything: 'Alcança tudo (operador da rede)',
			reachNothing: 'Não alcança nada',
			noOwner: 'Sem dono',
			operatorWarning: 'Operador alcança TODO o registro, sem trava de jurisdição. Só para a equipe da rede.',
			genericError: 'Não foi possível concluir. Tente de novo.',
			kinds: {
				government: 'Órgão público',
				association: 'Associação',
				vendor: 'Fornecedor',
				operator: 'Operador da rede',
			},
			tiers: { open: 'Aberta', association: 'Associação', institutional: 'Institucional' },
			fields: {
				name: 'Nome',
				kind: 'Tipo',
				tier: 'Camada',
				reach: 'Alcance',
				owners: 'Dono',
				ownerEmail: 'E-mail da pessoa dona',
				countries: 'Países',
				countriesHint: 'Países que esta organização pode ver. Busque pelo nome. Dá para acrescentar mais depois.',
				countriesOperatorHint: 'O operador da rede alcança todos os países; não há o que escolher.',
				state: 'Estado (opcional)',
				stateHint: 'Restringe a concessão a este estado do país.',
				ownerEmailHint: 'Precisa ter conta no ecossistema. É quem vai administrar a equipe dessa organização.',
				firstCountry: 'Primeira jurisdição (id do país)',
				firstCountryHint: 'Em branco, a organização nasce sem enxergar nada.',
				countryId: 'País (id)',
				stateId: 'Estado (id, opcional)',
				cityId: 'Município (id, opcional)',
				cityIdHint: 'Exige o estado preenchido.',
				namedEntities: 'Pode ver o diretório com nomes',
				mayExport: 'Pode exportar',
				issueKey: 'Emitir chave de API agora',
			},
		},
		accessRequests: {
			title: 'Pedidos de acesso',
			subTitle:
				'Quem pediu acesso ao Observatório na página pública. Conceder acesso é feito em Organizações; aqui fica a fila de com quem conversar.',
			searchLabel: 'Buscar por nome, e-mail ou organização',
			all: 'Todos',
			noResults: 'Nenhum pedido de acesso aqui.',
			details: 'Detalhes do pedido',
			reply: 'Responder por e-mail',
			deleteConfirm: 'Excluir o pedido de {name}? Os dados pessoais são apagados e isso não pode ser desfeito.',
			deleted: 'Pedido excluído.',
			saved: 'Pedido atualizado.',
			genericError: 'Algo deu errado. Tente novamente.',
			consentedAt: 'Aceitou o aviso em',
			handledBy: 'Tratado por',
			notesHelp: 'Interno. Quem pediu nunca vê isto.',
			createOrganization: 'Criar organização',
			convertedTo: 'Convertido na organização:',
			noAccount:
				'Nenhuma conta da Mundo Gamer Network usa este e-mail ainda. A organização precisa de um dono com conta, então peça para quem solicitou se cadastrar primeiro.',
			fields: {
				createdAt: 'Recebido',
				name: 'Nome',
				email: 'E-mail',
				organization: 'Organização',
				role: 'Cargo',
				territory: 'Território',
				message: 'Mensagem',
				status: 'Status',
				notes: 'Anotações internas',
				locale: 'Idioma da página',
			},
			statuses: {
				new: 'Novo',
				contacted: 'Contatado',
				converted: 'Convertido',
				dismissed: 'Descartado',
			},
		},
		// Funil comercial: fila de pedidos de acesso, termos e uso da organização.
		commercial: {
			stages: {
				new: 'Novo',
				contacted: 'Contatado',
				qualified: 'Qualificado',
				won: 'Ganho',
				lost: 'Perdido',
				discarded: 'Descartado',
			},
			intents: {
				market_intelligence: 'Inteligência de mercado',
				talent_benchmark: 'Benchmark de talentos',
				research: 'Pesquisa',
				institutional_report: 'Relatório institucional',
				advertising: 'Publicidade',
				other: 'Outra',
				unspecified: 'Não informada',
			},
			organizationKinds: {
				studio: 'Estúdio',
				publisher: 'Publisher',
				service_provider: 'Prestador de serviços',
				association: 'Associação',
				government: 'Governo',
				education: 'Educação',
				investor: 'Investidor',
				media: 'Mídia',
				other: 'Outro',
			},
			sizeBands: {
				solo: 'Individual',
				'2_10': '2 a 10 pessoas',
				'11_50': '11 a 50 pessoas',
				'51_200': '51 a 200 pessoas',
				'201_1000': '201 a 1.000 pessoas',
				'1000_plus': 'Mais de 1.000 pessoas',
			},
			accessKinds: {
				query: 'Consulta de dados',
				curation: 'Curadoria',
				survey: 'Pesquisa',
				application: 'Candidatura',
				operations: 'Operação da rede',
			},
			fields: {
				stage: 'Estágio',
				owner: 'Responsável',
				kind: 'Tipo de organização',
				size: 'Porte',
				country: 'País',
				intent: 'Intenção',
				utm: 'Origem (UTM)',
				stageChangedAt: 'Última movimentação',
				firstResponseAt: 'Primeira resposta em',
			},
			contract: {
				active: 'Vigente',
				expiring: 'Vence em breve',
				expiringIn: 'Vence em {days} d',
				expired: 'Vencido',
				none: 'Sem contrato',
			},
			queue: {
				summaryTitle: 'Resumo da fila',
				last_30_days: 'Últimos 30 dias',
				last_90_days: 'Últimos 90 dias',
				awaitingResponse: 'Aguardando resposta',
				awaitingHint: 'Pedidos ainda em "Novo", de qualquer data.',
				medianResponse: 'Tempo mediano de resposta',
				medianHint: 'Da chegada ao primeiro contato, em {count} pedidos respondidos.',
				noResponseYet: 'Nenhum pedido respondido nesta janela.',
				receivedInWindow: 'Recebidos',
				openHint: '{open} ainda em aberto',
				windowEmpty: 'Nenhum pedido recebido nesta janela.',
				byStage: 'Por estágio (o de hoje)',
				byIntent: 'Por intenção',
				minutes: '{n} min',
				hours: '{n} h',
				days: '{n} dias',
				summaryError: 'Não foi possível carregar o resumo da fila.',
				noResultsFiltered: 'Nenhum pedido com estes filtros.',
				clearFilters: 'Limpar filtros',
				noOwner: 'Sem responsável',
				ownerHint: 'Só administradores da rede podem ser responsáveis.',
				allowedHint: 'A partir daqui dá para ir para: {stages}.',
				noTransition: 'Não há estágio para onde mover a partir daqui.',
				allowedNow: 'Estágios possíveis agora:',
				discard: 'Descartar',
			},
			usage: {
				title: 'Uso de {name}',
				window: 'Últimos {days} dias. Só contagens: o que foi consultado e por quem não aparece aqui.',
				queries: 'Consultas',
				rows: 'Linhas',
				cells: 'Células',
				kind: 'Tipo',
				noActivity: 'Nenhuma consulta nesta janela.',
				budgetTitle: 'Orçamento de células do mês',
				budgetUsed: '{used} de {budget} células neste mês civil ({percent}%)',
				noBudget: 'Sem orçamento mensal definido: nada bloqueia por consumo. {used} células lidas neste mês civil.',
				budgetExceeded: 'O orçamento de células do mês acabou: as consultas novas são recusadas até o mês virar ou o orçamento subir.',
				lastActivity: 'Última atividade',
				never: 'Nenhuma atividade registrada',
				apiKeys: 'Chaves de API',
				apiKeysValue: '{active} ativas de {total}',
				seats: 'Assentos',
				seatsValue: '{used} em uso de {limit} contratados',
				seatsNoLimit: '{used} em uso (sem limite registrado)',
				overLimit: 'Acima do contratado',
				contract: 'Contrato',
				noAccess: 'O contrato não está vigente: o acesso desta organização está sendo recusado (contrato inativo).',
				extractionSuspect: 'Padrão de extração suspeito: {count} recortes distintos na janela.',
				loadError: 'Não foi possível carregar o uso desta organização.',
			},
			org: {
				edit: 'Editar',
				usage: 'Uso',
				editTitle: 'Editar {name}',
				empty: 'Nenhuma organização cadastrada.',
				limitsTitle: 'Limites e contrato',
				limitsHelp: 'O que o produto aplica: tetos de consulta e a janela em que o acesso vale. Contrato vencido recusa o acesso.',
				commercialTitle: 'Termos comerciais',
				commercialHelp: 'O que foi vendido. É só registro: nada no produto cobra por estes campos, e a organização nunca os vê.',
				statuses: { active: 'Ativa', suspended: 'Suspensa' },
				fields: {
					maxRows: 'Máximo de linhas por consulta',
					maxRowsHint: 'De 1 a 10.000. Em branco mantém o valor atual.',
					cellBudget: 'Orçamento mensal de células',
					cellBudgetHint: 'Em branco, nada bloqueia por consumo.',
					contractStart: 'Início do contrato',
					contractEnd: 'Fim do contrato',
					contractEndHint: 'O acesso termina à 00:00 do dia informado (o dia em si não conta).',
					contract: 'Contrato',
					planKey: 'Plano',
					planKeyHint: 'Identificador em minúsculas, como studio_intel. O catálogo de planos ainda não está fechado.',
					seats: 'Assentos',
					seatsHint: 'Quantas pessoas foram contratadas.',
					seatsHintUsed: '{used} pessoas na organização hoje. Nada recusa quem passar do limite.',
					price: 'Preço',
					priceHint: 'Até 2 casas decimais. Exemplo: 1500,50.',
					currency: 'Moeda',
					currencyHint: 'Três letras, como USD ou BRL.',
					notes: 'Anotações comerciais',
					notesHint: 'Interno. A organização nunca vê isto.',
					status: 'Situação',
					statusHint: 'Suspensa, a organização perde o acesso mesmo com contrato vigente.',
				},
			},
			validation: {
				name: 'O nome precisa ter de 2 a 200 caracteres.',
				planKey: 'Use letras minúsculas, números, hífen ou sublinhado, até 40 caracteres.',
				priceFormat: 'Use só números, com até 2 casas decimais.',
				currencyFormat: 'A moeda tem três letras, como USD ou BRL.',
				priceNeedsCurrency: 'Um preço precisa de moeda.',
				seats: 'Assentos: um número inteiro de 1 a 100.000.',
				maxRows: 'Linhas por consulta: um número inteiro de 1 a 10.000.',
				cellBudget: 'Orçamento: um número inteiro maior que zero.',
				notes: 'No máximo 5.000 caracteres.',
				contractDates: 'O contrato não pode terminar antes de começar.',
				contractEndFuture: 'Ao criar, o fim do contrato precisa ser depois de hoje.',
			},
		},
		// Diretório de profissionais (quem aceitou aparecer no Observatório): a fila de apresentações que a MGN intermedeia,
		// e o interruptor de acesso e a cota mensal de revelações de cada organização.
		professionalIntroductions: {
			title: 'Apresentações (profissionais)',
			refresh: 'Atualizar',
			subTitle:
				'Organizações que revelaram um profissional no diretório de quem aceitou aparecer e pediram que a MGN as apresente. A MGN faz a ponte: a organização nunca recebe o contato da pessoa.',
			readOnlyNotice:
				'Fila somente leitura, das mais novas para as mais antigas. A pessoa aparece aqui pelo nome porque a MGN precisa apresentá-la; nenhum dado de contato é mostrado nem enviado por esta tela. O serviço não registra se a apresentação foi feita, então todo pedido continua listado até o fim do prazo de retenção do registro. Abrir esta página fica registrado no log de acesso do Observatório.',
			withdrawnWarning:
				'Uma pessoa desta página retirou o consentimento depois do pedido. Não faça a apresentação. | {count} pessoas desta página retiraram o consentimento depois do pedido. Não façam a apresentação.',
			fields: {
				requestedAt: 'Pedido em',
				organization: 'Organização',
				person: 'Pessoa',
				consent: 'Consentimento',
			},
			consentActive: 'Consentimento vigente',
			consentWithdrawn: 'Consentimento retirado',
			doNotApproach: 'Não procurar esta pessoa',
			accountRef: 'Referência da conta',
			copyRef: 'Copiar referência da conta',
			copied: 'Referência da conta copiada.',
			copyFailed: 'Não foi possível copiar. Selecione a referência na tela e copie à mão.',
			noName: 'Conta sem nome',
			empty: 'Nenhuma apresentação foi pedida ainda.',
			emptyHint: 'Quando uma organização revelar um profissional e pedir para ser apresentada, o pedido aparece aqui.',
			problems: {
				off: {
					title: 'O diretório de profissionais está desligado',
					body: 'O serviço do Observatório respondeu que o diretório não está disponível neste ambiente, então ninguém pode pedir apresentação e não há fila para mostrar. Isso vem da configuração do serviço (OBS_PROFESSIONAL_DIRECTORY), não de uma falha desta tela.',
				},
				forbidden: {
					title: 'Só administradores da rede podem abrir esta fila',
					body: 'A fila mostra pessoas pelo nome, então o Observatório confere o papel admin_master da Mundo Gamer Network antes de responder. Você está logado, mas a sua conta não tem esse papel.',
				},
				unauthenticated: {
					title: 'O Observatório não reconhece a sua sessão',
					body: 'Entre de novo e recarregue esta página.',
				},
				migration: {
					title: 'A atualização do banco do diretório está pendente',
					body: 'O diretório está ligado, mas as tabelas dele ainda não existem no banco. Peça à equipe da plataforma para aplicar as migrations pendentes do api-main (2026_10_11_1300xx) e atualize.',
				},
				route: {
					title: 'O Observatório não conhece esta fila',
					body: 'O serviço respondeu "não encontrado" sem dizer que o diretório está desligado. A versão que está no ar provavelmente é mais antiga que esta tela, ou este admin aponta para o host errado (VUE_APP_API_OBSERVATORY_URL).',
				},
				network: {
					title: 'Não foi possível falar com o serviço do Observatório',
					body: 'Ou o serviço está fora do ar, ou este admin aponta para o host errado, ou o que voltou não é a API do Observatório. A mensagem abaixo diz qual, quando o navegador sabe.',
				},
				generic: {
					title: 'Não foi possível carregar a fila',
					body: 'O serviço do Observatório respondeu com um erro.',
				},
			},
		},
		directory: {
			title: 'Diretório de profissionais',
			help: 'Pessoas que aceitaram aparecer no Observatório. A lista mostra cartões sem nome; o nome só sai quando a organização revela uma pessoa, e isso gasta a cota mensal.',
			access: 'Pode ver o diretório de profissionais',
			accessHint:
				'Sem este interruptor a organização não vê o diretório, qualquer que seja o contrato. Ela também precisa ser fornecedora ou associação com contrato vigente, e o diretório precisa estar ligado no serviço.',
			operatorNote: 'O operador da rede sempre tem acesso ao diretório.',
			operatorNoQuota: 'O operador da rede não tem cota.',
			quota: 'Cota mensal de revelações do diretório de profissionais',
			quotaDefault: 'Padrão do serviço',
			quotaHint:
				'Quantas pessoas diferentes a organização pode revelar pelo nome em cada mês civil (UTC). Rever a mesma pessoa não gasta. Em branco vale o padrão do serviço (20, salvo se a configuração do serviço mudar isso). 0 fecha as revelações: a lista continua abrindo, mas nenhum nome sai.',
			quotaNoAccess: 'Esta organização ainda não tem acesso ao diretório; a cota só tem efeito depois que o interruptor acima for ligado.',
			quotaMigrationPending:
				'A cota não foi salva, e nada mais deste formulário foi: o banco do Observatório ainda não tem a coluna da cota. Peça à equipe da plataforma para aplicar as migrations pendentes do api-main (2026_10_11_1300xx) e salve de novo.',
			// Uma linha sob a jurisdição na tabela de organizações, só para quem tem acesso.
			listDefaultQuota: 'Profissionais: cota padrão',
			listClosed: 'Profissionais: revelações fechadas',
			listPerMonth: 'Profissionais: {count} por mês',
			validation: {
				revealQuota: 'Um número inteiro de 0 a 1000, ou em branco para o padrão.',
			},
		},
		// Pacote comercial (Local, Regional, Nacional, Sob medida) e acesso por vertical de indicadores: a seção do formulário da organização,
		// a coluna da tabela de organizações e o texto de cada falha ao salvar.
		package: {
			column: 'Pacote',
			title: 'Pacote e verticais',
			help:
				'O pacote é uma escada de escala: Local, Regional, Nacional e Sob medida. Cada degrau define os limites e as verticais de indicadores que o contrato lê. Escolher um degrau preenche os campos; tudo continua editável.',
			notEnforced: 'O acesso por vertical está desligado neste ambiente: as verticais são registradas, mas ainda não são aplicadas.',
			unsupported:
				'Esta versão do serviço do Observatório ainda não oferece pacotes nem verticais, então esta seção não tem nada a salvar.',
			operatorNote: 'O operador da rede lê todas as verticais. Não há o que escolher.',
			pendingTitle: 'Atualização do banco pendente',
			pendingCreate:
				'O pacote e as verticais não podem ser definidos até que a equipe da plataforma aplique a migration pendente do api-main. Nada é enviado para eles a partir deste formulário.',
			pendingEdit:
				'O pacote e as verticais desta organização não podem ser lidos nem alterados até que a equipe da plataforma aplique a migration pendente do api-main. Os demais campos deste formulário continuam sendo salvos.',
			fields: {
				package: 'Pacote',
			},
			none: 'Sem pacote',
			names: {
				local: 'Local',
				regional: 'Regional',
				national: 'Nacional',
				custom: 'Sob medida',
			},
			hint: {
				noneEdit: 'Esta organização não tem degrau de pacote. As verticais abaixo são salvas como estão marcadas.',
				noneEnforced: 'Escolha um degrau ou marque verticais abaixo. Organização sem nenhum dos dois é recusada.',
				noneOpen: 'Sem degrau e sem nada marcado, a organização recebe todas as verticais.',
				custom: 'Sob medida: só o que você definir abaixo é salvo. Limites e verticais partem do que o formulário mostra agora.',
				summary:
					'{cells} células por mês · {rows} linhas por consulta · {seats} assentos · {verticals} verticais · {exporting} · {names}',
				exportYes: 'exporta',
				exportNo: 'sem exportação',
				namesYes: 'mostra nomes de empresas',
				namesNo: 'sem nomes de empresas',
			},
			validation: {
				choose: 'Escolha um degrau do pacote ou marque ao menos uma vertical. O serviço recusa organização sem nenhum dos dois.',
			},
			planKeyLocked: 'Definido pelo degrau do pacote.',
			drift: {
				title: 'Difere do pacote {name}',
				limits: 'Limites alterados: {list}.',
				added: 'Verticais acrescentadas: {list}.',
				removed: 'Verticais retiradas: {list}.',
				note: 'O degrau continua {name}, e o que é salvo é o que o formulário mostra, não o que o degrau define.',
				restore: 'Restaurar valores de {name}',
			},
			limits: {
				monthly_cell_budget: 'Orçamento mensal de células',
				max_rows_per_request: 'Máximo de linhas por consulta',
				seats: 'Assentos',
				may_export: 'Exportar',
				may_view_named_entities: 'Nomes das empresas',
			},
			verticalsTitle: 'Verticais incluídas',
			counter: '{count} de {total} marcadas',
			selectAll: 'Marcar todas',
			selectNone: 'Desmarcar todas',
			extras: 'Fora de qualquer degrau (extras): {list}. Marque-as só para um contrato que as venda à parte.',
			empty: {
				readsNothing: 'Nenhuma vertical marcada: com o acesso por vertical ligado, esta organização não lê nenhum indicador.',
				recordedOnly:
					'Nenhuma vertical marcada. O acesso por vertical está desligado, então isto é registrado, mas ainda não muda nada.',
				getsAll: 'Nada marcado: a organização recebe todas as verticais.',
			},
			verticals: {
				companies: 'Empresas e estúdios',
				games: 'Games',
				work: 'Trabalho',
				pay: 'Salários e folha',
				skills: 'Habilidades e formação',
				players: 'Jogadores',
				streaming: 'Streaming',
				creators: 'Criadores',
				esports: 'E-sports',
				events: 'Eventos',
				funding: 'Editais e fomento',
				investment: 'Investimento e freelance',
				activity: 'Atividade da rede',
				research: 'Pesquisa própria',
				professionals: 'Profissionais por nome',
				leads: 'Leads',
			},
			list: {
				operator: 'Todas as verticais',
				noPackage: 'Sem pacote',
				pending: 'atualização pendente',
			},
			errors: {
				migration:
					'Nada foi salvo: o banco do Observatório ainda não tem a tabela do acesso por vertical. Peça à equipe da plataforma para aplicar a migration pendente do api-main (2026_10_12_100000) e salve de novo.',
				network: 'O serviço do Observatório não respondeu, então nada foi salvo. Verifique a conexão e tente de novo.',
				networkDetail: 'O serviço do Observatório não respondeu, então nada foi salvo. {detail}',
			},
		},
		// Ambiente de demonstração: os botões que preparam a demonstração do Observatório (três organizações fictícias com dados
		// inventados) e o acompanhamento do pedido, que um agendador roda em segundo plano.
		demo: {
			title: 'Ambiente de demonstração',
			refresh: 'Atualizar',
			subTitle:
				'Prepara a demonstração do Observatório: três organizações fictícias com dados inventados, uma para cada degrau do pacote (Nacional, Regional e Local), para a equipe apresentar o portal. Só funciona num ambiente com banco próprio e o modo demonstração ligado.',
			requestSent: 'Pedido enviado. O agendador o pega em cerca de um minuto.',
			details: 'Detalhes',
			personas: {
				association: 'Nacional',
				agency: 'Regional',
				city: 'Local',
				operator: 'Equipe MGN',
			},
			state: {
				environment: 'Ambiente',
				environmentOn: 'Modo demonstração ligado',
				prepared: 'Demonstração',
				preparedYes: 'Preparada',
				preparedYesHint: 'As três organizações de demonstração existem.',
				preparedNo: 'Não preparada',
				preparedNoHint: 'As organizações de demonstração ainda não existem. Use "Preparar a demonstração".',
				database: 'Banco de dados',
				lockedYes: 'Travado: tem cliente real',
				lockedNo: 'Livre: sem cliente real',
				lockedTitle: 'Este banco tem um cliente real',
				lockedBody:
					'A demonstração não pode ser preparada nem reiniciada aqui, porque dado inventado nunca pode dividir banco com cliente real. Os dois botões estão desabilitados.',
				viewingAs: 'Você está vendo como',
				viewingNone: 'Nenhum perfil de demonstração',
				profiles: 'Perfis',
				profileReady: 'pronto',
				profileMissing: 'não criado',
			},
			buttons: {
				prepare: 'Preparar a demonstração',
				prepareHint: 'Cria o que falta e atualiza o resto. Pode ser repetido sem risco.',
				reset: 'Reiniciar do zero',
				resetHint: 'Apaga só o que a demonstração criou e refaz tudo, renovando os contratos.',
			},
			disabled: {
				locked: 'Os dois botões estão desabilitados: o banco tem um cliente real.',
				queued: 'Os dois botões ficam desabilitados enquanto há um pedido na fila. Voltam quando ele terminar.',
				running: 'Os dois botões ficam desabilitados enquanto um pedido está rodando. Voltam quando ele terminar.',
			},
			confirmReset: {
				title: 'Reiniciar a demonstração do zero?',
				body: 'Isto apaga tudo o que a demonstração criou (as três organizações e os dados inventados delas) e refaz tudo, renovando os contratos.',
				duration:
					'Roda em segundo plano e leva alguns minutos. Até terminar, as telas de demonstração do portal podem ficar incompletas.',
			},
			stale: {
				title: 'Não foi possível atualizar o estado. Mostrando a resposta recebida às {time}.',
			},
			last: {
				title: 'Último pedido',
				none: 'Nenhum pedido foi feito ainda.',
				noneHint: 'Quando você preparar a demonstração, o pedido aparece aqui e é acompanhado até terminar.',
				action: 'Ação',
				requested: 'Pedido em',
				started: 'Iniciado em',
				finished: 'Terminado em',
				notStarted: 'Não iniciado',
				notFinished: 'Ainda não terminou',
				states: {
					queued: 'Na fila',
					running: 'Rodando',
					done: 'Concluído',
					failed: 'Falhou',
				},
				hints: {
					queued: 'Esperando o agendador pegar o pedido, em geral em até um minuto. Esta tela se atualiza sozinha a cada 5 segundos.',
					running:
						'O comando está rodando e costuma levar alguns minutos. Esta tela se atualiza sozinha a cada 5 segundos e pausa enquanto a aba está escondida.',
				},
				queuedLongTitle: 'Ainda na fila depois de mais de 3 minutos',
				queuedLongBody:
					'O agendador costuma pegar um pedido em até um minuto, então o container dele pode estar parado. O serviço desiste do pedido sozinho depois de 10 minutos.',
				failedTitle: 'O pedido falhou',
				doneTitle: 'A demonstração está pronta',
				doneBody:
					'O seletor "Ver como" agora aparece na faixa de demonstração no topo do portal para os administradores da rede (admin_master).',
				doneNotSeededTitle: 'O pedido terminou, mas a demonstração não está completa',
				doneNotSeededBody:
					'As três organizações de demonstração não estão todas lá. Leia a saída técnica abaixo, se houver, e tente de novo.',
				showDetail: 'Mostrar a saída técnica',
				hideDetail: 'Esconder a saída técnica',
				detailHint: 'Saída bruta do comando, como o serviço a registrou. Pode ser longa e estar em português.',
			},
			reasons: {
				not_picked_up:
					'Ninguém pegou o pedido em 10 minutos: o container do agendador provavelmente está parado. Suba-o e peça de novo.',
				stale_run:
					'A rodada ainda estava em andamento depois de 60 minutos, então o serviço desistiu dela: o processo provavelmente morreu no meio. Confira o agendador e tente de novo.',
				locked:
					'A trava de segurança recusou rodar: o modo demonstração foi desligado, ou apareceu um cliente real no banco depois do pedido. Nada foi alterado.',
				exception: 'O comando levantou uma exceção antes de terminar. A saída técnica abaixo diz qual.',
				command_failed: 'O comando terminou com erro. A saída técnica abaixo é o fim do que ele imprimiu.',
				other: 'O pedido falhou (motivo "{code}").',
				unknown: 'O pedido falhou e o serviço não disse o motivo.',
			},
			problems: {
				off: {
					title: 'O modo demonstração está desligado neste ambiente',
					body: 'O serviço do Observatório responde "não encontrado" de propósito enquanto o modo demonstração está desligado (OBS_DEMO_MODE), então não há nada a preparar aqui nem estado a mostrar. Isso vem da configuração do serviço, não de uma falha desta tela. A demonstração é preparada no ambiente de homologação, que tem banco próprio.',
				},
				route: {
					title: 'O Observatório não conhece esta rota',
					body: 'O serviço respondeu "não encontrado" de um jeito que não é a resposta de demonstração desligada. A versão que está no ar provavelmente é mais antiga que esta tela, ou este admin aponta para o host errado (VUE_APP_API_OBSERVATORY_URL).',
				},
				forbidden: {
					title: 'Só administradores da rede podem usar esta tela',
					body: 'A demonstração altera dados, então o Observatório confere o papel admin_master da Mundo Gamer Network antes de responder. Você está logado, mas a sua conta não tem esse papel.',
				},
				unauthenticated: {
					title: 'O Observatório não reconhece a sua sessão',
					body: 'Entre de novo e recarregue esta página.',
				},
				host: {
					title: 'Quem respondeu não é a API do Observatório',
					body: 'A resposta foi uma página web, veio no formato errado, ou este build do admin não tem endereço do Observatório. Confira se este admin aponta para o host certo (VUE_APP_API_OBSERVATORY_URL). A mensagem abaixo diz qual, quando o navegador sabe.',
				},
				network: {
					title: 'Não foi possível falar com o serviço do Observatório',
					body: 'A chamada não teve resposta: o serviço pode estar fora do ar, ou a rede pode ter caído. A mensagem abaixo diz mais, quando o navegador sabe.',
				},
				generic: {
					title: 'O Observatório respondeu com um erro',
					body: 'O serviço não conseguiu completar a chamada. A mensagem abaixo é o que ele disse.',
				},
				busy: {
					title: 'Já existe um pedido em andamento',
					body: 'Só um pedido pode estar na fila ou rodando por vez. Nada novo foi enviado; o estado desta tela foi atualizado.',
				},
				locked: {
					title: 'O banco tem um cliente real',
					body: 'Nada foi enviado: dado inventado nunca pode dividir banco com cliente real. É uma trava de segurança do serviço, e o estado desta tela foi atualizado.',
				},
				invalid: {
					title: 'O serviço não aceitou a ação',
					body: 'A ação enviada não foi reconhecida. Recarregue a página; se acontecer de novo, esta tela e o serviço estão fora de sincronia.',
				},
			},
		},
		common: {
			loadError: 'Não foi possível carregar os dados do Observatório. O serviço não respondeu como esperado.',
			retry: 'Tentar de novo',
			empty: 'Nada por aqui.',
			actionError: 'Não foi possível concluir. Tente de novo.',
		},
		events: {
			consent: 'Consentimento',
			consented: 'Consentido',
			anonymous: 'Anônimo',
		},
		precedence: {
			create: 'Criar exceção',
			saved: 'Exceção de precedência salva.',
			deleted: 'Exceção de precedência removida.',
			editRank: 'Alterar rank',
			rank: 'Rank',
			deleteConfirm: 'Remover a exceção {item}? Isso muda qual número é publicado, e a mudança fica na trilha de acesso.',
		},
	},
	ventures: {
		categories: {
			list: { title: 'Categorias de Ventures', subTitle: 'Gerencie as categorias de ventures.' },
			create: { title: 'Nova Categoria' },
			update: { title: 'Editar Categoria' },
			delete: { title: 'Categoria excluída com sucesso' },
		},
		regions: {
			list: { title: 'Regiões de Investimento', subTitle: 'Gerencie as regiões geográficas de investimento.' },
			create: { title: 'Nova Região' },
			update: { title: 'Editar Região' },
			delete: { title: 'Região excluída com sucesso' },
			countries_hint: 'Países que pertencem a esta região (usado para expandir filtros de região em países).',
		},
		investorTypes: {
			list: { title: 'Tipos de Investidor', subTitle: 'Gerencie os tipos de investidor.' },
			create: { title: 'Novo Tipo de Investidor' },
			update: { title: 'Editar Tipo de Investidor' },
			delete: { title: 'Tipo de investidor excluído com sucesso' },
		},
		pitchMediaTypes: {
			list: { title: 'Tipos de Mídia de Pitch', subTitle: 'Gerencie os tipos de mídia de pitch.' },
			create: { title: 'Novo Tipo de Mídia de Pitch' },
			update: { title: 'Editar Tipo de Mídia de Pitch' },
			delete: { title: 'Tipo de mídia de pitch excluído com sucesso' },
		},
		scoreAxes: {
			list: { title: 'Eixos de Pontuação', subTitle: 'Gerencie os eixos de pontuação.' },
			create: { title: 'Novo Eixo de Pontuação' },
			update: { title: 'Editar Eixo de Pontuação' },
			delete: { title: 'Eixo de pontuação excluído com sucesso' },
		},
		stages: {
			list: { title: 'Etapas', subTitle: 'Gerencie as etapas de ventures.' },
			create: { title: 'Nova Etapa' },
			update: { title: 'Editar Etapa' },
			delete: { title: 'Etapa excluída com sucesso' },
		},
		projects: {
			list: { title: 'Projetos', subTitle: 'Gerencie os projetos de ventures.' },
			create: { title: 'Novo Projeto' },
			update: { title: 'Editar Projeto' },
			delete: { title: 'Projeto excluído com sucesso' },
			viewPublic: 'Ver página pública',
			tabs: { media: 'Mídia & Links', team: 'Equipe & Mercado', editorial: 'Editorial' },
			fundingRaised: 'Valor Captado',
			tagline: 'Tagline',
			videoUrl: 'URL do Vídeo',
			logoUrl: 'URL do Logo',
			coverUrl: 'URL da Capa',
			teamBio: 'Bio da Equipe',
			teamSize: 'Tamanho da Equipe',
			targetLaunch: 'Data Alvo de Lançamento',
			engine: 'Motor do Jogo',
			targetAudience: 'Público-Alvo',
			marketDescription: 'Descrição de Mercado',
			featuredSince: 'Em destaque desde',
			notFeatured: 'Não está em destaque',
			featuredHint: 'O destaque é ativado pela tela de Pitch Decks (é uma decisão editorial sobre o pitch, aplicada aqui no projeto).',
			featuredNote: 'Nota de Destaque (interna)',
			boostedUntil: 'Impulsionado Até',
			viewCompany: 'Ver empresa',
		},
		studioProspects: {
			title: 'Prospecção de Estúdios',
			subTitle: 'Descubra estúdios de jogos e convide-os a enviar um projeto para a Mundo Gamer Ventures.',
			role: 'Cargo',
			studioName: 'Estúdio',
			category: 'Categoria',
			linkedinUrl: 'URL do LinkedIn',
			website: 'Site',
			linkedin: 'Ver LinkedIn',
			openLinkedin: 'Abrir LinkedIn',
			searchTerms: 'Termos de busca',
			termsRequired: 'Informe ao menos um termo de busca (ex.: "estúdio indie", "desenvolvedor de jogos").',
			discoverHint: 'Busca no LinkedIn via Apify. Requer configuração do Apify (credencial apify_linkedin). Caso contrário, use entrada manual.',
			sendInviteOnAdd: 'Enviar convite agora',
			sendInviteOnAddHint: 'Envia o e-mail de convite assim que o contato for salvo, em vez de enviar depois pelas opções da linha.',
			add: 'Adicionar prospect',
			editProspect: 'Editar prospect',
			invite: 'Convidar',
			sendInvite: 'Enviar convite',
			inviteSent: 'Convite enviado.',
			discover: 'Descobrir (Apify)',
			maxResults: 'Máx. resultados',
			sendSelected: 'Enviar selecionados ({count})',
			bulkInviteResult: '{sent} convite(s) enviado(s), {failed} falharam.',
			bulkInviteResultsTitle: 'Resultado do envio',
			editEmail: 'Editar e-mail',
			discoverQueued: 'Descoberta iniciada em segundo plano — você será avisado quando terminar.',
			discoverBusy: 'Já existe uma descoberta em andamento. Aguarde terminar.',
			apifyUsage: 'Consumo Apify',
			apifyNotConfigured: 'Apify não configurado',
			apifyActive: 'ativa',
			details: 'Detalhes',
			discoveredVia: 'Descoberto via',
			sourceUrl: 'URL de origem',
			possibleDuplicate: 'Possível duplicata de',
			notes: 'Notas',
			email: 'E-mail',
			hasEmail: 'Com e-mail',
			noEmail: 'Sem e-mail',
			emailLanguage: 'Idioma do e-mail',
			emailSubject: 'Assunto',
			emailBody: 'Mensagem',
			emailBodyHint: 'Deixe uma linha em branco entre parágrafos.',
			emailPreview: 'Pré-visualização',
			sequence: 'Sequência',
			funnelStage0: 'Convite enviado',
			funnelConverted: 'Convertido',
			funnelStopped: 'Interrompido',
			funnelNotInvited: 'Ainda não convidado',
			funnelUnsubscribed: 'Descadastrado',
			savedButUnsubscribed: 'Contato salvo, mas o e-mail de convite não foi enviado — este endereço está descadastrado.',
			checkRegistration: 'Verificar cadastro',
			registrationFound: 'Este prospect agora tem um projeto cadastrado — vinculado e marcado como registrado.',
			registrationNotFound: 'Nenhum projeto cadastrado correspondente foi encontrado ainda.',
		},
		investors: {
			list: { title: 'Investidores', subTitle: 'Gerencie os investidores.' },
			create: { title: 'Novo Investidor' },
			update: { title: 'Editar Investidor' },
			delete: { title: 'Investidor excluído com sucesso' },
			linkedUser: 'Usuário Vinculado',
			firmName: 'Nome da Empresa/Fundo',
			firmNameHint: 'Opcional — preencha se este investidor representa um fundo ou empresa, em vez de investir individualmente.',
		},
		investorProspects: {
			title: 'Prospecção de Investidores',
			subTitle: 'Descubra VCs e profissionais de investimento e convide-os a conhecer o Mundo Gamer Ventures.',
			role: 'Cargo',
			firmName: 'Firma',
			investorType: 'Tipo de Investidor',
			linkedinUrl: 'URL do LinkedIn',
			website: 'Site',
			linkedin: 'Ver LinkedIn',
			openLinkedin: 'Abrir LinkedIn',
			searchTerms: 'Termos de busca',
			termsRequired: 'Informe ao menos um termo de busca (ex.: "venture capital", "angel investor").',
			discoverHint: 'Busca no LinkedIn via Apify. Requer configuração do Apify (credencial apify_linkedin). Caso contrário, use entrada manual.',
			sendInviteOnAdd: 'Enviar convite agora',
			sendInviteOnAddHint: 'Envia o e-mail de convite assim que o contato for salvo, em vez de enviar depois pelas opções da linha.',
			add: 'Adicionar prospect',
			editProspect: 'Editar prospect',
			invite: 'Convidar',
			sendInvite: 'Enviar convite',
			inviteSent: 'Convite enviado.',
			discover: 'Descobrir (Apify)',
			maxResults: 'Máx. resultados',
			sendSelected: 'Enviar selecionados ({count})',
			bulkInviteResult: '{sent} convite(s) enviado(s), {failed} falharam.',
			bulkInviteResultsTitle: 'Resultado do envio',
			editEmail: 'Editar e-mail',
			discoverQueued: 'Descoberta iniciada em segundo plano — você será avisado quando terminar.',
			discoverBusy: 'Já existe uma descoberta em andamento. Aguarde terminar.',
			apifyUsage: 'Consumo Apify',
			apifyNotConfigured: 'Apify não configurado',
			apifyActive: 'ativa',
			details: 'Detalhes',
			discoveredVia: 'Descoberto via',
			sourceUrl: 'URL de origem',
			possibleDuplicate: 'Possível duplicata de',
			notes: 'Notas',
			email: 'E-mail',
			hasEmail: 'Com e-mail',
			noEmail: 'Sem e-mail',
			emailLanguage: 'Idioma do e-mail',
			emailSubject: 'Assunto',
			emailBody: 'Mensagem',
			emailBodyHint: 'Deixe uma linha em branco entre parágrafos.',
			emailPreview: 'Pré-visualização',
			sequence: 'Sequência',
			funnelStage0: 'Convite enviado',
			funnelConverted: 'Convertido',
			funnelStopped: 'Interrompido',
			funnelNotInvited: 'Ainda não convidado',
			funnelUnsubscribed: 'Descadastrado',
			savedButUnsubscribed: 'Contato salvo, mas o e-mail de convite não foi enviado — este endereço está descadastrado.',
			checkRegistration: 'Verificar cadastro',
			registrationFound: 'Este prospect agora tem conta cadastrada — vinculado e marcado como registrado.',
			registrationNotFound: 'Nenhuma conta cadastrada correspondente foi encontrada ainda.',
			registeredAs: 'Registrado como',
		},
		publishers: {
			list: { title: 'Publishers', subTitle: 'Gerencie os publishers.' },
			create: { title: 'Novo Publisher' },
			update: { title: 'Editar Publisher' },
			delete: { title: 'Publisher excluído com sucesso' },
			slugHint: 'Gerado automaticamente a partir do nome — edite só se precisar de uma URL personalizada.',
			linkedCompany: 'Empresa Vinculada (opcional)',
		},
		investments: {
			list: { title: 'Investimentos', subTitle: 'Gerencie os investimentos.' },
			create: { title: 'Novo Investimento' },
			update: { title: 'Editar Investimento' },
			delete: { title: 'Investimento excluído com sucesso' },
		},
		waitlist: {
			list: { title: 'Lista de Espera', subTitle: 'Visualize os registros da lista de espera.' },
			details: 'Detalhes',
			invited: 'Convidado',
			sendInvite: 'Enviar convite',
			resendInvite: 'Reenviar convite',
			sendSelected: 'Enviar convite ({count})',
			inviteSent: 'E-mail de convite enviado.',
			bulkInviteResult: '{sent} convite(s) enviado(s), {failed} falhou(aram).',
		},
		pitches: {
			list: { title: 'Pitch Decks', subTitle: 'Modere os pitch decks.' },
			editStatus: 'Editar Status',
			feature: 'Destacar',
			unfeature: 'Remover Destaque',
			recommend: 'Indicar para Investidor',
			recommendNote: 'Nota (opcional)',
			recommendSuccess: 'Pitch indicado ao investidor',
			recommendError: 'Não foi possível indicar este pitch',
		},
		connections: {
			list: { title: 'Conexões', subTitle: 'Monitore conexões entre investidores e projetos.' },
			archive: 'Arquivar Negócio',
			archiveConfirm: 'Arquivar este negócio? Ele será marcado como arquivado e removido do pipeline ativo.',
			archiveSuccess: 'Negócio arquivado',
			archiveError: 'Não foi possível arquivar este negócio',
			detail: {
				title: 'Detalhe do Negócio',
				closingSteps: 'Etapas de Fechamento',
				step: 'Etapa',
				completedAt: 'Concluído Em',
				successFee: 'Taxa de Sucesso',
				feePercent: 'Taxa %',
				feeAmount: 'Valor da Taxa',
				closedAmount: 'Valor Fechado',
				noFeeYet: 'Nenhuma taxa de sucesso registrada ainda.',
				saveSuccess: 'Taxa atualizada',
				saveError: 'Não foi possível atualizar a taxa',
				history: 'Histórico de Relacionamento',
				loadError: 'Não foi possível carregar o detalhe do negócio',
				ndaAudit: 'Auditoria da NDA',
				ndaSignedAt: 'Assinado em',
				ndaTemplate: 'Modelo',
				ndaIp: 'Endereço IP',
				ndaUserAgent: 'User agent',
				ndaContent: 'Ver o texto exato da NDA assinada',
				messages: 'Mensagens',
				initialMessage: 'Mensagem inicial (do investidor)',
				responseMessage: 'Resposta (do estúdio)',
			},
		},
		scoreEngine: {
			list: { title: 'Motor de Pontuação', subTitle: 'Visualize e recalcule as pontuações.' },
			recalculate: 'Recalcular Pontuação',
			recalculateSuccess: 'Pontuação recalculada com sucesso',
			belowThresholdOnly: 'Mostrar só perfis incompletos (abaixo do limite)',
			completeness: 'Completude do Perfil',
			declaredAnswers: 'Respostas do Score Declarado',
		},
		subscriptions: {
			list: { title: 'Assinaturas', subTitle: 'Gerencie as assinaturas de ventures.' },
			cancel: 'Cancelar Assinatura',
			cancelConfirm: 'Tem certeza que deseja cancelar esta assinatura?',
			cancelSuccess: 'Assinatura cancelada com sucesso',
		},
		dashboard: {
			title: 'Painel Ventures',
			totalProjects: 'Total de Projetos',
			totalInvestors: 'Total de Investidores',
			totalPublishers: 'Total de Publishers',
			totalInvestments: 'Total de Investimentos',
			totalWaitlist: 'Total na Lista de Espera',
			pipeline: 'Pipeline',
			featured: 'Em destaque',
			pending: 'Pendentes',
			pitches: 'Propostas',
			connections: 'Conexões',
			recentInvestors: 'Investidores recentes com perfil',
			profileCompleted: 'Perfil concluído',
			noInvestors: 'Ainda não há perfis de investidores concluídos.',
			revenue: 'Receita deste mês',
			empty: 'Ainda não há projetos de ventures. Crie um projeto para começar.',
			funnel: 'Funil de conversão',
			attentionQueue: 'Precisa de atenção',
			incompletePitches: 'pitches abaixo do limite de completude',
			pendingConnections: 'conexões aguardando resposta',
			recentActivity: 'Atividade recente',
			noActivity: 'Nenhuma atividade recente.',
			revenueTrend: 'Volume de investimentos — últimos 6 meses',
		},
		fundingGoal: 'Meta de Captação',
		investmentMin: 'Investimento Mínimo',
		investmentMax: 'Investimento Máximo',
		investedAt: 'Data do Investimento',
		ndaSigned: 'NDA Assinado',
		totalScore: 'Pontuação Total',
		featured: 'Destaque',
		role: 'Papel',
		studioName: 'Nome do Estúdio',
		newsletterOptIn: 'Newsletter',
		financials: 'Financeiro',
		revenue: 'Receita',
		burnRate: 'Burn Rate',
		runwayMonths: 'Runway (meses)',
		fundingAsk: 'Valor Buscado',
		preMoneyValuation: 'Valuation Pré-Money',
		materials: 'Materiais',
		noPitchDeck: 'Sem pitch deck',
		noGdd: 'Sem GDD',
		noVideo: 'Sem vídeo',
		video: 'Vídeo',
		selectInvestor: 'Selecionar investidor',
	},

	feedPromotion: {
		title: 'Promoções no Feed',
		subtitle: 'Gerencie posts promovidos e conteúdo patrocinado no feed da comunidade.',
		create: 'Nova Promoção',
		createTitle: 'Criar Promoção no Feed',
		createSubmit: 'Criar',
		createSuccess: 'Promoção criada com sucesso',
		createError: 'Falha ao criar promoção',
		deleteTitle: 'Excluir Promoção',
		deleteConfirm: 'Tem certeza que deseja remover esta promoção?',
		deleteSuccess: 'Promoção excluída',
		deleteError: 'Falha ao excluir promoção',
		loadError: 'Falha ao carregar promoções',
		sponsored: 'Patrocinado',
		editorial: 'Editorial',
		fieldUrl: 'URL do Post',
		fieldUrlHint: 'Cole a URL completa do post a ser promovido',
		invalidUrl: 'Deve ser uma URL válida começando com http:// ou https://',
		fieldType: 'Tipo',
		fieldActive: 'Ativo',
		fieldStartAt: 'Data de início',
		fieldEndAt: 'Data de término',
		platformDetected: '{platform} detectado',
		previewBtn: 'Pré-visualizar',
		previewNoTitle: 'Sem título disponível',
		previewError: 'Não foi possível carregar o preview — a URL pode não suportar OpenGraph ou está inacessível.',
		colUrl: 'URL',
		colType: 'Tipo',
		colStatus: 'Status',
		colStartAt: 'Início',
		colEndAt: 'Fim',
		status_live: 'Ativo',
		status_scheduled: 'Agendado',
		status_expiring: 'Expirando',
		status_expired: 'Expirado',
		status_inactive: 'Inativo',
		editTitle: 'Editar Promoção',
		updateSubmit: 'Atualizar',
		updateSuccess: 'Promoção atualizada',
		updateError: 'Falha ao atualizar promoção',
		job_hiring: 'Vagas Jobs',
		quiz: 'Quiz',
		tv_live: 'TV Live',
		community: 'Comunidade',
	},
	meetings: {
		list: {
			title: 'Reuniões',
			subtitle: 'Veja todas as reuniões agendadas desta rede.',
		},
		filter: {
			all: 'Todas',
			upcoming: 'Próximas',
			past: 'Passadas',
			platform: 'Plataforma',
			status: 'Status',
			source: 'Origem',
			refresh: 'Atualizar',
		},
		columns: {
			source: 'Orig.',
			organizer: 'Organizador',
			candidate: 'Participante',
			scheduledAt: 'Data / Horário',
			duration: 'Duração',
			platform: 'Plataforma',
			status: 'Status',
			link: 'Link',
		},
		source: {
			database: 'Interno',
			google_calendar: 'Google Calendar',
		},
		status: {
			scheduled: 'Agendada',
			cancelled: 'Cancelada',
		},
		detail: {
			organizer: 'Organizador',
			candidate: 'Participante',
			date: 'Data',
			time: 'Horário',
			duration: 'Duração',
			platform: 'Plataforma',
			description: 'Descrição',
			cancellationReason: 'Motivo do cancelamento',
		},
		minutes: 'min',
		accessLink: 'Acessar reunião',
	},
	indieWallStats: 'Visão Geral IndieWall',
	indieWallTotalWalls: 'Total de Murais (ativos / total)',
	indieWallPixelsSold: 'Pixels Vendidos',
	indieWallTotalGross: 'Total Bruto',
	indieWallMgCommission: 'Comissão MG',
	indieWallUserNet: 'Líquido dos Usuários',
	indieWallPendingPayouts: 'Saques Pendentes',
	indieWallWallsTab: 'Murais',
	indieWallPayoutsTab: 'Saques',
	indieWallPayoutMarkProcessing: 'Marcar Em Processamento',
	indieWallPayoutMarkPaid: 'Marcar Pago',
	indieWallPayoutReject: 'Rejeitar',
	indieWallActivate: 'Ativar',
	indieWallDeactivate: 'Desativar',
	indieWallActivateConfirm: 'Tem certeza que deseja ativar o mural',
	indieWallDeactivateConfirm: 'Tem certeza que deseja desativar o mural',
	indieWallActivateSuccess: 'Mural ativado com sucesso',
	indieWallDeactivateSuccess: 'Mural desativado com sucesso',

	crmPeriod: 'Período',
	crmSalesStatistics: 'Estatísticas de Vendas',
	crmSalesSubtitle: 'Receita mensal de invoices pagos',
	crmAppInstalls: 'Aplicativos Instalados',
	crmSalesAll: 'Tudo',
	crmSalesSubscriptions: 'Assinaturas',
	crmSalesProducts: 'Produtos',
	crmSalesSubtitleAll: 'Receita total de faturas pagas',
	crmSalesSubtitleSubscriptions: 'Receita de assinaturas (planos)',
	crmSalesSubtitleProducts: 'Receita de produtos e bundles',
	crmGrowthRate: 'Taxa de Crescimento',
	crmGrowthSubtitle: 'Novos usuários por plataforma',
	noDataForPeriod: 'Sem dados para este período',
	'commissions.title': 'Comissões & Splits',
	'commissions.subtitle': 'Relatório de vendas e divisão de receita por tipo de produto',
	'commissions.productType': 'Tipo de produto',
	'commissions.from': 'De',
	'commissions.to': 'Até',
	'commissions.totalSales': 'Vendas',
	'commissions.totalRevenue': 'Receita total',
	'commissions.paid': 'Pago',
	'commissions.unpaid': 'Não pago',
	'commissions.owes': 'Deve',
	'commissions.dailyChart': 'Receita & split diário',
	'commissions.salesList': 'Vendas',
	'commissions.buyer': 'Comprador',
	'commissions.productName': 'Produto',
	'commissions.amount': 'Valor',
	'commissions.soldAt': 'Vendido em',
	'commissions.statusPaid': 'Totalmente pago',
	'commissions.statusUnpaid': 'Com pendência',
	'commissions.payParty': 'Pagar {label}',
	'commissions.registerPayment': 'Registrar pagamento',
	'commissions.outstanding': 'Em aberto',
	'commissions.paidAt': 'Pago em',
	'commissions.method': 'Método',
	'commissions.reference': 'Referência',
	'commissions.notes': 'Observações',
	'commissions.manualSale': 'Venda manual',
	'commissions.buyerName': 'Nome do comprador',
	'commissions.buyerEmail': 'Email do comprador',
	'commissions.rules': 'Regras',
	'commissions.rulesHint': 'Alterar percentuais NÃO afeta vendas passadas. Crie uma nova regra com nova data de início.',
	'commissions.newRule': 'Nova regra',
	'commissions.ruleName': 'Nome da regra',
	'commissions.activeFrom': 'Ativa a partir de',
	'commissions.partnerLinks': 'Links do parceiro',
	'commissions.partnerLinksHint': 'Gere um link somente leitura. O parceiro abre sem login e vê a venda bruta + a divisão completa.',
	'commissions.newLink': 'Novo link',
	'commissions.partnerName': 'Nome do parceiro',
	'commissions.expiresAt': 'Expira em',
	'commissions.generateLink': 'Gerar link',
	'commissions.partnerLink': 'Link',
	'commissions.copyLink': 'Copiar link',
	'commissions.copied': 'Copiado!',
	'commissions.partnerLogo': 'Logo do parceiro',
	'commissions.partnerLogoHint': 'Opcional. Aparece na dashboard do parceiro.',
	'commissions.views': 'Acessos',
	'commissions.partner.title': 'Dashboard de comissões',
	'commissions.partner.subtitle': 'Relatório de vendas e a sua parte',
	'commissions.partner.yourShare': 'Sua parte',
	'commissions.partner.readonly': 'Visualização somente leitura. Os valores atualizam automaticamente conforme novas vendas são confirmadas.',
	'commissions.partner.invalidTitle': 'Link indisponível',
	'commissions.partner.invalidText': 'Este link é inválido, expirou ou foi desativado. Entre em contato com a MG Network.',
	'commissions.products': 'Produtos associados',
	'commissions.bundles': 'Bundles associados',
	'commissions.itemsHint': 'Opcional: associe produtos/bundles específicos. Se vazio, a regra vale para todo o tipo de produto.',
	'commissions.payouts': 'Repasses',
	'commissions.payoutsHint': 'Um repasse quita o saldo em aberto de uma parte em várias vendas de uma vez.',
	'commissions.newPayout': 'Novo repasse',
	'commissions.payoutLabel': 'Descrição',
	'commissions.payoutParty': 'Pagar a',
	'commissions.markPaidNow': 'Marcar como pago agora',
	'commissions.payoutFormHint': 'Quita todas as vendas em aberto da parte selecionada no período. Deixe as datas vazias para incluir tudo.',
	'commissions.createPayout': 'Criar repasse',
	'commissions.markPaid': 'Marcar pago',
	'commissions.statusAberto': 'Aberto',
	'commissions.statusParcial': 'Parcial',
	'commissions.statusRepassado': 'Repassado',
	'commissions.grossRevenue': 'Receita bruta',
	'commissions.netRevenue': 'Receita líquida',
	'commissions.gateway': 'Gateway',
	'commissions.tax': 'Impostos',
	'commissions.net': 'Líquido',
	'commissions.ofNet': 'do líquido',
	'commissions.gatewayPct': 'Gateway %',
	'commissions.taxPct': 'Impostos %',
	'commissions.deductionsHint': 'A taxa de gateway e os impostos são deduzidos do bruto antes do split. O split é aplicado sobre o valor LÍQUIDO.',





	'notifSuggestions.list.title': 'Sugestões de Notificações',
	'notifSuggestions.list.subTitle': 'Notificações automáticas de engajamento e marketing enviadas aos usuários por assunto',
	'notifSuggestions.newSubject': 'Novo Assunto',
	'notifSuggestions.edit': 'Editar Assunto',
	'notifSuggestions.delete': 'Excluir Assunto',
	'notifSuggestions.deleteConfirm': 'Tem certeza que deseja excluir',
	'notifSuggestions.globalActive': 'Disparo automático ATIVO',
	'notifSuggestions.globalDisabled': 'Disparo automático INATIVO',
	'notifSuggestions.disableAll': 'Desativar Tudo',
	'notifSuggestions.enableAll': 'Ativar Tudo',
	'notifSuggestions.disableAllConfirm': 'Isso irá parar TODOS os disparos automáticos imediatamente. Tem certeza?',
	'notifSuggestions.enableAllConfirm': 'Isso irá reativar os disparos automáticos para todos os assuntos ativos.',
	'notifSuggestions.frequencyHours': 'Frequência Mínima (h)',
	'notifSuggestions.channels': 'Canais',
	'notifSuggestions.targetingRules': 'Regras de Segmentação',
	'notifSuggestions.variantsCount': 'Variantes',
	'notifSuggestions.statsPeriod': 'Período das estatísticas (dias)',
	'notifSuggestions.stats.totalSent': 'Total Enviadas',
	'notifSuggestions.stats.totalClicked': 'Total de Cliques',
	'notifSuggestions.stats.totalRead': 'Lidas (in-app)',

	'notifSuggestions.stats.ctr': 'Taxa de Clique (CTR)',
	'notifSuggestions.stats.totalSubjects': 'Assuntos Ativos',
	'notifSuggestions.stats.header': 'Desempenho',
	'notifSuggestions.variants': 'Variantes',
	'notifSuggestions.newVariant': 'Nova Variante',
	'notifSuggestions.editVariant': 'Editar Variante',
	'notifSuggestions.imageUrl': 'URL da Imagem',
	'notifSuggestions.weight': 'Peso (rotatividade)',
	'notifSuggestions.dispatchHistory': 'Histórico de Disparos',
	'notifSuggestions.variant': 'Variante',
	'notifSuggestions.sentAt': 'Enviado em',
	'notifSuggestions.sendToPlatform': 'Enviar para',
	'notifSuggestions.sendToAll': 'Todos (web + mobile)',
	'notifSuggestions.sendToWeb': 'Somente web (browser push)',
	'notifSuggestions.sendToMobile': 'Somente mobile (FCM)',
	'notifSuggestions.emailEligible': 'Permitir disparo por e-mail',
	'notifSuggestions.broadcastChannels': 'Transmitir para canais Telegram/Discord',
	'notifSuggestions.chartTitle': 'Desempenho diário (enviadas vs cliques)',
	'notifSuggestions.triggerNow': 'Disparar agora',
	'notifSuggestions.triggerHint': 'Sobrescreva título, corpo e URL CTA para este disparo único. Deixe em branco para usar as variantes do seeder.',
	'notifSuggestions.triggerOptional': 'Opcional — deixe em branco para usar a variante semeada',
	'notifSuggestions.triggerLimit': 'Máx. usuários',
	'notifSuggestions.triggerFire': 'Enviar agora',
	'notifSuggestions.triggerSent': 'Enviadas',
	'notifSuggestions.triggerFailed': 'Falhas',
	'notifSuggestions.dryRun': 'Simulação',
	'notifSuggestions.eligibleUsers': 'usuários elegíveis',
	'notifSuggestions.platforms': 'Plataformas',
	'notifSuggestions.noPlatform': 'Sem plataforma',

	'deployCenter.title': 'Deploy Center',
	'deployCenter.subtitle': 'Comparação entre homologação e produção dos repositórios da Mundo Gamer Network.',
	'deployCenter.readonly': 'somente leitura',
	'deployCenter.monitored': 'Monitorados',
	'deployCenter.synced': 'Sincronizados',
	'deployCenter.pending': 'Com pendências',
	'deployCenter.errored': 'Com erro',
	'deployCenter.totalMonitored': '{n} projetos monitorados',
	'deployCenter.lastCheck': 'Última verificação',
	'deployCenter.never': 'nunca',
	'deployCenter.justNow': 'agora mesmo',
	'deployCenter.minutesAgo': 'min atrás',
	'deployCenter.hoursAgo': 'h atrás',
	'deployCenter.noCache': 'Nenhuma verificação foi executada ainda.',
	'deployCenter.seeMore': 'Ver mais',
	'deployCenter.refreshBtn': 'Atualizar status',
	'deployCenter.refreshSuccess': 'Status atualizado com sucesso.',
	'deployCenter.projectRefreshSuccess': 'Projeto atualizado com sucesso.',
	'deployCenter.refreshLocked': 'Atualização recente em andamento ou concluída há pouco. Aguarde alguns instantes.',
	'deployCenter.refreshError': 'Falha ao atualizar. Tente novamente em instantes.',
	'deployCenter.checkProject': 'Verificar este projeto',
	'deployCenter.filterAll': 'Todos',
	'deployCenter.filterSynced': 'Sincronizados',
	'deployCenter.filterPending': 'Pendentes',
	'deployCenter.filterError': 'Erro',
	'deployCenter.colProject': 'Projeto',
	'deployCenter.colStatus': 'Status',
	'deployCenter.colFrontRepo': 'Repo Frontend',
	'deployCenter.colFrontStatus': 'Status Front',
	'deployCenter.colFrontPending': 'Pendências Front',
	'deployCenter.colBackRepo': 'Repo Backend',
	'deployCenter.colBackStatus': 'Status Back',
	'deployCenter.colBackPending': 'Pendências Back',
	'deployCenter.colLastCommit': 'Último Commit',
	'deployCenter.colLinks': 'Links',
	'deployCenter.colCheck': 'Check',
	'deployCenter.statusSynced': 'Sincronizado',
	'deployCenter.statusAhead': 'Homologação à frente',
	'deployCenter.statusBehind': 'Produção à frente',
	'deployCenter.statusDiverged': 'Divergente',
	'deployCenter.statusError': 'Erro ao consultar',
	'deployCenter.statusPending': 'Pendente',
	'deployCenter.commitsPending': 'commits pendentes',
	'fulfillmentQueue.title': 'Fila de Entregas',
	'fulfillmentQueue.subtitle': 'Itens comprados — de pedidos de campanha, pacotes de showcase ou vendas individuais avulsas — que a equipe ainda precisa produzir e entregar.',
	'fulfillmentQueue.filters.type': 'Tipo',
	'fulfillmentQueue.filters.status': 'Status',
	'fulfillmentQueue.filters.search': 'Buscar',
	'fulfillmentQueue.filters.searchPlaceholder': 'Comprador, estúdio ou nome do item…',
	'fulfillmentQueue.filters.dateFrom': 'De',
	'fulfillmentQueue.filters.dateTo': 'Até',
	'fulfillmentQueue.types.campaign_order_item': 'Pedido de campanha',
	'fulfillmentQueue.types.showcase_submission': 'Showcase',
	'fulfillmentQueue.types.review_request': 'Review',
	'fulfillmentQueue.types.fulfillment_task': 'Venda individual',
	'fulfillmentQueue.types.onboarding_purchase': 'Pacote pago',
	'fulfillmentQueue.status.pending': 'Pendente',
	'fulfillmentQueue.status.in_progress': 'Em andamento',
	'fulfillmentQueue.status.delivered': 'Entregue',
	'fulfillmentQueue.status.blocked': 'Bloqueado',
	'fulfillmentQueue.status.cancelled': 'Cancelado',
	'fulfillmentQueue.table.buyer': 'Comprador',
	'fulfillmentQueue.table.item': 'Item',
	'fulfillmentQueue.table.type': 'Tipo',
	'fulfillmentQueue.table.status': 'Status',
	'fulfillmentQueue.table.purchasedAt': 'Comprado em',
	'fulfillmentQueue.table.amount': 'Valor',
	'fulfillmentQueue.table.actions': 'Ações',
	'fulfillmentQueue.actions.view': 'Abrir',
	'fulfillmentQueue.actions.markDelivered': 'Marcar como entregue',
	'fulfillmentQueue.feedback.loadError': 'Falha ao carregar a fila de entregas.',
	'fulfillmentQueue.feedback.deliverSuccess': 'Marcado como entregue.',
	'fulfillmentQueue.feedback.deliverError': 'Falha ao marcar como entregue.',
	'fulfillmentQueue.emptyState': 'Nada pendente — todos os itens rastreados já foram entregues.',
	'fulfillmentQueue.degradedWarning': 'Algumas fontes falharam ao carregar — esta lista pode estar incompleta: {sources}',
	'infraStatus.title': 'Status de Infra & Deploy',
	'infraStatus.disk': 'Disco',
	'infraStatus.memory': 'Memória',
	'infraStatus.cpu': 'Carga de CPU',
	'infraStatus.noData': 'Nenhuma métrica de infra disponível ainda.',
	'infraStatus.outdatedRepos': 'repositórios desatualizados (homologação à frente da produção)',

	fieldActivations: {
		title: 'Ativações de campo',
		subtitle: 'Serviço gerenciado: a MGN monta a campanha para a empresa cliente, escolhe os representantes e cuida dos links. A empresa acompanha tudo no painel do agency, só em leitura.',
		new: 'Nova campanha',
		newTitle: 'Nova campanha de ativação',
		editTitle: 'Editar campanha',
		back: 'Voltar',
		create: 'Criar campanha',
		save: 'Salvar',
		created: 'Campanha criada.',
		saved: 'Campanha salva.',
		copied: 'Copiado.',
		filterSearch: 'Buscar por nome, cliente ou evento',
		filterStatus: 'Status',
		filterMode: 'Modo',
		colName: 'Campanha',
		colCompany: 'Empresa cliente',
		colMode: 'Modo',
		colStatus: 'Status',
		colPeriod: 'Período',
		colLeads: 'Contatos',
		noCompany: 'Sem empresa vinculada',
		managed: 'Gerenciada pela MGN',
		selfServe: 'Autosserviço',
		statuses: {
			draft: 'Rascunho',
			active: 'Ativa',
			paused: 'Pausada',
			completed: 'Concluída',
		},
		tabCampaign: 'Campanha',
		tabBooth: 'Tela do estande',
		tabEmails: 'E-mails',
		tabClient: 'Cliente',
		tabRepresentatives: 'Representantes',
		tabLinks: 'Links',
		fieldCompany: 'Empresa cliente',
		fieldCompanyHint: 'A empresa vê esta campanha no painel do agency.',
		fieldName: 'Nome da campanha',
		fieldSlug: 'Slug (usado no QR)',
		fieldSlugHint: 'Não muda depois de criada: é o caminho impresso no QR.',
		fieldClient: 'Nome do cliente (exibição)',
		fieldEvent: 'Evento',
		fieldLocation: 'Local / pavilhão',
		fieldLocationHint: 'Ex.: pavilhão, estande B12. Cidade e país ficam nos campos ao lado.',
		fieldCity: 'Cidade',
		fieldStartsAt: 'Início',
		fieldEndsAt: 'Fim',
		fieldStatus: 'Status',
		fieldDestination: 'URL de destino (formulário do cliente)',
		fieldDestinationHint: 'Para onde todo QR e link de e-mail leva. Pode trocar a qualquer momento sem reimprimir.',
		fieldAttribution: 'Janela de atribuição (dias)',
		fieldFeeValue: 'Success fee',
		fieldFeeCurrency: 'Moeda',
		fieldFeeMetric: 'Métrica do success fee',
		fieldManaged: 'Gerenciada pela MGN',
		fieldManagedHint: 'Ligado: a empresa só acompanha no agency. Desligado: a empresa também edita (autosserviço).',
		fieldHeadline: 'Frase principal',
		fieldSubline: 'Frase de apoio',
		fieldCta: 'Chamada abaixo do QR',
		fieldLogoUrl: 'URL da logo do cliente',
		uploadLogo: 'Enviar logo',
		logoHint: 'PNG, JPG, WebP ou SVG, até 2 MB.',
		logoUploaded: 'Logo enviada.',
		saveFirst: 'Salve a campanha para habilitar.',
		boothPreview: 'Prévia do modo estande',
		boothHeadlinePlaceholder: 'Frase principal do estande',
		fieldConfirmation: 'Enviar e-mail de confirmação ao estúdio',
		fieldConfirmationTemplate: 'Template de confirmação',
		fieldReminder: 'Enviar lembrete (follow-up) ao estúdio',
		fieldReminderTemplate: 'Template de lembrete',
		fieldReminderDelay: 'Após (horas)',
		fieldFromName: 'Nome do remetente',
		fieldFromEmail: 'E-mail do remetente',
		fieldReplyTo: 'Responder para',
		editTemplates: 'Editar textos dos e-mails',
		testEmailTitle: 'Enviar e-mail de teste',
		testEmailTo: 'Para',
		testEmailKind: 'Tipo',
		testEmailSend: 'Enviar teste',
		sampleTitle: 'Enviar exemplo destes e-mails',
		sampleHint: 'Mostra ao cliente o que ele vai receber. O resumo diário usa os números atuais desta campanha; o alerta usa um lead de exemplo. O assunto vai marcado como teste.',
		sampleTo: 'Enviar para',
		sampleDaily: 'Exemplo do resumo diário',
		sampleStrongFit: 'Exemplo do alerta de alto interesse',
		sampleSent: 'Exemplo enviado para {email}.',
		testEmailSent: 'E-mail de teste enviado.',
		fieldClientLocale: 'Idioma dos e-mails do cliente',
		fieldClientLocaleHint: 'Resumo diário e alerta de lead quente. Os e-mails dos estúdios seguem o país e os idiomas do jogo de cada visitante.',
		fieldDailySummaryTemplate: 'Template do resumo diário',
		fieldStrongFitTemplate: 'Template do alerta de lead quente',
		fieldTemplateDefaultHint: 'Vazio = o padrão',
		previewLanguage: 'Idioma',
		preview: 'Visualizar',
		previewTitle: 'Prévia do e-mail',
		previewSubject: 'Assunto',
		previewDaily: 'Ver resumo diário',
		previewStrongFit: 'Ver alerta',
		locales: { en: 'English', 'pt-BR': 'Português (BR)', es: 'Español', de: 'Deutsch', ro: 'Română' },
		testKinds: {
			confirmation: 'Confirmação',
			reminder: 'Lembrete',
			daily_summary: 'Resumo diário',
			strong_fit: 'Alerta de lead quente',
		},
		fieldClientContact: 'Responsável no cliente',
		fieldClientEmail: 'E-mail do responsável (relatórios)',
		fieldDailySummary: 'Enviar resumo diário ao cliente',
		fieldDailySummaryTime: 'Horário do resumo',
		fieldStrongFit: 'Avisar o cliente na hora quando entrar lead com interesse alto',
		noClientEmail: 'Sem o e-mail do responsável, o resumo diário e o alerta não são enviados.',
		reportTitle: 'Link do relatório do cliente',
		reportHint: 'Página pública com os contatos e as métricas da campanha. Gerar de novo invalida o link anterior.',
		reportGenerate: 'Gerar link',
		reportRegenerate: 'Gerar novo link',
		reportRegenerateConfirm: 'Gerar um novo link? O link já enviado ao cliente vai parar de funcionar.',
		repsHint: 'Escolha quem vai atender no estande. Cada representante recebe um link pessoal: os contatos que cadastrar ficam no nome dele.',
		repSelect: 'Representantes (usuários Mundo Gamer)',
		repSendEmail: 'Enviar o link por e-mail',
		repAdd: 'Adicionar representantes',
		repAdded: '{added} representante(s) adicionado(s).',
		repAddedEmailed: '{added} representante(s) adicionado(s); {mailed} link(s) enviado(s) por e-mail.',
		repAddFailed: 'Não foi possível adicionar: {ids}. Eles continuam selecionados para tentar de novo.',
		repColName: 'Representante',
		repColLink: 'Link de acesso',
		repEmpty: 'Nenhum representante ainda.',
		commercialTitle: 'Termos comerciais (MGN)',
		commercialHint: 'Opcional. Success fee e janela de atribuição combinados com o cliente — só para campanhas que a MGN opera; a empresa nunca vê.',
		repInviteTitle: 'Ou convide por e-mail (não precisa de conta)',
		repInviteEmail: 'E-mail',
		repInviteName: 'Nome (opcional)',
		repInvite: 'Convidar',
		repInviteInvalid: 'Informe um e-mail válido',
		repHasAccount: 'tem conta',
		repNoAccount: 'sem conta ainda (só link)',
		repLeads: '{count} contatos',
		repRemove: 'Remover',
		repRemoveConfirm: 'Remover {name} desta campanha? Os contatos que cadastrou continuam.',
		repRemoved: 'Representante removido',
		repHasLink: 'Link já gerado',
		repNoLink: 'Sem link',
		repShowLink: 'Mostrar link',
		repEmailLink: 'Enviar por e-mail',
		repLinkCreated: 'Link de acesso pronto.',
		repLinkEmailed: 'Link enviado por e-mail ao representante.',
		repEmailFailed: 'O link foi gerado, mas o e-mail não saiu. Copie e envie manualmente.',
		howTrackingTitle: 'Como sabemos que a visita veio da gente',
		howTrackingBody: 'Você salva só UM endereço: a URL de destino (aba Campanha). Os QR codes e os links dos e-mails nunca apontam direto para ela: apontam para um link nosso rastreado, que registra a leitura ou o clique e depois manda o visitante ao seu destino com tags UTM (utm_source=mundo_gamer, a campanha e a origem). Assim o QR é impresso uma vez e o destino pode mudar a qualquer momento. No analytics do cliente, filtre por utm_source = mundo_gamer.',
		linksArrives: 'O que a página de destino recebe',
		linksArrivesHint: 'O mesmo endereço que você salvou, mais as nossas tags. O utm_content diz de onde veio: o cartão do representante, o QR pessoal do visitante ou o e-mail de follow-up ({id} é o lead, {user} o representante).',
		arrival: { card: 'Leitura do cartão impresso', lead_qr: 'QR pessoal do visitante', email: 'Link no e-mail' },
		tabLeads: 'Leads e dados',
		leads: {
			kpi: { studios_approached: 'Estúdios', interested: 'Alto interesse', lead_qr_scanned: 'QR lidos', email_clicks: 'Cliques no e-mail', submissions: 'Enviaram o jogo', signed: 'Assinaram', follow_ups: 'Acompanhar', card_scans: 'Leituras do cartão' },
			search: 'Buscar estúdio, contato, e-mail, jogo, país',
			interest: 'Interesse',
			pipeline: 'Pipeline',
			exportCsv: 'Exportar CSV',
			exportPdf: 'Relatório final (PDF)',
			sendFinalReport: 'Enviar relatório final',
			sendFinalReportConfirm: 'Enviar agora o e-mail com o relatório final para o cliente?',
			finalReportSent: 'Relatório final enviado.',
			finalReportError: 'Não foi possível gerar o relatório final.',
			empty: 'Nenhum lead capturado ainda.',
			col: { studio: 'Estúdio', contact: 'Contato', game: 'Jogo', country: 'País', interest: 'Interesse', status: 'Situação', rep: 'Representante', date: 'Captado em' },
			interests: { HIGH: 'Alto', FOLLOW_UP: 'Acompanhar', NOT_INTERESTED: 'Sem interesse' },
			field: {
				studio_name: 'Estúdio', studio_country: 'País', studio_state: 'Estado', studio_city: 'Cidade', company_type_label: 'Tipo de empresa', company_size_label: 'Porte',
				contact_name: 'Contato', contact_role: 'Cargo', email: 'E-mail', phone_e164: 'Telefone', linkedin_url: 'LinkedIn / site', game_project: 'Jogo', game_status_label: 'Estágio do jogo',
				platform_names: 'Plataformas', language_names: 'Idiomas', genre_names: 'Gêneros', game_release_date: 'Lançamento previsto', game_page_url: 'Página do jogo',
				booth_location: 'Estande', interest_level: 'Interesse', submission_expected: 'Vai enviar o jogo', follow_up_required: 'Precisa de acompanhamento', notes: 'Anotações',
				email_declined: 'Sem e-mail informado', contact_consent: 'Consentiu ser contatado', representative_name: 'Captado por', created_at: 'Captado em',
			},
			edit: {
				button: 'Editar dados', save: 'Salvar', cancel: 'Cancelar', saved: 'Contato salvo.',
				hint: 'Complete ou corrija o que o representante coletou. Toda alteração fica registrada no contato.',
				required: 'Obrigatório.', invalidEmail: 'Informe um e-mail válido.', httpsOnly: 'Use um link começando com https://', maxGenres: 'No máximo 6 gêneros.',
			},
			photos: 'Fotos',
			photoKinds: { visiting_card: 'Cartão de visita', stand: 'Estande', evidence: 'Evidência' },
			voiceNotes: 'Notas de voz',
			play: 'Carregar e ouvir',
			audioError: 'Não foi possível carregar a nota de voz.',
			emails: 'E-mails que o estúdio recebeu',
			activity: 'Atividade',
			yes: 'Sim',
			no: 'Não',
		},
		tabMaterials: 'Materiais',
		tabDebrief: 'Debrief',
		tabMessages: 'Mensagens',
		messages: {
			close: 'Fechar',
			emailDeclined: 'Sem e-mail informado',
			emailDeclinedHint: 'O estúdio preferiu não informar um e-mail, então o endereço salvo é o do representante (um substituto). Este estúdio fica de fora de todo e-mail automático ou em massa (confirmação, lembrete, follow-up, sequências) e não é possível escrever mensagens para ele.',
			declinedSwitch: 'O estúdio não informou um e-mail',
			declinedSwitchHint: 'O campo de e-mail passa a guardar o endereço substituto do representante. O estúdio fica fora de todo e-mail automático ou em massa.',
			statuses: {
				draft: 'Rascunho', pending_approval: 'Aguardando o cliente', approved: 'Aprovada', rejected: 'Rejeitada', scheduled: 'Agendada', queued: 'Na fila', sending: 'Enviando',
				sent: 'Enviada', delivered: 'Entregue', bounced: 'Devolvida', complained: 'Marcada como spam', failed: 'Falhou', cancelled: 'Cancelada', skipped: 'Ignorada',
			},
			timeline: {
				created: 'Escrita', approval_requested: 'Enviada ao cliente para aprovação', approved: 'Decisão registrada', scheduled: 'Agendada para', queued: 'Na fila',
				sent: 'Enviada', delivered: 'Entregue', bounced: 'Devolvida', complained: 'O estúdio marcou como spam',
			},
			blockers: {
				campaign_inactive: 'A campanha não está ativa.',
				messages_disabled: 'As mensagens estão desligadas nesta campanha (aba E-mails).',
				email_declined: 'O estúdio não informou um e-mail: fica fora de todo e-mail.',
				no_consent: 'O estúdio não consentiu em ser contatado.',
				opted_out: 'O estúdio saiu da lista de e-mails.',
				invalid_email: 'O e-mail cadastrado não é válido.',
				address_bounced: 'Uma mensagem anterior para este endereço foi devolvida em definitivo.',
				booking_link_missing: 'O texto usa o link de agendamento, mas a campanha não tem URL de agendamento (aba E-mails).',
			},
			warnings: {
				not_interested: 'O estúdio foi marcado como sem interesse.',
				pipeline_advanced: 'O estúdio já avançou no funil (enviou o jogo ou depois).',
				existing_client: 'O estúdio já é cliente.',
				recent_message: 'Já saiu uma mensagem para este estúdio nas últimas 48 horas.',
			},
			compose: {
				title: 'Escrever mensagem', editTitle: 'Editar mensagem', to: 'Para: {email}', subject: 'Assunto', body: 'Mensagem',
				bodyHint: 'Texto simples. Uma linha em branco começa um novo parágrafo. Um parágrafo só com o link de agendamento ou o link pessoal vira um botão. O rodapé para sair da lista é adicionado automaticamente.',
				variables: 'Variáveis (clique para inserir onde está o cursor)', unknown: 'Variáveis desconhecidas: {list}',
				language: 'Idioma', schedule: 'Agendar (opcional)', scheduleHint: 'Deixe vazio para enviar o quanto antes. As mensagens só saem dentro da janela de envio e do limite diário.',
				preview: 'Pré-visualização', previewEmpty: 'Escreva um assunto e uma mensagem para ver como o estúdio vai receber.',
				previewFrom: 'De', previewReplyTo: 'Respostas vão para', previewLanguage: 'Idioma',
				blockersTitle: 'Esta mensagem não pode ser enviada', warningsTitle: 'Confira antes de enviar',
				cap: 'Enviadas hoje: {sent} de {cap}.', testEmail: 'Enviar um teste para', sendTest: 'Enviar teste', testSent: 'E-mail de teste enviado.',
				saveDraft: 'Salvar rascunho', send: 'Enviar', scheduleBtn: 'Agendar', ask: 'Pedir aprovação ao cliente',
				draftSaved: 'Rascunho salvo.', sent: 'Mensagem na fila para envio.', scheduledOk: 'Mensagem agendada.', askSent: 'Enviada ao cliente para aprovação.',
				disabled: 'As mensagens estão desligadas nesta campanha. Ligue na aba E-mails.',
				confirmTitle: 'Enviar mesmo assim?', confirmBody: 'O envio é permitido, mas confirme que quer seguir apesar de:',
				back: 'Voltar', sendAnyway: 'Enviar mesmo assim',
				schedulePast: 'Esse horário já passou. Escolha um horário futuro ou deixe vazio.', discardConfirm: 'Descartar o que você escreveu?',
			},
			section: {
				title: 'Mensagens e respostas', send: 'Enviar mensagem', empty: 'Nenhuma mensagem escrita para este estúdio ainda.', view: 'Ver conteúdo',
			},
			detail: {
				title: 'Mensagem', fromTo: 'De {from} para {to}', content: 'Conteúdo',
				proof: 'Este é o conteúdo exato guardado no momento do envio. É a prova do que foi enviado.',
				decidedBy: 'Decisão de {who}',
				bounce: { hard: 'O endereço não existe ou recusa e-mails (devolução definitiva). Ele não será mais usado.', soft: 'A caixa não conseguiu receber por enquanto (devolução temporária).' },
			},
			actions: {
				cancel: 'Cancelar mensagem', retry: 'Tentar de novo', edit: 'Editar rascunho', send: 'Enviar', ask: 'Pedir aprovação ao cliente',
			},
			confirmCancel: 'Cancelar esta mensagem? Ela não será enviada.',
			confirmSend: 'Enviar esta mensagem agora? Ela sai para o estúdio e não dá para desfazer.',
			confirmAsk: 'Enviar esta mensagem ao cliente para aprovação?',
			confirmApprove: 'Registrar a aprovação do cliente? A mensagem é liberada e será enviada ao estúdio.',
			decision: {
				title: 'Registrar a decisão do cliente', hint: 'Use quando o cliente respondeu por e-mail ou telefone em vez de pelo link do relatório. Quem decidiu fica guardado como prova.',
				who: 'Quem decidiu (nome e empresa)', note: 'Observação (opcional)', approve: 'Cliente aprovou', reject: 'Cliente rejeitou',
			},
			replies: {
				title: 'Respostas', empty: 'Nenhuma resposta registrada ainda.', hint: 'Registre uma resposta que o estúdio deu por e-mail, WhatsApp, telefone ou pessoalmente. Uma resposta interrompe as sequências que param ao responder.',
				channel: 'Canal', outcome: 'Resultado', date: 'Quando', body: 'O que disseram (opcional)', save: 'Registrar resposta', saved: 'Resposta registrada.',
				remove: 'Remover', removeConfirm: 'Remover esta resposta do histórico?',
				channels: { email: 'E-mail', whatsapp: 'WhatsApp', phone: 'Telefone', in_person: 'Pessoalmente', other: 'Outro' },
				outcomes: { interested: 'Interessado', call_booked: 'Call agendada', not_interested: 'Sem interesse', opt_out: 'Pediu para parar os e-mails', other: 'Outro' },
				consequence: {
					opt_out: 'Este estúdio será marcado como sem interesse E sairá da lista de e-mails. As mensagens que ainda aguardam serão canceladas e as sequências dele param. Continuar?',
					not_interested: 'Este estúdio será marcado como sem interesse. As mensagens que ainda aguardam serão canceladas e as sequências dele param. Continuar?',
				},
			},
			panel: {
				messages: 'Mensagens', sequences: 'Sequências', all: 'Todas', empty: 'Nenhuma mensagem nesta visão.', more: 'Carregar mais', selectAll: 'Selecionar todos os rascunhos', sendSelected: 'Enviar selecionados ({n})', sendTitle: 'Enviar {n} mensagem(ns)?', sendBody: 'Cada e-mail é verificado de novo antes de sair e vai para o estúdio na hora. As mensagens que o sistema recusar são listadas depois.', sendConfirm: 'Enviar agora', sendDone: '{n} mensagem(ns) na fila. Saem uma de cada vez, com 20 a 45 segundos de intervalo.', sendFailed: '{n} não enviada(s): {reasons}', manual: 'Escrita à mão', sequence: 'De uma sequência',
				hint: 'Todo e-mail escrito para um estúdio desta campanha, com a vida inteira registrada: quem escreveu, a aprovação, quando saiu, o que foi entregue. Clique numa mensagem para ver o conteúdo exato.',
				col: { studio: 'Estúdio', subject: 'Assunto', status: 'Status', when: 'Data' },
			},
			sequences: {
				hint: 'Uma sequência envia uma série de mensagens a cada estúdio inscrito, esperando entre elas. Ela para sozinha quando o estúdio responde, recusa, avança ou não pode ser alcançado. Cada passo é uma mensagem comum, com a mesma aprovação, limites e rastreio.',
				add: 'Nova sequência', addTitle: 'Nova sequência', editTitle: 'Editar sequência', empty: 'Nenhuma sequência ainda.', edit: 'Editar', delete: 'Excluir', enroll: 'Inscrever estúdios', enrollments: 'Quem está dentro',
				active: 'Ativa', paused: 'Pausada', name: 'Nome', isActive: 'Ativa', stopOnReply: 'Parar quando o estúdio responder', stopsOnReply: 'para ao responder',
				windowHint: 'Os passos só são criados entre 09:00 e 20:00 (horário de São Paulo).',
				summary: '{steps} passos · {active} ativos de {total} inscritos', afterHours: 'após {n} h', fromTemplate: 'a partir de um modelo',
				steps: 'Passos', step: 'Passo {n}', delay: 'Esperar (horas)', delayFirst: 'Depois que o estúdio é inscrito', delayNext: 'Depois do passo anterior',
				bodyHint: 'Mesmas variáveis de uma mensagem. Linhas em branco separam parágrafos.', addStep: 'Adicionar passo', save: 'Salvar', saved: 'Sequência salva.',
				deleteConfirm: 'Excluir a sequência "{name}"? As mensagens já criadas ficam como prova; só o agendamento é removido.',
				enrollTitle: 'Inscrever estúdios em "{name}"', enrollHint: 'Estúdios que saíram da lista, recusaram ou não têm e-mail utilizável são ignorados e você verá o motivo.', enrollN: 'Inscrever {n}',
				enrolled: '{n} estúdio(s) inscrito(s).',
				confirmEnroll: 'Inscrever {n} estúdio(s) em "{name}"? A primeira mensagem é criada {hours} h após a inscrição e as seguintes vêm sozinhas.',
				notActive: 'Esta sequência está pausada. Ative-a antes de inscrever estúdios.', unenrollConfirm: 'Tirar {name} da sequência?',
				skipReasons: {
					already_enrolled: 'já está nesta sequência', not_interested: 'sem interesse', campaign_inactive: 'campanha inativa', messages_disabled: 'mensagens desligadas',
					email_declined: 'não informou e-mail', no_consent: 'sem consentimento', opted_out: 'saiu da lista', invalid_email: 'e-mail inválido', address_bounced: 'endereço devolvido',
				},
				enrollmentsOf: 'Estúdios em "{name}"', noEnrollments: 'Ninguém inscrito ainda.', nextStep: 'próximo: passo {n},', unenroll: 'Remover',
				enrollmentStatuses: { active: 'Ativa', completed: 'Concluída', stopped: 'Parada' },
				stopReasons: { removed_by_staff: 'removido pela equipe', replied: 'o estúdio respondeu', refused: 'o estúdio recusou', opt_out: 'o estúdio pediu para não ser contatado', not_interested: 'o estúdio não tem interesse', complaint: 'o estúdio marcou uma mensagem como spam', pipeline_advanced: 'o estúdio avançou no funil', existing_client: 'já é cliente', opted_out: 'o estúdio saiu da lista', email_declined: 'o estúdio não passou e-mail', no_consent: 'sem consentimento para contato', invalid_email: 'e-mail inválido', address_bounced: 'o endereço foi devolvido', campaign_inactive: 'campanha não está ativa', messages_disabled: 'mensagens desativadas', booking_link_missing: 'a campanha não tem link de agendamento', missing: 'estúdio ou sequência não existe mais' },
			},
			settings: {
				title: 'Mensagens aos estúdios',
				hint: 'Configurações dos e-mails escritos um a um para os estúdios desta campanha (abas Leads e Mensagens).',
				schedulingUrl: 'Link de agendamento', schedulingUrlHint: 'Usado pela variável do link de agendamento nas mensagens. Sem ele, as mensagens que a usam não podem ser enviadas.',
				approvalMode: 'Aprovação', approvalModeHint: 'Se o cliente aprova cada mensagem antes de sair.',
				modes: { none: 'A equipe envia', client: 'O cliente aprova antes' },
				dailyCap: 'Limite diário', dailyCapHint: 'Mensagens que podem sair por dia (1 a 2000).',
				enabled: 'A equipe pode escrever mensagens aos estúdios', visibleToClient: 'O cliente vê o conteúdo e o status das mensagens no relatório',
			},
		},
		materials: {
			hint: 'Links, arquivos, vídeos e textos para os representantes do estande estudarem antes e durante o evento. Eles recebem assim que são convidados, mesmo antes da campanha ficar ativa. Publicar envia um e-mail uma vez.',
			kinds: { link: 'Link', video: 'Vídeo', text: 'Texto', file: 'Arquivo' },
			fieldTitle: 'Título', fieldDescription: 'Descrição curta (opcional)', fieldBody: 'Texto que os representantes vão ler', fieldFile: 'Arquivo (PDF, Word, PowerPoint, Excel ou imagem, até 25 MB)',
			publishNow: 'Publicar agora e avisar os representantes por e-mail', add: 'Adicionar', saveChanges: 'Salvar alterações', cancel: 'Cancelar', empty: 'Nenhum material ainda.',
			published: 'Publicado', draft: 'Rascunho', studiedBy: '{n} de {total} estudaram', byCompany: 'adicionado pela empresa',
			edit: 'Editar', publish: 'Publicar', unpublish: 'Despublicar', remove: 'Remover', confirmDelete: 'Remover "{title}"?',
			titleRequired: 'Dê um título.', fileRequired: 'Escolha um arquivo.', saved: 'Salvo.',
		},
		followup: {
			open: 'Enviar follow-up', title: 'Enviar um e-mail de follow-up aos estúdios', close: 'Fechar',
			hint: 'Escrito para a ocasião ou baseado em um modelo, enviado depois da confirmação e do lembrete automáticos. Estúdios que saíram da lista, disseram não ter interesse, já enviaram o jogo ou já são clientes nunca recebem. O cliente vê no relatório o que foi enviado e para quantos, nunca para quem.',
			history: 'Follow-ups anteriores', fromTemplate: 'a partir de um modelo', historyCounts: '{sent} enviados · {queued} na fila · {skipped} ignorados · {failed} com falha',
			sourceCustom: 'Escrever o texto', sourceTemplate: 'Usar um modelo', template: 'Modelo', subject: 'Assunto', body: 'Mensagem',
			bodyHint: 'Linhas em branco separam parágrafos. Variáveis: {{first_name}} {{studio_name}} {{game_project}} {{rep_name}} {{event}} {{client}}. Uma linha só com {{personal_link}} vira o botão "enviar meu jogo".',
			previewLanguage: 'Idioma', preview: 'Pré-visualizar', testEmail: 'Enviar teste para', sendTest: 'Enviar teste', testSent: 'E-mail de teste enviado.',
			recipients: 'Destinatários', selectEligible: 'Todos elegíveis', selectNone: 'Nenhum', reminderSent: 'lembrete já enviado',
			send: 'Enviar para {n} estúdios', confirm: 'Enviar este e-mail agora para {n} estúdios? Não dá para desfazer.', queued: '{n} e-mails na fila ({skipped} ignorados).',
			blockers: {
				not_interested: 'Sem interesse', pipeline_advanced: 'Já enviou o jogo', opted_out: 'Saiu da lista', no_consent: 'Sem consentimento', invalid_email: 'E-mail inválido',
				existing_client: 'Já é cliente', campaign_inactive: 'Campanha inativa', email_declined: 'Sem e-mail informado',
			},
		},
		debrief: {
			hint: 'Debrief opcional de cada representante ao fim da campanha: o que viram e ouviram no estande. Abre quando a campanha termina ou é marcada como concluída, nunca afeta pagamentos ou comissão e fica interno até você compartilhar com o cliente.',
			enable: 'Pedir um debrief aos representantes quando a campanha terminar', autoShare: 'Compartilhar novas respostas com o cliente por padrão', showRepName: 'Mostrar o nome do representante ao cliente',
			stateWaiting: 'Abre quando a campanha termina ou é marcada como concluída, o que vier primeiro.', stateOpen: 'Aberto desde {date}. Os representantes foram avisados e recebem dois lembretes.', stateClosed: 'Encerrado em {date}. Ninguém pode editar.',
			close: 'Encerrar debrief', reopen: 'Reabrir debrief', remind: 'Lembrar pendentes', reminded: 'Lembrete enviado a {n} representante(s).',
			progress: '{n} de {total} entregues', questions: 'Perguntas', kind: 'Tipo de pergunta', kinds: { text: 'Texto', rating: 'Nota de 1 a 5', choice: 'Escolha única' },
			prompt: 'Pergunta', options: 'Uma opção por linha (2 a 8)', add: 'Adicionar pergunta', delete: 'Excluir', promptRequired: 'Escreva a pergunta.', optionsRequired: 'Informe pelo menos 2 opções, uma por linha.',
			responses: 'Respostas', noReps: 'Ainda não há representantes nesta campanha.', statuses: { submitted: 'Enviado', draft: 'Rascunho', none: 'Não começou' },
			share: 'Compartilhar com o cliente', shareAll: 'Compartilhar tudo', shareNone: 'Não compartilhar nada', copyLink: 'Copiar link do debrief', linkCopied: 'Link do debrief copiado.', reset: 'Limpar e pedir de novo', resetConfirm: 'Limpar o debrief de {name}? As respostas e os anexos serão apagados de vez, o debrief será reaberto e a pessoa receberá um e-mail para preencher de novo.', resetDone: 'Debrief limpo e o representante foi avisado para preencher de novo.', photo: 'Foto', audio: 'Nota de voz',
			directNote: 'Esta campanha foi montada pela própria equipe do cliente: os debriefs vão direto para eles, sem revisão nem envio.',
			reviewNote: 'Você revisa primeiro. O cliente só lê o que você marcou como compartilhado, e só depois de você enviar.',
			sharedCounts: '{answers} resposta(s) e {media} anexo(s) marcados como compartilhados.', release: 'Enviar ao cliente', releaseAgain: 'Reenviar o aviso', withdraw: 'Retirar do cliente',
			releasedAt: 'Enviado ao cliente em {date}. Ele lê no relatório o que está marcado como compartilhado.', releaseConfirm: 'Enviar o debrief ao cliente agora? Ele receberá um e-mail e poderá ler o que está marcado como compartilhado.',
			releaseNeedsShare: 'Marque pelo menos uma resposta ou anexo como compartilhado para habilitar o envio.',
			released: 'Enviado ao cliente.', releasedNoMail: 'Liberado no relatório, mas o cliente não tem e-mail de relatório cadastrado, então ninguém foi avisado.',
		},
		tabAccess: 'Pedidos de acesso',
		accessHint: 'Pessoas que abriram o link público do relatório e pediram a visão completa (contato, e-mails, notas de voz, CSV). Aprovar libera esse e-mail, depois de entrar com ele, para ver tudo.',
		accessEmpty: 'Nenhum pedido ainda.',
		accessWho: 'Quem',
		accessMessage: 'Mensagem',
		accessStatus: 'Situação',
		accessApprove: 'Aprovar',
		accessDeny: 'Negar',
		accessStatuses: { pending: 'Pendente', approved: 'Aprovado', denied: 'Negado' },
		accessDecided: { approved: '{email} agora vê o relatório completo ao entrar.', denied: 'Pedido de {email} negado.', pending: 'Pedido reaberto.' },
		linksDestination: 'Destino atual',
		linksDestinationHint: 'Para trocar, edite a URL de destino na aba Campanha e salve: todos os QR e links passam a usar a nova URL na hora.',
		linksCard: 'Links do cartão impresso',
		linksCardHint: 'Um por representante, para a leitura ser atribuída a ele. Use para gerar o QR do cartão.',
		linksGeneral: 'Geral (sem representante)',
	},
	prospectEmailTemplates: {
		title: 'Templates de E-mail para Prospectos',
		newTitle: 'Novo Template de E-mail',
		editTitle: 'Editar Template de E-mail',
		new: 'Novo Template',
		filterName: 'Buscar por nome',
		filterPurpose: 'Propósito',
		filterActive: 'Status',
		colName: 'Nome',
		colSlug: 'Slug',
		colPurpose: 'Propósito',
		colSubject: 'Assunto',
		colActive: 'Ativo',
		fieldName: 'Nome do Template',
		fieldSlug: 'Slug (único, imutável após criação)',
		slugHint: 'Letras minúsculas, números e hífens',
		fieldPurpose: 'Propósito',
		fieldSubject: 'Assunto (padrão EN)',
		fieldFromEmail: 'E-mail de Envio',
		fieldFromName: 'Nome do Remetente',
		fieldHasDiscount: 'Suporta desconto',
		fieldIsActive: 'Ativo',
		fieldRequiresUpcomingRelease: 'Assume lançamento futuro',
		fieldRequiresUpcomingReleaseHint: 'Esse texto promete um lançamento futuro ("encontramos vocês nos lançamentos futuros da Steam"). O envio fica bloqueado para qualquer prospect cujo jogo já foi lançado.',
		tabContent: 'Conteúdo',
		tabTranslate: 'Traduções',
		tabSubject: 'Assunto',
		tabBody: 'Body HTML',
		tabPreview: 'Preview',
		availableVars: 'Variáveis disponíveis (clique para copiar):',
		varCopied: 'copiado',
		deleteTitle: 'Excluir Template',
		deleteConfirm: 'Tem certeza que deseja excluir',
		deleted: 'Template excluído.',
		created: 'Template criado.',
		updated: 'Template atualizado.',
		translationsSaved: 'Traduções salvas.',
		purposes: {
			showcase:           'Showcase',
			relationship:       'Relacionamento',
			content_commission: 'Comissão de Conteúdo',
			key_distribution:   'Distribuição de Chaves',
			pr_service:         'Serviço de PR',
			ventures:           'Ventures',
			jobs:               'Vagas / Jobs',
			field_activation_confirmation: 'Ativação: confirmação',
			field_activation_reminder: 'Ativação: lembrete',
			field_activation_daily_summary: 'Ativação: resumo diário',
			field_activation_strong_fit: 'Ativação: lead quente',
		},
	},

	errorOccurred: 'Ocorreu um erro. Tente novamente.',

	token: {
		sale: {
			menu: 'Venda de Token',
			round: 'Rodada',
			distribution: {
				title: 'Distribuição do token',
				bucket: 'Bucket',
				add: 'Adicionar bucket',
				sum_warning: 'As alocações devem somar 100%.',
			},
			onchain: {
				title: 'On-chain (ao vivo)',
				symbol: 'Símbolo',
				decimals: 'Decimais',
				total_supply: 'Supply total',
				match: 'O supply configurado bate com o contrato.',
				mismatch: 'O supply total configurado difere do valor on-chain.',
				unavailable: 'Dados on-chain indisponíveis no momento.',
			},
			list: {
				title: 'Rodadas de venda de token',
				subTitle: 'Configure as rodadas da pré-ICO, tokenomics e whitelist.',
				confirmDeactivate: 'Tem certeza que deseja desativar {item}?',
				deactivated: 'Rodada desativada.',
			},
			create: { title: 'Criar rodada' },
			update: { title: 'Editar rodada' },
			fields: {
				slug: 'Slug',
				price: 'Preço previsto (USD)',
				total_supply: 'Supply total',
				offered: 'Tokens ofertados',
				soft_cap: 'Soft cap',
				hard_cap: 'Hard cap',
				whitelist_cap: 'Vagas na whitelist',
				whitelist: 'Whitelist',
				starts_at: 'Início',
				ends_at: 'Fim',
				contract: 'Endereço do contrato',
				chain_id: 'Chain ID',
				vesting: 'Vesting',
				tge_percent: 'Desbloqueio no TGE (%)',
				cliff_months: 'Cliff (meses)',
				linear_months: 'Vesting linear (meses)',
			},
			status: {
				coming_soon: 'Em breve',
				whitelist: 'Whitelist',
				sale_open: 'Venda aberta',
				paused: 'Pausada',
				closed: 'Encerrada',
			},
			entry_status: {
				registered: 'Registrado',
				approved: 'Aprovado',
				waitlisted: 'Lista de espera',
				rejected: 'Rejeitado',
			},
			entries: {
				title: 'Whitelist',
				subTitle: 'Gerencie as inscrições e exporte os endereços ETH capturados.',
				export: 'Exportar CSV',
				position: 'Posição',
				user: 'Usuário',
				country: 'País',
				intended: 'Intenção (USD)',
				referral_code: 'Código de indicação',
				referred_by: 'Indicado por',
			},
		},
	},

	mgCity: {
		loading: 'Carregando... Aguarde',
		loadError: 'Falha ao carregar os dados',
		saveError: 'Falha ao salvar',
		deleteError: 'Falha ao excluir',
		jsonHint: 'Objeto JSON opcional',
		jsonInvalid: 'JSON inválido',
		active: 'Ativo',
		inactive: 'Inativo',
		menu: {
			group: 'Mundo Gamer City',
			districts: 'Distritos',
			npcs: 'NPCs',
			features: 'Funcionalidades',
			missions: 'Missões',
			coinSpawns: 'Pontos de Moedas',
			easterEggs: 'Easter Eggs',
			seasonalEvents: 'Eventos Sazonais',
			profiles: 'Perfis',
			dialogues: 'Diálogos',
			texts: 'Textos do Jogo',
			analytics: 'Analytics',
			settings: 'Configurações',
		},
		tabs: {
			general: 'Geral',
			narrative: 'Cadeia de itens narrativos',
			coinSpawns: 'Pontos de moedas',
			translations: 'Traduções',
		},
		fields: {
			slug: 'Slug',
			title: 'Título',
			platform: 'Plataforma',
			platformId: 'ID da plataforma (vazio = Global)',
			xpReward: 'Recompensa de XP',
			sortOrder: 'Ordem',
			status: 'Status',
			active: 'Ativo',
			tagline: 'Tagline',
			introText: 'Texto de introdução',
			completionText: 'Texto de conclusão',
			interiorTemplate: 'Template do interior',
			startsAt: 'Começa em',
			endsAt: 'Termina em',
			seasonalWindow: 'Janela sazonal',
			mood: 'Clima (iluminação do interior)',
			layoutConfig: 'Configuração de layout (JSON)',
			grantsItemSlug: 'Slug do item concedido',
			grantsItemIcon: 'Ícone do item concedido',
			itemName: 'Nome do item',
			requiresItem: 'Slug do item necessário',
			district: 'Distrito',
			role: 'Papel',
			slotKey: 'Slot',
			npcTitle: 'Título do NPC',
			sprite: 'Sprite',
			profileConditions: 'Condições de perfil (JSON)',
			ctaLabel: 'Rótulo do CTA',
			screenshotUrl: 'URL da captura de tela',
			ctaUrl: 'URL do CTA',
			ctaPath: 'Caminho',
			ctaConversion: 'CTA de conversão',
			ctaKind: 'Tipo de CTA',
			interestTags: 'Tags de interesse',
			icon: 'Ícone',
		},
		districts: {
			title: 'Distritos da Cidade',
			subtitle: 'Gerencie os distritos do Mundo Gamer City, sua narrativa e janelas sazonais',
			new: 'Novo Distrito',
			update: 'Atualizar Distrito',
			narrative: 'Narrativa',
			narrativeHint: 'Concluir este distrito pode conceder um item narrativo, e entrar nele pode exigir um item concedido por outro distrito.',
			grants: 'Concede',
			requires: 'Exige',
			grantsItem: 'Item concedido na conclusão',
			requiresItem: 'Item necessário para entrar',
		},
		coinSpawns: {
			title: 'Pontos de Moedas da Cidade',
			subtitle: 'Visão geral de todos os pontos de moedas por distrito — edite-os dentro de cada distrito',
			hint: 'Pontos de moedas deste distrito. Use count na posição para áreas.',
			spawnKey: 'Chave do ponto',
			value: 'Valor',
			position: 'Posição',
		},
		npcs: {
			title: 'NPCs da Cidade',
			subtitle: 'Gerencie os personagens que povoam os distritos',
			new: 'Novo NPC',
			update: 'Atualizar NPC',
		},
		features: {
			title: 'Funcionalidades da Cidade',
			subtitle: 'Gerencie as funcionalidades exibidas dentro dos distritos',
			new: 'Nova Funcionalidade',
			update: 'Atualizar Funcionalidade',
		},
		missions: {
			title: 'Missões da Cidade',
			subtitle: 'Gerencie as missões e seus objetivos por distrito',
			new: 'Nova Missão',
			update: 'Atualizar Missão',
			type: 'Tipo',
			coinReward: 'Recompensa em moedas',
			required: 'Obrigatória para conclusão',
			objective: 'Objetivo',
			objectiveHint: 'Campos de objetivo para o tipo de missão:',
			npcSlugs: 'Slugs de NPC',
			coinCount: 'Moedas a coletar',
			featureCount: 'Funcionalidades a visitar',
			featureSlugs: 'Slugs específicos (opcional)',
			minCorrect: 'Mín. de respostas corretas',
			question: 'Pergunta',
			options: 'Opções',
			answer: 'Resposta',
			addQuestion: 'Adicionar pergunta',
			itemKey: 'Chave do item',
			propInteract: 'Interação com prop',
			propKind: 'Tipo de prop',
			customObjective: 'Objetivo customizado (JSON)',
			selectTypeFirst: 'Selecione um tipo de missão na aba Geral primeiro.',
			gamificationMissionId: 'ID da missão de gamificação (opcional)',
			gamificationAchievementId: 'ID da conquista de gamificação (opcional)',
		},
		mood: {
			default: 'Padrão (tema)',
			warm: 'Quente',
			cool: 'Frio',
			neon: 'Neon',
			dim: 'Escuro',
		},
		easterEggs: {
			title: 'Easter Eggs da Cidade',
			subtitle: 'Gerencie segredos escondidos e seus gatilhos',
			new: 'Novo Easter Egg',
			update: 'Atualizar Easter Egg',
			coinReward: 'Recompensa em moedas',
			achievementId: 'ID da conquista',
			hint: 'Dica',
			revealText: 'Texto de revelação',
			trigger: 'Gatilho',
			secret: 'Secreto',
			triggerKind: 'Tipo de gatilho',
			kindNone: 'Nenhum',
			kindX: 'Posição (X)',
			kindInteract: 'Interação',
			kindSecretDoor: 'Porta secreta',
			triggerX: 'Posição X',
			triggerXOptional: 'Posição X (opcional)',
			triggerRadius: 'Raio (px, opcional)',
			triggerFloor: 'ID do andar (opcional)',
			triggerTargetId: 'ID do alvo (NPC, prop ou decoração)',
			triggerCount: 'Interações necessárias (opcional)',
			advancedJson: 'JSON avançado',
			advancedOnly: 'Este JSON de gatilho é inválido ou usa um tipo desconhecido — edite no modo avançado.',
			triggerIncomplete: 'Preencha os campos obrigatórios do gatilho (posição X / ID do alvo).',
		},
		seasonalEvents: {
			title: 'Eventos Sazonais da Cidade',
			subtitle: 'Gerencie janelas sazonais e sobrescritas de conteúdo',
			new: 'Novo Evento Sazonal',
			update: 'Atualizar Evento Sazonal',
			overrides: 'Sobrescritas (JSON)',
		},
		profiles: {
			title: 'Perfis da Cidade',
			subtitle: 'Gerencie os perfis de visitante e suas jornadas recomendadas',
			new: 'Novo Perfil',
			update: 'Atualizar Perfil',
			journey: 'Jornada recomendada',
			journeyHint: 'Arraste para reordenar os distritos que um visitante com este perfil deve seguir.',
			introNpcId: 'ID do NPC de introdução',
			recommendationText: 'Texto de recomendação',
		},
		dialogues: {
			title: 'Diálogos da Cidade',
			subtitle: 'Gerencie as árvores de diálogo dos NPCs',
			new: 'Novo Diálogo',
			update: 'Atualizar Diálogo',
			npc: 'NPC',
			npcId: 'ID do NPC',
			editTree: 'Editar árvore',
		},
		dialogueEditor: {
			title: 'Árvore de Diálogo',
			backToList: 'Voltar à lista',
			saveTree: 'Salvar árvore',
			addRootNode: 'Adicionar nó raiz',
			selectNode: 'Selecione um nó à esquerda ou adicione um novo.',
			nodeKey: 'Chave do nó',
			nodeType: 'Tipo',
			speaker: 'Falante',
			parent: 'Nó pai',
			text: 'Texto',
			action: 'Ação',
			actionType: 'Tipo de ação',
			missionSlug: 'Slug da missão',
			featureSlug: 'Slug da funcionalidade',
			coinAmount: 'Quantidade de moedas',
			flag: 'Flag',
			ctaLabel: 'Rótulo do CTA',
			conditions: 'Condições (JSON)',
			addChild: 'Adicionar nó filho',
			deleteNode: 'Excluir nó (e filhos)',
			duplicateKeys: 'As chaves dos nós devem ser únicas e não vazias.',
		},
		settings: {
			title: 'Configurações do Mundo Gamer City',
			subtitle: 'Estatísticas manuais de marketing exibidas na introdução da cidade e URL do convite do Discord da comunidade',
			statsHint: 'Estes números ainda não têm fonte de dados ao vivo — mantenha-os atualizados manualmente. 0 oculta a estatística.',
			candidates: 'Candidatos ajudados',
			gamesTracked: 'Jogos monitorados',
			keysDistributed: 'Chaves distribuídas',
			pressKits: 'Press kits criados',
			playtesters: 'Playtesters',
			certificates: 'Certificados emitidos',
			discordUrl: 'URL do convite do Discord',
			discordHint: 'Usada por futuros seeds narrativos e consumidores em tempo de execução. Nós de diálogo já criados mantêm a URL registrada na época.',
		},
		analytics: {
			title: 'Analytics do Mundo Gamer City',
			from: 'De',
			to: 'Até',
			refresh: 'Atualizar',
			unavailable: 'Os endpoints de analytics ainda não estão disponíveis neste ambiente da API.',
			funnel: 'Funil de visitantes',
			districtDropOff: 'Abandono por distrito',
			ctaClicks: 'Cliques em CTA',
			noData: 'Sem dados para este período',
			sessionsTotal: 'Sessões',
			sessionsCompleted: 'Concluídas',
			sessionsClaimed: 'Resgatadas',
			coinsCollected: 'Moedas coletadas',
			leadsCaptured: 'Leads capturados',
			ctaClicksTotal: 'Cliques em CTA',
			conversionCtaClicks: 'Cliques em CTA de conversão',
			sessions: 'Sessões',
			entered: 'Entraram',
			completed: 'Concluíram',
			eventType: 'Evento',
			subject: 'Assunto',
			clicks: 'Cliques',
		},
		texts: {
			title: 'Textos do Jogo',
			subtitle: 'Revise e edite todos os textos do Mundo Gamer City em todos os idiomas',
			contentType: 'Tipo de conteúdo',
			missingLocale: 'Idioma faltando',
			type: 'Tipo',
			attribute: 'Atributo',
			enText: 'Texto EN',
			global: 'Global',
			baseText: 'Texto base (EN)',
			chars: 'caracteres',
			dialogueLengthWarning: 'O texto do diálogo está ficando longo — considere reduzi-lo para melhor leitura no jogo.',
			types: {
				district: 'Distrito',
				npc: 'NPC',
				dialogue_node: 'Diálogo',
				feature: 'Funcionalidade',
				mission: 'Missão',
				profile: 'Perfil',
				easter_egg: 'Easter Egg',
			},
		},
	},
	aiAgents: {
		menu: {
			group: 'MG AI',
			runs: 'Execuções de Agentes',
			agents: 'Agentes',
			settings: 'Configurações',
		},
		loading: 'Carregando... Aguarde',
		status: {
			queued: 'Na fila',
			running: 'Em execução',
			pending_approval: 'Aguardando aprovação',
			completed: 'Concluída',
			failed: 'Falhou',
			rejected: 'Rejeitada',
			cancelled: 'Cancelada',
		},
		runs: {
			title: 'Execuções de Agentes de IA',
			subtitle: 'Monitore e modere as execuções dos agentes de IA na plataforma',
			openDetail: 'Abrir detalhes',
			filters: {
				status: 'Status',
				agent: 'Agente',
				userId: 'ID do usuário',
			},
			columns: {
				id: 'ID',
				agent: 'Agente',
				userId: 'ID do usuário',
				status: 'Status',
				tokens: 'Tokens (entrada/saída)',
				steps: 'Etapas',
				createdAt: 'Criada em',
				finishedAt: 'Finalizada em',
			},
		},
		detail: {
			title: 'Execução do Agente',
			agent: 'Agente',
			user: 'ID do usuário',
			tokens: 'Tokens (entrada/saída)',
			startedAt: 'Iniciada em',
			finishedAt: 'Finalizada em',
			input: 'Entrada',
			output: 'Saída',
			steps: 'Etapas',
			noSteps: 'Nenhuma etapa registrada para esta execução.',
			payload: 'Payload',
			result: 'Resultado',
			approve: 'Aprovar',
			reject: 'Rejeitar',
			cancel: 'Cancelar',
			notFound: 'Execução não encontrada.',
			actionError: 'Não foi possível concluir a ação. Tente novamente.',
			confirm: {
				approve: 'Tem certeza de que deseja aprovar esta execução? O agente retomará o processamento.',
				reject: 'Tem certeza de que deseja rejeitar esta execução? O processamento será encerrado.',
				cancel: 'Tem certeza de que deseja cancelar esta execução?',
			},
			success: {
				approve: 'Execução aprovada com sucesso',
				reject: 'Execução rejeitada com sucesso',
				cancel: 'Execução cancelada com sucesso',
			},
		},
		agents: {
			title: 'Agentes de IA',
			subtitle: 'Gerencie os agentes de IA registrados e sua disponibilidade',
			internal: 'Interno',
			public: 'Público',
			active: 'Ativo',
			inactive: 'Inativo',
			enabled: 'Agente ativado com sucesso',
			disabled: 'Agente desativado com sucesso',
			toggleError: 'Não foi possível atualizar o status do agente. Tente novamente.',
			confirmDisable: 'Tem certeza de que deseja desativar o agente {item}? Novas execuções serão bloqueadas até que ele seja ativado novamente.',
			filters: {
				status: 'Status',
				internal: 'Visibilidade',
			},
			columns: {
				modelCode: 'Modelo',
				version: 'Versão',
				internal: 'Visibilidade',
				tools: 'Ferramentas',
				status: 'Status',
				createdAt: 'Criado em',
			},
		},
	},
	esignature: {
		title: 'Assinaturas eletrônicas MGN',
		newDocument: 'Novo documento',
		createTitle: 'Novo envelope de assinatura',
		signers: 'Signatários',
		addSigner: 'Adicionar signatário',
		createDraft: 'Criar rascunho',
		required: 'Obrigatório',
		enhancedRiskWarning: 'O envio ficará bloqueado até a implantação e ativação do WebAuthn e da revisão de identidade.',
		qualifiedWarning: 'Este documento será classificado para assinatura qualificada externa e não poderá ser enviado pelo fluxo interno.',
		created: 'Envelope criado.',
		invitationsSent: 'Convites enviados.',
		remindersSent: 'Lembretes enviados.',
		operationFailed: 'Não foi possível concluir a operação.',
		fields: { title: 'Título', system: 'Sistema', risk: 'Risco', legalMethod: 'Método jurídico', htmlContent: 'Conteúdo HTML congelável', legalName: 'Nome legal', email: 'E-mail', createdAt: 'Criado em' },
		risk: { low: 'Baixo — OTP por e-mail', medium: 'Médio — requer WebAuthn', high: 'Alto — WebAuthn e revisão' },
		legal: { private: 'Assinatura eletrônica privada', qualified: 'Assinatura qualificada externa' },
		actions: { send: 'Enviar', remind: 'Lembrar', evidence: 'Evidência' },
		statuses: { draft: 'Rascunho', sent: 'Enviado', partially_signed: 'Parcialmente assinado', completed: 'Concluído', cancelled: 'Cancelado', voided: 'Invalidado' },
	},
	aiSettings: {
		title: 'Configurações da Plataforma de IA',
		subtitle: 'Ajustes de comportamento em tempo real da plataforma de IA — aplicados imediatamente, sem deploy',
		enabled: 'Configuração ativada com sucesso',
		disabled: 'Configuração desativada com sucesso',
		toggleError: 'Não foi possível atualizar a configuração. Tente novamente.',
		confirmEnable: 'Tem certeza de que deseja ativar {item}? A alteração terá efeito imediato.',
		model: {
			label: 'Modelo de linguagem das traduções',
			useSender: 'Usar o modelo que o remetente pedir',
			hint: 'Vale também para traduções que já estão na fila. Se o modelo escolhido ficar inativo ou perder a credencial do provedor, as traduções voltam ao modelo do remetente.',
			confirmSet: 'As próximas traduções da Comunidade vão usar {model}.',
			confirmClear: 'As próximas traduções da Comunidade voltarão a usar o modelo que o remetente pedir.',
			confirmChange: 'Anterior: {from}. Novo: {to}.',
			costWarning: 'Isso muda qual modelo é cobrado, então pode afetar o custo, e também vale para traduções que já estão na fila.',
			updated: 'Modelo de tradução atualizado com sucesso',
			loadError: 'Não foi possível carregar a lista de modelos de linguagem.',
		},
		columns: {
			setting: 'Configuração',
			value: 'Valor',
			updatedAt: 'Atualizado em',
		},
	},
	reviewDistribution: {
		subtitle: 'Gerencie a distribuição das avaliações no Steam, OpenCritic e Metacritic.',
		search: 'Buscar por jogo', selectedCount: '{count} selecionado(s)', empty: 'Nenhuma distribuição encontrada.',
		cancel: 'Cancelar', save: 'Salvar', copied: 'Texto do Steam copiado.', copyFailed: 'Não foi possível copiar o texto do Steam.',
		actionFailed: 'Não foi possível concluir a ação. Tente novamente.',
		fields: { game: 'Jogo', score: 'Nota', locale: 'Idioma', publishedAt: 'Publicado em' },
		cards: { total: 'Total', steamPending: 'Steam pendente', opencriticPending: 'OpenCritic pendente', opencriticFailed: 'OpenCritic falhou', metacriticPending: 'Metacritic pendente' },
		steam: { title: 'Steam', bulkCopy: 'Copiar texto do Steam', bulkMarkDrafted: 'Marcar Steam como rascunhado', bulkMarkSkipped: 'Ignorar na Steam', queue: 'Fila da Steam (mais antigas primeiro)', openStore: 'Abrir na Steam', bulkMarkPosted: 'Marcar Steam como publicado', copy: 'Copiar', markPosted: 'Marcar como publicado', status: { pending: 'Pendente', drafted: 'Rascunhado', posted: 'Publicado', skipped: 'Ignorado' } },
		opencritic: { title: 'OpenCritic', bulkRetry: 'Tentar OpenCritic novamente', retry: 'Tentar novamente', status: { pending: 'Pendente', submitted: 'Enviado', failed: 'Falhou', skipped: 'Ignorado' } },
		metacritic: { title: 'Metacritic', update: 'Atualizar', dialogTitle: 'Atualizar status do Metacritic', note: 'Observação', status: { pending: 'Pendente', pitched: 'Proposto', accepted: 'Aceito', rejected: 'Rejeitado' } },
	},
	AdminTasks: { title: 'Tarefas', myDay: 'Meu dia', newTask: 'Nova tarefa', editTask: 'Editar tarefa', focus: 'Foco de hoje', pending: '{count} pendentes', today: 'Para hoje', overdue: 'Atrasadas', open: 'Em aberto', completedToday: 'Concluídas hoje', subtitle: 'Seu espaço pessoal para organizar o trabalho da plataforma.', empty: 'Tudo em dia. Aproveite o ritmo.', titleField: 'Título', description: 'Descrição', attachment: 'Anexo', priority: 'Prioridade', status: 'Status', project: 'Projeto', assignee: 'Responsável', start: 'Início', due: 'Prazo final', cancel: 'Cancelar', save: 'Salvar', saving: 'Salvando...', requiredTitle: 'Título obrigatório', uploadError: 'Não foi possível enviar o anexo.', saveError: 'Não foi possível salvar a tarefa.', statuses: { open: 'Aberta', in_progress: 'Em andamento', done: 'Concluída', cancelled: 'Cancelada' }, priorities: { low: 'Baixa', medium: 'Média', high: 'Alta', urgent: 'Urgente' } },
	ShowcasePrivateInvites: { title: 'Showcase — Convites Privados', subtitle: 'Fluxo independente do onboarding', linkNotice: 'O link gerado funciona somente para o Showcase atual.', contactName: 'Nome da pessoa', contactEmail: 'E-mail (opcional)', studioName: 'Nome do estúdio', gameName: 'Nome do jogo', mode: 'Modalidade', modeFullPrice: 'Valor integral', modePartnerDiscount: 'Parceiro — 50%', modePartnerHint: 'O pacote mais barato entre os selecionados abaixo fica grátis; os demais têm 50% de desconto. Não acumula com outros cupons.', modeFullPriceHint: 'Preço integral. O estúdio pode usar cupons existentes.', expiresAt: 'Validade', expiresAtRequired: 'Defina uma data de validade.', expiresAtPast: 'A data de validade não pode ser no passado.', converted: 'Convertido', inviteLocale: 'Idioma do convite e do e-mail', availableBundles: 'Pacotes disponíveis neste convite', availableBundlesHint: 'Desmarque um pacote (ex: um que não deve mais ser oferecido) para excluí-lo só deste convite. Deixe todos marcados para usar o catálogo padrão.', create: 'Gerar convite privado', copyLink: 'Copiar link', sendAndPreview: 'Enviar e ver corpo', delete: 'Excluir', bodyDialogTitle: 'Corpo enviado', close: 'Fechar', confirmSendTitle: 'Enviar convite por e-mail?', confirmSendText: 'Convite criado. Enviar agora para {email}?', notNow: 'Agora não', send: 'Enviar', createdSuccess: 'Convite privado criado.', createdError: 'Não foi possível criar o convite.', linkCopied: 'Link copiado.', linkCopyError: 'Não foi possível copiar o link.', sentSuccess: 'E-mail enviado e registrado nos logs.', deleteConfirm: 'Excluir o convite de "{name}" ({game})? O link para de funcionar imediatamente.', deletedSuccess: 'Convite excluído.', deletedError: 'Não foi possível excluir o convite.' },
	GameJams: {
		title: 'Revisão de game jams',
		subtitle: 'Jams públicas criadas pela comunidade esperam aqui antes de aparecerem no site. Você também aprova prêmios que usam recursos da plataforma.',
		empty: 'Nenhuma jam neste filtro.',
		columns: { title: 'Jam', organizer: 'Organizador', visibility: 'Visibilidade', review: 'Revisão', sent: 'Enviada para revisão', dates: 'Datas' },
		filters: { pending: 'Aguardando revisão', approved: 'Aprovadas', rejected: 'Recusadas', all: 'Todas as jams da comunidade' },
		review: { not_submitted: 'Não enviada', pending: 'Aguardando', approved: 'Aprovada', rejected: 'Recusada' },
		visibility: { public: 'Pública', private: 'Privada' },
		status: { draft: 'Rascunho', published: 'Publicada', archived: 'Arquivada', suspended: 'Suspensa' },
		actions: { details: 'Detalhes', approve: 'Aprovar', reject: 'Recusar' },
		reject: { title: 'Recusar esta jam', note: 'Recado para o organizador (opcional)', confirm: 'Recusar' },
		detail: { description: 'Descrição', rules: 'Regras', prizes: 'Prêmios', noPrizes: 'Nenhum prêmio ainda.', note: 'Nota da revisão' },
		prize: {
			approved: 'Aprovado', pending: 'Precisa de aprovação', approve: 'Aprovar', withdraw: 'Retirar aprovação',
			funded: 'Lastro confirmado', unfunded: 'Lastro não confirmado', confirmFunding: 'Confirmar lastro', removeFunding: 'Remover lastro',
			draft: 'Rascunho', confirmed: 'Confirmado', ownResources: 'Usa recursos da plataforma',
		},
		done: { approve: 'Jam aprovada e publicada.', reject: 'Jam recusada.', prize: 'Prêmio atualizado.' },
		errors: { generic: 'Não foi possível concluir. Tente de novo.' },
		sponsors: {
			title: 'Patrocinadores de game jams',
			subtitle: 'Marcas cadastradas pela comunidade. Uma marca aprovada pode ser vinculada a jams com o selo de verificado.',
			filters: { pending: 'Aguardando aprovação', approved: 'Aprovados', rejected: 'Não aprovados', suspended: 'Suspensos', all: 'Todos' },
			columns: { brand: 'Marca', owner: 'Cadastrada por', status: 'Situação', jams: 'Em jams', sent: 'Enviada' },
			status: { pending: 'Aguardando', approved: 'Aprovado', rejected: 'Não aprovado', suspended: 'Suspenso' },
			actions: { approve: 'Aprovar', reject: 'Recusar', suspend: 'Suspender' },
			reject: { title: 'Recusar este patrocinador', note: 'Recado para o responsável (opcional)', confirm: 'Recusar' },
			done: { approve: 'Patrocinador aprovado.', reject: 'Patrocinador recusado.', suspend: 'Patrocinador suspenso.' },
		},
	},
	GameJamsAdmin: {
		yes: 'Sim',
		no: 'Não',
		errors: {
			generic: 'Não foi possível concluir. Tente de novo.',
		},
		overview: {
			title: 'Game jams: visão geral',
			subtitle: 'O que precisa da atenção da plataforma e como estão as jams.',
			queue: 'Precisa da sua atenção',
			reviews_pending: 'Jams aguardando revisão',
			reports_open: 'Denúncias abertas',
			prizes_to_approve: 'Prêmios para aprovar',
			awards_to_deliver: 'Prêmios para entregar',
			results_to_publish: 'Resultados para publicar',
			jams: 'Jams',
			featured: 'Em destaque',
			phasesTitle: 'Jams publicadas por fase',
			participation: 'Participação',
			registrations: 'Inscrições aprovadas',
			registrations_pending: 'Inscrições aguardando aprovação',
			payments_awaiting: 'Pagamentos aguardando',
			refunds_pending: 'Reembolsos pendentes',
		},
		list: {
			title: 'Todas as game jams',
			subtitle: 'Todas as jams da rede, as da plataforma e as da comunidade. Abra uma para ver tudo e gerenciar.',
			search: 'Buscar por título ou slug',
			empty: 'Nenhuma jam com esses filtros.',
			reports: '{n} denúncia(s)',
			filters: {
				all: 'Todos',
				status: 'Status',
				review_status: 'Revisão',
				origin: 'Origem',
				visibility: 'Visibilidade',
				phase: 'Fase',
				featured: 'Só em destaque',
				reported: 'Com denúncias abertas',
			},
			columns: {
				title: 'Jam',
				origin: 'Origem / organizador',
				status: 'Status',
				phase: 'Fase',
				counts: 'Inscrições / equipes / jogos',
				starts: 'Começa',
			},
		},
		origin: {
			platform: 'Plataforma',
			community: 'Comunidade',
		},
		visibility: {
			public: 'Pública',
			private: 'Privada',
		},
		status: {
			draft: 'Rascunho',
			published: 'Publicada',
			suspended: 'Suspensa',
			archived: 'Arquivada',
		},
		phase: {
			scheduled: 'Em breve',
			registration: 'Inscrições abertas',
			running: 'Acontecendo',
			judging: 'Votação',
			closed: 'Apurando votos',
			results: 'Resultados',
			draft: 'Rascunho',
			archived: 'Arquivada',
			suspended: 'Suspensa',
		},
		review: {
			not_submitted: 'Não enviada',
			pending: 'Aguardando revisão',
			approved: 'Aprovada',
			rejected: 'Rejeitada',
		},
		actions: {
			open: 'Abrir',
			approve: 'Aprovar',
			reject: 'Rejeitar',
			suspend: 'Suspender',
			reactivate: 'Reativar',
			feature: 'Destacar',
			unfeature: 'Tirar do destaque',
			archive: 'Arquivar',
			delete: 'Excluir',
			edit: 'Editar',
		},
		dialogs: {
			suspendTitle: 'Suspender esta jam',
			suspendHelp: 'A jam sai do ar: some do site e do app, e inscrições, jogos e votos param. Nada é apagado. O organizador é avisado do motivo.',
			reason: 'Motivo (o organizador vai ler)',
			reasonOptional: 'Motivo (opcional, o organizador vai ler)',
			reasonRequired: 'Escreva o motivo.',
			note: 'Observação (opcional)',
			archiveTitle: 'Arquivar esta jam',
			archiveHelp: 'Arquivar encerra a jam de vez. O organizador é avisado.',
			deleteTitle: 'Excluir esta jam?',
			deleteHelp: 'Só dá para excluir uma jam sem participantes. Isso não pode ser desfeito.',
		},
		done: {
			approve: 'Jam aprovada.',
			reject: 'Jam rejeitada.',
			suspend: 'Jam suspensa.',
			reactivate: 'Jam de volta ao ar.',
			feature: 'Jam em destaque.',
			unfeature: 'Jam fora do destaque.',
			archive: 'Jam arquivada.',
			registration: 'Inscrição atualizada.',
			disqualify: 'Jogo desqualificado.',
			restore: 'Jogo restaurado.',
			rating: 'Avaliação atualizada.',
			prize: 'Prêmio atualizado.',
			awardCompute: 'Vencedores calculados.',
			awardConfirm: 'Prêmios confirmados.',
			awardDeliver: 'Entrega iniciada.',
			awardForfeit: 'Prêmio perdido.',
			results: 'Resultados publicados.',
			transfer: 'Propriedade transferida.',
			report: 'Denúncia resolvida.',
			edit: 'Jam salva.',
		},
		detail: {
			back: 'Todas as jams',
			notFound: 'Essa jam não foi encontrada.',
			suspendedNotice: 'Suspensa pela plataforma',
			reviewNote: 'Nota da revisão',
			tabs: {
				overview: 'Visão geral',
				registrations: 'Inscrições',
				teams: 'Equipes',
				entries: 'Jogos',
				judging: 'Jurados',
				prizes: 'Prêmios e resultados',
				staff: 'Organizadores',
				audit: 'Histórico',
			},
		},
		overviewTab: {
			about: 'Sobre esta jam',
			numbers: 'Números',
			checklist: 'Pronta para publicar?',
			checklistOk: 'Não falta nada.',
			announce: 'Mensagem para os participantes',
			announceLabel: 'Mensagem',
			announceSend: 'Enviar',
			announceDone: 'Enviada para {n} pessoa(s).',
			free: 'Gratuita',
			facts: {
				organizer: 'Organizador',
				theme: 'Tema',
				mode: 'Formato',
				languages: 'Idiomas',
				registration_opens_at: 'Inscrições abrem',
				registration_closes_at: 'Inscrições fecham',
				starts_at: 'A jam começa',
				submissions_close_at: 'Prazo dos jogos',
				voting_ends_at: 'Votação termina',
				results_at: 'Resultados',
				registration_mode: 'Quem pode entrar',
				capacity: 'Participantes / equipes / tamanho da equipe',
				solo: 'Permite solo',
				ai: 'Exige declarar uso de IA',
				judging: 'Julgamento',
				fee: 'Taxa de inscrição',
				contact: 'Contato', created: 'Criada',
				reviewed: 'Revisada',
			},
			numberLabels: {
				approved: 'Inscrições aprovadas',
				pending: 'Aguardando aprovação',
				waitlisted: 'Na lista de espera',
				teams: 'Equipes',
				submitted: 'Jogos enviados',
				drafts: 'Rascunhos de jogo',
			},
		},
		registrations: {
			empty: 'Nenhuma inscrição aqui.',
			seats: 'Vagas: {taken} de {max}',
			promote: 'Promover a lista de espera',
			confirmPayment: 'Confirmar pagamento',
			waive: 'Isentar a taxa',
			refund: 'Reembolsar',
			status: {
				pending: 'Aguardando',
				approved: 'Aprovada',
				waitlisted: 'Lista de espera',
				awaiting_payment: 'Aguardando pagamento',
				rejected: 'Rejeitada',
				cancelled: 'Cancelada',
			},
			payment: {
				none: '—',
				awaiting: 'Aguardando',
				paid: 'Pago',
				external_confirmed: 'Confirmado pelo organizador',
				waived: 'Isento',
				refund_pending: 'Reembolso pendente',
				refunded: 'Reembolsado',
				expired: 'Expirado',
			},
			columns: {
				person: 'Pessoa',
				status: 'Status',
				payment: 'Pagamento',
				sent: 'Enviada',
			},
		},
		teams: {
			empty: 'Nenhuma equipe ainda.',
			columns: {
				name: 'Equipe',
				leader: 'Líder',
				members: 'Membros',
				submission: 'Jogo',
			},
		},
		entries: {
			empty: 'Nenhum jogo enviado ainda.',
			open: 'Abrir o jogo',
			disqualify: 'Desqualificar',
			restore: 'Restaurar',
			needsRepublish: 'Os resultados já foram publicados: publique de novo para a mudança valer.',
			status: {
				draft: 'Rascunho',
				submitted: 'Enviado',
				disqualified: 'Desqualificado',
			},
			columns: {
				title: 'Jogo / equipe',
				status: 'Status',
				score: 'Nota (avaliações)',
			},
		},
		judging: {
			judges: 'Jurados',
			ratings: 'Avaliações',
			noJudges: 'Nenhum jurado convidado.',
			noRatings: 'Nenhuma avaliação neste filtro.',
			pending: 'pendentes',
			void: 'Anular',
			counts: {
				submitted_games: 'Jogos',
				jury_valid: 'Avaliações do júri',
				public_valid: 'Avaliações do público',
				flagged: 'Retidas para revisão',
				voided: 'Anuladas',
			},
			judgeStatus: {
				invited: 'Convidado',
				accepted: 'Aceitou',
				declined: 'Recusou',
				revoked: 'Revogado',
			},
			ratingStatus: {
				valid: 'Válida',
				flagged: 'Retida para revisão',
				voided: 'Anulada',
			},
			columns: {
				judge: 'Jurado',
				panel: 'Painel',
				status: 'Status',
				progress: 'Avaliou',
				game: 'Jogo',
				rater: 'Avaliador',
				overall: 'Nota',
			},
		},
		prizes: {
			catalog: 'Prêmios',
			results: 'Resultados',
			awards: 'Vencedores e entrega',
			resultsReady: 'Pronto para publicar.',
			resultsPublished: 'Os resultados estão publicados. Publique de novo só para corrigir.',
			publish: 'Publicar resultados',
			republish: 'Publicar de novo',
			compute: 'Calcular vencedores',
			confirm: 'Confirmar',
			deliver: 'Entregar',
			forfeit: 'Perder prêmio',
			noAwards: 'Nenhum vencedor calculado ainda.',
			awardStatus: {
				pending_review: 'Para revisar',
				confirmed: 'Confirmado',
				processing: 'Processando',
				delivered: 'Entregue',
				failed: 'Falhou',
				forfeited: 'Perdido',
			},
			columns: {
				prize: 'Prêmio',
				game: 'Jogo',
				recipient: 'Recebe',
				status: 'Status',
			},
		},
		staff: {
			title: 'Quem organiza esta jam',
			empty: 'Sem organizadores.',
			transfer: 'Transferir a propriedade',
			transferHelp: 'O novo dono assume a jam. O dono anterior continua como admin.',
			userId: 'Id da conta do novo dono',
			transferConfirm: 'Transferir',
			roles: {
				owner: 'Dono',
				admin: 'Admin',
				moderator: 'Moderador',
			},
			columns: {
				person: 'Pessoa',
				role: 'Papel',
			},
		},
		audit: {
			subtitle: 'Quem fez o quê nesta jam.',
			empty: 'Nada registrado ainda.',
			system: 'Sistema',
			actions: {
				review_approved: 'Revisão aprovada',
				review_rejected: 'Revisão rejeitada',
				suspended: 'Suspensa',
				reactivated: 'Reativada',
				archived: 'Arquivada',
				featured: 'Destacada',
				unfeatured: 'Tirada do destaque',
				deleted: 'Excluída',
				results_published: 'Resultados publicados',
				results_republished: 'Resultados publicados de novo',
				submission_disqualified: 'Jogo desqualificado',
				submission_restored: 'Jogo restaurado',
				ownership_transferred: 'Propriedade transferida',
				staff_added: 'Organizador adicionado',
				report_resolved: 'Denúncia resolvida',
				draft_reminder: 'Lembrete de rascunho enviado',
			},
			columns: {
				when: 'Quando',
				who: 'Quem',
				action: 'O quê',
				reason: 'Motivo',
			},
		},
		reports: {
			title: 'Denúncias de game jams',
			subtitle: 'O que as pessoas denunciaram. Veja a jam e então descarte a denúncia ou aja: suspenda a jam ou fale com o organizador.',
			empty: 'Nenhuma denúncia neste filtro.',
			dismiss: 'Descartar',
			actioned: 'Marcar como tratada',
			dismissTitle: 'Descartar esta denúncia',
			actionedTitle: 'Marcar esta denúncia como tratada',
			suspendAndClose: 'Suspender a jam',
			filters: {
				open: 'Abertas',
				actioned: 'Tratadas',
				dismissed: 'Descartadas',
				all: 'Todas',
			},
			status: {
				open: 'Aberta',
				actioned: 'Tratada',
				dismissed: 'Descartada',
			},
			reasons: {
				spam: 'Spam',
				scam: 'Golpe',
				inappropriate: 'Inapropriado',
				rights: 'Direitos autorais',
				other: 'Outro',
			},
			columns: {
				jam: 'Jam',
				reason: 'Motivo',
				reporter: 'Denunciada por',
				sent: 'Enviada',
				status: 'Status',
			},
		},
		edit: {
			title: 'Editar esta jam',
			save: 'Salvar alterações',
			required: 'Obrigatório.',
			noLimit: 'Sem limite',
			invalidEmail: 'Informe um e-mail válido.',
			invalidUrl: 'Informe um link que comece com http:// ou https://.',
			sections: {
				participation: 'Participação',
				dates: 'Datas',
				contact: 'Contato',
			},
			fields: {
				title: 'Título',
				description: 'Descrição',
				theme: 'Tema',
				languages: 'Idiomas',
				mode: 'Formato',
				location: 'Local',
				rules: 'Regras',
				max_team_size: 'Tamanho da equipe',
				max_teams: 'Máximo de equipes',
				max_participants: 'Máximo de participantes',
				registration_mode: 'Quem pode entrar',
				visibility: 'Visibilidade',
				allow_solo: 'Permitir participantes solo',
				require_ai_disclosure: 'Exigir declaração de uso de IA',
				waitlist_enabled: 'Lista de espera',
				contact_email: 'E-mail de contato',
				contact_url: 'Site ou página',
				contact_discord: 'Discord',
			},
			mode: {
				online: 'Online',
				in_person: 'Presencial',
				hybrid: 'Híbrido',
			},
			registration: {
				open: 'Aberta a todos',
				approval: 'O organizador aprova cada um',
				invite_only: 'Só com convite',
			},
		},
		errorCodes: {
			reason_required: 'Escreva o motivo.',
			not_suspendable: 'Só uma jam publicada pode ser suspensa.',
			not_suspended: 'Essa jam não está suspensa.',
			not_featurable: 'Só uma jam pública e publicada pode ficar em destaque.',
			has_participants: 'Uma jam com participantes não pode ser excluída. Arquive.',
			forbidden: 'Você não pode fazer isso.',
			platform_only: 'Só a equipe da plataforma pode fazer isso.',
			review_not_pending: 'Essa jam não está aguardando revisão.',
			report_already_resolved: 'Essa denúncia já foi resolvida.',
			announce_needs_published: 'Só uma jam publicada pode enviar mensagens.',
			announce_too_soon: 'Uma mensagem acabou de ser enviada. Espere um pouco.',
			staff_user_not_found: 'Nenhuma conta tem esse id.',
			cannot_publish_results: 'Os resultados ainda não estão prontos para publicar.',
			results_already_published: 'Os resultados já foram publicados.',
			voting_not_ended: 'A votação ainda não terminou.',
		},
	},
	Votings: {
		title: 'Votações',
		subtitle: 'Votações recorrentes da comunidade: melhores do ano, podcasts, showcases e enquetes rápidas.',
		new: 'Nova votação',
		edit: 'Editar votação',
		empty: 'Nenhuma votação ainda. Crie a primeira a partir de um template.',
		duplicate: 'Duplicar',
		archive: 'Arquivar',
		saved: 'Salvo.',
		columns: { title: 'Votação', phase: 'Fase', entries: 'Competidores', votes: 'Votos', ends: 'Fim da votação' },
		phases: { draft: 'Rascunho', archived: 'Arquivada', scheduled: 'Agendada', voting: 'Votação aberta', closed: 'Encerrada', results: 'Resultado' },
		kinds: { game: 'Jogos', podcast_episode: 'Episódios de podcast', podcast_show: 'Podcasts', studio: 'Estúdios', showcase: 'Showcase', custom: 'Escolha livre' },
		confirm: { archive: 'Arquivar esta votação? Ela some do site público:', destroy: 'Excluir esta votação definitivamente?' },
		steps: { template: 'Template', competitors: 'Competidores', calendar: 'Calendário', review: 'Revisar e publicar', promote: 'Divulgar' },
		template: { choose: 'Comece por um template', categoriesCount: '{n} categorias', duration: '{n} dias de votação', createContinue: 'Criar e continuar' },
		fields: { title: 'Título', titleHint: 'Deixe vazio para usar o nome do template', edition: 'Edição (ex.: 2026)' },
		competitors: {
			image: 'Imagem do competidor',
			count: '{n} competidores',
			pasteLabel: 'Adicionar competidores',
			pasteHint: 'Um por linha. Link opcional depois de um |, ex.: Hades II | https://loja.exemplo/hades-2',
			add: 'Adicionar à categoria',
			newCategory: 'Nome da nova categoria',
			addCategory: 'Adicionar categoria',
			removeCategory: 'Remover categoria',
		},
		calendar: {
			votingStart: 'Abertura da votação',
			votingEnd: 'Fim da votação',
			resultsAt: 'Anúncio do resultado',
			liveResults: 'Mostrar placar ao vivo',
			liveResultsHint: 'Desligado: o público só vê o resultado depois do fim da votação',
			locked: 'A votação já abriu. As datas dela não podem mais mudar.',
			saveContinue: 'Salvar e revisar',
		},
		review: {
			ready: 'Tudo pronto para publicar.',
			blockers: 'Corrija antes de publicar',
			warnings: 'Vale conferir',
			publish: 'Publicar votação',
			published: 'Publicada',
			publishedOk: 'Votação publicada.',
		},
		checks: {
			title_missing: 'A votação precisa de um título.',
			no_categories: 'Adicione ao menos uma categoria.',
			voting_dates_invalid: 'Defina o início da votação e um fim posterior a ele.',
			voting_already_ended: 'O fim da votação já passou.',
			category_needs_entries: '{category} precisa de ao menos 2 competidores (tem {n}).',
			entry_without_image: 'Alguns competidores estão sem imagem.',
			cover_missing: 'A votação está sem imagem de capa.',
		},
		cover: { label: 'Imagem de capa' },
		image: { hint: 'Use uma imagem 1280x720 (16:9). JPG, PNG ou GIF.', hintEntry: 'Use uma imagem vertical (5:8, ex.: 600x960), como o cartão exibido na votação. O botão de votar cobre a base da foto, então mantenha rostos e logos na parte de cima. JPG, PNG ou GIF.', remove: 'Remover imagem' },
		kit: {
			notPublished: 'Os links funcionam assim que a votação for publicada. Você já pode preparar as legendas.',
			intro: 'Divulgue a votação e cada competidor. Todo link carrega a sua origem, então os números abaixo mostram qual canal trouxe os votos.',
			language: 'Idioma do público',
			source: 'Onde você vai postar?',
			sourceHint: 'Escolha um ou digite o seu',
			medium: 'Mídia',
			campaign: 'Campanha',
			votingLink: 'Link da votação',
			caption: 'Legenda pronta',
			competitorLinks: 'Competidores',
			noCompetitors: 'Adicione competidores no passo anterior para gerar os links deles.',
			downloadCard: 'Baixar card',
			copied: 'Copiado.',
			copyFailed: 'Não foi possível copiar. Selecione o texto e copie manualmente.',
			cardNoPicture: 'Card salvo sem a imagem: o servidor da imagem não permite usá-la no card.',
			cardError: 'Não foi possível criar o card.',
			statsTitle: 'Resultado por origem',
			refresh: 'Atualizar',
			statsTotals: '{votes} votos de {voters} pessoas',
			statsSource: 'Origem',
			statsVotes: 'Votos',
			statsDirect: 'Direto (sem link rastreado)',
			statsEmpty: 'Ainda não há votos. Os números aparecem aqui assim que as pessoas começarem a votar.',
		},
		errors: { generic: 'Algo deu errado. Tente novamente.' },
	},
}
